import { todayMessagesDe } from "../../features/clock/messages.today.de";
import { setupWizardMessagesDe } from "../../features/setup/messages.setup.de";
import { platformMessagesDe } from "./messages.platform.de";

/**
 * German messages (default language, spec 11.2). The keys of this dictionary define
 * {@link MessageKey}; every other language must provide all of them.
 */
export const messagesDe = {
  "app.title": "Zeitavo",
  "app.slogan": "Arbeitszeit. Einfach erfasst.",
  "app.skipToContent": "Zum Inhalt springen",
  "app.loading": "Wird geladen …",
  "app.language": "Sprache",
  "app.theme": "Darstellung",
  "app.theme.system": "System",
  "app.theme.light": "Hell",
  "app.theme.dark": "Dunkel",
  "nav.main": "Hauptnavigation",
  "nav.clock": "Heute",
  ...todayMessagesDe,
  "nav.times": "Meine Zeiten",
  "nav.balances": "Salden",
  "nav.corrections": "Korrekturen",
  "nav.absences": "Abwesenheiten",
  "nav.team": "Team",
  "nav.violations": "Verstöße",
  "nav.admin": "Verwaltung",
  "nav.privacy": "Datenschutz",
  "nav.bar.absences": "Abwesen\u00adheiten",
  "nav.more": "Mehr",
  "more.areas": "Weitere Bereiche",
  "more.settings": "Einstellungen",
  "more.account": "Konto",
  "more.language.de": "Deutsch",
  "more.language.en": "English",
  "account.settings": "Einstellungen",
  "account.preferences": "Sprache und Darstellung",
  "account.menu": "{name} – Konto",
  "auth.redirecting": "Weiterleitung zur Anmeldung …",
  "auth.emailFirst.title": "Anmelden",
  "auth.emailFirst.label": "Dienstliche E-Mail-Adresse",
  "auth.emailFirst.invalid":
    "Bitte geben Sie Ihre vollständige dienstliche E-Mail-Adresse ein, zum Beispiel name@firma.de.",
  "auth.emailFirst.continue": "Weiter",
  "auth.emailFirst.hint":
    "Über die Adresse findet die Anmeldung Ihren Arbeitgeber. Sie wird nicht gespeichert.",
  "legalLinks.title": "Rechtliches",
  "legalLinks.privacyPolicy": "Datenschutzerklärung",
  "legalLinks.imprint": "Impressum",
  "legalLinks.accessibility": "Barrierefreiheit",
  "legalLinks.security": "Sicherheitslücke melden",
  "start.notRegistered.title": "Konto noch nicht zugeordnet",
  "start.notRegistered.text":
    "Ihr Konto ist noch keiner beschäftigten Person zugeordnet, deshalb können Sie noch nicht stempeln. Das erledigt die Personalabteilung; danach steht hier die Stempeluhr.",
  "start.notRegistered.retry": "Erneut prüfen",
  "start.notRegistered.account":
    "Einstellungen und Abmelden finden Sie im Kontomenü an Ihrem Namen oben rechts.",
  "start.noAppFunctions.title": "Willkommen",
  "start.noAppFunctions.text":
    "Für Ihre Rolle gibt es in dieser App keine Funktionen. Einstellungen und Abmelden finden Sie im Kontomenü an Ihrem Namen oben rechts.",
  "auth.signIn": "Anmelden",
  "auth.completing": "Anmeldung wird abgeschlossen …",
  "auth.retry": "Erneut anmelden",
  "auth.logout": "Abmelden",
  "auth.signedInAs": "Angemeldet als {name}",
  "auth.logoutPendingWarning.one":
    "{count} Eintrag ist noch nicht an den Server übertragen. Beim Abmelden wird er von diesem Gerät gelöscht und geht verloren.",
  "auth.logoutPendingWarning.other":
    "{count} Einträge sind noch nicht an den Server übertragen. Beim Abmelden werden sie von diesem Gerät gelöscht und gehen verloren.",
  "auth.logoutConfirm": "Trotzdem abmelden",
  "auth.logoutFailed": "Die Abmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "common.cancel": "Abbrechen",
  "error.title": "Etwas ist schiefgelaufen.",
  "error.reload": "Seite neu laden",
  "error.notFound": "Diese Seite gibt es nicht.",
  "error.backHome": "Zur Startseite",
  "error.network": "Der Server ist nicht erreichbar. Bitte prüfen Sie die Verbindung.",
  "error.forbidden": "Dafür fehlt Ihnen die Berechtigung.",
  "error.administrationReadOnly":
    "Die Verwaltung ist schreibgeschützt, weil eine Zahlung offen ist oder der Vertrag endete. Stempeln, eigene Zeiten und Exporte funktionieren weiter.",
  "error.entitlementMissing":
    "Ihr Tarif enthält diese Funktion nicht. Die Mandanten-Administration kann den Tarif ändern.",
  "error.functionNotEnabled": "Diese Funktion ist für Ihre Organisation nicht freigeschaltet.",
  "error.readOnly":
    "Die Verwaltung ist schreibgeschützt. Stempeln, eigene Zeiten und Exporte funktionieren weiter.",
  "error.projectTimeTrackingDisabled":
    "Die Projektzeiterfassung ist ausgeschaltet. Die Mandanten-Administration schaltet sie in den Mandanten-Einstellungen ein.",
  "error.managersMayNotCreateProjects":
    "Führungskräfte dürfen in diesem Mandanten keine Projekte anlegen. Die Mandanten-Administration kann es unter Mandant → Einstellungen („Führungskräfte dürfen Projekte anlegen“) erlauben.",
  "error.notRegistered":
    "Ihr Konto ist keiner beschäftigten Person zugeordnet. Bitte wenden Sie sich an die Personalabteilung.",
  "error.generic": "Die Anfrage ist fehlgeschlagen.",
  "sync.online": "Online",
  "sync.offline": "Offline",
  "sync.syncing": "Wird synchronisiert …",
  "sync.pending.one": "{count} Eintrag noch nicht übertragen",
  "sync.pending.other": "{count} Einträge noch nicht übertragen",
  "sync.error": "Synchronisierung fehlgeschlagen ({code}). Neuer Versuch folgt automatisch.",
  "sync.refreshFailed":
    "Alle Einträge übertragen. Der Stand vom Server konnte nicht geladen werden ({code}); neuer Versuch folgt automatisch.",
  "sync.notYet": "Noch nicht synchronisiert",
  "sync.upToDate": "Synchronisiert um {time}",
  "sync.upToDateOn": "Synchronisiert am {date} um {time}",
  "sync.conflicts.one": "{count} Konflikt zu klären",
  "sync.conflicts.other": "{count} Konflikte zu klären",
  "sync.retry": "Jetzt senden",
  "update.available": "Eine neue Version ist verfügbar.",
  "update.activate": "Jetzt aktualisieren",
  "update.waitingForSync": "Die neue Version wird nach der laufenden Synchronisierung aktiviert …",
  "update.activating": "Die neue Version wird aktiviert …",
  "push.title": "Benachrichtigungen",
  "push.hint":
    "Erinnerungen an offene Arbeitstage (z. B. vergessenes Ausstempeln) als Mitteilung auf diesem Gerät. Die Mitteilungen enthalten keine Namen und keine Arbeitszeiten. Beim Abmelden wird das Gerät abgemeldet.",
  "push.enable": "Benachrichtigungen einschalten",
  "push.disable": "Benachrichtigungen ausschalten",
  "push.state.on": "Dieses Gerät erhält Erinnerungen.",
  "push.state.off": "Dieses Gerät erhält keine Erinnerungen.",
  "push.state.denied":
    "Mitteilungen sind in den Browser-Einstellungen blockiert. Erlauben Sie sie dort, um Erinnerungen zu erhalten.",
  "push.state.notConfigured": "Benachrichtigungen sind auf dem Server nicht eingerichtet.",
  "push.state.unsupported": "Dieser Browser unterstützt keine Benachrichtigungen.",
  "push.state.installRequired":
    "Auf iPhone und iPad gibt es Benachrichtigungen nur für die installierte App. Fügen Sie Zeitavo zuerst zum Home-Bildschirm hinzu.",
  "nav.install": "Installieren",
  "install.why.title": "Warum installieren?",
  "install.why":
    "Die installierte App startet vom Home-Bildschirm, funktioniert ohne Verbindung und kann an vergessenes Ausstempeln erinnern (auf iPhone und iPad nur als installierte App).",
  "install.how.title": "So geht es",
  "install.button": "App installieren",
  "install.installed": "Die App ist auf diesem Gerät installiert.",
  "install.dismissed":
    "Die Installation wurde abgebrochen. Sie können sie jederzeit über das Browsermenü nachholen.",
  "install.ios.intro": "Auf iPhone und iPad in Safari:",
  "install.ios.step1":
    "Tippen Sie unten (iPad: oben) auf das Teilen-Symbol (Quadrat mit Pfeil nach oben).",
  "install.ios.step2": "Wählen Sie „Zum Home-Bildschirm“.",
  "install.ios.step3":
    "Tippen Sie auf „Hinzufügen“ und öffnen Sie Zeitavo künftig über das neue Symbol.",
  "install.android.intro": "Auf Android in Chrome:",
  "install.android.step1": "Öffnen Sie das Menü (drei Punkte oben rechts).",
  "install.android.step2": "Wählen Sie „App installieren“ oder „Zum Startbildschirm hinzufügen“.",
  "install.desktop.intro": "Am Computer in Chrome oder Edge:",
  "install.desktop.step1":
    "Klicken Sie auf das Installationssymbol rechts in der Adressleiste oder öffnen Sie das Browsermenü.",
  "install.desktop.step2": "Wählen Sie „Zeitavo installieren“ bzw. „App installieren“.",
  "clock.action.ClockIn": "Kommen",
  "clock.action.BreakStart": "Pause",
  "clock.action.BreakEnd": "Weiter",
  "clock.action.ClockOut": "Gehen",
  "clock.breakAction.RestBreak": "Ruhepause",
  "clock.breakAction.Standby": "Bereitschaft/Wartezeit",
  "clock.breakHint":
    "Ruhepause: Die Pause steht bei ihrem Beginn fest und Sie sind frei von Arbeit und Bereitschaft. Müssen Sie erreichbar bleiben oder warten, wählen Sie „Bereitschaft/Wartezeit“ – sie zählt nicht als Ruhepause.",
  "clock.state.OnStandby": "In Bereitschaft/Wartezeit seit {time}",
  "breakQualification.Unclassified": "nicht eingeordnet",
  "breakQualification.RestBreak": "Ruhepause",
  "breakQualification.Standby": "Bereitschaft/Wartezeit",
  "clock.state.Off": "Ausgestempelt",
  "clock.state.Working": "Eingestempelt seit {time}",
  "clock.state.OnBreak": "In Pause seit {time}",
  "clock.workToday": "Arbeitszeit",
  "clock.breakToday": "Pause",
  "clock.dayOf": "Arbeitstag {date}",
  "clock.recorded": "{action} um {time} gespeichert.",
  "clock.notStored":
    "Die Eingabe wurde auf diesem Gerät nicht gespeichert und ist nicht erfasst. Bitte versuchen Sie es erneut.",
  "clock.snapshotMissing":
    "Noch kein Stand vom Server – der angezeigte Zustand beruht nur auf diesem Gerät.",
  "clock.snapshotFrom": "Stand vom Server: {time}",
  "clock.inconsistent": "Lokale und Serverdaten passen nicht zusammen. Bitte synchronisieren.",
  "clock.warning.breakDue":
    "Pause fällig: In {minutes} min arbeiten Sie länger als {limit} h ohne Pause.",
  "clock.warning.breakOverdue":
    "Sie arbeiten seit mehr als {limit} h ohne Pause. Bitte machen Sie jetzt eine Pause.",
  "clock.warning.breakMissing":
    "Heute sind mindestens {required} min Pause vorgeschrieben, bisher {taken} min (Abschnitte ab 15 min).",
  "clock.warning.dailyLimitSoon":
    "In {minutes} min erreichen Sie die gesetzliche Höchstarbeitszeit von {limit} h.",
  "clock.warning.dailyLimitExceeded":
    "Die gesetzliche Höchstarbeitszeit von {limit} h ist überschritten.",
  "clock.warning.regularLimitExceeded":
    "Mehr als {limit} h Arbeitszeit – ein Ausgleich ist erforderlich.",
  "clock.warning.restActive":
    "Ruhezeit bis {time}: Ein früherer Arbeitsbeginn unterschreitet die gesetzliche Ruhezeit.",
  "clock.warning.openDays":
    "Nicht abgeschlossene Arbeitstage: {dates}. Bitte eine Korrektur beantragen.",
  "clock.confirmEarlyStart":
    "Die Ruhezeit läuft noch bis {time}. Trotzdem jetzt einstempeln? Die Stempelung wird gespeichert und als Unterschreitung der Ruhezeit gemeldet.",
  "clock.confirmEarlyStartAction": "Trotzdem einstempeln",
  "clock.conflicts": "Konflikte klären",
  "clock.conflict": "{action} vom {time} wurde abgelehnt: {reason}",
  "clock.conflictCorrection": "Korrektur beantragen",
  "clock.conflictDismiss": "Ausblenden",
  "crew.title": "Für andere stempeln",
  "crew.intro":
    "Wählen Sie eine oder mehrere Personen, für die Sie zuständig sind, und stempeln Sie für alle zugleich. Jede Person erhält ein eigenes Ereignis mit Ihnen als erfassender Person; sie sieht es unter „Meine Zeiten“ und kann eine Korrektur beantragen.",
  "crew.empty": "Niemand, für den Sie heute stempeln können.",
  "crew.search": "Person suchen",
  "crew.people": "Personen ({count} ausgewählt)",
  "crew.open": "Personen wählen und stempeln",
  "crew.selectShown": "Alle angezeigten auswählen",
  "crew.selectNone": "Auswahl aufheben",
  "crew.action": "{action} für {count}",
  "crew.recorded": "{action} für {count} Personen um {time} erfasst",
  "crew.skipped": "Nicht erfasst, weil der Schritt nicht zum Stand passt: {names}",
  "crew.pending": "{count} nicht gesendet",
  "crew.recordFailed":
    "Die Einträge konnten auf diesem Gerät nicht gespeichert werden. Prüfen Sie den Stand der Personen und stempeln Sie fehlende Schritte erneut.",
  "crew.fromDevice": "Ohne Verbindung – Personen und Stand vom {time}",
  "crew.conflicts": "Abgelehnte Einträge für andere",
  "crew.conflictHint": "Fehlende Zeiten trägt die Person über eine Korrektur nach.",
  "crew.conflict": "{action} für {name} vom {time} wurde abgelehnt: {reason}",
  "crew.unknownPerson": "eine nicht mehr zugeordnete Person",
  "project.title": "Projekt",
  "project.forClockIn": "Projekt beim Kommen",
  "project.none": "Kein Projekt",
  "project.budgetNearlyExhausted": "Budget fast erschöpft",
  "project.current": "Projekt: {project}",
  "project.currentNone": "Kein Projekt zugeordnet",
  "project.switch": "Projekt wechseln",
  "project.search": "Projekt suchen (Kürzel oder Name)",
  "project.list": "Projekte",
  "project.favorite": "{project} als Favorit",
  "project.noMatch": "Kein passendes Projekt.",
  "project.stop": "Ohne Projekt weiterarbeiten",
  "project.switched": "Projekt gewechselt um {time}.",
  "dayOverview.title": "Tagesübersicht {date}",
  "dayOverview.summary": "Arbeitszeit {work}, davon keinem Projekt zugeordnet: {open}",
  "dayOverview.segments": "Zeitabschnitte",
  "dayOverview.range": "{from}–{to}",
  "dayOverview.unknownProject": "Nicht mehr wählbares Projekt",
  "dayOverview.split": "{range} aufteilen",
  "dayOverview.splitShort": "Aufteilen",
  "dayOverview.splitAt": "Aufteilen um",
  "dayOverview.splitConfirm": "Teilen",
  "dayOverview.splitInvalid": "Bitte eine Uhrzeit zwischen {from} und {to} angeben.",
  "dayOverview.later": "Später zuordnen",
  "dayOverview.done": "Fertig",
  "dayOverview.saved": "Zuordnung gespeichert.",
  "openDays.title": "Offene Projektzuordnungen",
  "openDays.none": "Keine offenen Projektzuordnungen.",
  "openDays.item": "{date}: {open} ohne Projekt",
  "openDays.assign": "Zuordnen",
  "nav.setup": "Einrichtung",
  ...setupWizardMessagesDe,
  "setup.intro":
    "Richten Sie Zeitavo in wenigen Schritten ein. Alle Schritte können Sie später in der Verwaltung ändern.",
  "setup.checklist": "Checkliste zur Einrichtung",
  "setup.progress": "Einrichtung: {done} von {total} Schritten erledigt",
  "setup.continue": "Einrichtung fortsetzen",
  "setup.derived": "ergibt sich aus den Daten",
  "setup.invitationsStepHint":
    "Gilt auch als erledigt für Beschäftigte, die schon ein Konto zur Anmeldung haben, zum Beispiel über die Anmeldung Ihres Unternehmens. Sie brauchen keine Einladung.",
  "setup.open": "Öffnen",
  "setup.confirm": "Erledigt",
  "setup.withdraw": "Zurücknehmen",
  "setup.confirmNamed": "{step} als erledigt markieren",
  "setup.withdrawNamed": "{step}: Bestätigung zurücknehmen",
  "setup.downloadTemplate": "Vorlage herunterladen",
  "setup.step.Establishment": "Betrieb geprüft (Bundesland, Branchen, Sonntagsausnahme)",
  "setup.step.WorkTimeModels": "Arbeitszeitmodelle geprüft",
  "setup.step.Employees": "Beschäftigte angelegt",
  "setup.step.Invitations": "Alle Beschäftigten eingeladen",
  "setup.step.WorksCouncil": "Betriebsrat informiert (§ 87 Abs. 1 Nr. 6 BetrVG)",
  "setup.step.EmployeeInformation": "Beschäftigte nach Art. 13 DSGVO informiert",
  "setup.step.FirstClockEvent": "Erste Stempelung erfasst",
  "setup.models": "Arbeitszeitmodelle aus Vorlagen",
  "setup.modelsHint": "Jede Vorlage legt ein eigenes Modell an, das Sie danach frei ändern können.",
  "setup.templates": "Vorlagen",
  "setup.templateItem": "{name} ({hours} h pro Woche)",
  "setup.templateExists": "bereits angelegt",
  "setup.createModels": "Ausgewählte Modelle anlegen",
  "setup.modelsCreated.one": "{count} Arbeitszeitmodell angelegt.",
  "setup.modelsCreated.other": "{count} Arbeitszeitmodelle angelegt.",
  "setup.employees": "Beschäftigte",
  "setup.employeesHint":
    "Laden Sie eine CSV-Datei (Semikolon oder Komma) oder legen Sie Beschäftigte einzeln an. Wer eine E-Mail-Adresse hat, erhält eine Einladung.",
  "setup.csvFile": "CSV-Datei",
  "setup.csvText": "Inhalt der CSV-Datei",
  "setup.csvHint":
    "Pflichtspalten: Personalnummer, Vorname, Nachname, Eintrittsdatum. Optional: E-Mail, Arbeitszeitmodell, Betrieb, Beschäftigungsart, 18. Geburtstag.",
  "setup.csvTooLarge": "Die Datei ist zu groß (höchstens 900 KB).",
  "setup.check": "Prüfen",
  "setup.import": "Importieren",
  "setup.checkOk.one": "Keine Fehler: {count} beschäftigte Person kann importiert werden.",
  "setup.checkOk.other": "Keine Fehler: {count} Beschäftigte können importiert werden.",
  "setup.checkErrors.one":
    "{count} Fehler gefunden. Es wird nichts importiert, bis er behoben ist.",
  "setup.checkErrors.other":
    "{count} Fehler gefunden. Es wird nichts importiert, bis alle behoben sind.",
  "setup.errorTable": "Fehler je Zeile",
  "setup.errorLine": "Zeile",
  "setup.errorField": "Spalte",
  "setup.errorMessage": "Fehler",
  "import.field.csv": "Datei",
  "import.field.personnelNumber": "Personalnummer",
  "import.field.firstName": "Vorname",
  "import.field.lastName": "Nachname",
  "import.field.email": "E-Mail",
  "import.field.entryDate": "Eintrittsdatum",
  "import.field.workTimeModel": "Arbeitszeitmodell",
  "import.field.establishment": "Betrieb",
  "import.field.employmentType": "Beschäftigungsart",
  "import.field.minorUntil": "18. Geburtstag",
  "import.field.leaveYear": "Urlaubsjahr",
  "import.field.days": "Resturlaub",
  "import.field.taken": "Genommen",
  "import.field.part": "Teil",
  "import.field.reason": "Begründung",
  "import.field.number": "Nummer",
  "import.field.name": "Name",
  "import.field.externalReference": "Referenz",
  "import.field.code": "Kürzel",
  "import.field.billable": "Abrechenbar",
  "setup.imported.one":
    "{count} beschäftigte Person angelegt; vorbereitete Einladungen: {invitations}.",
  "setup.imported.other": "{count} Beschäftigte angelegt; vorbereitete Einladungen: {invitations}.",
  "setup.single": "Einzeln anlegen",
  "setup.field.personnelNumber": "Personalnummer",
  "setup.field.firstName": "Vorname",
  "setup.field.lastName": "Nachname",
  "setup.field.email": "E-Mail für die Einladung",
  "setup.field.entryDate": "Eintrittsdatum",
  "setup.add": "Anlegen",
  "setup.singleAdded": "Beschäftigte Person angelegt.",
  "setup.invitations": "Einladungen",
  "setup.noInvitations":
    "Noch keine Einladungen. Beschäftigte mit E-Mail-Adresse erhalten eine, sobald Sie sie oben importieren oder einzeln anlegen.",
  "setup.invitation.Pending": "wartet auf Versand",
  "setup.invitation.Sent": "gesendet",
  "setup.invitation.Failed": "fehlgeschlagen",
  "setup.send": "Senden",
  "setup.sendNamed": "Einladung an {name} senden",
  "setup.resend": "Erneut senden",
  "setup.resendNamed": "Einladung an {name} erneut senden",
  "setup.sendInvitations": "Offene Einladungen senden ({count})",
  "admin.teams": "Teams",
  "admin.team.hint":
    "Beschäftigte gehören über ihre Beschäftigung zu einem Team. Projekte und Pflicht-Richtlinien können sich auf Teams beziehen.",
  "admin.team.new": "Neues Team",
  "admin.team.name": "Name des Teams",
  "admin.team.lead": "Teamleitung",
  "admin.team.establishment": "Betrieb",
  "admin.team.noEstablishment": "Kein bestimmter Betrieb",
  "admin.team.item": "{name} – Leitung: {lead}, ab {from}",
  "admin.team.editNamed": "Team {name} bearbeiten",
  "admin.employment.team": "Team",
  "admin.employment.noTeam": "Kein Team",
  "admin.employment.teamItem": "Team {team}",
  "projects.members.noTeams":
    "Noch keine Teams angelegt. HR legt Teams unter Verwaltung → Teams an und ordnet Beschäftigte über ihre Beschäftigung einem Team zu.",
  "projects.members.noEmployees":
    "Keine Personen zur Auswahl. Manager sehen hier die Personen ihres Teams.",
  "projects.members.unknown": "Nicht in Ihrer Auswahl",
  "projects.policies.noEstablishments": "Noch keine Betriebe angelegt.",
  "projects.policies.noEmployments": "Für diese Person ist keine Beschäftigung erfasst.",
  "projects.policies.employmentItem": "Beschäftigung {from} bis {to}",
  "nav.projects": "Projekte",
  "projects.list": "Projektliste",
  "projects.none": "Keine Projekte vorhanden.",
  "projects.new": "Neues Projekt",
  "projects.edit": "Bearbeiten",
  "projects.editNamed": "{code} bearbeiten",
  "projects.archive": "Archivieren",
  "projects.archiveNamed": "{code} archivieren",
  "projects.reactivate": "Reaktivieren",
  "projects.reactivateNamed": "{code} reaktivieren",
  "projects.archived": "archiviert",
  "projects.participants": "Mitglieder",
  "projects.participantsNamed": "Mitglieder von {code}",
  "projects.field.code": "Projektnummer",
  "projects.field.name": "Name",
  "projects.field.description": "Beschreibung",
  "projects.field.costCenter": "Kostenstelle",
  "projects.field.customerReference": "Kundenreferenz",
  "projects.field.validFrom": "Gültig ab",
  "projects.field.validTo": "Gültig bis",
  "projects.field.visibility": "Wählbar für",
  "projects.field.billable": "Abrechenbar",
  "projects.visibility.AllEmployees": "Alle Beschäftigten",
  "projects.visibility.Members": "Nur Mitglieder",
  "projects.members": "Mitglieder",
  "projects.members.none": "Keine Mitglieder.",
  "projects.members.kind": "Art",
  "projects.members.choose": "Bitte wählen",
  "projects.members.from": "Ab",
  "projects.members.add": "Hinzufügen",
  "projects.members.save": "Mitglieder speichern",
  "projects.memberKind.Team": "Team",
  "projects.memberKind.Employee": "Person",
  "projects.period": "{from} bis {to}",
  "projects.remove": "Entfernen",
  "projects.responsibles": "Projektverantwortung",
  "projects.responsibles.none": "Keine Projektverantwortlichen.",
  "projects.responsibles.employee": "Person",
  "projects.responsibles.add": "Hinzufügen",
  "projects.responsibles.save": "Projektverantwortung speichern",
  "projects.saved": "Gespeichert.",
  "projects.policies": "Pflicht zur Projektzuordnung",
  "projects.policies.hint":
    "Die genaueste Ebene gilt: Beschäftigung vor Team vor Betrieb vor Mandant.",
  "projects.policies.none": "Keine Richtlinien; die Projektzuordnung ist freiwillig.",
  "projects.policies.set": "Richtlinie festlegen",
  "projects.policies.scopeKind": "Ebene",
  "projects.policies.scope": "Geltungsbereich",
  "projects.policies.mode": "Pflicht",
  "projects.policies.deadlineDays": "Frist (Arbeitstage)",
  "projects.scope.Tenant": "Mandant",
  "projects.scope.Establishment": "Betrieb",
  "projects.scope.Team": "Team",
  "projects.scope.Employment": "Beschäftigung",
  "projects.mode.Disabled": "Aus",
  "projects.mode.Optional": "Freiwillig",
  "projects.mode.RequiredByDayClose": "Pflicht bis zur Frist",
  "projects.mode.PromptAtClockOut": "Abfrage beim Ausstempeln",
  // F-27: project list as a table with a detail view.
  "projects.search": "Projekt suchen (Nummer oder Name)",
  "projects.statusFilter": "Status",
  "projects.filter.Active": "Aktiv",
  "projects.filter.Archived": "Archiviert",
  "projects.filter.All": "Alle",
  "projects.count.one": "{count} Projekt",
  "projects.count.other": "{count} Projekte",
  "projects.noneFound": "Keine Projekte passen zu Suche und Status.",
  "projects.column.project": "Projekt",
  "projects.column.status": "Status",
  "projects.column.members": "Mitglieder",
  "projects.column.responsibles": "Verantwortlich",
  "projects.column.period": "Zeitraum",
  "projects.status.Active": "Aktiv",
  "projects.status.Archived": "Archiviert",
  "projects.members.everyone": "Alle Beschäftigten",
  "projects.members.nobody": "Noch niemand",
  "projects.members.teams.one": "{count} Team",
  "projects.members.teams.other": "{count} Teams",
  "projects.people.one": "{count} Person",
  "projects.people.other": "{count} Personen",
  "projects.responsibles.nobody": "Niemand",
  "projects.period.open": "unbefristet",
  "projects.period.from": "ab {from}",
  "projects.period.to": "bis {to}",
  "projects.period.ended": "beendet",
  "projects.period.upcoming": "geplant",
  "projects.back": "Alle Projekte",
  "projects.facts": "Stammdaten",
  "projects.yes": "Ja",
  "projects.no": "Nein",
  "projects.members.hintEveryone":
    "Alle Beschäftigten können dieses Projekt wählen. Mitglieder schränken die Auswahl erst ein, wenn „Wählbar für“ auf „Nur Mitglieder“ steht.",
  "projects.members.hintNobody":
    "Noch niemand kann dieses Projekt wählen. Fügen Sie Teams oder Personen hinzu und speichern Sie.",
  "projects.members.name": "Name",
  "projects.members.addTitle": "Mitglied hinzufügen",
  "projects.responsibles.addTitle": "Verantwortliche Person hinzufügen",
  "projects.responsiblesNamed": "Projektverantwortung von {code}",
  "projects.removeNamed": "{name} entfernen",
  "projects.unsaved": "Nicht gespeicherte Änderungen",
  "projects.discard": "Änderungen verwerfen",
  // T-169: project report.
  "projects.sections": "Bereiche der Projekte",
  "projects.section.list": "Projektliste",
  "projects.section.report": "Auswertung",
  "projects.section.catalog": "Kunden und Tätigkeiten",
  "projects.section.billing": "Abrechnung",
  "projects.field.customer": "Kunde",
  "projects.customerNone": "Kein Kunde",
  "projects.activities.title": "Erlaubte Tätigkeiten",
  "projects.activities.all": "Keine Auswahl: Alle aktiven Tätigkeiten sind erlaubt.",
  "projects.activities.some":
    "Nur die gewählten Tätigkeiten sind erlaubt. Offline erfasste andere Tätigkeiten werden angenommen und markiert.",
  "projects.activities.none":
    "Es gibt noch keine Tätigkeiten. Legen Sie sie unter „Kunden und Tätigkeiten“ an.",
  "projects.activities.saved": "Erlaubte Tätigkeiten gespeichert.",
  "projects.policies.requireActivity": "Tätigkeit verlangen (nur Hinweis, blockiert nie)",
  "projects.policies.requireActivityShort": "Tätigkeit verlangt",
  "projects.report.column.customer": "Kunde",
  "projects.report.column.activity": "Tätigkeit",
  "projects.report.customer": "Kunde",
  "projects.report.allCustomers": "Alle Kunden",
  "projects.report.byActivity": "Nach Tätigkeit aufteilen",
  // T-185: project budgets.
  "budgets.title": "Budgets",
  "budgets.setting.limits":
    "Grenzen gegen kleinteilige Budgets (Betriebsvereinbarung): Budget mindestens {hours} Stunden, Warnschwellen {min} bis {max} %, höchstens {count} je Budget, Gültigkeit mindestens {days} Tage, höchstens {budgets} laufende Budgets je Projekt.",
  "budgets.name": "{scope}, {period}, {validity}",
  "budgets.problem.validity": "Ein Budget mit Ende gilt mindestens {days} Tage.",
  "budgets.hint":
    "Budgets in Stunden für das ganze Projekt oder eine Tätigkeit, für die Laufzeit oder je Monat. Sie warnen nur: Die Projektverantwortlichen erhalten je Budget und Zeitraum höchstens eine Nachricht je Warnschwelle, erfasst wird weiter. Der Verbrauch ist die Projektzeit der Auswertung; HR sieht ihn ebenfalls.",
  "budgets.none": "Für dieses Projekt gibt es noch kein Budget.",
  "budgets.add": "Budget anlegen",
  "budgets.new": "Neues Budget",
  "budgets.edit": "Budget ändern",
  "budgets.editShort": "Ändern",
  "budgets.editNamed": "Budget {name} ändern",
  "budgets.remove": "Entfernen",
  "budgets.removeNamed": "Budget {name} entfernen",
  "budgets.removeConsequence":
    "Das Budget und die Markierungen erreichter Warnschwellen werden entfernt. Erfasste Zeiten bleiben unverändert.",
  "budgets.removeConfirm": "Budget entfernen",
  "budgets.removed": "Budget entfernt.",
  "budgets.saved": "Budget gespeichert.",
  "budgets.cancel": "Abbrechen",
  "budgets.offline": "Budgets lassen sich nur mit Verbindung ändern.",
  "budgets.azvOmitted":
    "Der Verbrauch enthält keine Zeiten an Tagen von Bundesbeamtinnen und Bundesbeamten (§ 7 Abs. 8 AZV); den vollständigen Verbrauch sieht die Personalabteilung.",
  "budgets.wholeProject": "Ganzes Projekt",
  "budgets.unknownActivity": "Unbekannte Tätigkeit",
  "budgets.period.Total": "Laufzeit",
  "budgets.period.Monthly": "Je Monat",
  "budgets.field.activity": "Gilt für",
  "budgets.field.period": "Zeitraum",
  "budgets.field.hours": "Budget in Stunden",
  "budgets.field.thresholds": "Warnschwellen in Prozent",
  "budgets.field.validFrom": "Gültig ab",
  "budgets.field.validTo": "Gültig bis",
  "budgets.formHint":
    "Warnschwellen mit Komma trennen, zum Beispiel „80, 100“. Tätigkeit und Zeitraum lassen sich später nicht ändern.",
  "budgets.problem.hours":
    "Bitte ein Budget von mindestens {hours} Stunden angeben (höchstens eine Million).",
  "budgets.problem.thresholds":
    "Bitte eine bis {count} Warnschwellen zwischen {min} und {max} Prozent angeben.",
  "budgets.problem.range":
    "Beginn und Ende liegen zwischen 2000 und 2100, das Ende nicht vor dem Beginn.",
  "budgets.column.scope": "Gilt für",
  "budgets.column.period": "Zeitraum",
  "budgets.column.budget": "Budget",
  "budgets.column.validity": "Gültigkeit",
  "budgets.column.thresholds": "Warnschwellen",
  "budgets.column.usage": "Verbrauch",
  "budgets.column.actions": "Aktionen",
  "budgets.hours": "{hours} h",
  "budgets.usage": "{used} von {budget} h ({percent} %)",
  "budgets.level.warning": "Warnschwelle erreicht",
  "budgets.level.exceeded": "Budget erreicht",
  "budgets.validSince": "ab {from}",
  "budgets.validRange": "{from} bis {to}",
  "budgets.notCurrent": "Heute nicht gültig",
  "budgets.report.title": "Plan und Ist der Budgets",
  "budgets.report.hint":
    "Je Budgetzeitraum, der den Zeitraum der Auswertung berührt: das Budget und der Verbrauch des ganzen Budgetzeitraums.",
  "budgets.setting.title": "Hinweis für Beschäftigte",
  "budgets.setting.hint":
    "Eingeschaltet sehen Beschäftigte bei den Projekten, die sie wählen können, „Budget fast erschöpft“, sobald im laufenden Zeitraum eine Warnschwelle ab 80 % erreicht ist – nie Stunden oder Prozent. Die Betriebsvereinbarung regelt, ob der Hinweis gezeigt wird.",
  "budgets.setting.employeeHint": "Beschäftigte sehen „Budget fast erschöpft“",
  "budgets.setting.saved": "Hinweis für Beschäftigte gespeichert.",
  "rates.projectTitle": "Stundensätze",
  "rates.projectHint":
    "Verkaufssätze je Stunde (nie Lohn). Für einen Arbeitstag gilt der speziellste gültige Satz: Projekt mit Tätigkeit vor Projekt vor Tätigkeit vor Mandant.",
  "rates.fallbackTitle": "Allgemeine Sätze, falls kein Projektsatz gilt",
  "rates.generalTitle": "Allgemeine Stundensätze",
  "rates.generalHint":
    "Sätze des Mandanten und je Tätigkeit für alle Projekte. Ein Satz eines Projekts geht vor.",
  "rates.table": "Tabelle {title}",
  "rates.none": "Keine Sätze.",
  "rates.add": "Satz hinzufügen",
  "rates.new": "Neuer Stundensatz",
  "rates.edit": "Stundensatz ändern",
  "rates.saved": "Stundensatz gespeichert.",
  "rates.removed": "Stundensatz entfernt.",
  "rates.cancel": "Abbrechen",
  "rates.offline": "Sätze lassen sich nur mit Verbindung ändern.",
  "rates.chooseActivity": "Tätigkeit wählen",
  "rates.unknownActivity": "unbekannte Tätigkeit",
  "rates.field.scope": "Gilt für",
  "rates.field.activity": "Tätigkeit",
  "rates.field.amount": "Satz je Stunde in Euro (netto)",
  "rates.field.validFrom": "Gültig ab",
  "rates.field.validTo": "Gültig bis (leer: offen)",
  "rates.formHint":
    "Sätze desselben Geltungsbereichs dürfen sich nicht überschneiden: Beenden Sie den bisherigen Satz am Vortag des neuen.",
  "rates.problem.amount":
    "Geben Sie einen Betrag zwischen 0,01 € und 100.000 € mit höchstens zwei Nachkommastellen ein.",
  "rates.problem.activity": "Wählen Sie eine Tätigkeit.",
  "rates.problem.validity": "Das Ende darf nicht vor dem Beginn liegen.",
  "rates.scope.Tenant": "Alle Projekte",
  "rates.scope.Activity": "Tätigkeit",
  "rates.scope.Project": "Projekt",
  "rates.scope.ProjectActivity": "Projekt und Tätigkeit",
  "rates.column.scope": "Gilt für",
  "rates.column.amount": "Satz",
  "rates.column.validity": "Gültigkeit",
  "rates.column.actions": "Aktionen",
  "rates.perHour": "{amount} je Std.",
  "rates.validSince": "ab {from}",
  "rates.validRange": "{from} bis {to}",
  "rates.editShort": "Ändern",
  "rates.editNamed": "Satz ändern: {name}",
  "rates.remove": "Entfernen",
  "rates.removeNamed": "Satz entfernen: {name}",
  "rates.removeConsequence":
    "Der Satz wird entfernt. Eine neue Abrechnung des Zeitraums nutzt dann den nächst allgemeineren Satz; heruntergeladene Dateien bleiben unverändert.",
  "rates.removeConfirm": "Satz entfernen",
  "locks.projectTitle": "Gesperrte Zeiträume",
  "locks.allTitle": "Gesperrte Zeiträume aller Projekte",
  "locks.hint":
    "Nach der Abrechnung an den Kunden wird der Zeitraum gesperrt. Zuordnungen im gesperrten Zeitraum sind dann nur per Antrag möglich, den die Projektverantwortung genehmigt. Nur HR hebt eine Sperre auf.",
  "locks.none": "Kein gesperrter Zeitraum.",
  "locks.period": "{from} bis {to}",
  "locks.everyProject": "alle Projekte",
  "locks.new": "Zeitraum sperren",
  "locks.lock": "Zeitraum sperren",
  "locks.locked": "Zeitraum gesperrt.",
  "locks.field.from": "Von",
  "locks.field.to": "Bis",
  "locks.field.reason": "Grund, z. B. Rechnungsnummer",
  "locks.problem.range": "Geben Sie einen Zeitraum an; das Ende darf nicht vor dem Beginn liegen.",
  "locks.problem.reason": "Geben Sie einen Grund mit höchstens 500 Zeichen an.",
  "locks.offline": "Sperren lassen sich nur mit Verbindung ändern.",
  "locks.release": "Sperre aufheben",
  "locks.releaseNamed": "Sperre aufheben: {period}",
  "locks.releaseConsequence":
    "Zuordnungen im Zeitraum sind dann wieder ohne Antrag möglich; eine erneute Abrechnung kann andere Beträge ergeben.",
  "locks.releaseConfirm": "Sperre aufheben",
  "locks.released": "Sperre aufgehoben.",
  "billing.title": "Abrechnung",
  "billing.hint":
    "Abrechenbare Projektzeit eines Kunden mit Stundensätzen. Zeitavo schreibt keine Rechnung: Laden Sie die CSV-Datei für Ihr Rechnungsprogramm (z. B. Lexware Office, sevdesk) und den Leistungsnachweis als PDF für den Kunden.",
  "billing.filter": "Abrechnung wählen",
  "billing.customer": "Kunde",
  "billing.chooseCustomer": "Kunden wählen",
  "billing.chooseCustomerHint": "Wählen Sie einen Kunden, um seine Abrechnung zu sehen.",
  "billing.from": "Von",
  "billing.to": "Bis",
  "billing.persons": "Personen im Leistungsnachweis",
  "billing.persons.none": "nicht nennen",
  "billing.persons.initials": "mit Initialen",
  "billing.personsHint":
    "Der Leistungsnachweis geht an den Kunden. Initialen nur, wenn die Auswertung je Person freigegeben ist und Ihre Beschäftigten darüber informiert sind.",
  "billing.period": "{customer}: {from} bis {to}",
  "billing.final": "Abgeschlossen: Der Zeitraum ist für alle abgerechneten Projekte gesperrt.",
  "billing.preliminary":
    "Vorläufig: Der Zeitraum ist nicht gesperrt, Zeiten können sich noch ändern. Sperren Sie ihn nach der Rechnungsstellung.",
  "billing.missingRate":
    "Für einige Positionen gilt kein Stundensatz; ihr Betrag fehlt in der Summe.",
  "billing.billableTime": "Abrechenbare Zeit: {hours} Std.",
  "billing.azvOmitted":
    "Unvollständig: Zeiten an Tagen von Bundesbeamtinnen und Bundesbeamten (§ 7 Abs. 8 AZV) sind nicht enthalten. Die vollständige Abrechnung erstellt die Personalabteilung.",
  "billing.empty":
    "Im Zeitraum gibt es keine abrechenbaren Zeiten für diesen Kunden, die Sie abrechnen dürfen.",
  "billing.table": "Positionen für {customer} vom {from} bis {to}",
  "billing.column.project": "Projekt",
  "billing.column.activity": "Tätigkeit",
  "billing.column.period": "Leistungszeitraum",
  "billing.column.quantity": "Menge",
  "billing.column.unitPrice": "Satz",
  "billing.column.amount": "Betrag (netto)",
  "billing.linePeriod": "{from} bis {to}",
  "billing.quantity": "{hours} Std.",
  "billing.noRate": "kein Satz",
  "billing.total": "Summe",
  "billing.downloadCsv": "CSV für Rechnungsprogramm",
  "billing.downloadPdf": "Leistungsnachweis (PDF)",
  "billing.downloaded": "Gespeichert als {name}.",
  "billing.setting.title": "Beträge für Projektverantwortliche",
  "billing.setting.hint":
    "HR sieht alle Sätze und Beträge, Beschäftigte und Betriebsrat nie. Projektverantwortliche sehen Sätze und Beträge ihrer Projekte nur, wenn Sie das hier einschalten (Teil der Betriebsvereinbarung).",
  "billing.setting.responsiblesSeeAmounts":
    "Projektverantwortliche sehen Sätze und Beträge ihrer Projekte",
  "billing.setting.saved": "Einstellung gespeichert.",
  "projects.report.customers": "Projektzeit je Kunde",
  "projects.report.noCustomer": "Projekte ohne Kunde",
  "activity.none": "Ohne Tätigkeit",
  "activity.notChoosable": "Tätigkeit nicht (mehr) wählbar",
  "activity.requiredHint":
    "Für diese Projektzeit wird eine Tätigkeit erwartet. Sie können sie auch später zuordnen.",
  "activity.forClockIn": "Tätigkeit beim Kommen",
  "activity.current": "Tätigkeit",
  "activity.ofSegment": "Tätigkeit {range}",
  "catalog.customers.title": "Kunden",
  "catalog.customers.intro":
    "Kunden, denen Projektzeit zugeordnet wird. Kunden werden nie gelöscht, nur archiviert.",
  "catalog.customers.new": "Neuer Kunde",
  "catalog.customers.edit": "Kunde bearbeiten",
  "catalog.customers.empty": "Keine Kunden gefunden.",
  "catalog.customers.import": "Kunden aus CSV-Datei importieren",
  "catalog.customers.importColumns":
    "Spalten: Kundennummer (oder number), Kunde (oder name), optional Referenz (oder externalReference). Bekannte Nummern werden geändert, neue angelegt.",
  "catalog.activities.title": "Tätigkeiten",
  "catalog.activities.intro":
    "Tätigkeiten (Leistungsarten) der Projektzeit. Sie ändern nie die Arbeitszeit und werden nie gelöscht, nur archiviert.",
  "catalog.activities.new": "Neue Tätigkeit",
  "catalog.activities.edit": "Tätigkeit bearbeiten",
  "catalog.activities.empty": "Keine Tätigkeiten gefunden.",
  "catalog.activities.import": "Tätigkeiten aus CSV-Datei importieren",
  "catalog.activities.importColumns":
    "Spalten: Kürzel (oder code), Bezeichnung (oder name), optional abrechenbar (ja/nein). Bekannte Kürzel werden geändert, neue angelegt.",
  "catalog.field.number": "Kundennummer",
  "catalog.field.code": "Kürzel",
  "catalog.field.name": "Bezeichnung",
  "catalog.field.reference": "Referenz",
  "catalog.field.billable": "Üblicherweise abrechenbar",
  "catalog.field.status": "Status",
  "catalog.field.actions": "Aktionen",
  "catalog.yes": "Ja",
  "catalog.no": "Nein",
  "catalog.status.Active": "Aktiv",
  "catalog.status.Archived": "Archiviert",
  "catalog.edit": "Bearbeiten",
  "catalog.editNamed": "{key} bearbeiten",
  "catalog.archive": "Archivieren",
  "catalog.archiveNamed": "{key} archivieren",
  "catalog.reactivate": "Reaktivieren",
  "catalog.reactivateNamed": "{key} reaktivieren",
  "catalog.saved": "Gespeichert.",
  "catalog.search": "Suchen",
  "catalog.showArchived": "Archivierte anzeigen",
  "catalog.import.file": "CSV-Datei",
  "catalog.import.check": "Prüfen",
  "catalog.import.run": "Importieren",
  "catalog.import.errors.one": "{count} Fehler. Es wurde nichts gespeichert.",
  "catalog.import.errors.other": "{count} Fehler. Es wurde nichts gespeichert.",
  "catalog.import.error": "Zeile {line}, {field}: {message}",
  "catalog.import.checked": "Datei geprüft: {created} neu, {updated} geändert. Jetzt importieren?",
  "catalog.import.done": "Importiert: {created} neu, {updated} geändert.",
  "catalog.proposals.title": "Kunden aus Kundenreferenzen übernehmen",
  "catalog.proposals.intro":
    "Je unterschiedlicher Kundenreferenz der Projekte gibt es einen Vorschlag. Bestätigen Sie einen bestehenden oder einen neuen Kunden. Die Kundenreferenz bleibt an den Projekten erhalten.",
  "catalog.proposals.reference.one": "„{reference}“ an {count} Projekt",
  "catalog.proposals.reference.other": "„{reference}“ an {count} Projekten",
  "catalog.proposals.customer": "Kunde",
  "catalog.proposals.newCustomer": "Neuen Kunden anlegen",
  "catalog.proposals.confirm": "Bestätigen",
  "catalog.proposals.confirmFor": "Bestätigen für „{reference}“",
  "catalog.proposals.customerFor": "Kunde für „{reference}“",
  "catalog.proposals.numberFor": "Kundennummer für „{reference}“",
  "catalog.proposals.nameFor": "Bezeichnung für „{reference}“",
  "catalog.offline":
    "Ohne Verbindung lassen sich Kunden und Tätigkeiten nicht ändern. Die Listen zeigen den zuletzt geladenen Stand.",
  "catalog.proposals.confirmed.one": "Kunde {customer} mit {count} Projekt verknüpft.",
  "catalog.proposals.confirmed.other": "Kunde {customer} mit {count} Projekten verknüpft.",
  "projects.report.title": "Projektauswertung",
  "projects.report.hint":
    "Summen der Projektzeiten, die Sie sehen dürfen. Die Zeilen stehen in der Reihenfolge Projekt, Tag und Personalnummer und lassen sich nicht nach Dauer sortieren.",
  "projects.report.filter": "Zeitraum und Projekt der Auswertung",
  "projects.report.from": "Von",
  "projects.report.to": "Bis",
  "projects.report.project": "Projekt",
  "projects.report.allProjects": "Alle Projekte",
  "projects.report.grouping": "Gliederung",
  "projects.report.grouping.project": "Je Projekt",
  "projects.report.grouping.day": "Je Projekt und Tag",
  "projects.report.grouping.person": "Je Projekt und Person",
  "projects.report.azvOmitted":
    "Ohne die Tage von Bundesbeamtinnen und Bundesbeamten (§ 7 Abs. 8 AZV): Die Summen sind nicht die ganze Projektzeit.",
  "projects.report.perPersonUnavailable":
    "Eine Auswertung je Person ist für Sie nicht freigegeben; sie braucht die Mandanteneinstellung „Projektzeiten je Person auswerten“.",
  "projects.report.range.invalid": "Bitte geben Sie zwei gültige Tage an.",
  "projects.report.range.reversed": "Der letzte Tag liegt vor dem ersten.",
  "projects.report.range.tooLong": "Wählen Sie höchstens {days} Tage.",
  "projects.report.period": "{from} bis {to}",
  "projects.report.totals": "Summen",
  "projects.report.total.work": "Arbeitszeit gesamt",
  "projects.report.total.billable": "Abrechenbar",
  "projects.report.total.nonBillable": "Nicht abrechenbar",
  "projects.report.total.unattributed": "Ohne Projekt",
  "projects.report.total.share": "Anteil ohne Projekt",
  "projects.report.hours": "{hours} h",
  "projects.report.table": "Projektzeiten {from} bis {to}",
  "projects.report.column.project": "Projekt",
  "projects.report.column.day": "Tag",
  "projects.report.column.person": "Personalnummer",
  "projects.report.column.billable": "Abrechnung",
  "projects.report.column.hours": "Stunden",
  "projects.report.billable": "abrechenbar",
  "projects.report.nonBillable": "nicht abrechenbar",
  "projects.report.notApplicable": "entfällt",
  "projects.report.noProject": "Ohne Projekt",
  "projects.report.empty": "Im Zeitraum gibt es keine Projektzeiten, die Sie sehen dürfen.",
  "projects.report.downloadPdf": "PDF herunterladen",
  "projects.report.downloadCsv": "CSV herunterladen",
  "projects.report.downloaded": "Die Datei {name} wurde heruntergeladen.",
  "rule.ARBZG-DAILY-MAX": "Tägliche Höchstarbeitszeit (§ 3 ArbZG)",
  "rule.ARBZG-AVERAGE": "Durchschnittliche Arbeitszeit (§ 3 ArbZG)",
  "rule.ARBZG-WEEKLY-MAX": "Wöchentliche Höchstarbeitszeit",
  "rule.ARBZG-BREAK": "Ruhepausen (§ 4 ArbZG)",
  "rule.ARBZG-REST": "Ruhezeit (§ 5 ArbZG)",
  "rule.ARBZG-REST-REDUCED": "Verkürzte Ruhezeit (§ 5 Abs. 2 ArbZG)",
  "rule.ARBZG-NIGHT": "Nachtarbeit (§ 6 ArbZG)",
  "rule.ARBZG-SUNDAY": "Sonn- und Feiertagsruhe (§§ 9–11 ArbZG)",
  "rule.ARBZG-ADJOINING-REST":
    "Ruhezeit zusammen mit Sonn-, Feiertags- und Ersatzruhe (§ 11 Abs. 4 ArbZG)",
  "rule.ARBZG-RECORD": "Aufzeichnung der Arbeitszeit (frühere Regel-ID)",
  "rule.ARBSCHG-RECORD": "Vollständige Arbeitszeiterfassung (§ 3 ArbSchG)",
  "rule.ARBZG-OVERTIME-RECORD": "Aufzeichnung der Mehrarbeit (§ 16 Abs. 2 ArbZG)",
  "rule.ARBZG-DRAFT-RECORD":
    "Aufzeichnung am Tag der Arbeitsleistung (nicht amtlich veröffentlichter Arbeitsentwurf, Stand Juni 2026)",
  "check.IncompleteRecord": "Arbeitsende fehlt – Erfassung unvollständig",
  "rule.JARBSCHG-DAILY": "Arbeitszeit Jugendlicher (§ 8 JArbSchG)",
  "rule.JARBSCHG-BREAK": "Ruhepausen Jugendlicher (§ 11 JArbSchG)",
  "rule.JARBSCHG-REST": "Freizeit Jugendlicher (§ 13 JArbSchG)",
  "rule.JARBSCHG-NIGHT": "Nachtruhe Jugendlicher (§ 14 JArbSchG)",
  "rule.JARBSCHG-5DAY": "Fünf-Tage-Woche Jugendlicher (§§ 15–17 JArbSchG)",
  "rule.JARBSCHG-SHIFT-TIME": "Schichtzeit Jugendlicher (§ 12 JArbSchG)",
  "rule.ARBZG-MULTI-EMPLOYER": "Mehrere Arbeitgeber (§ 2 Abs. 1 ArbZG)",
  "rule.JARBSCHG-MULTI-EMPLOYER": "Mehrere Arbeitgeber Jugendlicher (§ 4 Abs. 5 JArbSchG)",
  "rule.MUSCHG-DAILY": "Arbeitszeit im Mutterschutz (§ 4 MuSchG)",
  "rule.MUSCHG-NIGHT": "Nachtarbeit im Mutterschutz (§ 5 MuSchG)",
  "rule.MUSCHG-SUNDAY": "Sonn- und Feiertagsarbeit im Mutterschutz (§ 6 MuSchG)",
  "rule.MUSCHG-MULTI-EMPLOYER": "Mehrere Arbeitgeber im Mutterschutz (§ 4 Abs. 1 MuSchG)",
  "rule.MILOG-RECORD": "Aufzeichnungsfrist (§ 17 MiLoG)",
  "rule.AENTG-RECORD": "Aufzeichnungsfrist (§ 19 AEntG)",
  "rule.AUEG-RECORD": "Aufzeichnungsfrist des Entleihers (§ 17c AÜG)",
  "rule.ARBZG-ROAD-TRANSPORT": "Straßentransport (§ 21a ArbZG)",
  "rule.GSA-FLEISCH-RECORD": "Aufzeichnung in der Fleischwirtschaft (§ 6 GSA Fleisch)",
  "rule.ARBZG-MINING-BREAKS": "Pausen als Arbeitszeit im Bergbau unter Tage (§ 2 Abs. 1 ArbZG)",
  "rule.JARBSCHG-UNDERGROUND": "Arbeit Jugendlicher unter Tage (§ 24 JArbSchG)",
  "rule.MUSCHG-UNDERGROUND": "Bergbau unter Tage im Mutterschutz (§§ 11, 12 MuSchG)",
  "rule.OFFSHORE-PERIOD": "Offshore-Zeitraum (§ 6 Offshore-ArbZV)",
  "rule.OFFSHORE-RECORD": "Tägliche Aufzeichnung bei Offshore-Tätigkeiten (§ 8 Offshore-ArbZV)",
  "rule.BINSCH-DAILY-MAX": "Höchstarbeitszeit in der Binnenschifffahrt (§ 4 BinSchArbZV)",
  "rule.BINSCH-BREAK": "Ruhepausen in der Binnenschifffahrt (§ 5 BinSchArbZV)",
  "rule.BINSCH-REST": "Ruhezeit in der Binnenschifffahrt (§ 6 BinSchArbZV)",
  "rule.BINSCH-SUNDAY": "Sonn- und Feiertage in der Binnenschifffahrt (§ 7 BinSchArbZV)",
  "rule.BINSCH-SEVEN-DAYS": "Sieben-Tage-Grenzen und Arbeitstage in Folge (§§ 4, 6, 7 BinSchArbZV)",
  "rule.PROTECTION-RULE": "Besondere Schutzregel",
  "check.Average": "Durchschnitt überschritten",
  "check.ContinuousWork": "Zu lange ohne Pause",
  "check.ContractualMonth": "Vertragliche Monatsarbeitszeit überschritten",
  "check.DailyAbsolute": "Höchstgrenze überschritten",
  "check.DailyCompensation": "Verlängerung ohne Ausgleich",
  "check.DailyRegular": "Mehr als die regelmäßige Arbeitszeit – Ausgleich nötig",
  "check.DoubleWeek": "Doppelwochengrenze überschritten",
  "check.FreeSundays": "Zu wenige freie Sonntage",
  "check.NightWork": "Nachtarbeit",
  "check.NightWorker": "Nachtarbeitnehmer-Status",
  "check.NightWorkerAverage": "Durchschnitt für Nachtarbeitnehmer überschritten",
  "check.RecordingDeadline": "Aufzeichnungsfrist",
  "check.LateStartRecording": "Beginn nicht bei Arbeitsaufnahme aufgezeichnet",
  "check.LateEndRecording": "Ende oder Dauer nicht am Tag der Arbeitsleistung aufgezeichnet",
  "check.Rest": "Ruhezeit unterschritten",
  "check.RestCompensation": "Ausgleich der Ruhezeitverkürzung fehlt",
  "check.RestDayWork": "Arbeit an einem Ruhetag",
  "check.SameDayRecording": "Nicht taggleich erfasst (frühere Produktprüfung)",
  "check.SubstituteRestDay": "Ersatzruhetag fehlt",
  "check.AdjoiningRest": "Ruhetag ohne angeschlossene Ruhezeit",
  "check.SundayConsent": "Einwilligung fehlt",
  "check.SundayWork": "Arbeit an Sonn- oder Feiertag",
  "check.ShiftTime": "Schichtzeit überschritten",
  "check.ExternalShiftTime": "Schichtzeit beim anderen Arbeitgeber fehlt",
  "check.ExternalWorkingTime": "Arbeitszeit bei anderen Arbeitgebern fehlt",
  "check.ExternalWorkIntervals": "Uhrzeiten bei anderen Arbeitgebern fehlen",
  "check.TotalBreak": "Pause zu kurz",
  "check.UnclassifiedBreak":
    "Unterbrechung nicht als Ruhepause eingeordnet – per Korrektur einordnen",
  "check.Weekly": "Wochengrenze überschritten",
  "check.WeeklyRegular": "Mehr als die durchschnittliche Wochenarbeitszeit – Ausgleich nötig",
  "check.WeeklyAverage": "Wöchentlicher Durchschnitt überschritten",
  "check.NightWorkWithin24Hours": "Zu viel Arbeitszeit innerhalb von 24 Stunden mit Nachtarbeit",
  "check.WorkDaysPerWeek": "Zu viele Arbeitstage pro Woche",
  "check.WorkWindow": "Arbeit außerhalb der erlaubten Zeit",
  "check.UndergroundMinorBelowAge": "Arbeit unter Tage unter 16 Jahren",
  "check.UndergroundMinor": "Arbeit unter Tage ohne bestätigte Ausnahme",
  "check.UndergroundMaternity": "Arbeit unter Tage im Mutterschutz",
  "check.OffshorePeriodDays": "Offshore-Zeitraum länger als erlaubt",
  "check.OffshoreExtendedDays": "Zu viele Tage über 10 Stunden im Offshore-Zeitraum",
  "check.OffshoreConsecutiveExtendedDays": "Zu viele Tage über 10 Stunden hintereinander",
  "check.OffshoreAverage": "Durchschnitt im Offshore-Zeitraum über 10 Stunden",
  "check.SevenDays": "Arbeitszeit in sieben Tagen überschritten",
  "check.SevenDaysNight": "Nachtarbeit in sieben Tagen überschritten",
  "check.ConsecutiveWorkDays": "Zu viele Arbeitstage hintereinander",
  "finding.values": "Ist {actual} · Grenze {limit}",
  "finding.severity.Info": "Hinweis",
  "finding.severity.Warning": "Warnung",
  "finding.severity.Violation": "Verstoß",
  "finding.severity.IncompleteInput": "Angaben unvollständig",
  "unit.days.one": "{count} Tag",
  "unit.days.other": "{count} Tage",
  "unit.count": "{value}",
  "unit.hours": "{value} h",
  "times.view": "Ansicht",
  "times.view.day": "Tag",
  "times.view.week": "Woche",
  "times.view.month": "Monat",
  "times.today": "Heute",
  "times.period": "Zeitraum {from} bis {to}",
  "times.total": "Summe: {work} h Arbeit, {break} h Pause",
  "dayBand.kind.Work": "Arbeit",
  "dayBand.kind.Break": "Pause",
  "dayBand.kind.Presence": "Anwesenheit",
  "dayBand.now": "jetzt",
  "week.chart.title": "Arbeitszeit pro Tag",
  "team.kpi.working": "arbeiten jetzt",
  "team.kpi.onBreak": "in Pause",
  "team.kpi.decisions": "zu entscheiden",
  "team.kpi.worked": "haben gearbeitet",
  "team.kpi.withFindings": "mit Befunden",
  "team.column.day": "Tagesverlauf",
  "times.empty": "Keine Arbeitszeiten in diesem Zeitraum.",
  "times.open": "offen",
  "times.blocks": "Zeitblöcke",
  "times.block.Work": "Arbeit",
  "times.block.Break": "Pause",
  "times.block.breakQualified": "Pause ({qualification})",
  "times.correct": "Korrektur für diesen Tag",
  "times.proxyEntries": "Von anderen erfasst",
  "times.recordedBy": "erfasst von {name}",
  "times.recordedByUnknown": "einer anderen Person",
  "times.verifiedOfflineAtTerminal": "offline am Terminal geprüft",
  "times.proxyEntry": "{action} {time}",
  "times.proxyEntriesFailed":
    "Ob andere Personen Zeiten für Sie erfasst haben, konnte gerade nicht geladen werden.",
  "times.periodFindings": "Befunde für den Zeitraum",
  "times.pendingHint.one":
    "{count} Eintrag dieses Geräts ist noch nicht übertragen und fehlt hier.",
  "times.pendingHint.other":
    "{count} Einträge dieses Geräts sind noch nicht übertragen und fehlen hier.",
  "times.column.date": "Datum",
  "times.column.span": "Beginn – Ende",
  "times.column.work": "Arbeit",
  "times.column.break": "Pause",
  "balances.asOf": "Stichtag",
  "balances.asOfEmpty":
    "Bitte wählen Sie einen vollständigen Stichtag. Bis dahin sehen Sie die Salden zum {date}.",
  "balances.month": "Monat bis Stichtag",
  "balances.year": "Jahr bis Stichtag",
  "balances.carryOver": "Vortrag aus Vorjahren",
  "balances.target": "Soll",
  "balances.actual": "Ist",
  "balances.absenceCredit": "Gutschrift Abwesenheiten",
  "balances.overtime": "Überstunden",
  "balances.flexitime": "Gleitzeitsaldo",
  "balances.vacationDays": "Urlaubstage genommen",
  "balances.range": "{from} bis {to}",
  "balances.noAccount":
    "Vertrauensarbeitszeit: Es wird kein Zeitkonto geführt. Die Arbeitszeit wird trotzdem vollständig erfasst und geprüft.",
  "balances.cap.AbovePositiveCap": "Das Gleitzeitkonto liegt über der zulässigen Obergrenze.",
  "balances.cap.BelowNegativeCap": "Das Gleitzeitkonto liegt unter der zulässigen Untergrenze.",
  "timeAccount.title": "Zeitkonto",
  "timeAccount.intro":
    "Auszahlung und Freizeitausgleich mindern das Konto ab dem Buchungsmonat. Die erfasste Arbeitszeit und die Stempelungen bleiben unverändert; eine Buchung wird nur storniert, nie geändert.",
  "timeAccount.noAccount":
    "Das Arbeitszeitmodell führt am Stichtag kein Zeitkonto (Vertrauensarbeitszeit). Buchungen sind nur in Monaten mit Konto möglich.",
  "timeAccount.balance.caption": "Kontostand je Konto",
  "timeAccount.balance.recorded": "Erfasst",
  "timeAccount.balance.booked": "Gebucht",
  "timeAccount.balance.total": "Kontostand",
  "timeAccount.account.Overtime": "Überstundenkonto",
  "timeAccount.account.Flexitime": "Gleitzeitkonto",
  "timeAccount.kind.Payout": "Ausgezahlt",
  "timeAccount.kind.TimeOff": "Freizeitausgleich",
  "timeAccount.kind.CarryOverCap": "Kappung nach § 7 Abs. 4 AZV",
  "timeAccount.state.Booked": "Gebucht",
  "timeAccount.state.Reversed": "Storniert",
  "timeAccount.state.Reversal": "Storno",
  "timeAccount.column.month": "Monat",
  "timeAccount.column.account": "Konto",
  "timeAccount.column.kind": "Art",
  "timeAccount.column.hours": "Stunden",
  "timeAccount.column.reason": "Grund",
  "timeAccount.column.state": "Status",
  "timeAccount.column.actions": "Aktionen",
  "timeAccount.bookings": "Buchungen",
  "timeAccount.bookings.none": "Noch keine Buchungen.",
  "timeAccount.form.title": "Stunden buchen",
  "timeAccount.form.monthHint":
    "Ab diesem Monat mindert die Buchung das Konto, höchstens der laufende Monat.",
  "timeAccount.form.monthFuture": "Der Monat liegt nach dem laufenden Monat.",
  "timeAccount.form.time": "Stunden",
  "timeAccount.form.timeHint": "Zum Beispiel 5:30 oder 5,5 (ganze Minuten).",
  "timeAccount.form.timeInvalid":
    "Bitte Stunden in ganzen Minuten angeben, höchstens 2000 Stunden.",
  "timeAccount.form.capHint":
    "Nur für Bundesbeamtinnen und -beamte im ersten Monat des Abrechnungszeitraums: Stunden über dem zulässigen Übertrag, die nach der Dienstvereinbarung verfallen. Nichts wird automatisch gekappt.",
  "timeAccount.form.timeOffHint":
    "Nur buchen, wenn die freie Zeit nicht schon als Abwesenheit „Ersatzruhetag“ oder durch weniger Arbeit erfasst ist; sonst mindert sie das Konto doppelt.",
  "timeAccount.warning.CompensatoryRestInMonth":
    "Gespeichert. Im Monat ist ein Ersatzruhetag genehmigt, der das Konto schon mindert. Prüfen Sie, ob der Freizeitausgleich doppelt zählt, und stornieren Sie ihn sonst.",
  "timeAccount.warning.DaysWithoutWorkInMonth":
    "Gespeichert. Im Monat gibt es Arbeitstage ohne Arbeit und ohne Abwesenheit; sie mindern das Konto schon. Prüfen Sie, ob der Freizeitausgleich doppelt zählt, und stornieren Sie ihn sonst.",
  "timeAccount.form.reason": "Grund",
  "timeAccount.form.reasonMissing": "Bitte einen Grund angeben.",
  "timeAccount.form.submit": "Buchung speichern",
  "timeAccount.booked": "Die Buchung ist gespeichert.",
  "timeAccount.reverse": "Stornieren",
  "timeAccount.reverse.consequence":
    "Die Stornobuchung gibt die Stunden im selben Monat zurück. Die ursprüngliche Buchung bleibt sichtbar.",
  "timeAccount.reverse.hint":
    "Der Grund erscheint in der Buchungsliste und im Datenexport der Person.",
  "timeAccount.reversed": "Die Buchung ist storniert.",
  "timeAccount.own":
    "Buchungen auf dem eigenen Zeitkonto nimmt eine andere Person der Personalabteilung vor.",
  "timeAccount.milog.title": "Hinweise nach § 2 Abs. 2 MiLoG",
  "timeAccount.milog.none": "Derzeit keine Hinweise.",
  "timeAccount.milog.MonthlyCapExceeded":
    "{month}: {hours} auf das Konto eingestellt, mehr als die Hälfte der Sollzeit ({limit}).",
  "timeAccount.milog.CompensationDue":
    "{hours} aus {month} sind bis Ende {due} durch Freizeit oder Auszahlung auszugleichen.",
  "timeAccount.milog.CompensationOverdue":
    "{hours} aus {month} hätten bis Ende {due} ausgeglichen werden müssen.",
  "timeAccount.milog.ExitWithBalance":
    "Das Arbeitsverhältnis endet im {month} mit {hours} Guthaben; Ausgleich bis Ende {due}.",
  "timeAccount.milog.legal":
    "Hinweis für Personen mit MiLoG-Aufzeichnungspflicht; er gilt nur, soweit der Mindestlohn nicht schon mit dem regelmäßigen Entgelt bezahlt ist. Er sperrt nichts.",
  "timeAccount.own.title": "Zeitkonto",
  "timeAccount.own.intro":
    "Kontostand mit den Buchungen der Personalabteilung. Auszahlung und Freizeitausgleich mindern das Konto ab ihrem Monat, die erfasste Arbeitszeit oben bleibt unverändert.",
  "timeAccount.own.paidOutYear": "Ausgezahlt im Jahr",
  "timeAccount.own.timeOffYear": "Freizeitausgleich im Jahr",
  "timeAccount.own.bookings": "Buchungen auf dem Zeitkonto im Jahr",
  "timeAccount.azv.title": "Gleitzeitkonto nach § 7 AZV",
  "timeAccount.azv.intro.own":
    "Ihr Gleitzeitkonto als Bundesbeamtin oder Bundesbeamter. Hinweise erhält auch die Personalverwaltung; Ihre Vorgesetzten erfahren nur, ob der Saldo +20 oder −10 Stunden überschreitet.",
  "timeAccount.azv.intro.hr":
    "Gleitzeitkonto nach § 7 Abs. 4 und 5 AZV. Hinweise sperren nichts und kürzen den Saldo nicht; den Ausgleich regelt die Dienstvereinbarung, etwa mit einer Buchung im ersten Monat des neuen Abrechnungszeitraums.",
  "timeAccount.azv.period":
    "Abrechnungszeitraum {from} bis {to}; Gleittage zählen vom {yearFrom} bis {yearTo}.",
  "timeAccount.azv.opening": "Saldo am Ende des vorigen Zeitraums",
  "timeAccount.azv.carried": "Übertrag (nach Kappung)",
  "timeAccount.azv.countsFrom":
    "Tage vor dem {date} sind nach § 7 Abs. 7 AZV gelöscht und zählen im Saldo nicht mehr.",
  "timeAccount.azv.balance": "Saldo",
  "timeAccount.azv.excess": "Über {limit} Übertrag hinaus (Stand heute)",
  "timeAccount.azv.flexiDays": "Gleittage im Jahr",
  "timeAccount.azv.flexiDaysValue": "{days} von {max} (noch {left})",
  "timeAccount.azv.noHints": "Derzeit keine Hinweise.",
  "timeAccount.azv.hint.NegativeLimitExceeded":
    "Am {date} lag der Saldo erstmals mehr als {limit} unter null (niedrigster Stand {hours}, Abrechnungszeitraum {from} bis {to}).",
  "timeAccount.azv.hint.CarryOverExceeded":
    "Zum Ende des Abrechnungszeitraums {from} bis {to} wurden {hours} übertragen, zulässig sind höchstens {limit}. Eine Kappung im ersten Monat des neuen Zeitraums gleicht das aus.",
  "timeAccount.azv.hint.FlexiDaysExceeded":
    "Am {date} wurden mehr als {max} Gleittage genommen ({days} im Zeitraum {from} bis {to}).",
  "timeAccount.azv.hint.AccountIncompleteAfterDeletion":
    "Tage vor dem {date} sind nach § 7 Abs. 7 AZV gelöscht; dem Saldo fehlt ihre Zeit. Bis ein Abrechnungszeitraum nach diesem Tag vollständig vorliegt, prüft Zeitavo Übertrag und Unterschreitung nicht und teilt Vorgesetzten keinen Saldo mit.",
  "timeAccount.azv.legal":
    "§ 7 Abs. 4 AZV: höchstens 40 Stunden unter der regelmäßigen Arbeitszeit und höchstens 40 Stunden Übertrag; § 7 Abs. 5 AZV: bis zu 12, mit Zulassung bis zu 24 Gleittage. Gleittage sind genehmigter Freizeitausgleich an Arbeitstagen.",
  "error.TT-1240": "Bitte Stunden in ganzen Minuten angeben, höchstens 2000 Stunden je Buchung.",
  "error.TT-1241": "Der Monat der Buchung ist ungültig.",
  "error.TT-1242": "Die Buchung ist bereits storniert oder selbst ein Storno.",
  "error.TT-1243": "Eine Buchung betrifft das Überstunden- oder das Gleitzeitkonto.",
  "error.TT-3300": "Der Monat liegt nach dem laufenden Monat.",
  "error.TT-3301":
    "Der Monat ist abgeschlossen. Öffnen Sie ihn mit Begründung wieder, um zu buchen.",
  "error.TT-3302": "Die Person führte in diesem Monat kein solches Zeitkonto.",
  "error.TT-3303":
    "Die Buchung übersteigt den Kontostand am Ende des Monats oder eines späteren Monats.",
  "error.TT-3304":
    "Buchungen auf dem eigenen Zeitkonto nimmt eine andere Person der Personalabteilung vor.",
  "surcharges.own.day": "Zuschlagsstunden: {hours}",
  "surcharges.own.total": "Zuschlagsstunden im Zeitraum: {hours}",
  "surcharges.own.failed": "Die Zuschlagsstunden konnten nicht geladen werden.",
  "surcharges.profile.title": "Zuschlagsprofil",
  "surcharges.profile.hint":
    "Zeitavo zählt Zuschlagsstunden je Zuschlagsart in Zeitfenstern, ohne Prozentsätze oder Beträge; die Zuschläge rechnet die Lohnabrechnung. Eine neue Version gilt für die Arbeitstage ab ihrem ersten Tag; abgeschlossene Monate ändern sich nie.",
  "surcharges.profile.none": "Kein Zuschlagsprofil: Es werden keine Zuschlagsstunden gezählt.",
  "surcharges.profile.effective": "Gilt seit {from}: {source}.",
  "surcharges.profile.source.template": "Vorlage {template}",
  "surcharges.profile.source.custom": "eigene Zeitfenster",
  "surcharges.profile.source.off": "Zuschlagsstunden ausgeschaltet",
  "surcharges.profile.precedence":
    "Innerhalb einer Gruppe zählt eine Stunde nur für die erste passende Zuschlagsart (Vorrang von oben nach unten); die Gruppen zählen nebeneinander, zum Beispiel Nacht- und Sonntagsarbeit.",
  "surcharges.profile.limited":
    "Das Zuschlagsprofil gilt für alle Betriebe; ändern kann es nur die Personalabteilung des ganzen Unternehmens.",
  "surcharges.column.kind": "Zuschlagsart",
  "surcharges.column.group": "Gruppe",
  "surcharges.column.windows": "Zeitfenster",
  "surcharges.column.validFrom": "Gültig ab",
  "surcharges.column.source": "Inhalt",
  "surcharges.column.state": "Status",
  "surcharges.column.recordedAt": "Erfasst",
  "surcharges.state.current": "Gilt",
  "surcharges.state.planned": "Geplant",
  "surcharges.state.replaced": "Ersetzt",
  "surcharges.state.past": "Abgelöst",
  "surcharges.versions": "Versionen des Zuschlagsprofils",
  "surcharges.versions.none": "Noch keine Version.",
  "surcharges.window.range": "{days} {from}–{to}",
  "surcharges.window.days.daily": "täglich",
  "surcharges.window.days.weekday": "{weekday}",
  "surcharges.window.days.publicHoliday": "an gesetzlichen Feiertagen am Betrieb",
  "surcharges.window.days.publicHolidayWithEaster":
    "an gesetzlichen Feiertagen am Betrieb sowie Oster- und Pfingstsonntag",
  "surcharges.window.days.date": "am {date}",
  "surcharges.window.following": ", am Folgetag bis {until} bei Beginn vor 0 Uhr",
  "surcharges.window.startedBefore": ", nur bei Beginn vor 0 Uhr",
  "surcharges.weekday.1": "montags",
  "surcharges.weekday.2": "dienstags",
  "surcharges.weekday.3": "mittwochs",
  "surcharges.weekday.4": "donnerstags",
  "surcharges.weekday.5": "freitags",
  "surcharges.weekday.6": "samstags",
  "surcharges.weekday.7": "sonntags",
  "surcharges.form.validFrom": "Gültig ab",
  "surcharges.form.validFromHint":
    "Frühestens {date}: der erste Tag des Vormonats, nach dem letzten abgeschlossenen Monat.",
  "surcharges.form.validFromInvalid": "Bitte einen Tag ab dem frühesten möglichen Tag angeben.",
  "surcharges.form.source": "Zeitfenster",
  "surcharges.form.source.template": "Vorlage {template} übernehmen",
  "surcharges.form.source.custom": "Zeitfenster anpassen",
  "surcharges.form.source.off": "Zuschlagsstunden ausschalten",
  "surcharges.form.customHint":
    "Uhrzeiten als HH:MM, das Ende auch 24:00; ein Ende vor dem Beginn liegt am Folgetag. Zuschlagsarten, die nicht zählen, entfallen in der neuen Version.",
  "surcharges.form.kindIncluded": "{kind} zählen",
  "surcharges.form.noKind":
    "Mindestens eine Zuschlagsart muss zählen. Zum Ausschalten „Zuschlagsstunden ausschalten“ wählen.",
  "surcharges.form.previousMonth":
    "Die Version beginnt vor dem laufenden Monat. Ist der Vormonat schon abgerechnet, muss die Lohnabrechnung ihn korrigieren.",
  "surcharges.form.from": "Beginn ({window})",
  "surcharges.form.to": "Ende ({window})",
  "surcharges.form.timeInvalid": "Bitte eine Uhrzeit HH:MM angeben, das Ende auch 24:00.",
  "surcharges.form.submit": "Version speichern",
  "surcharges.form.saved": "Die Version des Zuschlagsprofils ist gespeichert.",
  "surcharges.form.titleOf": "Neue Version: {profile}",
  "surcharges.profile.kindsOf": "Zuschlagsarten und Zeitfenster: {profile}",
  "surcharges.profile.purposeMismatch":
    "Der Server liefert für diesen Abschnitt ein anderes Zuschlagsprofil; anzeigen und ändern ist erst nach seiner Aktualisierung möglich.",
  "surcharges.form.normReference": "Norm ({kind})",
  "surcharges.form.normVersion": "Fassung ({kind})",
  "surcharges.form.normInvalid": "Bitte Norm und Fassung angeben.",
  "surcharges.column.norm": "Grundlage",
  "surcharges.norm.text": "{reference}, Fassung {version}",
  "surcharges.conditions.title": "Zuschläge nach anwendbaren Arbeitsbedingungen (§ 19 AEntG)",
  "surcharges.conditions.hint":
    "Für Betriebe mit dem Branchenmerkmal AEntG: Zeitfenster der Zuschläge nach Uhrzeit, Wochentag, Datum oder Feiertag einer Rechtsverordnung oder eines allgemeinverbindlichen Tarifvertrags, je Zuschlag mit Norm und Fassung. Der Arbeitszeitnachweis weist daraus Beginn, Ende und Dauer jedes zuschlagsbegründenden Abschnitts mit Korrekturhistorie aus. Zuschläge ab einer Stundenschwelle oder je Tätigkeit bildet Zeitavo nicht ab; sie sind gesondert aufzuzeichnen. Die steuerfreien Zuschlagsstunden sind davon getrennt und kein Nachweis nach § 19 AEntG.",
  "surcharges.conditions.none":
    "Keine Zuschlagsgrundlage hinterlegt: Der Arbeitszeitnachweis weist für Tage mit AEntG-Pflicht keine Zuschlagsintervalle aus.",
  "surcharges.conditions.versions": "Versionen der Zuschlagsgrundlagen",
  "surcharges.conditions.limited":
    "Die Zuschlagsgrundlagen gelten für alle Betriebe; ändern kann sie nur die Personalabteilung des ganzen Unternehmens.",
  "surcharges.conditions.source.off":
    "keine Zuschläge nach Uhrzeit, Wochentag, Datum oder Feiertag",
  "surcharges.conditions.form.off": "Keine Zuschläge nach Uhrzeit, Wochentag, Datum oder Feiertag",
  "surcharges.conditions.form.noKind":
    "Mindestens ein Zuschlag muss zählen. Gilt kein Zuschlag nach Uhrzeit, Wochentag, Datum oder Feiertag, „Keine Zuschläge nach Uhrzeit, Wochentag, Datum oder Feiertag“ wählen.",
  "surcharges.conditions.apiHint":
    "Die erste Version mit Zuschlägen, Zeitfenstern und Normen legt die Personalabteilung über die Schnittstelle an (PUT …/surcharge-profile?purpose=WorkingConditions); danach passt dieses Formular Zeitfenster und Fassungen an.",
  "surcharges.month.title": "Zuschlagsstunden",
  "surcharges.month.hint":
    "Stunden je Zuschlagsart der Arbeitstage des Monats; ein Arbeitstag zählt zum Monat seines Beginns. Die Beträge rechnet die Lohnabrechnung. Diese Stunden sind kein Nachweis der Zuschlagsintervalle nach § 19 AEntG; der Arbeitszeitnachweis enthält ihn für Zuschläge nach Uhrzeit, Wochentag, Datum oder Feiertag, Zuschläge nach Stundenschwellen oder Tätigkeiten nicht.",
  "surcharges.month.caption": "Zuschlagsstunden {month}",
  "surcharges.month.none": "In diesem Monat gilt kein Zuschlagsprofil.",
  "surcharges.month.noPersons": "In diesem Monat ist niemand beschäftigt.",
  "surcharges.month.person": "Person",
  "surcharges.month.failed": "Nicht berechenbar",
  "error.TT-1250": "Das Zuschlagsprofil ist unvollständig oder zu groß.",
  "error.TT-1251":
    "Der Code einer Zuschlagsart beginnt mit einem Großbuchstaben und enthält nur Großbuchstaben, Ziffern und Bindestriche.",
  "error.TT-1252": "Ein Code bezeichnet mehrere Zuschlagsarten.",
  "error.TT-1253": "Der Name einer Gruppe oder Zuschlagsart fehlt oder ist zu lang.",
  "error.TT-1254": "Ein Zeitfenster ist ungültig.",
  "error.TT-1255": "Das Zuschlagsprofil beginnt an einem Tag zwischen 2000 und 2100.",
  "error.TT-3310":
    "Eine neue Version beginnt frühestens am ersten Tag des Vormonats; frühere Monate sind womöglich schon abgerechnet.",
  "error.TT-3311":
    "Der Monat ist abgeschlossen. Eine neue Version beginnt nach dem letzten abgeschlossenen Monat.",
  "error.TT-3312": "Diese Vorlage gibt es nicht.",
  "error.TT-3313": "Bitte eine Vorlage oder die Zeitfenster angeben.",
  "error.TT-1310":
    "Bitte für jede Zuschlagsart die Norm (bis 200 Zeichen) und ihre Fassung (bis 40 Zeichen) angeben.",
  "error.TT-1311":
    "Jeder Zuschlag der Arbeitsbedingungen braucht Norm und Fassung; Vorlagen gibt es dafür nicht.",
  "error.TT-3380":
    "Für die Zuschläge nach Arbeitsbedingungen gibt es keine Vorlage. Bitte die Zuschläge mit Norm und Fassung angeben.",
  "error.TT-3381": "Diesen Zweck eines Zuschlagsprofils gibt es nicht.",
  "corrections.new": "Neuer Korrekturantrag",
  "corrections.date": "Arbeitstag",
  "corrections.recorded": "Erfasste Stempelungen",
  "corrections.noEvents": "An diesem Tag gibt es keine Stempelungen.",
  "corrections.change": "Uhrzeit ändern",
  "corrections.void": "Stornieren",
  "corrections.add": "Fehlende Stempelung ergänzen",
  "corrections.kind": "Art",
  "corrections.time": "Uhrzeit",
  "corrections.newTime": "Neue Uhrzeit für {action} ({time})",
  "corrections.addChange": "Ergänzen",
  "corrections.applyTime": "Uhrzeit übernehmen",
  "corrections.changes": "Geplante Änderungen",
  "corrections.remove": "Entfernen",
  "corrections.reason": "Begründung",
  "corrections.reasonHint":
    "Beschreiben Sie, warum die Aufzeichnung falsch oder unvollständig ist.",
  "corrections.preview": "Auswirkung prüfen",
  "corrections.submit": "Antrag stellen",
  "corrections.previewTitle": "Auswirkung",
  "corrections.previewDay":
    "{date}: Arbeitszeit {before} h → {after} h, Befunde {findingsBefore} → {findingsAfter}",
  "corrections.previewFindings": "Befunde nach der Korrektur",
  "corrections.submitted.AutoApproved":
    "Die Korrektur wurde sofort übernommen (nur Ergänzungen der letzten 7 Tage).",
  "corrections.submitted.Pending":
    "Der Antrag wartet auf die Genehmigung durch die zuständige Führungskraft.",
  "corrections.change.AddEvent": "{action} um {time} ergänzen",
  "corrections.change.ReplaceEvent": "{action} auf {time} ändern",
  "corrections.change.VoidEvent": "{action} um {time} stornieren",
  "corrections.change.unknownEvent": "Stempelung",
  "corrections.mine": "Meine Anträge",
  "corrections.none": "Sie haben noch keinen Korrekturantrag gestellt.",
  "corrections.approvals": "Zu genehmigen",
  "corrections.noApprovals": "Keine offenen Anträge im Team.",
  "corrections.requestedAt": "Gestellt am {time}",
  "corrections.forEmployee": "Für {employee}",
  "corrections.decisionNote": "Notiz der Entscheidung: {note}",
  "corrections.withdraw": "Antrag zurückziehen",
  "corrections.withdrawNamed": "Antrag zurückziehen vom {time}",
  "corrections.withdrawConsequence":
    "Der Antrag vom {time} wird nicht mehr entschieden; Ihre Zeiten bleiben, wie sie erfasst sind.",
  "corrections.withdrawConfirm": "Zurückziehen",
  "corrections.keep": "Behalten",
  "corrections.withdrawn": "Antrag zurückgezogen.",
  "corrections.withdrawnAt": "Zurückgezogen am {time}.",
  "corrections.note": "Notiz",
  "corrections.approve": "Genehmigen",
  "corrections.reject": "Ablehnen",
  "corrections.rejectNoteRequired": "Für eine Ablehnung ist eine Notiz erforderlich.",
  "corrections.status.Pending": "Offen",
  "corrections.status.Approved": "Genehmigt",
  "corrections.status.Rejected": "Abgelehnt",
  "corrections.status.AutoApproved": "Automatisch übernommen",
  "corrections.status.Withdrawn": "Zurückgezogen",
  "corrections.error.noChanges":
    "Bitte ändern, stornieren oder ergänzen Sie mindestens eine Stempelung.",
  "corrections.error.tooManyChanges": "Höchstens 20 Änderungen je Antrag.",
  "corrections.error.reasonRequired": "Eine Begründung ist erforderlich.",
  "corrections.error.reasonTooLong": "Die Begründung ist zu lang (höchstens 2000 Zeichen).",
  "corrections.error.time": "Bitte geben Sie eine gültige Uhrzeit an.",
  "corrections.error.future":
    "Diese Uhrzeit liegt in der Zukunft. Korrigieren lassen sich nur vergangene Stempelungen.",
  "corrections.breakQualification": "Art der Pause",
  "corrections.breakQualificationHint":
    "Ruhepause nur, wenn die Pause bei ihrem Beginn feststand und Sie frei von Arbeit und Bereitschaft waren.",
  "corrections.change.withQualification": "{change} als {qualification}",
  "absences.new": "Abwesenheit beantragen",
  "absences.kind": "Art",
  "absences.kind.Vacation": "Urlaub",
  "absences.kind.Sick": "Krankheit",
  "absences.kind.Holiday": "Feiertag",
  "absences.kind.Special": "Sonderurlaub",
  "absences.kind.Training": "Fortbildung",
  "absences.kind.CompensatoryRest": "Ersatzruhetag",
  "absences.from": "Von",
  "absences.to": "Bis",
  "absences.halfDay": "Halber Tag",
  "absences.submit": "Beantragen",
  "absences.submitForOther": "Erfassen",
  "absences.submitted": "Die Abwesenheit wurde beantragt und wartet auf die Genehmigung.",
  "absences.recorded": "Die Abwesenheit wurde erfasst.",
  "absences.error.range": "Das Enddatum darf nicht vor dem Startdatum liegen.",
  "absences.error.halfDay": "Ein halber Tag ist nur für einen einzelnen Tag möglich.",
  "absences.error.past":
    "Urlaub lässt sich ab heute ({date}) beantragen. Urlaub für vergangene Tage trägt die Personalabteilung ein.",
  "absences.error.startMissing": "Bitte geben Sie das Startdatum ein.",
  "absences.error.endMissing": "Bitte geben Sie das Enddatum ein.",
  "absences.error.pastOfHr":
    "Urlaub lässt sich ab heute ({date}) beantragen. Eigenen Urlaub für vergangene Tage trägt eine andere Person der Personalabteilung ein.",
  "absences.sickHint":
    "Eine Krankmeldung ersetzt nicht die ärztliche Arbeitsunfähigkeitsbescheinigung.",
  "absences.calendar": "Kalender",
  "absences.weekday.1": "Mo",
  "absences.weekday.2": "Di",
  "absences.weekday.3": "Mi",
  "absences.weekday.4": "Do",
  "absences.weekday.5": "Fr",
  "absences.weekday.6": "Sa",
  "absences.weekday.7": "So",
  "absences.list": "Abwesenheiten im Monat",
  "absences.none": "Keine Abwesenheiten in diesem Monat.",
  "absences.status.Requested": "Beantragt",
  "absences.status.Approved": "Genehmigt",
  "absences.status.Rejected": "Abgelehnt",
  "absences.status.Cancelled": "Storniert",
  "absences.cancel": "Stornieren",
  "absences.approve": "Genehmigen",
  "absences.reject": "Ablehnen",
  "team.date": "Datum",
  "team.members": "Teammitglieder",
  "team.empty": "Diesem Konto sind keine Beschäftigten zugeordnet.",
  "team.column.name": "Name",
  "team.column.state": "Zustand",
  "team.column.work": "Arbeitszeit",
  "team.column.findings": "Befunde",
  "team.state.Off": "Ausgestempelt",
  "team.state.Working": "Arbeitet seit {time}",
  "team.state.OnBreak": "Pause seit {time}",
  "team.openDays": "Offene Tage: {count}",
  "team.offlineTerminal": "Offline am Terminal geprüft: {count}",
  "team.runningShiftDay": "laufende Schicht vom {date}",
  "team.workUnavailable": "nicht verfügbar",
  "team.stateNoTime.Working": "Arbeitet",
  "team.stateNoTime.OnBreak": "In Pause",
  "team.azvWithheld": "keine Angaben (§ 7 Abs. 8 AZV)",
  "team.azvWithheldCount":
    "Ohne Zeiten und Befunde nach § 7 Abs. 8 AZV (Bundesbeamtinnen und Bundesbeamte): {count}",
  "team.azvNotices.title": "Gleitzeitsalden (§ 7 Abs. 8 AZV)",
  "team.azvNotices.hint":
    "Nur für den gezielten Personaleinsatz, nicht zur Kontrolle oder Bewertung von Leistung oder Verhalten. Genannt wird nur, ob der Gleitzeitsaldo eine Schwelle überschreitet, nicht der Saldo selbst.",
  "team.azvNotices.above": "Saldo über +{hours} Stunden",
  "team.azvNotices.below": "Saldo unter −{hours} Stunden",
  "team.findings": "Verstöße: {violations}, Warnungen: {warnings}",
  "team.noFindings": "keine",
  "team.clockedIn": "{count} von {total} eingestempelt",
  "team.workedOn.one": "{count} von {total} hat am {date} gearbeitet",
  "team.workedOn.other": "{count} von {total} haben am {date} gearbeitet",
  "team.approvals": "Offene Korrekturanträge: {count}",
  "team.toApprovals": "Zu den Genehmigungen",
  "team.toViolations": "Verstöße ansehen",
  "violations.filters": "Filter",
  "violations.from": "Von",
  "violations.to": "Bis",
  "violations.status": "Status",
  "violations.status.all": "Alle",
  "violations.status.Open": "Offen",
  "violations.status.Acknowledged": "Zur Kenntnis genommen",
  "violations.status.Resolved": "Erledigt",
  "violations.employee": "Beschäftigte Person",
  "violations.employee.all": "Alle",
  "violations.none": "Keine Verstöße für diese Auswahl.",
  "violations.period": "Zeitraum: {from} – {to}",
  "violations.detected": "Erkannt am {time}",
  "violations.acknowledged": "Kenntnisnahme von {name} am {time}: {comment}",
  "violations.acknowledgedEarlier":
    "Kenntnisnahme von {name} am {time}, bevor der Befund zum Verstoß wurde: {comment}",
  "violations.escalated":
    "Der Befund ist nach der Kenntnisnahme zum Verstoß geworden und muss erneut zur Kenntnis genommen werden.",
  "violations.comment": "Kommentar zur Kenntnisnahme",
  "violations.acknowledge": "Zur Kenntnis nehmen",
  "violations.commentRequired": "Bitte geben Sie einen Kommentar ein.",
  "violations.masked": "Es gelten besondere Schutzregeln. Details sieht nur die Personalabteilung.",
  "admin.nav": "Verwaltungsbereiche",
  "admin.employees": "Beschäftigte",
  "admin.establishments": "Betriebe",
  "admin.models": "Arbeitszeitmodelle",
  "admin.models.leaveHint":
    "Die Arbeitstage eines Modells bestimmen, wie viele Urlaubstage ein Urlaub zählt. Ändern Sie die Arbeitstage einer Person ab einem Stichtag mit einer neuen Beschäftigung und einem anderen Modell, nicht durch Bearbeiten eines genutzten Modells: Urlaubskonten offener Jahre rechnen immer mit den aktuellen Modellen.",
  "admin.exports": "Exporte",
  "admin.profiles": "Regelprofile",
  "admin.absenceRequests": "Abwesenheitsanträge",
  "admin.absenceRequests.hint":
    "Offene Anträge aller Beschäftigten und wer in den nächsten vier Wochen abwesend ist. Führungskräfte entscheiden die Anträge ihres Teams auf der Seite „Team“, Krankmeldungen entscheidet die Personalabteilung.",
  "admin.save": "Speichern",
  "admin.saved": "Gespeichert.",
  "admin.new": "Neu anlegen",
  "admin.edit": "Bearbeiten",
  "admin.cancel": "Abbrechen",
  "admin.search": "Suchen",
  "admin.employee.personnelNumber": "Personalnummer",
  "admin.employee.displayName": "Name",
  "admin.employee.subject": "Kennung beim Identity Provider (sub)",
  "admin.employee.minorUntil": "Minderjährig bis (18. Geburtstag)",
  "admin.employee.open": "Öffnen",
  "admin.employee.back": "Zurück zur Liste",
  "admin.employee.notFound": "Diese beschäftigte Person gibt es nicht.",
  "admin.employments": "Beschäftigungsverhältnisse",
  "admin.employment.item": "{from} – {to}: {type}, {establishment}, {model}",
  "admin.employment.open": "offen",
  "admin.employment.new": "Neues Beschäftigungsverhältnis",
  "admin.employment.validFrom": "Gültig ab",
  "admin.employment.validTo": "Gültig bis",
  "admin.employment.type": "Art",
  "admin.employment.type.Regular": "Regulär",
  "admin.employment.type.MarginalMiniJob": "Minijob",
  "admin.employment.type.Trainee": "Ausbildung",
  "admin.employment.type.Temporary": "Befristet/Leiharbeit",
  "admin.employment.establishment": "Betrieb",
  "admin.employment.model": "Arbeitszeitmodell",
  "admin.employment.manager": "Führungskraft",
  "admin.employment.noManager": "Keine",
  "admin.employment.exempt":
    "Leitende Angestellte (ArbZG gilt nicht, § 18) – Erfassung bleibt aktiv",
  "admin.employment.rotatingShifts": "Regelmäßige Wechselschicht",
  "admin.employment.roadTransport":
    "Fahrerin, Fahrer oder Beifahrende im Straßentransport (§ 21a ArbZG, nicht mit § 18)",
  "admin.employment.roadTransportHint":
    "Gilt für Straßenverkehrstätigkeiten im Sinne der VO (EG) Nr. 561/2006 oder des AETR. Zeitavo prüft dann höchstens 60 Stunden je Woche, 48 Stunden im Durchschnitt, 10 Stunden innerhalb von 24 Stunden mit Nachtarbeit, Arbeitszeiten bei anderen Arbeitgebern und die Aufzeichnung nach § 21a Abs. 7 ArbZG. Lenk- und Ruhezeiten nach dem Fahrpersonalrecht prüft Zeitavo nicht.",
  "admin.employment.undergroundYouthException":
    "Ausnahme für Jugendliche ab 16 Jahren unter Tage bestätigt (§ 24 Abs. 2 JArbSchG)",
  "admin.employment.undergroundYouthExceptionHint":
    "Nur ankreuzen, wenn die Arbeit unter Tage zum Ausbildungsziel nötig ist, die Person eine Berufsausbildung für die Arbeit unter Tage abgeschlossen hat oder an einer von der Bergbehörde genehmigten Ausbildungsmaßnahme für Bergjungarbeiter teilnimmt oder teilgenommen hat, und eine fachkundige Person die Arbeit beaufsichtigt. Ohne Bestätigung ist jeder Arbeitstag Jugendlicher unter Tage ein Verstoß; unter 16 Jahren gilt keine Ausnahme.",
  "admin.employment.recording": "Spezialgesetzliche Aufzeichnungspflichten",
  "admin.employment.recordingHint":
    "Beginn und Ende werden immer erfasst (§ 3 Abs. 2 Nr. 1 ArbSchG). Diese Angaben bestimmen nur, welche Spezialnormen mit eigenen Fristen gelten.",
  "admin.employment.hiredIn":
    "Leiharbeitnehmer, der Mandant ist Entleiher (nur bei Befristet/Leiharbeit)",
  "admin.employment.wageOrdinance": "Lohnuntergrenze nach § 3a AÜG ist anzuwenden (§ 17c AÜG)",
  "admin.employment.confirm": "Voraussetzungen bestätigt: {reference} ({id}, Fassung {version})",
  "admin.employment.durationOnly":
    "Für diese Pflicht genügt die Dauer; Beginn und Ende werden weiter erfasst.",
  "admin.employment.hiredInItem": "Entleiher",
  "admin.employment.roadTransportItem": "Straßentransport (§ 21a ArbZG)",
  "admin.employment.undergroundYouthExceptionItem": "Ausnahme unter Tage (§ 24 Abs. 2 JArbSchG)",
  "admin.employment.workingTimeLaw": "Arbeitszeitrecht",
  "admin.employment.workingTimeLaw.ArbZG": "Arbeitnehmerin oder Arbeitnehmer (ArbZG)",
  "admin.employment.workingTimeLaw.FederalCivilServantAzv":
    "Bundesbeamtin oder Bundesbeamter (AZV)",
  "admin.employment.workingTimeLawHint":
    "Für Bundesbeamtinnen und Bundesbeamte löscht Zeitavo die Zeiterfassungsdaten nach § 7 Abs. 7 AZV (Frist unter Mandant → Einstellungen). Zeitavo prüft für sie die Regeln der AZV (Regelprofil DE-AZV), nicht die des ArbZG, und Vorgesetzte sehen nur, was § 7 Abs. 8 AZV erlaubt. Nicht für Landesbeamtinnen und Landesbeamte und nicht für Beschäftigte, auf die das Beamtenrecht nach § 19 ArbZG übertragen wurde. Nur für reguläre Beschäftigungen und Anwärterinnen und Anwärter (Ausbildung).",
  "admin.employment.civilServantItem": "Bundesbeamtin oder Bundesbeamter (AZV)",
  "admin.employment.civilServantConfirm":
    "Ich habe verstanden: Die Zeiterfassungsdaten dieser Beschäftigung ab ihrem ersten Tag, frühestens ab heute, werden nach § 7 Abs. 7 AZV gelöscht, frühestens 3 Monate nach Ablauf des Erhebungsmonats und unwiderruflich.",
  "admin.employment.civilServantPast":
    "Der erste Tag liegt in der Vergangenheit: Die Tage vor heute behalten die Fristen des ArbZG.",
  "admin.employment.confirmedItem": "bestätigt: {rules}",
  "admin.employment.profile": "Zusätzliches Regelprofil",
  "admin.employment.noProfile": "Keins (gesetzliche Standardprofile)",
  "admin.employment.end": "Beenden zum",
  "admin.employment.endAction": "Beenden",
  "admin.employment.missingData": "Bitte zuerst einen Betrieb und ein Arbeitszeitmodell anlegen.",
  "admin.absences": "Abwesenheiten",
  "admin.absences.record": "Abwesenheit erfassen",
  "admin.consents": "Opt-out-Einwilligungen (§ 7 Abs. 7 ArbZG)",
  "admin.consents.hint":
    "Eine Abweichung nach § 7 Abs. 2a ArbZG gilt nur an ganzen Tagen nach der Erfassung der Einwilligung. Mit dem Tag, an dem ein Widerruf erfasst wird, gelten wieder die gesetzlichen Grenzen; die Frist von sechs Monaten nutzt Zeitavo nicht.",
  "admin.consent.item": "Erteilt am {granted}, Dokument {document}",
  "admin.consent.revoked": "widerrufen am {revoked}",
  "admin.consent.document": "Dokumentreferenz",
  "admin.consent.add": "Einwilligung erfassen",
  "admin.consent.revoke": "Widerruf erfassen",
  "admin.protection": "Mutterschutz (Gesundheitsdaten, nur Personalabteilung)",
  "admin.protection.item": "{from} – {to}",
  "admin.protection.add": "Zeitraum erfassen",
  "admin.protection.sundayConsent": "Einwilligung zu Sonn-/Feiertagsarbeit",
  "admin.protection.eveningPermit": "Behördliche Genehmigung für Arbeit bis 22:00 Uhr",
  "admin.externalWork":
    "Mehrfachbeschäftigung (§ 2 Abs. 1 ArbZG, § 4 Abs. 5 JArbSchG, § 4 Abs. 1 MuSchG, § 21a Abs. 8 ArbZG)",
  "admin.externalWork.hint":
    "Erfasst werden nur Zeiträume, Dauern und – soweit bekannt – Uhrzeiten, kein Name des anderen Arbeitgebers und keine Tätigkeit. Die Arbeitszeiten bei allen Arbeitgebern werden zusammengerechnet; Pausen und Ruhezeiten werden mit den Uhrzeiten geprüft. Fehlende Angaben werden als unvollständig gemeldet. Im Straßentransport fordern Sie die Aufstellung schriftlich an (§ 21a Abs. 8 ArbZG).",
  "admin.externalWork.periods": "Zeiträume einer weiteren Beschäftigung",
  "admin.externalWork.periods.none": "Keine weitere Beschäftigung erfasst.",
  "admin.externalWork.period.item": "{from} – {to}",
  "admin.externalWork.period.add": "Zeitraum erfassen",
  "admin.externalWork.period.lastDay": "Letzter Tag",
  "admin.externalWork.period.end": "Zeitraum beenden",
  "admin.externalWork.declarations": "Arbeitszeiten bei anderen Arbeitgebern",
  "admin.externalWork.declarations.none": "Keine Angaben in den letzten sechs Monaten.",
  "admin.externalWork.declaration.withdrawn": "zurückgezogen am {withdrawn}",
  "admin.externalWork.declaration.withdraw": "Angabe zurückziehen",
  "admin.externalWork.declaration.new": "Neue Angabe",
  "admin.externalWork.declaration.from": "Von",
  "admin.externalWork.declaration.to": "Bis",
  "admin.externalWork.declaration.hint":
    "Leere Tage bedeuten: keine Arbeit bei anderen Arbeitgebern. Angaben werden für jeden Tag einer Woche mit eigener Arbeit benötigt. Uhrzeiten in der Zeitzone des Betriebs (z. B. 17:00-19:00, 19:30-22:00; ein Ende vor dem Beginn liegt am Folgetag) werden nur für eigene Arbeitstage und die Tage davor und danach benötigt, um Pausen und Ruhezeiten zu prüfen; mit ihnen darf die Arbeitszeit leer bleiben. Die Schichtzeit (Arbeitszeit einschließlich Ruhepausen) wird für Jugendliche benötigt; ohne sie zählt die Spanne der Uhrzeiten.",
  "admin.externalWork.declaration.source": "Herkunft der Angabe",
  "admin.externalWork.declaration.work": "Arbeitszeit am {date} (h:mm)",
  "admin.externalWork.declaration.shift": "Schichtzeit am {date} (h:mm)",
  "admin.externalWork.declaration.times": "Uhrzeiten am {date} (von-bis, {zone})",
  "admin.externalWork.declaration.timesItem": "{date}: {times} ({zone})",
  "admin.externalWork.declaration.timesHidden": "{date}: Uhrzeiten erfasst ({zone})",
  "admin.externalWork.declaration.zoneUnknown": "Zeitzone des Betriebs unbekannt",
  "admin.externalWork.declaration.tooLong": "Eine Angabe umfasst einen bis höchstens 31 Tage.",
  "admin.externalWork.declaration.invalid":
    "Dauern bitte als h:mm bis 24:00 angeben; eine Schichtzeit braucht eine Arbeitszeit und ist nicht kürzer als sie. Uhrzeiten beginnen an ihrem Tag, überschneiden sich nicht und ergeben zusammen die Arbeitszeit.",
  "admin.externalWork.source.SelfDeclaration": "Selbstauskunft der beschäftigten Person",
  "admin.externalWork.source.OtherEmployerRecord":
    "Aufzeichnung oder Bescheinigung des anderen Arbeitgebers",
  "admin.externalWork.declaration.add": "Angabe erfassen",
  "admin.preparation": "Vor- und Nachbereitungszeiten (§ 6 GSA Fleisch)",
  "admin.preparation.hint":
    "Fremdnützige Vor- und Nachbereitung wie Umkleiden, Waschen oder Rüsten ist Arbeitszeit. Kategorisieren Sie hier Teile der gestempelten Arbeitszeit; liegt die Zeit außerhalb, korrigieren Sie zuerst die Stempelzeiten. Die Einträge erscheinen im Nachweis für die Behörde.",
  "admin.preparation.none": "In den letzten 31 Tagen keine Vor- und Nachbereitungszeiten.",
  "admin.preparation.item": "{date}, {start}–{end}: {phase}, {activity} ({duration} h)",
  "admin.preparation.withdrawn": "zurückgezogen am {withdrawn}",
  "admin.preparation.withdraw": "Eintrag zurückziehen",
  "admin.preparation.totals": "Summe der letzten 31 Tage: {totals}",
  "admin.preparation.new": "Neue Vor- oder Nachbereitungszeit",
  "admin.preparation.date": "Arbeitstag",
  "admin.preparation.start": "Beginn",
  "admin.preparation.end": "Ende",
  "admin.preparation.phase": "Art",
  "admin.preparation.activity": "Tätigkeit",
  "admin.preparation.phase.Preparation": "Vorbereitung",
  "admin.preparation.phase.FollowUp": "Nachbereitung",
  "admin.preparation.activity.ChangingClothes": "Umkleiden",
  "admin.preparation.activity.Washing": "Waschen, Hygiene",
  "admin.preparation.activity.SetUp": "Rüsten",
  "admin.preparation.activity.InternalWalking": "Innerbetriebliche Wege",
  "admin.preparation.activity.Other": "Sonstiges",
  "admin.preparation.invalid":
    "Bitte Beginn und Ende angeben; ein Eintrag umfasst höchstens 4 Stunden.",
  "admin.preparation.add": "Zeit kategorisieren",
  "admin.establishment.name": "Name",
  "admin.establishment.timeZone": "Zeitzone (IANA)",
  "admin.establishment.state": "Bundesland",
  "admin.establishment.industries": "Branchenmerkmale",
  "admin.establishment.exemption": "Ausnahme für Sonn- und Feiertagsarbeit (§ 10 ArbZG)",
  "admin.establishment.regionalHolidays": "Regionale Feiertage",
  "admin.industry.Bakery": "Bäckerei/Konditorei",
  "admin.industry.Hospital": "Krankenhaus/Pflege",
  "admin.industry.Transport": "Verkehr",
  "admin.industry.Broadcasting": "Rundfunk (Aufnahmen und Sendungen)",
  "admin.industry.Agriculture": "Landwirtschaft",
  "admin.industry.AnimalHusbandry": "Tierhaltung",
  "admin.industry.SchwarzArbGSector": "Branche nach § 2a SchwarzArbG",
  "admin.industry.PostedWorkersActSector":
    "Branche mit Arbeitsbedingungen nach dem AEntG (§ 19 AEntG)",
  "admin.industry.UndergroundMining": "Bergbau unter Tage",
  "admin.industry.ConstructionSite": "Bau- und Montagestellen (Jugendliche dort tätig)",
  "admin.industry.MeatIndustry":
    "Fleischwirtschaft: Schlachtung, Zerlegung, Fleischverarbeitung (§ 6 GSA Fleisch)",
  "admin.industry.Offshore":
    "Offshore-Tätigkeiten im Küstenmeer oder in der AWZ (Offshore-ArbZV, ohne Schiffsbesatzung)",
  "admin.industry.InlandNavigation":
    "Binnenschifffahrt: Besatzung und Bordpersonal an Bord (BinSchArbZV)",
  // F-59: restaurant and accommodation split, open shops, effects of the industry flags.
  "admin.industry.Restaurant": "Gaststätte (Speisen oder Getränke zum Verzehr vor Ort)",
  "admin.industry.Accommodation": "Beherbergung (Hotel, Pension, Ferienunterkunft)",
  "admin.industry.Retail": "Einzelhandel mit offener Verkaufsstelle",
  "admin.establishment.assignIndustry.title": "Branchenmerkmal zuordnen",
  "admin.establishment.assignIndustry.text.one":
    "Das Merkmal „Gastronomie/Beherbergung“ ist jetzt in „Gaststätte“ und „Beherbergung“ aufgeteilt, weil das Jugendarbeitsschutzgesetz seine Ausnahmen nur Gaststätten gewährt. Bis Sie zuordnen, gelten diese Ausnahmen für Jugendliche nicht; die verkürzte Ruhezeit bleibt. Bitte wählen Sie für diesen Betrieb „Gaststätte“, „Beherbergung“, beides oder keines: {names}",
  "admin.establishment.assignIndustry.text.other":
    "Das Merkmal „Gastronomie/Beherbergung“ ist jetzt in „Gaststätte“ und „Beherbergung“ aufgeteilt, weil das Jugendarbeitsschutzgesetz seine Ausnahmen nur Gaststätten gewährt. Bis Sie zuordnen, gelten diese Ausnahmen für Jugendliche nicht; die verkürzte Ruhezeit bleibt. Bitte wählen Sie für diese {count} Betriebe „Gaststätte“, „Beherbergung“, beides oder keines: {names}",
  "admin.establishment.assignIndustry.form":
    "Dieser Betrieb trägt noch das aufgeteilte Merkmal „Gastronomie/Beherbergung“. Bis zur Zuordnung bleibt die verkürzte Ruhezeit, die Ausnahmen für Jugendliche gelten nicht. Wählen Sie bei „Zuordnung zu Gaststätte oder Beherbergung“ ausdrücklich Gaststätte, Beherbergung, beides oder keines davon; vorher lässt sich der Betrieb nicht speichern.",
  "admin.establishment.effects": "Was die Branchenmerkmale ändern",
  "admin.establishment.effects.reducedRest":
    "Ruhezeit: Verkürzung auf {hours} Stunden mit Ausgleich möglich (§ 5 Abs. 2 ArbZG)",
  "admin.establishment.effects.noReducedRest":
    "Ruhezeit: 11 Stunden ohne Verkürzung (§ 5 Abs. 1 ArbZG)",
  "admin.establishment.effects.minorShift":
    "Jugendliche: Schichtzeit bis {hours} Stunden (§ 12 JArbSchG)",
  "admin.establishment.effects.minorEvening":
    "Jugendliche ab 16 Jahren: Arbeit bis {time} Uhr (§ 14 JArbSchG)",
  "admin.establishment.effects.minorEveningRestaurant":
    "Jugendliche ab 16 Jahren: Arbeit bis {time} Uhr, vor einem Berufsschultag mit Unterricht vor 9 Uhr bis 20 Uhr (§ 14 Abs. 2 und 4 JArbSchG)",
  "admin.establishment.effects.minorSaturday.Allowed":
    "Jugendliche am Samstag: zulässig; mindestens zwei Samstage im Monat sollen frei bleiben (§ 16 JArbSchG)",
  "admin.establishment.effects.minorSaturday.Forbidden":
    "Jugendliche am Samstag: nicht zulässig (§ 16 JArbSchG)",
  "admin.establishment.effects.minorSunday.Allowed":
    "Jugendliche am Sonntag: zulässig; mindestens zwei Sonntage im Monat frei, jeder zweite soll frei bleiben (§ 17 JArbSchG)",
  "admin.establishment.effects.minorSunday.Forbidden":
    "Jugendliche am Sonntag: nicht zulässig (§ 17 JArbSchG)",
  "admin.establishment.effects.minorHoliday.Allowed":
    "Jugendliche an Feiertagen: zulässig außer am 25. Dezember, 1. Januar, Ostersonntag und 1. Mai, mit einem freien Ersatztag in derselben oder der folgenden Woche (§ 18 JArbSchG)",
  "admin.establishment.effects.minorHoliday.Forbidden":
    "Jugendliche an Feiertagen: nicht zulässig (§ 18 JArbSchG)",
  "admin.establishment.effects.minorDecemberEves":
    "Jugendliche am 24. und 31. Dezember: keine Arbeit nach 14 Uhr, auch nicht in Gaststätten (§ 18 JArbSchG)",
  "admin.establishment.assignIndustry.label": "Zuordnung zu Gaststätte oder Beherbergung",
  "admin.establishment.assignIndustry.choose": "Bitte wählen",
  "admin.establishment.assignIndustry.Restaurant": "Gaststätte",
  "admin.establishment.assignIndustry.Accommodation": "Beherbergung",
  "admin.establishment.assignIndustry.Both": "Gaststätte und Beherbergung",
  "admin.establishment.assignIndustry.Neither": "Keines davon (weder Gaststätte noch Beherbergung)",
  "admin.establishment.effects.schwarzArbG":
    "Aufzeichnung nach § 17 MiLoG: Branche nach § 2a SchwarzArbG",
  "check.FreeSaturdays": "Zu wenige freie Samstage",
  "check.AlternateSundays":
    "Zwei Sonntage nacheinander gearbeitet – jeder zweite Sonntag soll frei bleiben",
  "check.HolidaySubstituteDay":
    "Kein freier Ersatztag für die Arbeit am Feiertag in derselben oder der folgenden Woche",
  "check.EveAfternoonWork": "Arbeit am 24. oder 31. Dezember nach 14 Uhr",
  "error.TT-1350":
    "Das Merkmal „Gastronomie/Beherbergung“ ist aufgeteilt. Bitte wählen Sie „Gaststätte“, „Beherbergung“, beides oder keines.",
  "admin.holiday.AugsburgerFriedensfest": "Augsburger Friedensfest",
  "admin.holiday.MariaeHimmelfahrt": "Mariä Himmelfahrt",
  "admin.holiday.Fronleichnam": "Fronleichnam",
  "admin.model.name": "Name",
  "admin.model.kind": "Art",
  "admin.model.kind.Fixed": "Feste Arbeitszeit",
  "admin.model.kind.Flexitime": "Gleitzeit",
  "admin.model.kind.TrustBased": "Vertrauensarbeitszeit",
  "admin.model.kind.Shift": "Schichtarbeit",
  "admin.model.weekly": "Wochenstunden",
  "admin.model.days": "Arbeitstage",
  "admin.model.coreStart": "Kernzeit von",
  "admin.model.coreEnd": "Kernzeit bis",
  "admin.model.maxPlus": "Gleitzeit-Obergrenze in Stunden",
  "admin.model.maxMinus": "Gleitzeit-Untergrenze in Stunden",
  "admin.model.item": "{name}: {kind}, {hours} h/Woche",
  "admin.model.rosterTarget": "Soll aus dem Dienstplan",
  "admin.model.rosterTargetHint":
    "Tagessoll aus den veröffentlichten Schichten statt gleichmäßiger Verteilung: Tage mit Schicht zählen die geplante Arbeitszeit, Tage ohne Schicht in einem veröffentlichten Plan gelten als frei (Soll 0); nur eine gutgeschriebene Abwesenheit (zum Beispiel Urlaub oder Krankheit) an einem planfreien Tag nimmt ihren Anteil am Soll des Modells und schreibt ihn gut. Tage ohne veröffentlichten Plan behalten das Soll des Modells. Gilt ab dem ersten Tag eines Monats, der noch nicht begonnen hat; vergangene und abgeschlossene Monate bleiben unverändert.",
  "admin.model.rosterTargetEnabled": "Soll aus dem veröffentlichten Dienstplan übernehmen",
  "admin.model.rosterTargetFrom": "Ab Monat",
  "admin.model.rosterTargetMonthInvalid":
    "Bitte den Monat als JJJJ-MM angeben, zum Beispiel 2026-12.",
  "admin.model.rosterTargetHistory": "Bisher: {changes}",
  "admin.model.rosterTargetOn": "ein ab {date}",
  "admin.model.rosterTargetOff": "aus ab {date}",
  "admin.model.invalidHours": "Bitte die Stunden als Zahl angeben.",
  "admin.day.Monday": "Mo",
  "admin.day.Tuesday": "Di",
  "admin.day.Wednesday": "Mi",
  "admin.day.Thursday": "Do",
  "admin.day.Friday": "Fr",
  "admin.day.Saturday": "Sa",
  "admin.day.Sunday": "So",
  "admin.export.authority": "Behördenexport (§ 17 Abs. 4 ArbZG)",
  "admin.export.authorityHint":
    "Vollständige Aufzeichnungen einer Person inklusive Korrekturhistorie.",
  "admin.export.employee": "Beschäftigte Person",
  "admin.export.from": "Von",
  "admin.export.to": "Bis",
  "admin.export.format": "Format",
  "admin.export.format.surchargeCsv": "CSV: Zuschläge nach Zeitfenstern (§ 19 AEntG)",
  "export.surchargeCsv.hint":
    "Zuschlagsintervalle enthält die Datei nur, wenn im Zeitraum eine Pflicht nach § 19 AEntG besteht, Zuschläge nach anwendbaren Arbeitsbedingungen aufzuzeichnen; sonst nur die Kopfzeile.",
  "export.surchargeCsv.headerOnly":
    "Die Datei enthält nur die Kopfzeile: Im Zeitraum besteht keine Pflicht nach § 19 AEntG, Zuschlagsintervalle aufzuzeichnen, oder es fiel kein Zuschlag nach Uhrzeit, Wochentag, Datum oder Feiertag an.",
  "admin.export.download": "Herunterladen",
  "admin.export.payroll": "Lohnexport",
  "admin.export.month": "Monat",
  "admin.export.done": "Die Datei {name} wurde heruntergeladen.",
  "datev.title": "DATEV-Lohnexport",
  "datev.hint":
    "Überträgt Stunden und Tage je Personalnummer und Lohnart an DATEV LODAS oder Lohn und Gehalt. Die Datei enthält keine Namen. Lohnarten und Bearbeitungsschlüssel stimmen Sie mit Ihrem Steuerbüro ab.",
  "datev.settings": "DATEV-Einstellungen",
  "datev.program": "Lohnprogramm",
  "datev.program.Lodas": "DATEV LODAS",
  "datev.program.LohnUndGehalt": "DATEV Lohn und Gehalt",
  "datev.consultantNumber": "Beraternummer",
  "datev.clientNumber": "Mandantennummer",
  "datev.lodasHint":
    "LODAS liest die Datei über „Mandant → Daten übernehmen → ASCII-Import“. Der Bearbeitungsschlüssel sagt LODAS, wie der Wert verarbeitet wird (1 = Stunden).",
  "datev.lohnUndGehaltHint":
    "Für Lohn und Gehalt legt das Steuerbüro einmalig im ASCII-Import-Assistenten eine Importbeschreibung an: Trennzeichen Semikolon, Spalten Personalnummer, Lohnart, Stunden, Tage. Den Monat wählt es beim Import.",
  "datev.wageTypes": "Lohnarten",
  "datev.column.transfer": "Übertragen",
  "datev.column.wageType": "Lohnart",
  "datev.column.processingKey": "Bearbeitungsschlüssel",
  "datev.category.WorkedHours": "Gearbeitete Stunden",
  "datev.category.OvertimeHours": "Überstunden (Zuwachs des Überstundenkontos)",
  "datev.category.AbsenceHours": "Gutgeschriebene Abwesenheitsstunden",
  "datev.category.VacationDays": "Urlaubstage (Tage mit Sollzeit)",
  "datev.category.SickDays": "Krankheitstage (Kalendertage)",
  "datev.category.LeavePayoutDays": "Abgegoltene Urlaubstage (im Monat des Austritts)",
  "datev.transferFor": "{category} übertragen",
  "datev.wageTypeFor": "Lohnart für {category}",
  "datev.processingKeyFor": "Bearbeitungsschlüssel für {category}",
  "datev.save": "DATEV-Einstellungen speichern",
  "datev.saved": "Die DATEV-Einstellungen wurden gespeichert.",
  "datev.download": "DATEV-Datei herunterladen",
  "datev.unusableNumbers":
    "Diese Personalnummern kann DATEV nicht übernehmen (nur Ziffern, 1 bis 99999, jede nur einmal): {employees}. Ändern Sie sie in den Stammdaten, sonst lehnt der Export sie ab.",
  "admin.profile.item": "{id} (Version {version}, gültig ab {from})",
  "admin.profile.hint":
    "Die Regelprofile bilden die gesetzlichen Regeln ab; Zeitavo liefert sie in festen Versionen aus, Sie können sie hier nicht ändern. Strengere Werte aus Tarifvertrag oder Betriebsvereinbarung und rechtliche Abweichungen pflegt die Mandanten-Administration unter „Mandant → Abweichungen“.",
  "admin.recordingObligations": "Aufzeichnungspflichten",
  "admin.recordingObligation.item":
    "{ruleId}: {reference} (Profil {id}, Version {version}, gültig ab {from})",
  "admin.recordingObligation.retention": "Aufbewahrung: mindestens {years} Jahre",
  "admin.recordingObligation.timeliness":
    "Beginn unmittelbar bei Arbeitsaufnahme (Toleranz {minutes} Minuten), Ende und Dauer am Tag der Arbeitsleistung",
  "admin.recordingObligation.tamperProof":
    "Elektronisch und manipulationssicher; maßgeblich ist der Server-Zeitstempel, spätere Aufzeichnungen und Korrekturen werden als Befund ausgewiesen.",
  "admin.recordingObligation.rule":
    "{kind}: {reference} ({id}, Version {version}, gültig ab {from})",
  "admin.recordingObligation.kind.Exemption": "Ausnahme",
  "admin.recordingObligation.kind.Simplification": "Vereinfachung",
  "admin.recordingObligation.notConfigured":
    "Noch nicht anwendbar: Schwellenwerte fehlen (rechtliche Prüfung).",
  "admin.establishment.invalidTimeZone":
    "Die Zeitzone ist keine gültige IANA-Zeitzone (z. B. Europe/Berlin).",
  "privacy.export": "Meine Daten exportieren",
  "privacy.exportHint":
    "Auskunft nach Art. 15 DSGVO: Kopie Ihrer Stempelungen, Korrekturen, Abwesenheiten, Befunde, Projektzeiten, Monatssummen, Push-Registrierungen sowie Stamm- und Kontodaten – als PDF zum Lesen und als JSON in einem strukturierten, maschinenlesbaren Format. Das Recht auf Datenübertragbarkeit (Art. 20 DSGVO) gilt nur für die unten so gekennzeichneten Kategorien, nicht für die gesetzlich vorgeschriebene Arbeitszeitaufzeichnung.",
  "privacy.exportJson": "Als JSON herunterladen",
  "privacy.exportPdf": "Als PDF herunterladen",
  "privacy.exportDone": "Die Datei {name} wurde heruntergeladen.",
  "privacy.records": "Kopie meiner Arbeitszeitaufzeichnungen",
  "privacy.recordsHint":
    "Arbeitszeitnachweis eines Zeitraums mit allen Stempelungen, Korrekturen und Befunden, zum Beispiel als Kopie der Aufzeichnungen nach § 21a Abs. 7 ArbZG. Der Abruf wird im Prüfprotokoll vermerkt.",
  "privacy.records.from": "Von",
  "privacy.records.to": "Bis",
  "privacy.records.rangeHint": "Frühestens am Tag „Von“, höchstens {days} Tage (etwa drei Jahre).",
  "privacy.records.format": "Format",
  "privacy.records.format.surchargeCsv": "CSV: Zuschläge nach Zeitfenstern (§ 19 AEntG)",
  "privacy.records.download": "Kopie herunterladen",
  "privacy.configuration": "Konfiguration für die Betriebsvereinbarung",
  "privacy.configurationHint":
    "Alle mitbestimmungspflichtigen Einstellungen (§ 87 Abs. 1 Nr. 2 und 6 BetrVG) als Anlage zur Betriebsvereinbarung, ohne personenbezogene Daten.",
  "privacy.auditChain": "Audit-Kette prüfen",
  "privacy.auditChain.hint":
    "Jede Änderung an Arbeitszeiten, Stammdaten und Einstellungen steht in einem manipulationserkennbaren Protokoll (Hash-Kette). Die Prüfung rechnet die Kette Ihres Unternehmens vollständig nach und vergleicht sie mit den täglichen Ankern. Das Ergebnis enthält keine personenbezogenen Daten; die Prüfung wird selbst protokolliert.",
  "privacy.auditChain.verify": "Jetzt prüfen",
  "privacy.auditChain.verifying": "Wird geprüft …",
  "privacy.auditChain.intact":
    "Die Audit-Kette ist unverändert. Geprüfte Einträge: {count} (Nr. 1 bis {last}).",
  "privacy.auditChain.empty": "Die Audit-Kette enthält noch keine Einträge.",
  "privacy.auditChain.broken":
    "Die Audit-Kette ist nicht intakt. Abweichungen: {count}, die erste bei Eintrag Nr. {first}. Bitte melden Sie den Befund umgehend dem Betreiber.",
  "privacy.auditChain.breaks": "Gefundene Abweichungen",
  "privacy.auditChain.break": "Eintrag Nr. {sequence}: {kind}",
  "privacy.auditChain.moreBreaks": "Weitere, hier nicht aufgeführte Abweichungen: {count}.",
  "privacy.auditChain.checkedAt": "Geprüft am {at}. Verglichene Tagesanker: {anchors}.",
  "privacy.auditChain.anchor": "Letzter Tagesanker: {day}, Eintrag Nr. {sequence}, Prüfsumme:",
  "privacy.auditChain.anchorHint":
    "Bewahren Sie die Prüfsumme außerhalb von Zeitavo auf. Stimmt sie bei einer späteren Prüfung überein, ist die Kette bis zu diesem Eintrag unverändert.",
  "privacy.auditChain.noAnchor":
    "Es gibt noch keinen Tagesanker; der erste entsteht in der Nacht nach dem ersten Eintrag.",
  "privacy.auditChain.kind.SequenceGap":
    "Ein Eintrag fehlt oder wurde eingefügt (Lücke in der Nummerierung).",
  "privacy.auditChain.kind.PreviousHashMismatch":
    "Die Verkettung mit dem vorherigen Eintrag stimmt nicht.",
  "privacy.auditChain.kind.EntryHashMismatch": "Der Eintrag wurde nachträglich verändert.",
  "privacy.auditChain.kind.TenantMismatch": "Der Eintrag gehört nicht zu Ihrem Unternehmen.",
  "privacy.auditChain.kind.HeadMismatch": "Am Ende der Kette fehlen Einträge.",
  "privacy.auditChain.kind.AnchorMismatch": "Ein Tagesanker passt nicht zur Kette.",
  "privacy.auditChain.kind.unknown": "Abweichung anderer Art.",
  "privacy.device": "Daten auf diesem Gerät",
  "privacy.deviceHint":
    "Für das Stempeln ohne Verbindung speichert die App auf diesem Gerät nur die noch nicht übertragenen und die zuletzt übertragenen Stempelungen sowie den letzten Stand vom Server, außerdem den zuletzt abgerufenen Stand Ihres Urlaubskontos je Urlaubsjahr: Summen und Einzelposten mit Zeitraum, Art der Buchung und Regel, Posten mit Gesundheitsbezug (Urlaub, der wegen Krankheit im Urlaub gutgeschrieben wurde) nur zusammengefasst ohne Art und Zeitraum. Beim Abmelden werden diese Daten gelöscht, meldet sich jemand anderes an, die Urlaubskonten anderer Personen. Serverantworten mit personenbezogenen Daten werden nicht im Browser-Cache abgelegt.",
  "privacy.deviceCount": "Lokal gespeicherte Stempelungen: {count}",
  "privacy.deviceHintWithoutRecords":
    "Ihre Rolle erfasst keine eigenen Arbeitszeiten. Die App speichert für Sie auf diesem Gerät daher keine Stempelungen und kein Urlaubskonto, nur Ihre Rollen für die Navigation und technische Einstellungen, etwa für Benachrichtigungen. Beim Abmelden werden diese Daten gelöscht. Serverantworten mit personenbezogenen Daten werden nicht im Browser-Cache abgelegt.",
  "privacy.info": "Informationen nach Art. 13 DSGVO",
  "privacy.info.purpose.title": "Zweck und Rechtsgrundlage",
  "privacy.info.purpose":
    "Ihr Arbeitgeber ist gesetzlich verpflichtet, Beginn, Ende und Dauer Ihrer täglichen Arbeitszeit zu erfassen (§ 3 Abs. 2 Nr. 1 ArbSchG, BAG 1 ABR 22/21; § 16 Abs. 2 ArbZG; ggf. § 17 MiLoG). Rechtsgrundlage ist Art. 6 Abs. 1 lit. c DSGVO. Die Daten dienen außerdem der Prüfung von Höchstarbeitszeit, Pausen und Ruhezeiten zu Ihrem Schutz.",
  "privacy.info.data.title": "Welche Daten",
  "privacy.info.data":
    "Stempelzeitpunkte mit Zeitzone und Quelle (Web, App), die Uhrzeitabweichung Ihres Geräts, Korrekturen mit Begründung, Abwesenheiten, Arbeitszeitmodell und Beschäftigungsdaten. Ein Standort wird nicht erfasst; ein Geräte-Fingerabdruck wird nicht gebildet. Fehlerberichte der App an den Betreiber enthalten nur die Art und den technischen Typ eines Fehlers, den Bereich der App ohne Kennungen, Version und Plattform; sie werden nach 7 Tagen gelöscht.",
  "privacy.info.recipients.title": "Wer sieht die Daten",
  "privacy.info.recipients":
    "Sie selbst, Ihre zuständige Führungskraft (Zeiten und Befunde Ihres Teams, ohne Gesundheitsdaten und Abwesenheiten), die Personalabteilung, der Hosting-Anbieter Ihres Arbeitgebers als Auftragsverarbeiter und bei einer behördlichen Prüfung die Aufsichtsbehörde. Wenn Sie Benachrichtigungen einschalten, erhält der Push-Dienst Ihres Browsers oder Betriebssystems (Google, Apple, Mozilla oder Microsoft, ggf. mit Verarbeitung in den USA) eine Gerätekennung und verschlüsselte Hinweise ohne Namen und Arbeitszeiten.",
  "privacy.info.retention.title": "Speicherdauer",
  "privacy.info.retention":
    "Die Fristen zählen ab dem Ende des Kalenderjahres; danach werden die Daten automatisch gelöscht. Die Frist und ihre Grundlage je Datenkategorie stehen unten. Nach Ihrem Ausscheiden und dem Ablauf aller Fristen werden Name, Personalnummer und Anmeldekennung anonymisiert. Ihr Arbeitgeber kann längere Fristen festlegen.",
  "privacy.info.rights.title": "Ihre Rechte",
  "privacy.info.rights":
    "Auskunft (Export oben), Berichtigung über einen Korrekturantrag, Löschung, soweit keine Aufbewahrungspflicht besteht, Einschränkung und Widerspruch nach Art. 17, 18 und 21 DSGVO, Datenübertragbarkeit nach Art. 20 DSGVO für die unten so gekennzeichneten Kategorien sowie Beschwerde bei einer Datenschutzaufsichtsbehörde. Wenden Sie sich für alle Anliegen an Ihre Personalabteilung oder die oder den Datenschutzbeauftragten Ihres Arbeitgebers.",
  "privacy.info.integrity.title": "Nachvollziehbarkeit",
  "privacy.info.integrity":
    "Einträge werden nie überschrieben. Jede Änderung erzeugt einen neuen Eintrag mit Begründung, Person und Zeitpunkt und wird in einem manipulationserkennbaren Protokoll festgehalten.",
  "privacy.info.controller.title": "Verantwortliche Stelle",
  "privacy.info.controller": "Verantwortlich für die Verarbeitung ist Ihr Arbeitgeber: {employer}.",
  "privacy.info.contact": "Kontakt der oder des Datenschutzbeauftragten: {contact}",
  "privacy.info.contactMissing":
    "Der Kontakt der oder des Datenschutzbeauftragten ist noch nicht hinterlegt; bitte wenden Sie sich an Ihre Personalabteilung.",
  "privacy.categories.title": "Datenkategorien, Rechtsgrundlagen und Speicherdauer",
  "privacy.categories.hint":
    "Standardwerte der Software (Stand {version}). Ihr Arbeitgeber kann Fristen verlängern, höchstens auf 10 Jahre; gesetzliche Mindestfristen werden nie unterschritten. Auskunft nach Art. 15 DSGVO erhalten Sie für alle Kategorien.",
  "privacy.categories.label.basis": "Rechtsgrundlage",
  "privacy.categories.label.retention": "Speicherdauer",
  "privacy.categories.label.portability": "Datenübertragbarkeit (Art. 20 DSGVO)",
  "privacy.categories.portability.applies": "Ja",
  "privacy.categories.portability.partly": "Teilweise",
  "privacy.categories.portability.notApplicable": "Nein",
  "privacy.categories.portabilityValue": "{value}. {reason}",
  "privacy.categories.workingTime": "Stempelungen, Pausenerklärungen, Korrekturen und Befunde",
  "privacy.categories.workingTime.basis":
    "Rechtliche Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO) nach § 3 Abs. 2 Nr. 1 ArbSchG und § 16 Abs. 2 ArbZG, je nach Tätigkeit auch § 17 MiLoG, § 19 AEntG, § 17c AÜG, § 21a Abs. 7 ArbZG (Straßentransport) oder § 6 GSA Fleisch; Prüfung nach ArbZG, JArbSchG und MuSchG. Für Bundesbeamtinnen und Bundesbeamte Art. 6 Abs. 1 lit. c und e DSGVO mit § 87 Abs. 3 BBG und § 7 AZV.",
  "privacy.categories.workingTime.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres. Für Aufzeichnungen nach § 16 Abs. 2 ArbZG, § 21a Abs. 7 ArbZG, § 17 MiLoG, § 19 AEntG und § 17c AÜG ist das die gesetzliche Mindestfrist; für die übrige Erfassung nach dem ArbSchG gibt es keine gesetzliche Frist, es gilt derselbe Standard. Für Bundesbeamtinnen und Bundesbeamte gilt ab dem Tag der Markierung ihrer Beschäftigung § 7 Abs. 7 AZV: Aufbewahrung mindestens 3 Monate nach Ablauf des Erhebungsmonats, Löschung spätestens nach der Frist der obersten Dienstbehörde (6 Monate nach Ablauf des Abrechnungszeitraums oder 13 Monate nach Ablauf des Erhebungsmonats).",
  "privacy.categories.workingTime.portability":
    "Die Verarbeitung beruht auf einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO), nicht auf Einwilligung oder Vertrag.",
  "privacy.categories.clockLocations":
    "Standort beim Stempeln (nur wenn Ihr Arbeitgeber ihn eingeschaltet hat)",
  "privacy.categories.clockLocations.basis":
    "Legt Ihr Arbeitgeber beim Einschalten fest: berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO) oder Betriebsvereinbarung (Art. 88 DSGVO); der Zugriff auf den Gerätestandort nach § 25 TDDDG erst nach Ihrer Erlaubnis im Systemdialog.",
  "privacy.categories.clockLocations.retention":
    "Getrennt von der Stempelung gespeichert und spätestens 60 Tage nach dem Stempeln gelöscht (Ihr Arbeitgeber kann kürzer festlegen); die Stempelung bleibt.",
  "privacy.categories.clockLocations.portability":
    "Die Verarbeitung beruht auf berechtigtem Interesse oder einer Betriebsvereinbarung, nicht auf Einwilligung oder Vertrag; im Auskunftsexport sind die Standorte enthalten.",
  "privacy.categories.nfcTags":
    "Stempelungen an NFC-Tags (nur wenn Ihr Arbeitgeber Tags angelegt hat)",
  "privacy.categories.nfcTags.basis":
    "Berechtigtes Interesse am Nachweis des Orts der Stempelung (Art. 6 Abs. 1 lit. f DSGVO) oder Betriebsvereinbarung (Art. 88 DSGVO, § 87 Abs. 1 Nr. 6 BetrVG); kein Standort, gelesen wird nur, wenn Sie einen Schritt gewählt haben.",
  "privacy.categories.nfcTags.retention":
    "Tag und Betrieb einer Stempelung werden mit der Stempelung gelöscht, {years} Jahre nach Ende des Kalenderjahres.",
  "privacy.categories.nfcTags.portability":
    "Die Verarbeitung beruht auf berechtigtem Interesse oder einer Betriebsvereinbarung, nicht auf Einwilligung oder Vertrag; im Auskunftsexport sind Tag und Betrieb Ihrer Stempelungen enthalten.",
  "privacy.categories.terminalAccess":
    "Anmeldung am Terminal und persönliche NFC-Chips (nur wenn Ihr Arbeitgeber Terminals oder Chips eingerichtet hat)",
  "privacy.categories.terminalAccess.basis":
    "PIN und QR-Ausweis wie die Stempelungen (Art. 6 Abs. 1 lit. c DSGVO), nur als Hash gespeichert, mit dem Tag der Ausgabe und gescheiterten Anmeldungen. Ein persönlicher NFC-Chip wie die Stempelungen an NFC-Tags auf Grund berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO) oder einer Betriebsvereinbarung (Art. 88 DSGVO, § 87 Abs. 1 Nr. 6 BetrVG), mit Namen, Tag der Ausgabe und letzter Nutzung, seine Kennung nur als Hash. Keine Fotos, keine Biometrie, kein Standort.",
  "privacy.categories.terminalAccess.retention":
    "PIN und QR-Ausweis werden gelöscht, sobald die Personalabteilung sie entfernt, spätestens mit dem Ende Ihrer letzten Beschäftigung. Persönliche NFC-Chips bleiben bis zum Ende Ihrer letzten Beschäftigung gespeichert; einen Chip, den die Personalabteilung vorher entfernt, sperrt sie, statt ihn zu löschen.",
  "privacy.categories.terminalAccess.portability":
    "Anmeldedaten und Chips stellt Ihr Arbeitgeber aus; im Auskunftsexport stehen die Tage der Ausgabe, gescheiterte Anmeldungen und Ihre Chips, nie PIN, Ausweis oder die Kennung eines Chips.",
  "privacy.categories.rosters":
    "Dienstpläne und das Recht „Dienstplan erstellen“ (nur wenn Ihr Arbeitgeber die Dienstplanung eingeschaltet hat)",
  "privacy.categories.rosters.basis":
    "Durchführung des Arbeitsverhältnisses (Art. 6 Abs. 1 lit. b DSGVO, § 106 GewO); die Planungsgrundsätze regelt eine Betriebsvereinbarung (§ 87 Abs. 1 Nr. 2 und 3 BetrVG). Ein Dienstplan ist eine Planung, keine Aufzeichnung Ihrer Arbeitszeit.",
  "privacy.categories.rosters.retention":
    "Geplante Schichten werden {years} Jahre nach Ende des Kalenderjahres gelöscht, in dem der Dienstplan endet; das Recht „Dienstplan erstellen“ ebenso nach seinem Ende.",
  "privacy.categories.rosters.portability":
    "Dienstpläne erstellt Ihr Arbeitgeber; im Auskunftsexport sind Ihre Schichten und Ihr Recht „Dienstplan erstellen“ enthalten.",
  "privacy.categories.onCallPeriods": "Rufbereitschaft und Bereitschaftsdienst",
  "privacy.categories.onCallPeriods.basis":
    "Durchführung des Arbeitsverhältnisses und Prüfung der Ruhezeit (Art. 6 Abs. 1 lit. b und c DSGVO, §§ 5, 7 ArbZG); gespeichert werden nur Beginn, Ende und Art, kein Grund.",
  "privacy.categories.onCallPeriods.retention":
    "Zeiträume werden {years} Jahre nach Ende des Kalenderjahres ihres Endes gelöscht, wie die Stempelungen.",
  "privacy.categories.onCallPeriods.portability":
    "Zeiträume trägt Ihr Arbeitgeber ein; im Auskunftsexport sind Ihre Zeiträume enthalten.",
  "privacy.categories.rosterRequests":
    "Verfügbarkeiten und Anfragen zu Schichten (nur wenn Ihr Arbeitgeber die Dienstplanung eingeschaltet hat)",
  "privacy.categories.rosterRequests.basis":
    "Durchführung des Arbeitsverhältnisses (Art. 6 Abs. 1 lit. b DSGVO); Verfügbarkeiten sehen nur Sie und die Planenden Ihres Teams oder Betriebs, nie Kolleginnen und Kollegen.",
  "privacy.categories.rosterRequests.retention":
    "Verfügbarkeiten werden {years} Jahre nach Ende des Kalenderjahres ihres letzten Tages gelöscht, Anfragen mit ihrem Dienstplan; Verfügbarkeiten auch mit der Anonymisierung nach Ihrem Ausscheiden.",
  "privacy.categories.rosterRequests.portability":
    "Sie geben diese Daten selbst an; im Auskunftsexport sind Ihre Verfügbarkeiten mit Notiz und Ihre Anfragen enthalten.",
  "privacy.categories.projectTimes":
    "Projektzeiten (nur wenn Ihr Arbeitgeber sie eingeschaltet hat)",
  "privacy.categories.projectTimes.basis":
    "Legt Ihr Arbeitgeber fest, z. B. Arbeitsvertrag (Art. 6 Abs. 1 lit. b DSGVO) oder berechtigtes Interesse (lit. f); nie Teil der gesetzlichen Arbeitszeitaufzeichnung.",
  "privacy.categories.projectTimes.retention":
    "Wie die Stempelungen: Löschung {years} Jahre nach Ende des Kalenderjahres, wenn Ihr Arbeitgeber keine längere Frist festlegt (z. B. als Grundlage von Kundenrechnungen).",
  "privacy.categories.projectTimes.portability":
    "Nur wenn Ihr Arbeitgeber die Projektzeiterfassung auf den Arbeitsvertrag stützt.",
  "privacy.categories.budgetWarnings":
    "Budgetwarnungen (nur wenn Sie für ein Projekt mit Budget verantwortlich sind)",
  "privacy.categories.budgetWarnings.basis":
    "Legt Ihr Arbeitgeber wie für die Projektzeiten fest, z. B. Arbeitsvertrag (Art. 6 Abs. 1 lit. b DSGVO) oder berechtigtes Interesse (lit. f). Gespeichert werden Budget, Zeitraum und erreichte Warnschwelle mit Ihnen als Empfängerin oder Empfänger; Push-Nachricht und E-Mail nennen kein Projekt, keine Stunden und keine Namen.",
  "privacy.categories.budgetWarnings.retention":
    "Löschung 30 Tage nach dem Versand, nie versandte Warnungen 30 Tage nach dem Speichern, spätestens mit dem Budget.",
  "privacy.categories.budgetWarnings.portability":
    "Die Warnungen erzeugt die Anwendung aus der Projektzeit aller Beteiligten, sie stammen nicht von Ihnen; im Auskunftsexport sind sie enthalten.",
  "privacy.categories.monthlyTotals":
    "Monatssummen für die Lohnabrechnung und die Werte heruntergeladener Lohndateien (Prüfprotokoll)",
  "privacy.categories.monthlyTotals.basis":
    "Arbeitsvertrag und steuerliche Pflichten (Art. 6 Abs. 1 lit. b und c DSGVO; § 41 EStG, § 147 AO).",
  "privacy.categories.monthlyTotals.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres (Lohnkonto, § 41 EStG). Ob längere steuerliche Fristen gelten, hängt von der Art der Unterlage ab und wird von Ihrem Arbeitgeber festgelegt. Für Monate, die ganz in Ihre Zeit als Bundesbeamtin oder Bundesbeamter fallen, gilt § 7 Abs. 7 AZV wie für die Zeiterfassungsdaten; Monate mit Tagen als Arbeitnehmerin oder Arbeitnehmer behalten diese Frist.",
  "privacy.categories.monthlyTotals.portability":
    "Die Summen berechnet Ihr Arbeitgeber; Art. 20 DSGVO erfasst nur Daten, die Sie selbst bereitgestellt haben.",
  "privacy.categories.timeAccountBookings":
    "Buchungen auf dem Zeitkonto (Auszahlung und Freizeitausgleich durch die Personalabteilung)",
  "privacy.categories.timeAccountBookings.basis":
    "Arbeitsvertrag und Lohnabrechnung (Art. 6 Abs. 1 lit. b und c DSGVO; § 2 Abs. 2 MiLoG, § 41 EStG). Eine Buchung ändert nie Ihre erfasste Arbeitszeit.",
  "privacy.categories.timeAccountBookings.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres des Buchungsmonats, wie die Monatssummen (Lohnkonto, § 41 EStG).",
  "privacy.categories.timeAccountBookings.portability":
    "Die Buchungen nimmt Ihr Arbeitgeber vor; im Auskunftsexport sind sie mit Grund enthalten.",
  "privacy.categories.monthConfirmations":
    "Bestätigungen und Freigaben Ihrer Monate (Monatsabschluss)",
  "privacy.categories.monthConfirmations.basis":
    "Durchführung des Arbeitsverhältnisses und berechtigtes Interesse am Nachweis, welcher Saldo mit welchem Vorbehalt freigegeben wurde, auch zur Abwehr von Ansprüchen (Art. 6 Abs. 1 lit. b und f DSGVO); keine Lohnunterlage. Ihre Bestätigung ist freiwillig und ein Verzicht ist damit nicht verbunden.",
  "privacy.categories.monthConfirmations.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres des Monats, wie die Monatssummen (keine gesetzliche Frist); solange eine Bestätigung besteht, wird Ihr Name nach dem Ausscheiden nicht anonymisiert. Für Monate, die ganz in Ihre Zeit als Bundesbeamtin oder Bundesbeamter fallen, gilt § 7 Abs. 7 AZV wie für die Zeiterfassungsdaten.",
  "privacy.categories.monthConfirmations.portability":
    "Ihre Bestätigung und Anmerkung geben Sie selbst ab, die Freigabe nimmt Ihr Arbeitgeber vor; im Auskunftsexport sind beide enthalten.",
  "privacy.categories.absences": "Abwesenheiten",
  "privacy.categories.absences.basis":
    "Arbeitsvertrag und rechtliche Verpflichtung (Art. 6 Abs. 1 lit. b und c DSGVO; BUrlG, EFZG, Bildungsurlaubsgesetze der Länder; § 15 BBiG und §§ 9, 10 JArbSchG für Berufsschul- und Prüfungszeiten mit Uhrzeiten und Wegezeit); Krankheit und Reha als Gesundheitsdaten nach Art. 9 Abs. 2 lit. b DSGVO.",
  "privacy.categories.absences.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres, in dem die Abwesenheit endete. Es gibt keine gesetzliche Aufbewahrungsfrist; die Frist folgt der regelmäßigen Verjährung (§§ 195, 199 BGB).",
  "privacy.categories.absences.portability":
    "Für Ihre Urlaubsanträge (Arbeitsvertrag), nicht für Krankheits- und Rehazeiten.",
  "privacy.categories.maternityProtection": "Mutterschutzzeiträume",
  "privacy.categories.maternityProtection.basis":
    "Pflichten aus dem Mutterschutzgesetz für Gesundheitsdaten (Art. 9 Abs. 2 lit. b DSGVO).",
  "privacy.categories.maternityProtection.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres, in dem der Zeitraum endete (§ 27 Abs. 5 MuSchG).",
  "privacy.categories.maternityProtection.portability":
    "Die Verarbeitung beruht auf Art. 9 Abs. 2 lit. b DSGVO, nicht auf Einwilligung oder Vertrag.",
  "privacy.categories.optOutConsents": "Einwilligungen nach § 7 Abs. 7 ArbZG (Opt-out)",
  "privacy.categories.optOutConsents.basis":
    "Rechtliche Verpflichtung zum Verzeichnis (Art. 6 Abs. 1 lit. c DSGVO i. V. m. § 16 Abs. 2 ArbZG). Diese arbeitsrechtliche Einwilligung ist keine Einwilligung nach der DSGVO.",
  "privacy.categories.optOutConsents.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres des Widerrufs bzw. Ihres Ausscheidens (§ 16 Abs. 2 ArbZG).",
  "privacy.categories.optOutConsents.portability":
    "Die Verarbeitung beruht auf einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO).",
  "privacy.categories.externalWorkingTime":
    "Arbeitszeiten bei anderen Arbeitgebern (nur bei Mehrfachbeschäftigung)",
  "privacy.categories.externalWorkingTime.basis":
    "Rechtliche Verpflichtung zur Zusammenrechnung (Art. 6 Abs. 1 lit. c DSGVO i. V. m. § 2 Abs. 1 ArbZG, § 4 Abs. 5 JArbSchG, § 4 Abs. 1 MuSchG bzw. § 21a Abs. 8 ArbZG). Gespeichert werden Dauern, soweit angegeben die Uhrzeiten (für Pausen und Ruhezeiten) und die Herkunft der Angabe; der Name des anderen Arbeitgebers und die Tätigkeit werden nicht gespeichert.",
  "privacy.categories.externalWorkingTime.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres, wie Ihre Stempelungen.",
  "privacy.categories.externalWorkingTime.portability":
    "Die Verarbeitung beruht auf einer rechtlichen Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO).",
  "privacy.categories.preparationTimes":
    "Vor- und Nachbereitungszeiten (z. B. Umkleiden), von der Personalabteilung kategorisiert",
  "privacy.categories.preparationTimes.basis":
    "In der Fleischwirtschaft rechtliche Verpflichtung (Art. 6 Abs. 1 lit. c DSGVO i. V. m. § 6 Abs. 1 GSA Fleisch), sonst legt Ihr Arbeitgeber die Grundlage fest (z. B. Arbeitsvertrag). Es wird nur Art und Zeit gespeichert, kein Freitext.",
  "privacy.categories.preparationTimes.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres, wie Ihre Stempelungen.",
  "privacy.categories.preparationTimes.portability":
    "Die Einträge erfasst Ihr Arbeitgeber, nicht Sie selbst; Auskunft erhalten Sie über den Export (Art. 15 DSGVO).",
  "privacy.categories.masterData": "Stammdaten und Beschäftigung",
  "privacy.categories.masterData.basis":
    "Arbeitsvertrag und rechtliche Verpflichtung (Art. 6 Abs. 1 lit. b und c DSGVO).",
  "privacy.categories.masterData.retention":
    "Anonymisierung nach Ihrem Ausscheiden, sobald keine Aufzeichnung mehr auf Sie verweist (in der Regel nach Ablauf der Monatssummen).",
  "privacy.categories.masterData.portability":
    "Für Angaben zum Arbeitsvertrag, die Sie selbst bereitgestellt haben (z. B. Ihren Namen), nicht für Angaben, die Ihr Arbeitgeber vergibt, wie die Personalnummer.",
  "privacy.categories.pushSubscriptions": "Benachrichtigungen (Push-Registrierung Ihres Geräts)",
  "privacy.categories.pushSubscriptions.basis":
    "Ihre Einwilligung durch Einschalten (Art. 6 Abs. 1 lit. a DSGVO, § 25 Abs. 1 TDDDG), jederzeit auf dieser Seite widerrufbar.",
  "privacy.categories.pushSubscriptions.retention":
    "Löschung, wenn Sie Benachrichtigungen abschalten, sich abmelden oder der Push-Dienst das Gerät als ungültig meldet.",
  "privacy.categories.pushSubscriptions.portability":
    "Die Verarbeitung beruht auf Ihrer Einwilligung. Der Export nennt Ihre Registrierungen mit Kanal, Push-Dienst, Prüfsumme und Datum; Geräteadresse, Token und Schlüssel enthält er nicht, weil sie nur für diesen Dienst gelten.",
  "nav.tenant": "Mandant",
  "nav.billing": "Abrechnung",
  "roles.title": "Rollen",
  "roles.intro":
    "Rollen gehören zur Anwendung, nicht zum Anmeldedienst. Eine Änderung gilt ab dem gewählten Tag; frühere Rollen bleiben nachvollziehbar.",
  "roles.roles": "Rollen",
  "roles.validFrom": "Gültig ab",
  "roles.save": "Rollen speichern",
  "roles.cancel": "Abbrechen",
  "roles.saved": "Rollen gespeichert.",
  "roles.none": "keine",
  "roles.noneHint": "Ohne Rolle hat die Person ab diesem Tag keinen Zugriff mehr.",
  "roles.edit": "Ändern",
  "roles.editFor": "Rollen von {name} ändern",
  "roles.editTitle": "Rollen von {name}",
  "roles.column.name": "Name",
  "roles.column.roles": "Rollen",
  "roles.column.since": "Seit",
  "roles.column.actions": "Aktionen",
  "roles.name.Employee": "Beschäftigte",
  "roles.name.Manager": "Führungskraft",
  "roles.name.HrAdmin": "Personal",
  "roles.name.TenantAdmin": "Mandantenverwaltung",
  "roles.name.Auditor": "Prüfung",
  "roles.name.WorksCouncil": "Betriebsrat",
  "roles.name.BillingAdmin": "Abrechnung",
  "roles.establishments": "Personal nur für diese Betriebe",
  "roles.establishments.hint":
    "Ohne Auswahl gilt die Rolle Personal für alle Betriebe. Mandantenverwaltung und Prüfung gelten immer für alle Betriebe.",
  "roles.establishments.all": "alle Betriebe",
  "roles.establishments.count": "{count} Betriebe",
  "roles.establishments.hintLimited":
    "Ohne Auswahl bleibt die bisherige Beschränkung bestehen. Aufgehoben wird sie nur über „Beschränkung aufheben“.",
  "roles.establishments.unreadable": "Beschränkung unlesbar – keine Betriebe sichtbar",
  "roles.scope.unreadableHint":
    "Die gespeicherte Beschränkung auf Betriebe ist unlesbar: Die Rolle Personal sieht keinen Betrieb. Wählen Sie die Betriebe neu oder heben Sie die Beschränkung ausdrücklich auf; ohne Auswahl bleibt sie bestehen.",
  "roles.scope.notApplicable":
    "Die Rolle Personal ist auf Betriebe beschränkt. Ohne Personal oder zusammen mit Mandantenverwaltung oder Prüfung kann die Beschränkung nicht bestehen bleiben. Behalten Sie Personal ohne diese Rollen oder heben Sie die Beschränkung ausdrücklich auf.",
  "roles.scope.lift": "Beschränkung aufheben",
  "roles.scope.liftConsequence":
    "Die Rolle Personal gilt ab dem gewählten Tag für alle Betriebe. Auch eine spätere Vergabe von Personal, etwa über SCIM, ist dann nicht mehr beschränkt.",
  "roles.scope.liftConfirm": "Beschränkung aufheben",
  "roles.scope.liftPending":
    "Die Beschränkung auf Betriebe wird beim Speichern aufgehoben. „Abbrechen“ verwirft die Änderung.",
  "roles.column.establishments": "Betriebe",
  "establishmentFilter.label": "Betrieb",
  "establishmentFilter.all": "Alle Betriebe",
  "establishmentScope.limited": "Ihre Personalrechte gelten nur für: {names}.",
  "establishmentOverview.title": "Übersicht je Betrieb",
  "establishmentOverview.intro":
    "Nur Zahlen, keine Personen. Offene Tage sind noch nicht abgeschlossene Arbeitstage, offene Verstöße zählen mit einem Zeitraum, der in den letzten 31 Tagen endet.",
  "establishmentOverview.column.name": "Betrieb",
  "establishmentOverview.column.active": "Aktive Beschäftigte",
  "establishmentOverview.column.openDays": "Offene Tage",
  "establishmentOverview.column.violations": "Offene Verstöße",
  "establishmentOverview.empty": "Keine Betriebe.",
  "legal.title": "Verträge und Rechtsdokumente",
  "legal.intro":
    "Hier stehen die Fassungen, die für Ihr Unternehmen gelten. Neue Fassungen nehmen Sie als Administratorin oder Administrator an.",
  "legal.promptTitle": "Neue Vertragsfassung",
  "legal.prompt":
    "Bitte prüfen Sie die folgenden Dokumente. Stempeln und Exporte funktionieren unabhängig davon weiter.",
  "legal.kind.Terms": "Allgemeine Geschäftsbedingungen",
  "legal.kind.Dpa": "Auftragsverarbeitungsvertrag (AVV) mit TOM",
  "legal.kind.Sla": "Service Level Agreement",
  "legal.kind.PrivacyNotice": "Datenschutzhinweise",
  "legal.version": "Fassung {version}, gültig ab {day}",
  "legal.open": "{document} öffnen",
  "legal.inForce": "Für Sie gilt Fassung {version}.",
  "legal.none": "Noch keine Fassung angenommen.",
  "legal.accepted": "Angenommen.",
  "legal.declined": "Abgelehnt; es gilt weiter Fassung {version} bis zum Vertragsende.",
  "legal.informationOnly": "Zur Information, keine Annahme nötig.",
  "legal.accept": "{document} annehmen",
  "legal.decline": "{document} ablehnen",
  "legal.declineHint":
    "Wenn Sie ablehnen, gilt die bisherige Fassung bis zum Ende Ihres Vertrags weiter.",
  "legal.later": "Später",
  "legal.empty": "Der Betreiber hat keine Rechtsdokumente hinterlegt.",
  "subscription.title": "Tarif und Nutzung",
  "subscription.plan": "Tarif: {plan}",
  "subscription.status.Active": "aktiv",
  "subscription.status.PastDue": "Zahlung offen",
  "subscription.status.Suspended": "Verwaltung eingeschränkt",
  "subscription.status.ExportWindow": "beendet, nur Export",
  "subscription.trial": "Die Testphase endet am {day}.",
  "subscription.readOnly":
    "Die Verwaltung ist schreibgeschützt. Stempeln, eigene Zeiten und Exporte funktionieren weiter.",
  "serviceStatus.exportWindow":
    "Der Vertrag ist beendet. Die Daten können bis zur Löschung nur noch gelesen und exportiert werden.",
  "serviceStatus.exportWindowUntil":
    "Der Vertrag ist beendet. Die Daten können bis zu ihrer Löschung am {day} nur noch gelesen und exportiert werden.",
  "serviceStatus.readOnly":
    "Die Verwaltung ist schreibgeschützt. Stempeln, eigene Zeiten und Exporte funktionieren weiter.",
  "serviceStatus.toExport": "Zum Datenexport",
  "serviceStatus.toBilling": "Zur Abrechnung",
  "subscription.limitExceeded":
    "Mehr aktive Beschäftigte als im Tarif enthalten ({limit}). Es wird nichts gesperrt; die Abrechnung passt sich an.",
  "subscription.usage": "Aktive Beschäftigte je Monat",
  "subscription.month": "Monat",
  "subscription.active": "Aktiv",
  "billing.profile": "Rechnungsdaten",
  "billing.profileMissing":
    "Noch keine Rechnungsdaten hinterlegt. Rechnungen brauchen Firmenname, Anschrift und Rechnungsadresse.",
  "billing.companyName": "Firmenname (ohne Rechtsform)",
  "billing.legalForm": "Rechtsform",
  "billing.street": "Straße und Hausnummer",
  "billing.postalCode": "Postleitzahl",
  "billing.city": "Ort",
  "billing.vatId": "USt-IdNr.",
  "billing.vatIdHint":
    "In Deutschland ist die USt-IdNr. freiwillig. Für Unternehmen in anderen EU-Staaten ist sie Pflicht, weil die Rechnung dann ohne Umsatzsteuer gestellt wird (Reverse-Charge).",
  "billing.invoiceEmail": "E-Mail-Adresse für Rechnungen",
  "billing.save": "Rechnungsdaten speichern",
  "billing.paymentMethod": "Zahlungsart: {method}.",
  "billing.payment.SepaDebit": "SEPA-Lastschrift",
  "billing.payment.Card": "Karte",
  "billing.payment.BankTransfer": "Überweisung",
  "billing.notAvailable":
    "Diese Installation wird ohne Betreiber betrieben; es gibt keine Rechnungsdaten.",
  "payment.title": "Abo und Zahlung",
  "payment.notAvailable": "Ein Abo kann in dieser Installation nicht online abgeschlossen werden.",
  "payment.none": "Es ist noch kein Abo abgeschlossen.",
  "payment.state": "Abo {plan}:",
  "payment.unknownPlan": "unbekannter Tarif",
  "payment.status.Incomplete": "Zahlung wird bestätigt",
  "payment.status.Trialing": "Testzeitraum",
  "payment.status.Active": "aktiv",
  "payment.status.PastDue": "Zahlung fehlgeschlagen, wird erneut versucht",
  "payment.status.Unpaid": "unbezahlt",
  "payment.status.Paused": "pausiert",
  "payment.status.Canceled": "beendet",
  "payment.periodEnd": "Aktueller Abrechnungszeitraum bis {day}.",
  "payment.cancelAt": "Das Abo endet am {day}.",
  "payment.plan": "Tarif",
  "payment.checkout": "Abo abschließen",
  "payment.checkoutHint":
    "Sie werden zum Zahlungsdienstleister weitergeleitet und wählen dort SEPA-Lastschrift oder Karte. Berechnet werden die monatliche Grundgebühr, ab dem zweiten Monat die aktiven Beschäftigten des Vormonats und beim ersten Abo die einmalige Einrichtungsgebühr, falls der Tarif eine hat.",
  "payment.portal": "Zahlungsart verwalten oder kündigen",
  "payment.changePlan.title": "Tarif wechseln",
  "payment.changePlan.plan": "Neuer Tarif",
  "payment.changePlan.hint":
    "Ein höherer Tarif gilt sofort und wird für den laufenden Zeitraum anteilig berechnet; ein niedrigerer gilt ab dem Ende des bezahlten Zeitraums.",
  "payment.changePlan.submit": "Tarif wechseln",
  "payment.changePlan.confirm":
    "Zum Tarif {plan} wechseln? Ist er höher, wird die Differenz sofort anteilig berechnet.",
  "payment.changePlan.confirmButton": "Wechsel bestätigen",
  "payment.changePlan.cancel": "Abbrechen",
  "payment.changePlan.now":
    "Der Tarif {plan} gilt ab sofort. Er erscheint hier, sobald der Zahlungsdienstleister den Wechsel bestätigt.",
  "payment.changePlan.atPeriodEnd": "Der Tarif {plan} gilt ab {day}.",
  "payment.returned.success":
    "Danke! Sobald der Zahlungsdienstleister das Abo bestätigt, erscheint es hier.",
  "payment.returned.cancelled": "Der Abschluss wurde abgebrochen; es wurde nichts gebucht.",
  "payment.onRequest":
    "Ihr Tarif {plan} wird nach Vereinbarung abgerechnet. Ein Abo kann dafür nicht online abgeschlossen oder gewechselt werden.",
  "payment.onRequest.contact": "Änderungen am Tarif vereinbaren Sie mit dem Anbieter:",
  "payment.onRequest.noContact":
    "Änderungen am Tarif vereinbaren Sie mit Ihrer Ansprechperson beim Anbieter.",
  "invoices.title": "Rechnungen",
  "invoices.hint":
    "Rechnungen und Gutschriften des Anbieters als PDF mit eingebetteter E-Rechnung (ZUGFeRD). Bewahren Sie sie acht Jahre auf.",
  "invoices.none": "Es gibt noch keine Rechnungen.",
  "invoices.notAvailable":
    "Diese Installation wird ohne Betreiber betrieben; es gibt keine Rechnungen.",
  "invoices.number": "Nummer",
  "invoices.issueDate": "Datum",
  "invoices.period": "Zeitraum",
  "invoices.gross": "Betrag (brutto)",
  "invoices.periodRange": "{from} – {to}",
  "invoices.kind.Invoice": "Rechnung",
  "invoices.kind.CreditNote": "Gutschrift zu {number}",
  "invoices.reverseCharge": "Reverse-Charge",
  "invoices.download": "PDF {number} herunterladen",
  "invoices.downloaded": "{name} wurde gespeichert.",
  "contacts.title": "Ansprechpersonen für den Anbieter",
  "contacts.hint":
    "An diese Adressen schreibt der Anbieter zu Vertrag, Rechnungen, Datenpannen und Änderungen der Unterauftragsverarbeiter. Vertrag, Rechnung und Sicherheit sind Pflicht.",
  "contacts.kind.Contract": "Vertrag",
  "contacts.kind.Billing": "Rechnung",
  "contacts.kind.Security": "Sicherheit (Datenpannen, Unterauftragsverarbeiter)",
  "contacts.kind.DataProtection": "Datenschutzbeauftragte oder Datenschutzbeauftragter",
  "contacts.name": "Name oder Funktion",
  "contacts.email": "E-Mail-Adresse",
  "contacts.save": "Ansprechpersonen speichern",
  "contacts.missing": "Es fehlen noch: {list}.",
  "contacts.notAvailable":
    "Diese Installation wird ohne Betreiber betrieben; es gibt keine Ansprechpersonen.",
  "tenant.export": "Vollständiger Datenexport",
  "tenant.exportHint":
    "Alle Daten Ihres Unternehmens als ZIP-Archiv: JSON mit JSON-Schema, CSV je Tabelle und PDF-Berichte je Person und Jahr (Anbieterwechsel nach Data Act, kostenlos). Sie müssen Arbeitszeitaufzeichnungen mindestens zwei Jahre aufbewahren, auch nach Vertragsende.",
  "tenant.exportRequest": "Export anfordern",
  "tenant.exportState.pending": "Wird erstellt",
  "tenant.exportState.failed": "Fehlgeschlagen",
  "tenant.exportState.expired": "Abgelaufen",
  "tenant.exportState.ready": "Bereit",
  "tenant.exportPending": "Export vom {time} wird erstellt …",
  "tenant.exportFailed": "Export vom {time} ist fehlgeschlagen. Bitte fordern Sie einen neuen an.",
  "tenant.exportExpired": "Export vom {time} ist abgelaufen.",
  "tenant.exportReady": "Export vom {time}, {size}, herunterladbar bis {until}.",
  "tenant.exportDownload": "Export vom {time} herunterladen",
  "tenant.exportChecksum": "SHA-256: {hash}",
  "tenant.exportNone": "Es wurde noch kein Export angefordert.",
  "emergency.title": "Notfallzugriff des Supports",
  "emergency.intro":
    "Der Support des Betreibers sieht keine Daten Ihres Unternehmens. Nur wenn Sie eine Anfrage freigeben, darf er befristet und nur lesend zugreifen; jeder Zugriff wird im Audit-Log protokolliert.",
  "emergency.none": "Keine Anfragen.",
  "emergency.requestBy": "Anfrage von {name}",
  "emergency.details": "Angefragt {requested} für {hours} h.",
  "emergency.until": "Gültig bis {until}.",
  "emergency.hours": "Freigabe in Stunden",
  "emergency.hoursInvalid": "Bitte geben Sie eine ganze Zahl von 1 bis {max} ein.",
  "emergency.approve": "Freigeben",
  "emergency.reject": "Ablehnen",
  "emergency.revoke": "Zugriff beenden",
  "emergency.state.requested": "wartet auf Entscheidung",
  "emergency.state.active": "aktiv",
  "emergency.state.ended": "abgelaufen",
  "emergency.state.rejected": "abgelehnt",
  "emergency.state.revoked": "vorzeitig beendet",
  "scim.title": "SCIM-Zugänge",
  "scim.intro":
    "Mit einem SCIM-Zugang legt das Identitätssystem des Arbeitgebers (z. B. Microsoft Entra ID) Beschäftigte an, ändert Rollen und sperrt ausgeschiedene Personen sofort. Mehrere Zugänge können gleichzeitig gelten: neuen Zugang anlegen, im Identitätssystem eintragen, alten widerrufen.",
  "scim.name": "Bezeichnung",
  "scim.create": "Zugang anlegen",
  "scim.secretOnce":
    "Das Geheimnis wird nur jetzt angezeigt. Tragen Sie es im Identitätssystem ein.",
  "scim.baseUrl": "SCIM-Adresse (Tenant URL)",
  "scim.tokenUrl": "Token-Adresse (OAuth 2.0)",
  "scim.clientId": "Client-ID",
  "scim.secret": "Geheimnis (Client Secret oder Secret Token)",
  "scim.column.name": "Bezeichnung",
  "scim.column.created": "Angelegt",
  "scim.column.expires": "Gültig bis",
  "scim.column.state": "Status",
  "scim.column.actions": "Aktionen",
  "scim.state.active": "gültig",
  "scim.state.expired": "abgelaufen",
  "scim.state.revoked": "widerrufen",
  "scim.revoke": "Widerrufen",
  "scim.revokeFor": "Zugang {name} widerrufen",
  "publicApi.title": "Öffentliche API",
  "publicApi.intro":
    "Eigene Systeme (z. B. Lohnabrechnung, ERP oder Auswertungen) lesen Arbeitstage, Befunde, Beschäftigte, Abwesenheiten, Lohnmonate und Projektzeiten, stellen Abwesenheitsanträge und pflegen Projekte, Kunden und Tätigkeiten – über OAuth 2.0 Client Credentials, mit signierten Webhooks.",
  "publicApi.planHint": "Nur in Tarifen mit der Zusatzfunktion „Öffentliche API und Webhooks“.",
  "publicApi.rotation":
    "Geheimnisse wechseln: neuen Zugang anlegen, im System eintragen, alten widerrufen.",
  "publicApi.clients": "API-Zugänge",
  "publicApi.name": "Name des Systems",
  "publicApi.scopes": "Berechtigungen (Scopes)",
  "publicApi.healthScopeHint":
    "„absence-kinds:read“ zeigt die Art der Abwesenheiten und Krankheitstage im Lohnmonat (Gesundheitsdaten, Art. 9 DSGVO); ohne diesen Scope erscheint jede Abwesenheit als „abwesend“. Über „absences:write“ beantragte Abwesenheiten entscheiden Sie weiterhin in Zeitavo.",
  "publicApi.validityDays": "Gültigkeit in Tagen (1 bis 365)",
  "publicApi.createClient": "API-Zugang anlegen",
  "publicApi.secretOnce": "Das Geheimnis wird nur jetzt angezeigt. Tragen Sie es im System ein.",
  "publicApi.tokenPath": "Token-Pfad (an die Adresse der API anhängen)",
  "publicApi.clientId": "Client-ID",
  "publicApi.secret": "Client Secret",
  "publicApi.column.name": "System",
  "publicApi.column.scopes": "Berechtigungen",
  "publicApi.column.expires": "Gültig bis",
  "publicApi.column.state": "Status",
  "publicApi.column.actions": "Aktionen",
  "publicApi.column.url": "Empfänger",
  "publicApi.column.events": "Ereignisse",
  "publicApi.state.active": "gültig",
  "publicApi.state.expired": "abgelaufen",
  "publicApi.state.revoked": "widerrufen",
  "publicApi.state.enabled": "aktiv",
  "publicApi.state.disabled": "deaktiviert",
  "publicApi.revoke": "Widerrufen",
  "publicApi.revokeFor": "API-Zugang {name} widerrufen",
  "publicApi.webhooks": "Webhooks",
  "publicApi.webhooksIntro":
    "Benachrichtigungen enthalten nur Kennungen; Einzelheiten liest Ihr System über die API. Jede Zustellung ist mit HMAC-SHA256 signiert und wird bis zu achtmal wiederholt.",
  "publicApi.url": "Empfänger-Adresse (HTTPS, Port 443)",
  "publicApi.events": "Ereignisse",
  "publicApi.eventsHint":
    "„violation.escalated“ meldet einen gespeicherten Befund, der zum Verstoß geworden ist, etwa einen nicht gewährten Ausgleich. Bestehende Webhooks erhalten es nicht; legen Sie dafür einen zusätzlichen Webhook nur mit diesem Ereignis an und lassen Sie die bestehenden unverändert.",
  "publicApi.createWebhook": "Webhook anlegen",
  "publicApi.signingKeyOnce":
    "Der Signaturschlüssel wird nur jetzt angezeigt. Tragen Sie ihn im Empfänger ein.",
  "publicApi.signingKey": "Signaturschlüssel",
  "publicApi.disable": "Deaktivieren",
  "publicApi.disableFor": "Webhook {url} deaktivieren",
  "settings.title": "Einstellungen",
  "settings.features": "Überwachungsnahe Funktionen",
  "settings.featuresHint":
    "Standardmäßig aus. Einschalten nur mit Betriebsvereinbarung (§ 87 Abs. 1 Nr. 6 BetrVG).",
  "settings.feature.locationCaptureEnabled": "Standort beim Stempeln erfassen",
  "settings.feature.projectTimeReportsPerPersonEnabled": "Projektzeiten je Person auswerten",
  "settings.feature.teamComparisonsEnabled": "Vergleiche im Team",
  "settings.feature.projectTimeTrackingEnabled": "Projektzeiterfassung",
  "settings.feature.managersMayCreateProjects": "Führungskräfte dürfen Projekte anlegen",
  "settings.feature.managersMayConfigureProjectRequirement":
    "Führungskräfte dürfen die Pflicht-Richtlinie ihres Teams ändern",
  "settings.retention": "Aufbewahrung (Jahre nach Ende des Kalenderjahres)",
  "settings.retentionHint":
    "Leer lassen für den Standard der Plattform. Die Fristen können nur verlängert werden, höchstens auf 10 Jahre.",
  "settings.retention.rawDataYears": "Stempelungen und Befunde",
  "settings.retention.absenceYears": "Abwesenheiten",
  "settings.retention.aggregateYears": "Monatssummen (Lohn)",
  "settings.platformDefault": "Standard: {years}",
  "settings.azv": "Bundesbeamtinnen und Bundesbeamte (§ 7 Abs. 7 AZV)",
  "settings.azv.hint":
    "Gilt nur für Beschäftigungen mit dem Arbeitszeitrecht „Bundesbeamtin oder Bundesbeamter (AZV)“. Ihre Zeiterfassungsdaten bleiben mindestens 3 Monate nach Ablauf des Erhebungsmonats erhalten und werden spätestens zu der Frist gelöscht, die die oberste Dienstbehörde festlegt; die Jahre oben gelten für sie nicht. Ohne Festlegung gilt der frühere der beiden Höchsttermine.",
  "settings.azv.limitation":
    "Für Bundesbeamtinnen und Bundesbeamte prüft Zeitavo die Regeln der AZV (Regelprofil DE-AZV), nicht die des ArbZG. Abwesenheiten behalten ihre eigene Frist.",
  "settings.azv.mode": "Festlegung der obersten Dienstbehörde",
  "settings.azv.mode.none": "Keine Festlegung (früherer Höchsttermin)",
  "settings.azv.mode.AfterSettlementPeriod":
    "Löschung nach Ablauf des Abrechnungszeitraums (höchstens 6 Monate)",
  "settings.azv.mode.AfterCollectionMonth":
    "Löschung nach Ablauf des Erhebungsmonats (höchstens 13 Monate)",
  "settings.azv.deletionMonths": "Löschung nach Monaten (3 bis Höchstwert)",
  "settings.azv.latest": "Höchstens: {months}",
  "settings.azv.settlementStart": "Beginn des Abrechnungszeitraums",
  "settings.azv.settlementStartDefault": "Standard: {month}",
  "settings.azv.settlementLength": "Länge des Abrechnungszeitraums",
  "settings.azv.settlementLengthDefault": "Standard: 12 Monate (Kalenderjahr)",
  "settings.azv.months": "{months} Monate",
  "settings.azvFlexitime":
    "Gleitzeit der Bundesbeamtinnen und Bundesbeamten (§ 7 Abs. 4 und 5 AZV)",
  "settings.azvFlexitime.hint":
    "Das Gleitzeitkonto rechnet im Abrechnungszeitraum oben ab. Übertrag über 40 Stunden, Saldo unter −40 Stunden und zu viele Gleittage erscheinen als Hinweis an die Personalverwaltung; nichts verfällt automatisch.",
  "settings.azvFlexitime.maxFlexiDays": "Gleittage je Jahr",
  "settings.azvFlexitime.maxFlexiDaysHint":
    "Mehr als 12 Gleittage nur, wenn es dienstlichen Belangen förderlich oder nach den dienstlichen Verhältnissen zweckmäßig ist (§ 7 Abs. 5 Satz 2 AZV). Halbe Gleittage zählen nur mit Kernarbeitszeit halb.",
  "settings.azvFlexitime.default": "Standard: {days} (§ 7 Abs. 5 Satz 1 AZV)",
  "settings.azvFlexitime.days": "{days} Gleittage",
  "settings.azv.confirm":
    "Ich habe verstanden: Nach Ablauf von {days} Tagen löscht der nächste Nachtlauf ältere Zeiterfassungsdaten von Bundesbeamtinnen und Bundesbeamten nach der neuen Frist unwiderruflich. Bis dahin gilt, was die bisherige Frist aufbewahrt.",
  "settings.branding": "Erscheinungsbild",
  "settings.defaultLanguage": "Standardsprache",
  "settings.languageUnset": "Standard der App",
  "settings.accentColor": "Akzentfarbe (#rrggbb)",
  "settings.accentColorHint":
    "Gilt im hellen Design; die Farbe muss ausreichend Kontrast haben (WCAG 2.2 AA).",
  "settings.save": "Einstellungen speichern",
  "settings.saved": "Einstellungen gespeichert.",
  "settings.logo": "Logo (PNG oder JPEG)",
  "settings.logoHint": "Höchstens 64 KB; erscheint in der Kopfzeile.",
  "settings.logoTooLarge": "Das Logo ist größer als 64 KB.",
  "settings.logoCurrent": "Aktuelles Logo",
  "settings.logoRemove": "Logo entfernen",
  "overrides.title": "Verschärfungen der Regelprofile",
  "overrides.intro":
    "Strengere Werte als in den Regelprofilen auf Grundlage eines Tarifvertrags oder einer Betriebsvereinbarung, zum Beispiel eine längere Ruhezeit. Gesetzliche Grenzen lassen sich hier nicht lockern; dafür gibt es die rechtlichen Abweichungen. Nur freigegebene Parameter sind änderbar; frühere Stände bleiben erhalten.",
  "overrides.none": "Keine Abweichungen – es gelten die Regelprofile.",
  "overrides.row": "Abweichung {number}",
  "overrides.profile": "Regelprofil",
  "overrides.validFrom": "Gültig ab",
  "overrides.validTo": "Gültig bis",
  "overrides.allowed": "Änderbar: {parameters}",
  "overrides.legalBasis": "Rechtsgrundlage",
  "overrides.legalBasisKind": "Art der Rechtsgrundlage",
  "overrides.kind.CollectiveAgreement": "Tarifvertrag",
  "overrides.kind.WorksAgreement": "Betriebsvereinbarung",
  "overrides.remove": "Abweichung {number} entfernen",
  "overrides.add": "Abweichung hinzufügen",
  "overrides.save": "Abweichungen speichern",
  "overrides.saved": "Abweichungen gespeichert. Sie gelten für alle folgenden Auswertungen.",
  "overrides.ineffective":
    "Ohne Wirkung, weil gelockert: {parameters}. Lockerungen brauchen eine rechtliche Abweichung mit passender Norm.",
  "legalDeviations.title": "Rechtliche Abweichungen (§ 7, §§ 14, 15 ArbZG)",
  "legalDeviations.intro":
    "Gesetzliche Grenzen lassen sich nur mit passender Rechtsgrundlage lockern: Tarifvertrag oder Betriebsvereinbarung auf Grund eines Tarifvertrags (§ 7 ArbZG), behördliche Bewilligung (§ 7 Abs. 5, § 15 ArbZG) oder Notfall (§ 14 ArbZG). Jede Norm erlaubt nur bestimmte Parameter in festen Grenzen. Bewilligungen und Notfälle enden automatisch mit ihrem letzten Tag. Einträge werden nicht geändert, nur widerrufen; jeder Schritt wird protokolliert. Abgelaufene und widerrufene Einträge werden mit den Arbeitszeitaufzeichnungen ihres Zeitraums gelöscht. Der Konfigurationsexport für die Betriebsvereinbarung führt die geltenden und geplanten Abweichungen auf.",
  "legalDeviations.list": "Erfasste Abweichungen",
  "legalDeviations.none": "Keine Abweichungen – es gelten die gesetzlichen Grenzen.",
  "legalDeviations.column.norm": "Norm",
  "legalDeviations.column.basis": "Rechtsgrundlage",
  "legalDeviations.column.scope": "Geltungsbereich",
  "legalDeviations.column.period": "Zeitraum",
  "legalDeviations.column.parameters": "Parameter",
  "legalDeviations.column.status": "Stand",
  "legalDeviations.column.actions": "Aktionen",
  "legalDeviations.type.CollectiveAgreement": "Tarifvertrag",
  "legalDeviations.type.WorksAgreement": "Betriebsvereinbarung auf Grund eines Tarifvertrags",
  "legalDeviations.type.AuthorityPermit": "Behördliche Bewilligung",
  "legalDeviations.type.EmergencyCase": "Notfall oder außergewöhnlicher Fall",
  "legalDeviations.type.OperationalReasons": "Technische oder arbeitsorganisatorische Gründe",
  "legalDeviations.scope.Tenant": "Ganzer Arbeitgeber",
  "legalDeviations.scope.Establishment": "Betrieb",
  "legalDeviations.scope.Employee": "Beschäftigte Person",
  "legalDeviations.status.Scheduled": "Geplant",
  "legalDeviations.status.Active": "Gilt",
  "legalDeviations.status.Expired": "Abgelaufen",
  "legalDeviations.status.Revoked": "Widerrufen",
  "legalDeviations.status.Ineffective": "Ohne Wirkung (Norm geändert)",
  "legalDeviations.period": "{from} bis {to}",
  "legalDeviations.openEnd": "offen",
  "legalDeviations.revoke": "Abweichung {reference} widerrufen",
  "legalDeviations.revokeHint":
    "Nach dem Widerruf gilt die Abweichung für keinen Tag mehr, auch nicht rückwirkend. Um eine Abweichung vorzeitig zu beenden, widerrufen Sie sie und erfassen Sie sie mit kürzerem Zeitraum neu.",
  "legalDeviations.revokeReason": "Grund des Widerrufs",
  "legalDeviations.revokeConfirm": "Widerrufen",
  "legalDeviations.cancel": "Abbrechen",
  "legalDeviations.revoked": "Abweichung widerrufen.",
  "legalDeviations.new": "Neue Abweichung",
  "legalDeviations.type": "Art der Rechtsgrundlage",
  "legalDeviations.norm": "Norm",
  "legalDeviations.noNorm": "Für diese Rechtsgrundlage gibt es keine Norm.",
  "legalDeviations.conditions": "Voraussetzungen: {conditions}",
  "legalDeviations.allowed": "Zulässige Parameter (* Pflicht, Sekunden): {parameters}",
  "legalDeviations.scopeKind": "Geltungsbereich",
  "legalDeviations.choose": "Bitte wählen",
  "legalDeviations.validFrom": "Gültig ab",
  "legalDeviations.validTo": "Gültig bis",
  "legalDeviations.reference": "Fundstelle oder Aktenzeichen",
  "legalDeviations.authority": "Bewilligende Behörde",
  "legalDeviations.enablingAgreement": "Tarifvertrag mit Öffnungsklausel",
  "legalDeviations.justification": "Begründung des Notfalls",
  "legalDeviations.reasons": "Die technischen oder arbeitsorganisatorischen Gründe",
  "legalDeviations.confirm": "Ich bestätige, dass die Voraussetzungen der Norm vorliegen.",
  "legalDeviations.save": "Abweichung erfassen",
  "legalDeviations.saved": "Abweichung erfasst. Sie gilt für alle folgenden Auswertungen.",
  "tenantSelection.title": "Arbeitgeber wählen",
  "tenantSelection.intro":
    "Sie sind bei mehreren Arbeitgebern angemeldet. Wählen Sie, für wen Sie jetzt arbeiten; die Wahl gilt bis zur Abmeldung.",
  "tenantSelection.switch": "Arbeitgeber wechseln",
  "tenant.contact": "Kontakt der oder des Datenschutzbeauftragten",
  "tenant.contactHint":
    "Wird allen Beschäftigten in den Informationen nach Art. 13 DSGVO angezeigt, z. B. Name, E-Mail-Adresse und Anschrift. Leer lassen, um den Eintrag zu entfernen.",
  "tenant.employer": "Arbeitgeber: {employer}",
  "tenant.save": "Speichern",
  "tenant.saved": "Gespeichert.",
  "signup.title": "Unternehmen registrieren",
  "signup.intro":
    "Testen Sie Zeitavo 30 Tage kostenlos und ohne Zahlungsmittel. Das Angebot richtet sich nur an Unternehmen.",
  "signup.companyName": "Firma",
  "signup.legalForm": "Rechtsform",
  "signup.street": "Straße und Hausnummer",
  "signup.postalCode": "Postleitzahl",
  "signup.city": "Ort",
  "signup.federalState": "Bundesland des ersten Betriebs",
  "signup.vatId": "USt-IdNr.",
  "signup.contactFirstName": "Vorname der Ansprechperson",
  "signup.contactLastName": "Nachname der Ansprechperson",
  "signup.contactEmail": "E-Mail-Adresse der Ansprechperson",
  "signup.confirmations": "Bestätigungen",
  "signup.businessUse":
    "Ich registriere das Unternehmen als Unternehmer (§ 14 BGB), nicht als Verbraucher.",
  "signup.acceptTerms": "Ich akzeptiere die Allgemeinen Geschäftsbedingungen (Fassung {version}).",
  "signup.acceptDpa":
    "Ich schließe den Vertrag über die Auftragsverarbeitung ab (Fassung {version}).",
  "signup.noLegalAdvice":
    "Die Hinweise von Zeitavo unterstützen bei der Einhaltung des Arbeitszeitrechts, ersetzen aber keine Rechtsberatung.",
  "signup.submit": "Registrieren",
  "signup.checking": "Wird geprüft …",
  "signup.unavailable":
    "Die Registrierung ist gerade nicht möglich. Bitte versuchen Sie es später erneut.",
  "signup.checkEmail":
    "Fast geschafft: Wir haben eine E-Mail an {email} gesendet. Bestätigen Sie die Registrierung über den Link darin.",
  "signup.verifyTitle": "Registrierung bestätigen",
  "signup.tokenMissing": "Der Link ist unvollständig. Öffnen Sie ihn bitte direkt aus der E-Mail.",
  "signup.verified":
    "Ihre Registrierung ist bestätigt. Sie erhalten gleich eine zweite E-Mail, um Ihr Passwort festzulegen; danach können Sie sich anmelden.",
  "specialRegimes.title": "Spezialbranchen und Sonderregime",
  "specialRegimes.intro":
    "Zeitavo prüft die Regeln des allgemeinen Arbeitszeitrechts. Für die folgenden Branchen und Gruppen gelten eigene Regeln, die Zeitavo nicht oder nur teilweise prüft. Wählen Sie aus, was Ihren Betrieb betrifft. Die Einhaltung des Arbeitszeitrechts bleibt Aufgabe des Arbeitgebers.",
  "specialRegimes.registerVersion":
    "Stand der Übersicht: Fassung {version}, zuletzt überprüft am {date}.",
  "specialRegimes.pending":
    "{title}: kein geltendes Recht; Gesetzgebungsstand zuletzt geprüft am {date}.",
  "specialRegimes.status.Supported": "Vollständig geprüft",
  "specialRegimes.status.PartiallySupported": "Teilweise geprüft",
  "specialRegimes.status.OutOfScope": "Nicht geprüft",
  "specialRegimes.scope": "Gilt für: {scope}",
  "specialRegimes.checked": "Geprüft: {rules}",
  "specialRegimes.unchecked": "Nicht geprüft:",
  "specialRegimes.sources": "Rechtsquellen",
  "specialRegimes.sourceCheckedOn": "geprüft am {date}",
  "specialRegimes.sourceUnverified": "Fundstelle noch nicht am amtlichen Text geprüft",
  "specialRegimes.select": "Betrifft unseren Betrieb",
  "specialRegimes.acknowledgePartially":
    "Zur Kenntnis genommen: Zeitavo prüft die oben als nicht geprüft genannten Regeln nicht.",
  "specialRegimes.acknowledgeOutOfScope":
    "Zur Kenntnis genommen: Zeitavo prüft die Regeln dieses Sonderregimes nicht; Hinweise der allgemeinen Prüfungen können für diese Gruppe abweichen.",
  "specialRegimes.reconfirm":
    "Der Prüfumfang hat sich seit Ihrer Bestätigung geändert (bestätigt: {status}). Bitte bestätigen Sie die Auswahl erneut.",
  "specialRegimes.missingAcknowledgment": "Bitte bestätigen Sie den Prüfumfang für: {names}.",
  "specialRegimes.save": "Auswahl speichern",
  "specialRegimes.saved": "Die Auswahl ist gespeichert.",
  "specialRegimes.setupHint":
    "Zeitavo prüft die Regeln des allgemeinen Arbeitszeitrechts. Für einige Branchen und Gruppen gelten eigene Regeln, die Zeitavo nicht oder nur teilweise prüft:",
  "specialRegimes.setupAction":
    "Die Mandanten-Administration hält unter „Mandant“ fest, welche davon Ihren Betrieb betreffen.",
  "specialRegimes.openTenant": "Sonderregime auswählen",
  "times.projects": "Projekte: {list}",
  "times.projectShare": "{project} {duration} h",
  "times.unattributed": "ohne Projekt",
  "times.projectsLocked": "Projektzeitraum gesperrt",
  "times.attribute": "Projekte zuordnen",
  "times.attributeNamed": "Projekte zuordnen für {date}",
  "times.requests": "Anträge zur Projektzuordnung",
  "dayOverview.lockedSegment": "Gesperrt",
  "dayOverview.request": "Änderung beantragen",
  "dayOverview.requestNamed": "Änderung beantragen für {range}",
  "pastDay.sending": "Zuordnung wird übertragen …",
  "pastDay.rejected": "Die Zuordnung {from}–{to} zu {project} wurde nicht übernommen.",
  "pastDay.savedOffline":
    "Zuordnung auf diesem Gerät gespeichert. Sie wird übertragen, sobald eine Verbindung besteht.",
  "pastDay.locked":
    "Dieser Tag liegt in einem gesperrten Projektzeitraum. Zeiten gesperrter Projekte können Sie nur per Antrag an die Projektverantwortung ändern:",
  "pastDay.lock": "{project}: {from} bis {to} ({reason})",
  "pastDay.lockAll": "Alle Projekte",
  "pastDay.noProjects":
    "An diesem Tag stehen Ihnen keine Projekte zur Auswahl. Die Arbeitszeit bleibt ohne Projekt; Projekte vergibt die Projektverwaltung.",
  "pastDay.requestSubject": "{date}, {from}–{to}",
  "attributionRequest.title": "Änderung beantragen",
  "attributionRequest.explanation":
    "Der Projektzeitraum ist gesperrt, zum Beispiel weil er bereits abgerechnet wurde. Die Projektverantwortung entscheidet über Ihren Antrag; erst nach der Genehmigung ändert sich die Zuordnung. Ihre Arbeitszeit bleibt in jedem Fall unverändert.",
  "attributionRequest.project": "Gewünschtes Projekt",
  "attributionRequest.fixedProject": "Gewünschtes Projekt: {project}",
  "attributionRequest.reason": "Begründung",
  "attributionRequest.reasonHint":
    "Pflichtangabe, höchstens {max} Zeichen, zum Beispiel: Zeit versehentlich dem falschen Projekt zugeordnet.",
  "attributionRequest.reason.required": "Bitte geben Sie eine Begründung an.",
  "attributionRequest.reason.tooLong": "Die Begründung ist zu lang.",
  "attributionRequest.offline":
    "Anträge brauchen eine Internetverbindung. Bitte stellen Sie den Antrag, sobald Sie wieder online sind.",
  "attributionRequest.submit": "Antrag stellen",
  "attributionRequest.sent":
    "Antrag gestellt. Die Projektverantwortung entscheidet darüber; den Stand sehen Sie in „Meine Zeiten“ beim betreffenden Tag.",
  "attributionRequests.title": "Anträge auf Änderung",
  "attributionRequests.none":
    "Keine offenen Anträge. Anträge entstehen, wenn Beschäftigte Zeiten in einem gesperrten Projektzeitraum ändern möchten; Sie entscheiden dann hier darüber.",
  "attributionRequests.offline":
    "Entscheidungen brauchen eine Internetverbindung. Sie sind wieder möglich, sobald Sie online sind.",
  "attributionRequests.status.Pending": "Offen",
  "attributionRequests.status.Approved": "Genehmigt",
  "attributionRequests.status.Rejected": "Abgelehnt",
  "attributionRequests.subject": "{date}, {time} → {project}",
  "attributionRequests.from": "ab {from}",
  "attributionRequests.removal": "Kein Projekt (Zuordnung entfernen)",
  "attributionRequests.employee": "Person: {employee}",
  "attributionRequests.unknownEmployee": "Unbekannte Person",
  "attributionRequests.reason": "Begründung: {reason}",
  "attributionRequests.requestedAt": "Beantragt am {time}",
  "attributionRequests.decisionNote": "Notiz zur Entscheidung: {note}",
  "attributionRequests.note": "Notiz",
  "attributionRequests.noteHint": "Bei einer Ablehnung Pflicht; die Person sieht die Notiz.",
  "attributionRequests.noteRequired": "Bitte begründen Sie die Ablehnung in der Notiz.",
  "attributionRequests.approve": "Genehmigen",
  "attributionRequests.reject": "Ablehnen",
  "attributionRequests.confirm.approve":
    "Antrag genehmigen? Die Zuordnung wird trotz Sperre gespeichert und ändert die Projektzeiten im gesperrten Zeitraum.",
  "attributionRequests.confirm.reject": "Antrag ablehnen? Die Zuordnung bleibt unverändert.",
  "attributionRequests.confirmAction.approve": "Ja, genehmigen",
  "attributionRequests.confirmAction.reject": "Ja, ablehnen",
  "attributionRequests.approved": "Antrag genehmigt.",
  "attributionRequests.rejected": "Antrag abgelehnt.",
  "rejectedAttributions.title": "Abgelehnte Projektzuordnungen",
  "rejectedAttributions.switch": "Projektwechsel am {time} zu {project}",
  "rejectedAttributions.range": "{date}, {from}–{to}: {project}",
  "rejectedAttributions.locked":
    "Der Projektzeitraum ist gesperrt. Sie können die Änderung bei der Projektverantwortung beantragen.",
  "rejectedAttributions.reason":
    "Die Zuordnung wurde nicht übernommen ({code}). Ihre Arbeitszeit ist davon nicht betroffen.",
  "rejectedAttributions.dismiss": "Verwerfen",
  // UX WP-2: shared feedback components, error codes and names (ux-review.md).
  "error.code": "Fehlercode {code}",
  "error.withCode": "{message} (Fehlercode {code})",
  "error.retry": "Erneut versuchen",
  "error.retrying": "Wird erneut versucht …",
  "error.hint.offline":
    "Stempeln funktioniert auch ohne Verbindung; die Stempelungen werden später übertragen. Diese Daten werden geladen, sobald die Verbindung wieder besteht.",
  "error.hint.permission":
    "Wenn Sie diesen Zugriff brauchen, wenden Sie sich an die Personalabteilung oder die Mandanten-Administration.",
  "error.hint.server":
    "Das liegt nicht an Ihren Eingaben. Bitte versuchen Sie es in einigen Minuten erneut; bleibt der Fehler bestehen, nennen Sie der Administration den Fehlercode.",
  "error.TT-1001":
    "Diese Stempelung passt nicht zum aktuellen Stand, zum Beispiel „Gehen“ ohne „Kommen“. Bitte laden Sie die Seite neu und prüfen Sie Ihren Stand.",
  "error.TT-1002":
    "Sie sind bereits eingestempelt. Ein neuer Arbeitstag beginnt erst nach „Gehen“.",
  "error.TT-1003":
    "Der Zeitpunkt liegt in der Zukunft. Bitte prüfen Sie Datum und Uhrzeit Ihres Geräts.",
  "error.TT-1004":
    "Nachträgliche Änderungen an Stempelungen sind nur über einen Korrekturantrag möglich.",
  "error.TT-1005":
    "Die Zeitzone ist unbekannt. Bitte geben Sie eine IANA-Zeitzone an, zum Beispiel Europe/Berlin.",
  "error.TT-1006": "Eine Pflichtangabe fehlt. Bitte füllen Sie alle Pflichtfelder aus.",
  "error.TT-1007": "Der Zeitraum ist ungültig: Das Ende darf nicht vor dem Beginn liegen.",
  "error.TT-1008": "Der Zeitraum überschneidet sich mit einem bereits erfassten Zeitraum.",
  "error.TT-1009":
    "Diese Änderung ist im aktuellen Status nicht möglich, zum Beispiel weil bereits entschieden wurde. Bitte laden Sie die Seite neu.",
  "error.TT-1010":
    "Der Monat ist bereits abgeschlossen. Änderungen sind nur noch über einen Korrekturantrag möglich.",
  "error.TT-1012": "Dieser Eintrag ist bereits vorhanden.",
  "error.TT-1013": "Ein Wert ist ungültig. Bitte prüfen Sie Ihre Eingaben.",
  "error.TT-1014":
    "Die Stempelung ist älter als 7 Tage. Bitte tragen Sie sie über einen Korrekturantrag nach.",
  "error.TT-1015":
    "Über diese Fassung kann nicht entschieden werden, zum Beispiel weil sie noch nicht gilt oder bereits angenommen ist. Bitte laden Sie die Seite neu.",
  "error.TT-1019": "Die Art der Pause kann nur beim Beginn einer Pause angegeben werden.",
  "error.TT-1030": "Dieses Sonderregime ist nicht bekannt. Bitte laden Sie die Seite neu.",
  "error.TT-1031":
    "Der Prüfumfang eines ausgewählten Sonderregimes hat sich geändert. Bitte bestätigen Sie ihn erneut.",
  "error.TT-1040":
    "Die Zeit liegt nicht vollständig in der gestempelten Arbeitszeit. Korrigieren Sie zuerst die Stempelzeiten.",
  "error.TT-1045":
    "Eine Beschäftigung kann nicht zugleich zum Straßentransport (§ 21a ArbZG) gehören und vom ArbZG ausgenommen sein (§ 18 ArbZG).",
  "error.TT-1050":
    "Der Urlaubsanspruch liegt unter dem gesetzlichen Mindesturlaub (§ 3 BUrlG, für Jugendliche § 19 JArbSchG).",
  "error.TT-1051": "Urlaubstage sind in ganzen oder halben Tagen anzugeben.",
  "error.TT-1052": "Diese Buchung ist schon aufgehoben oder selbst eine Gegenbuchung.",
  "error.TT-1053":
    "Für dieses Urlaubsjahr und diesen Teil gibt es schon einen Anfangsbestand oder schon im Vorsystem genommene Tage. Heben Sie die Buchung zuerst mit einer Gegenbuchung auf.",
  "error.TT-1054": "Für diesen Zeitraum gibt es keine gesetzlichen Urlaubsregeln im System.",
  "error.TT-1060":
    "Für dieses Jahr gibt es kein Urlaubskonto: Die Urlaubsregeln sind noch nicht gespeichert, das Urlaubskonto der Person beginnt erst später, oder das Jahr liegt außerhalb der Urlaubsjahre 2000 bis 2100.",
  "error.TT-1100":
    "Abgeltung und Anrechnung eines Vorarbeitgebers nennen den ersten Tag ihres Arbeitsverhältnisses, andere Buchungen keinen.",
  "error.TT-1101":
    "Urlaub eines Vorarbeitgebers wird nur für das Urlaubsjahr des Eintritts angerechnet.",
  "error.TT-1102": "An diesem Tag beginnt kein Arbeitsverhältnis der Person.",
  "error.TT-1103":
    "Das Arbeitsverhältnis hat noch kein Ende. Beenden Sie zuerst die Beschäftigung.",
  "error.TT-1104":
    "Die gebuchten Tage von Vorarbeitgebern lägen über einem vollen Jahresurlaub hier. Buchen Sie höchstens einen vollen Jahresurlaub, auch wenn die Bescheinigung mehr nennt; mehr mindert den Anspruch nicht weiter (§ 6 Abs. 1 BUrlG).",
  "error.TT-1105": "Für dieses Arbeitsverhältnis ist kein Urlaub mehr abzugelten.",
  "error.TT-1107": "Das gewählte Arbeitsverhältnis liegt nicht im Urlaubsjahr der Buchung.",
  "error.TT-1106":
    "Es gibt noch offene Urlaubsanträge im Arbeitsverhältnis. Entscheiden Sie sie vor der Abgeltung.",
  "error.TT-1410":
    "Eine Beschäftigung als Bundesbeamtin oder Bundesbeamter (AZV) kann nicht geringfügig, Leiharbeit oder Straßentransport (§ 21a ArbZG) sein und keine Vereinfachung der Aufzeichnung nach MiLoG oder AEntG haben.",
  "error.TT-1411":
    "Die Löschfrist für Bundesbeamtinnen und Bundesbeamte liegt außerhalb der Grenzen von § 7 Abs. 7 AZV: mindestens 3 Monate, höchstens 6 Monate nach dem Abrechnungszeitraum oder 13 Monate nach dem Erhebungsmonat; ein Abrechnungszeitraum hat 1, 2, 3, 4, 6 oder 12 Monate.",
  "error.TT-1460":
    "Die Gleittage für Bundesbeamtinnen und Bundesbeamte liegen außerhalb von § 7 Abs. 5 AZV: 0 bis 24 je Jahr.",
  "error.TT-1461": "Eine Kappung nach § 7 Abs. 4 AZV wird nur auf dem Gleitzeitkonto gebucht.",
  "error.TT-3680":
    "Der Stichtag liegt außerhalb der berechneten Zeit: frühestens 01.01.2000, höchstens ein Jahr nach heute.",
  "error.TT-3681":
    "Eine Kappung nach § 7 Abs. 4 AZV setzt eine Beschäftigung als Bundesbeamtin oder Bundesbeamter im Buchungsmonat voraus.",
  "error.TT-3682":
    "Eine Kappung nach § 7 Abs. 4 AZV wird im ersten Monat des Abrechnungszeitraums gebucht.",
  "error.TT-3683":
    "Die Zeiten dieses Monats sind nach § 7 Abs. 7 AZV gelöscht; eine Buchung in diesem Monat zählt nicht.",
  "error.TT-2001": "Die Werte sind ungültig. Bitte prüfen Sie die Parameter.",
  "error.TT-2002":
    "Dieser Parameter darf nicht geändert werden; änderbar sind nur die freigegebenen Parameter.",
  "error.TT-2003": "Für dieses Datum gibt es kein gültiges Regelprofil.",
  "error.TT-2011":
    "Diese Aufzeichnungsregel kann noch nicht bestätigt werden: Für den Zeitraum gilt keine Fassung oder die Schwellenwerte fehlen.",
  "error.TT-2013":
    "Die Norm erlaubt diese Abweichung nicht. Bitte prüfen Sie Rechtsgrundlage, Geltungsbereich, Zeitraum und Parameter.",
  "error.TT-2014":
    "Verschärfungen dürfen Werte nur verschärfen. Für eine Lockerung erfassen Sie eine rechtliche Abweichung.",
  "error.TT-2015": "Diese Norm gibt es nicht oder sie gilt nicht für den ganzen Zeitraum.",
  "error.TT-2025":
    "Schutz- und Sonderprofile gelten automatisch und können nicht zugewiesen werden.",
  "error.TT-3003": "Sie sind für diese Person nicht zuständig.",
  "error.TT-3005": "Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "error.TT-3006": "Diese beschäftigte Person gibt es nicht.",
  "error.TT-3007": "Eigene Anträge entscheidet eine andere Person.",
  "error.TT-3008": "Der Korrekturantrag ist nicht vorhanden oder für Sie nicht sichtbar.",
  "error.TT-3009":
    "Dieser Wert wird bereits verwendet, zum Beispiel eine Personalnummer oder ein Name.",
  "error.TT-3010": "Ein verknüpfter Eintrag ist nicht vorhanden. Bitte laden Sie die Seite neu.",
  "error.TT-3011": "Der Verstoß ist nicht vorhanden oder für Sie nicht sichtbar.",
  "error.TT-3012": "Benachrichtigungen sind auf dem Server nicht eingerichtet.",
  "error.TT-3013":
    "Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es dann erneut.",
  "error.TT-3014": "Die gesendeten Daten sind zu groß.",
  "error.TT-3016":
    "Die E-Mail-Adresse gehört bereits zu einem Konto. Bitte verwenden Sie eine andere Adresse.",
  "error.TT-3017":
    "Der Mandant braucht an diesem Tag mindestens eine Person mit der Rolle Mandantenverwaltung. Vergeben Sie die Rolle zuerst an eine andere Person.",
  "error.TT-3018":
    "Dieser Arbeitgeber ist für Ihr Konto nicht verfügbar. Bitte wählen Sie den Arbeitgeber erneut.",
  "error.TT-3021":
    "Ihr Konto wurde von Ihrem Arbeitgeber deaktiviert. Bitte wenden Sie sich an die Personalabteilung.",
  "error.TT-3023":
    "Der Notfallzugriff kann in seinem aktuellen Zustand nicht geändert werden. Bitte laden Sie die Seite neu.",
  "error.TT-3024": "Im Notfallzugriff können Daten nur gelesen werden.",
  "error.TT-3030":
    "Die Daten Ihres Unternehmens werden gerade umgezogen. Bitte senden Sie die Änderung in einigen Minuten erneut.",
  "error.TT-3035":
    "Der Projektzeitraum ist gesperrt. Bitte wenden Sie sich an die Projektverantwortung.",
  "error.TT-3037": "Dieses Projekt ist an diesem Tag nicht wählbar.",
  "error.TT-1260": "Diese Nummer bzw. dieses Kürzel steht schon in einer früheren Zeile der Datei.",
  "error.TT-1261": "Die Datei enthält Fehler. Es wurde nichts gespeichert.",
  "error.TT-3320": "Diese Tätigkeit ist archiviert oder für das Projekt nicht erlaubt.",
  "error.TT-3321": "Dieser Kunde ist archiviert. Reaktivieren Sie ihn zuerst.",
  "error.TT-3322": "Diese Tätigkeit ist archiviert. Reaktivieren Sie sie zuerst.",
  "error.TT-1280":
    "Das Projekt hat schon so viele laufende Budgets, wie der Mandant erlaubt. Beenden oder entfernen Sie zuerst ein Budget.",
  "error.TT-3340":
    "Diese Tätigkeit ist archiviert oder für das Projekt nicht erlaubt; ein Budget braucht eine wählbare Tätigkeit.",
  "error.TT-1290": "Ein Stundensatz gilt nur zwischen 2000 und 2100.",
  "error.TT-1291":
    "Der Zeitraum überschneidet sich mit einem anderen Satz für dasselbe. Beenden Sie den bisherigen Satz zuerst.",
  "error.TT-1292":
    "Der Satz passt nicht zu seinem Geltungsbereich: Wählen Sie Projekt und Tätigkeit passend zur Auswahl.",
  "error.TT-3350":
    "Stundensätze und Beträge sind für Projektverantwortliche nicht freigegeben. Wenden Sie sich an HR.",
  "error.TT-3360":
    "Krankheit und Reha können nicht über die öffentliche API beantragt werden; die Person meldet sie oder HR erfasst sie in Zeitavo.",
  "error.TT-1281": "Ein Budget gilt nur zwischen 2000 und 2100.",
  "error.TT-1282": "Die Warnschwellen liegen außerhalb der Grenzen des Mandanten.",
  "error.TT-1283": "Das Budget ist kleiner als die Grenze des Mandanten.",
  "error.TT-1284": "Die Gültigkeit ist kürzer als die Grenze des Mandanten.",
  "error.TT-3323":
    "Kein Projekt ohne Kunden trägt diese Kundenreferenz mehr. Bitte die Vorschläge neu laden.",
  "error.TT-3038": "Projektzeiten je Person sind ausgeschaltet oder für Sie nicht freigegeben.",
  "error.TT-3040": "Der Auftragsverarbeitungsvertrag, der heute gilt, ist noch nicht angenommen.",
  "error.TT-3041":
    "Die Sicherheitsprüfung ist fehlgeschlagen. Bitte laden Sie die Seite neu und senden Sie das Formular erneut.",
  "error.TT-3042":
    "Inzwischen gelten neue Fassungen der Vertragsdokumente. Bitte laden Sie die Seite neu und bestätigen Sie sie erneut.",
  "error.TT-3043":
    "Der Bestätigungslink ist unbekannt oder abgelaufen. Bitte registrieren Sie sich erneut.",
  "error.TT-3044":
    "Dieses Unternehmen ist bereits registriert. Bitte wenden Sie sich an die Administration Ihres Unternehmens.",
  "error.TT-3046":
    "Dieser Schritt ergibt sich aus den Daten und kann nicht von Hand bestätigt werden.",
  "error.TT-3047": "Diese Vorlage gibt es nicht. Bitte laden Sie die Seite neu.",
  "error.TT-3048":
    "Die E-Mail-Adresse gehört bereits zum Konto einer anderen beschäftigten Person.",
  "error.TT-3180":
    "Diese Einladung kann nicht automatisch mit einem Konto verbunden werden. Bitte wenden Sie sich an den Support.",
  "error.TT-3049":
    "Einige Angaben sind fehlerhaft; es wurde nichts gespeichert. Bitte prüfen Sie die Fehler je Zeile.",
  "error.TT-3050": "Bitte hinterlegen Sie zuerst die Rechnungsdaten.",
  "error.TT-3051": "Dieser Tarif kann nicht online gebucht werden.",
  "error.TT-3052":
    "Es gibt bereits ein Abo. Den Tarif wechseln Sie unter „Tarif wechseln“, die Zahlungsart über „Zahlungsart verwalten oder kündigen“.",
  "error.TT-3471": "Es gibt kein laufendes Abo, dessen Tarif gewechselt werden könnte.",
  "error.TT-3472": "Das Abo hat diesen Tarif bereits.",
  "error.TT-3053": "Es ist noch kein Abo abgeschlossen.",
  "error.TT-3470":
    "Ihr Tarif wird nach Vereinbarung abgerechnet; ein Abo kann nicht online abgeschlossen werden. Änderungen vereinbaren Sie mit dem Anbieter.",
  "error.TT-3055": "Rechnungen können in dieser Installation nicht ausgestellt werden.",
  "error.TT-3058":
    "Der Export wird noch erstellt oder ist fehlgeschlagen. Bitte warten Sie, bis er fertig ist, oder fordern Sie einen neuen an.",
  "error.TT-3059": "Der Export ist abgelaufen und gelöscht. Bitte fordern Sie einen neuen an.",
  "error.TT-3060":
    "Der Vertrag ist beendet. Anmelden können sich nur noch Mandantenverwaltung, Personalabteilung und Abrechnung, um Daten zu lesen und zu exportieren.",
  "error.TT-3064":
    "Der DATEV-Export ist noch nicht eingerichtet: Beraternummer, Mandantennummer und mindestens eine Lohnart fehlen.",
  "error.TT-3065":
    "Einige Personalnummern kann DATEV nicht übernehmen (nur Ziffern, 1 bis 99999, jede nur einmal). Ändern Sie sie in den Stammdaten; es wurde nichts exportiert.",
  "error.TT-3066": "Im gewählten Monat gibt es nichts an DATEV zu übertragen.",
  "error.TT-3070": "Urlaubsregeln können frühestens ab dem 1. Januar des laufenden Jahres gelten.",
  "error.TT-3071":
    "Im Gültigkeitszeitraum hat die Person keine Beschäftigung. Erfassen Sie zuerst die Beschäftigung.",
  "error.TT-3072":
    "Diese Art von Buchung entsteht in ihrem eigenen Ablauf und kann hier nicht erfasst werden.",
  "error.TT-3073": "Die Datei enthält Fehler; es wurde nichts gebucht.",
  "error.TT-3074":
    "Diese Änderung verschlechtert Urlaubsregeln oder Urlaubskonten für vergangene Zeiträume. Lassen Sie geänderte Regeln frühestens heute gelten; den Beginn der Urlaubskonten und Übernahmen können Sie nicht hinter Jahre mit Urlaubsdaten legen.",
  "error.TT-3075":
    "Die Urlaubskonten können nur im Vorjahr, im laufenden oder im nächsten Jahr beginnen, vor dem laufenden Jahr nur, solange es keine Urlaubsdaten gibt. Übernahmen aus dem Vorsystem sind erst nach dem Speichern der Urlaubsregeln und nur für Jahre ab „Urlaubskonto ab“ möglich.",
  "error.TT-3076":
    "Ein Anfangsbestand gilt nur für das erste Jahr des Urlaubskontos der Person, weil er den Urlaub aller Vorjahre überträgt. Für ein früheres Jahr heben Sie den späteren Anfangsbestand zuerst mit einer Gegenbuchung auf.",
  "error.TT-5001":
    "Der Anmeldedienst hat die Anfrage abgelehnt oder nicht beantwortet. Bitte versuchen Sie es später erneut.",
  "error.TT-5002":
    "Der Vorgang wurde unterbrochen. Bitte wiederholen Sie ihn, um ihn abzuschließen.",
  "error.TT-5003":
    "Die Registrierung ist gerade nicht möglich. Bitte versuchen Sie es später erneut.",
  "error.TT-5004":
    "Diese Installation wird ohne Betreiber betrieben; die Funktion gibt es hier nicht.",
  "error.TT-5005": "Ein Abo kann in dieser Installation nicht online abgeschlossen werden.",
  "error.TT-5006":
    "Der Zahlungsdienstleister hat nicht geantwortet. Bitte versuchen Sie es später erneut.",
  "error.TT-5007":
    "Die USt-IdNr. konnte gerade nicht geprüft werden und bleibt vorerst unbestätigt. Bitte versuchen Sie es später erneut.",
  "error.TT-5008": "E-Mails können nicht versendet werden, weil kein Mailserver eingerichtet ist.",
  "error.TT-5010":
    "Die Datenbank antwortet gerade nicht. Bitte versuchen Sie es in etwa 30 Sekunden erneut.",
  "field.optional": "(optional)",
  "form.errorSummary.one": "1 Problem – bitte prüfen Sie diese Angabe:",
  "form.errorSummary.other": "{count} Probleme – bitte prüfen Sie diese Angaben:",
  "form.problem": "{label}: {message}",
  "form.error.missing": "Bitte füllen Sie dieses Feld aus.",
  "form.error.missingNumber": "Bitte geben Sie eine Zahl ein.",
  "form.error.missingDate": "Bitte geben Sie ein Datum ein.",
  "form.error.missingMonth": "Bitte geben Sie einen Monat ein.",
  "form.error.missingTime": "Bitte geben Sie eine Uhrzeit ein.",
  "form.error.missingChoice": "Bitte wählen Sie einen Eintrag aus.",
  "form.error.missingCheckbox": "Bitte setzen Sie dieses Häkchen, um fortzufahren.",
  "form.error.missingFile": "Bitte wählen Sie eine Datei aus.",
  "form.error.number": "Bitte geben Sie eine gültige Zahl ein.",
  "form.error.incompleteDate": "Bitte geben Sie ein vollständiges Datum ein.",
  "form.error.incompleteTime": "Bitte geben Sie eine vollständige Uhrzeit ein.",
  "form.error.email":
    "Bitte geben Sie eine gültige E-Mail-Adresse ein, zum Beispiel name@firma.de.",
  "form.error.url":
    "Bitte geben Sie eine vollständige Webadresse ein, zum Beispiel https://firma.de.",
  "form.error.pattern": "Bitte geben Sie den Wert im Format ein, das beim Feld beschrieben ist.",
  "form.error.digitsOnly": "Bitte geben Sie nur Ziffern ein.",
  "form.error.digitsExactly.one": "Bitte geben Sie genau eine Ziffer ein.",
  "form.error.digitsExactly.other": "Bitte geben Sie genau {count} Ziffern ein.",
  "form.error.digitsBetween": "Bitte geben Sie {min} bis {max} Ziffern ein.",
  "form.error.lettersAndDigitsExactly.one":
    "Bitte geben Sie genau einen Buchstaben oder eine Ziffer ein.",
  "form.error.lettersAndDigitsExactly.other":
    "Bitte geben Sie genau {count} Buchstaben oder Ziffern ein.",
  "form.error.lettersAndDigitsBetween":
    "Bitte geben Sie {min} bis {max} Buchstaben oder Ziffern ein, ohne Leer- oder Sonderzeichen.",
  "form.error.tooShort.one": "Bitte geben Sie mindestens ein Zeichen ein.",
  "form.error.tooShort.other": "Bitte geben Sie mindestens {count} Zeichen ein.",
  "form.error.tooLong.one": "Bitte geben Sie höchstens ein Zeichen ein.",
  "form.error.tooLong.other": "Bitte geben Sie höchstens {count} Zeichen ein.",
  "form.error.min": "Bitte geben Sie mindestens {min} ein.",
  "form.error.max": "Bitte geben Sie höchstens {max} ein.",
  "form.error.earliest": "Bitte wählen Sie frühestens {min}.",
  "form.error.latest": "Bitte wählen Sie spätestens {max}.",
  "form.error.wholeNumber": "Bitte geben Sie eine ganze Zahl ein.",
  "form.error.decimals.one": "Bitte geben Sie höchstens eine Nachkommastelle ein.",
  "form.error.decimals.other": "Bitte geben Sie höchstens {count} Nachkommastellen ein.",
  "form.error.step": "Bitte geben Sie einen Wert in Schritten von {step} ein.",
  "form.error.invalid": "Bitte prüfen Sie diese Angabe.",
  "entitlement.Projects": "Projekte, Teams und Kostenstellen",
  "entitlement.DatevExport": "DATEV-Lohnexport",
  "entitlement.PublicApi": "Öffentliche API und Webhooks",
  "entitlement.MultiEstablishment": "Mehrere Betriebe",
  "entitlement.Sso": "Single Sign-on und SCIM",
  "entitlement.Silo": "Eigene Datenbank und eigener Schlüssel",
  "entitlement.NfcAndLocation": "NFC und Standort",
  "federalState.BW": "Baden-Württemberg",
  "federalState.BY": "Bayern",
  "federalState.BE": "Berlin",
  "federalState.BB": "Brandenburg",
  "federalState.HB": "Bremen",
  "federalState.HH": "Hamburg",
  "federalState.HE": "Hessen",
  "federalState.MV": "Mecklenburg-Vorpommern",
  "federalState.NI": "Niedersachsen",
  "federalState.NW": "Nordrhein-Westfalen",
  "federalState.RP": "Rheinland-Pfalz",
  "federalState.SL": "Saarland",
  "federalState.SN": "Sachsen",
  "federalState.ST": "Sachsen-Anhalt",
  "federalState.SH": "Schleswig-Holstein",
  "federalState.TH": "Thüringen",
  // UX WP-3: employee screens (ux-review.md).
  "times.previous.day": "Voriger Tag",
  "times.previous.week": "Vorige Woche",
  "times.previous.month": "Voriger Monat",
  "times.next.day": "Nächster Tag",
  "times.next.week": "Nächste Woche",
  "times.next.month": "Nächster Monat",
  "times.emptyClockIn": "Jetzt einstempeln",
  "times.emptyCorrection": "Fehlende Zeiten nachtragen",
  "times.emptyRunningShift":
    "Sie sind eingestempelt. Ihre laufende Schicht hat am {date} begonnen und zählt zu diesem Arbeitstag.",
  "times.toRunningShift": "Laufende Schicht anzeigen",
  "corrections.noteHint": "Bei einer Ablehnung Pflicht; die beantragende Person sieht die Notiz.",
  "corrections.errorSummary": "Der Antrag kann noch nicht gestellt werden:",
  "corrections.noneAction": "Neuen Antrag stellen",
  "corrections.approved": "Antrag genehmigt.",
  "corrections.rejected": "Antrag abgelehnt.",
  "absences.item.one": "{kind}: {from} – {to} ({count} Kalendertag)",
  "absences.item.other": "{kind}: {from} – {to} ({count} Kalendertage)",
  "absences.itemHalfDay": "{kind}: {from} (halber Tag)",
  "absences.cancelConsequence":
    "{kind} vom {from} bis {to} wird storniert. Das lässt sich nicht rückgängig machen.",
  "absences.cancelConfirm": "Abwesenheit stornieren",
  "absences.keep": "Behalten",
  "absences.cancelled": "Abwesenheit storniert.",
  "absences.approved": "Abwesenheit genehmigt.",
  "absences.rejected": "Abwesenheit abgelehnt.",
  "absences.overview.open": "Offene Abwesenheitsanträge",
  "absences.overview.upcoming": "Abwesend in den nächsten vier Wochen",
  "absences.overview.noOpen": "Keine offenen Anträge.",
  "absences.overview.noUpcoming": "In den nächsten vier Wochen ist niemand abwesend.",
  "absences.overview.hiddenKind": "Abwesenheit",
  "absences.overview.decidedByHr":
    "Den Grund sieht nur die Personalabteilung; sie entscheidet über den Antrag.",
  "absences.overview.notYours": "Über diesen Antrag entscheidet eine andere berechtigte Person.",
  "absences.overview.unknownPerson": "Unbekannte Person",
  "absences.noneAction": "Abwesenheit beantragen",
  "planning.calendar": "Teamkalender",
  "planning.calendar.hint":
    "Beantragte und genehmigte Abwesenheiten im Monat. Manche Abwesenheiten erscheinen nur als „Abwesend“, ohne Art.",
  "planning.calendar.previous": "Vorheriger Monat",
  "planning.calendar.next": "Nächster Monat",
  "planning.calendar.team": "Team",
  "planning.calendar.allTeams": "Alle Beschäftigten",
  "planning.calendar.person": "Person",
  "planning.calendar.empty": "In diesem Monat sind keine Personen zu sehen.",
  "planning.calendar.absent": "Abwesend",
  "planning.calendar.code.hidden": "A",
  "planning.calendar.shutdown": "Betriebsferien",
  "planning.calendar.legend":
    "Legende: Kürzel der Art (A = abwesend, ohne Angabe der Art), gestrichelt = beantragt, ausgefüllt = genehmigt, markierte Tage = Urlaubssperre.",
  "planning.calendar.blackouts": "Urlaubssperren im Monat",
  "planning.calendar.blackoutDay": "Urlaubssperre",
  "planning.blackout.item": "{from} – {to}: {reason} ({mode})",
  "planning.blackout.mode.Block": "blockiert Anträge",
  "planning.blackout.mode.Warn": "nur Hinweis",
  "planning.blackout.warning":
    "Der Zeitraum liegt in einer Urlaubssperre: {list}. Sie können den Antrag stellen; die entscheidende Person sieht den Hinweis.",
  "planning.blackout.blocked":
    "Der Zeitraum liegt in einer Urlaubssperre, die Anträge blockiert: {list}. Bitte wählen Sie andere Tage oder wenden Sie sich an die Personalabteilung.",
  "planning.substitute": "Vertretung",
  "planning.substitute.none": "Keine Vertretung angeben",
  "planning.substitute.hint": "Wer Sie während der Abwesenheit vertritt.",
  "planning.substituteOf": "Vertretung: {name}",
  "planning.substituteNamed": "Vertretung benannt",
  "planning.rejectionReason": "Begründung der Ablehnung: {reason}",
  "planning.cancellationReason": "Begründung der Stornierung: {reason}",
  "planning.cancel.reason": "Begründung der Stornierung",
  "planning.cancel.reasonHint":
    "Pflichtangabe; die Person sieht die Begründung und wird benachrichtigt.",
  "planning.cancel.consequence":
    "{kind} vom {from} bis {to} wird storniert; die Person erhält Ihre Begründung.",
  "planning.shutdownLabel": "Betriebsferien",
  "planning.cancellationRequested": "Stornierung beantragt",
  "planning.requestCancellation": "Stornierung beantragen",
  "planning.requestCancellation.consequence":
    "{kind} vom {from} bis {to} bleibt genehmigt, bis über die Stornierung entschieden ist.",
  "planning.requestCancellation.confirm": "Stornierung beantragen",
  "planning.cancellationRequestedAnnounce": "Stornierung beantragt.",
  "planning.decide.cancellation": "Stornierung beantragt: Genehmigen storniert die Abwesenheit.",
  "planning.decide.cancellationAfterStart":
    "Stornierung beantragt, die Abwesenheit hat aber schon begonnen: Sie kann nur noch abgelehnt werden. Eine Erkrankung im Urlaub erfasst die Personalverwaltung.",
  "planning.reject.reason": "Begründung der Ablehnung",
  "planning.reject.reasonHint": "Pflichtangabe; die Person sieht die Begründung.",
  "planning.reject.consequence": "Die Person erhält die Ablehnung mit Ihrer Begründung.",
  "planning.reject.confirm": "Ablehnen",
  "planning.reject.missing": "Bitte geben Sie eine Begründung an.",
  "planning.hint.blackout.Block": "Liegt in einer Urlaubssperre, die Anträge blockiert.",
  "planning.hint.blackout.Warn": "Liegt in einer Urlaubssperre (Hinweis).",
  "planning.hint.overlap.one": "Im Zeitraum ist {count} weitere Person aus dem Team abwesend.",
  "planning.hint.overlap.other": "Im Zeitraum sind {count} weitere Personen aus dem Team abwesend.",
  "planning.hint.shortfall": "Am {date} wäre die Mindestbesetzung des Teams unterschritten.",
  "planning.hint.noBlock":
    "Im Jahr ist noch kein zusammenhängender Urlaub von zwölf Werktagen genehmigt (§ 7 Abs. 2 BUrlG).",
  "error.TT-1110": "Urlaub aus Betriebsferien ändert nur die Personalabteilung.",
  "error.TT-1111":
    "Begonnener Urlaub lässt sich nicht mehr per Antrag stornieren. Bei Krankheit im Urlaub wenden Sie sich mit der ärztlichen Bescheinigung an die Personalabteilung.",
  "error.TT-3132":
    "Betriebsferien beginnen frühestens heute; vergangene Tage werden nicht nachträglich gebucht.",
  "error.TT-3150":
    "Urlaub lässt sich nur ab heute beantragen. Urlaub für vergangene Tage trägt die Personalabteilung ein.",
  "error.TT-3130":
    "Der Urlaub liegt in einer Urlaubssperre, die Anträge blockiert. Bitte wählen Sie andere Tage oder wenden Sie sich an die Personalabteilung.",
  "error.TT-3131":
    "Als Vertretung kommen nur Personen aus Ihrem Team, mit derselben Führungskraft oder Ihre Führungskraft infrage.",
  "admin.leavePlanning": "Urlaubsplanung",
  "admin.leavePlanning.open": "Urlaubsplanung: Sperren, Betriebsferien, Mindestbesetzung",
  "admin.leavePlanning.back": "Zurück zu den Abwesenheitsanträgen",
  "admin.leavePlanning.codetermination":
    "Urlaubsgrundsätze, Urlaubssperren und Betriebsferien unterliegen der Mitbestimmung des Betriebsrats (§ 87 Abs. 1 Nr. 5 BetrVG). Legen Sie sie nur so fest, wie eine Betriebsvereinbarung es vorsieht oder wenn kein Betriebsrat besteht. Die Konfigurationsanlage zur Betriebsvereinbarung führt sie auf.",
  "admin.leavePlanning.blackouts": "Urlaubssperren",
  "admin.leavePlanning.blackouts.none": "Keine Urlaubssperren.",
  "admin.leavePlanning.blackout.new": "Urlaubssperre anlegen",
  "admin.leavePlanning.scope": "Gilt für",
  "admin.leavePlanning.scope.Tenant": "Alle Beschäftigten",
  "admin.leavePlanning.scope.Establishment": "Betrieb",
  "admin.leavePlanning.scope.Team": "Team",
  "admin.leavePlanning.scopeTarget": "Betrieb oder Team",
  "admin.leavePlanning.reason": "Grund",
  "admin.leavePlanning.reasonHint": "Wird den betroffenen Beschäftigten angezeigt.",
  "admin.leavePlanning.mode": "Wirkung",
  "admin.leavePlanning.mode.Warn": "Hinweis (Anträge möglich)",
  "admin.leavePlanning.mode.Block": "Blockieren (eigene Anträge abgelehnt)",
  "admin.leavePlanning.save": "Urlaubssperre speichern",
  "admin.leavePlanning.remove": "Entfernen",
  "admin.leavePlanning.remove.consequence": "Die Urlaubssperre vom {from} bis {to} wird entfernt.",
  "admin.leavePlanning.removed": "Urlaubssperre entfernt.",
  "admin.leavePlanning.saved": "Gespeichert.",
  "admin.leavePlanning.required": "Pflichtangabe: bitte ausfüllen.",
  "admin.leavePlanning.shutdowns": "Betriebsferien",
  "admin.leavePlanning.shutdowns.none": "Keine Betriebsferien gebucht.",
  "admin.leavePlanning.shutdown.new": "Betriebsferien buchen",
  "admin.leavePlanning.shutdown.hint":
    "Bucht genehmigten Urlaub ab heute für alle Betroffenen an den freien Tagen des Zeitraums und benachrichtigt sie. Tage mit anderen Abwesenheiten und Elternzeit bleiben unverändert. Wessen Urlaubskonto die Tage nicht deckt oder wer im Zeitraum unter besonderem Schutz steht, wird nicht gebucht und unten aufgeführt; darüber entscheiden Sie einzeln.",
  "admin.leavePlanning.shutdown.book": "Betriebsferien buchen",
  "admin.leavePlanning.shutdown.booked": "Gebucht: {absences} Abwesenheiten für {people} Personen.",
  "admin.leavePlanning.shutdown.notBooked.NotCovered":
    "Nicht gebucht, weil das Urlaubskonto die Tage nicht deckt – bitte als bezahlte Freistellung erfassen oder einzeln entscheiden, sonst entstehen Minusstunden (§ 615 BGB): {names}.",
  "admin.leavePlanning.shutdown.notBooked.CoverageUnknown":
    "Nicht gebucht, weil das Urlaubskonto nicht geprüft werden konnte: {names}.",
  "admin.leavePlanning.shutdown.notBooked.ProtectedPeriod":
    "Nicht gebucht wegen Mutterschutz im Zeitraum – bitte einzeln entscheiden: {names}.",
  "admin.leavePlanning.shutdown.notBooked.IndividualDecision":
    "Nicht gebucht – bitte einzeln entscheiden: {names}.",
  "admin.leavePlanning.shutdown.item": "{from} – {to}, {scope}: {reason}",
  "admin.leavePlanning.shutdown.counts": "{people} Personen, {absences} Abwesenheiten",
  "admin.leavePlanning.shutdown.withdrawn": "Zurückgenommen: {reason}",
  "admin.leavePlanning.shutdown.withdraw": "Zurücknehmen",
  "admin.leavePlanning.shutdown.withdraw.consequence":
    "Noch nicht begonnener Urlaub dieser Betriebsferien wird storniert, die Betroffenen werden benachrichtigt. Bereits begonnener Urlaub bleibt bestehen und wird Ihnen aufgeführt.",
  "admin.leavePlanning.shutdown.withdrawResult.one": "{count} Abwesenheit storniert.",
  "admin.leavePlanning.shutdown.withdrawResult.other": "{count} Abwesenheiten storniert.",
  "admin.leavePlanning.shutdown.kept":
    "Bereits begonnen, bleibt bestehen – bitte mit den Personen klären: {list}.",
  "admin.leavePlanning.shutdown.keptItem": "{name} ({from} – {to})",
  "admin.leavePlanning.shutdown.keptCounts":
    "Bestehen geblieben, weil bereits begonnen: {people} Personen, {absences} Abwesenheiten – bitte mit den Personen klären.",
  "admin.leavePlanning.shutdown.withdraw.reason": "Grund der Rücknahme",
  "admin.leavePlanning.shutdown.withdrawnAnnounce": "Betriebsferien zurückgenommen.",
  "admin.leavePlanning.staffing": "Mindestbesetzung je Team",
  "admin.leavePlanning.staffing.hint":
    "Wie viele Mitglieder mindestens anwesend sein sollen. Beim Entscheiden über Urlaub erscheint eine Warnung, wenn die Besetzung darunter fiele; abgelehnt wird nichts. Leer lassen für keine Mindestbesetzung.",
  "admin.leavePlanning.staffing.none": "Keine Teams angelegt.",
  "admin.leavePlanning.staffing.minimum": "Mindestens anwesend: {team}",
  "admin.leavePlanning.staffing.save": "Mindestbesetzung speichern",
  "admin.leavePlanning.staffing.invalid":
    "Bitte eine ganze Zahl von 1 bis 1000 eingeben oder das Feld leeren.",
  "absences.code.Vacation": "U",
  "absences.code.Sick": "K",
  "absences.code.Holiday": "FT",
  "absences.code.Special": "S",
  "absences.code.Training": "F",
  "absences.code.CompensatoryRest": "E",
  "absences.calendarEntry": "{kind} ({status})",
  "absences.chargedDays.one": "{count} Urlaubstag angerechnet",
  "absences.chargedDays.other": "{count} Urlaubstage angerechnet",
  "absences.holidayEntry": "Feiertag: {name}",
  "absences.legend": "Legende",
  "absences.legend.requested": "Beantragt (gestrichelter Rahmen)",
  "absences.legend.approved": "Genehmigt",
  "absences.legend.weekend": "Wochenende (grau hinterlegt)",
  "absences.holidays": "Feiertage im Monat",
  "absences.holidayItem": "{date}: {name}",
  // UX WP-4: manager and HR screens (ux-review.md).
  "team.approvalsUnavailable": "Offene Korrekturanträge: nicht verfügbar",
  "violations.day": "Tag: {date}",
  "violations.filterSummary": "Filter: {from} – {to} · Status: {status} · Person: {employee}",
  "violations.filterSummary.establishment":
    "Filter: {from} – {to} · Status: {status} · Person: {employee} · Betrieb: {establishment}",
  "violations.employee.unknown": "unbekannte Person",
  "violations.commentHint": "Zum Beispiel, was Sie besprochen oder veranlasst haben.",
  "violations.acknowledgeSave": "Kenntnisnahme speichern",
  "violations.acknowledgedNow": "Kenntnisnahme gespeichert.",
  "violations.noneHint": "Ändern Sie bei Bedarf Zeitraum, Status oder Person im Filter.",
  "violations.acknowledgeFurther": "Weitere Kenntnisnahme",
  "violations.acknowledgedByYou": "Von Ihnen zur Kenntnis genommen.",
  "violations.group.count.one": "{count} Befund",
  "violations.group.count.other": "{count} Befunde",
  "violations.group.state.Open.one": "{count} offen",
  "violations.group.state.Open.other": "{count} offen",
  "violations.group.state.Acknowledged.one": "{count} zur Kenntnis genommen",
  "violations.group.state.Acknowledged.other": "{count} zur Kenntnis genommen",
  "violations.group.state.Resolved.one": "{count} erledigt",
  "violations.group.state.Resolved.other": "{count} erledigt",
  "violations.group.acknowledge.one": "Befund zur Kenntnis nehmen",
  "violations.group.acknowledge.other": "Alle {count} Befunde zur Kenntnis nehmen",
  "violations.group.acknowledgeFirst":
    "Die ersten {count} von {total} Befunden zur Kenntnis nehmen",
  "violations.group.batchHint":
    "Höchstens {count} Befunde werden auf einmal zur Kenntnis genommen; danach bietet die Schaltfläche die nächsten an.",
  "violations.group.acknowledgedNow.one": "Kenntnisnahme für {count} Befund gespeichert.",
  "violations.group.acknowledgedNow.other": "Kenntnisnahme für {count} Befunde gespeichert.",
  "violations.group.details.one": "Einzelnen Befund anzeigen",
  "violations.group.details.other": "Einzelne Befunde anzeigen ({count})",
  "projects.savedNamed": "Projekt {code} gespeichert.",
  "projects.archiveConsequence":
    "{code} wird archiviert: Das Projekt ist danach nicht mehr wählbar, alle bisherigen Zuordnungen bleiben erhalten. Sie können es später reaktivieren.",
  "projects.archiveConfirm": "Projekt archivieren",
  "projects.archivedNamed": "Projekt {code} archiviert.",
  "projects.reactivatedNamed": "Projekt {code} reaktiviert.",
  "projects.noneHint": "Legen Sie mit „Neues Projekt“ das erste Projekt an.",
  "projects.policies.deadline.one": "Frist {count} Arbeitstag",
  "projects.policies.deadline.other": "Frist {count} Arbeitstage",
  "projects.policies.removeNamed": "Richtlinie {scope} entfernen",
  "projects.policies.removeConsequence":
    "Die Richtlinie für {scope} wird entfernt. Dort gilt danach die Richtlinie der nächst allgemeineren Ebene oder keine Pflicht.",
  "projects.policies.removeConfirm": "Richtlinie entfernen",
  "projects.policies.removed": "Richtlinie entfernt.",
  "projects.policies.saved": "Richtlinie gespeichert.",
  "projects.policies.scopeMissing": "Wählen Sie zuerst den Geltungsbereich ({scope}) aus.",
  "admin.externalWork.declaration.item.one": "{from} – {to}: {work} h an {count} Tag",
  "admin.externalWork.declaration.item.other": "{from} – {to}: {work} h an {count} Tagen",
  "admin.recordingObligation.deadline.one":
    "Frist: {count} Kalendertag nach dem Tag der Arbeitsleistung",
  "admin.recordingObligation.deadline.other":
    "Frist: {count} Kalendertage nach dem Tag der Arbeitsleistung",
  "setup.invitation.failedReason": "Der Grund ist nicht bekannt.",
  "setup.invitation.failedNextStep":
    "Prüfen Sie die E-Mail-Adresse in den Stammdaten und senden Sie die Einladung mit „Erneut senden“ noch einmal. Bleibt der Fehler bestehen, nennen Sie der Administration den Fehlercode.",
  "setup.errorUnknown": "Dieser Wert ist ungültig.",
  "admin.documentTitle": "{area} – {page} – {app}",
  "admin.savedNamed": "{name} gespeichert.",
  "admin.editNamed": "{name} bearbeiten",
  "admin.employee.none":
    "Noch keine Beschäftigten. Legen Sie die erste Person mit „Neu anlegen“ an oder importieren Sie mehrere unter „Einrichtung“.",
  "admin.employee.noMatch": "Keine Treffer für „{term}“.",
  "admin.establishment.none":
    "Noch keine Betriebe. Legen Sie mit „Neu anlegen“ den ersten Betrieb an; er bestimmt Zeitzone und Feiertage.",
  "admin.establishment.item": "{name} · {state} · {timeZone}",
  "admin.establishment.timeZoneHint": "IANA-Name, zum Beispiel Europe/Berlin.",
  "admin.model.none":
    "Noch keine Arbeitszeitmodelle. Legen Sie mit „Neu anlegen“ eines an oder übernehmen Sie Vorlagen unter „Einrichtung“.",
  "admin.team.none": "Noch keine Teams. Legen Sie mit „Neues Team“ das erste Team an.",
  "admin.employment.endConsequence":
    "Das Beschäftigungsverhältnis endet mit Ablauf des {date}. Für spätere Tage gilt es nicht mehr.",
  "admin.employment.endConfirm": "Beschäftigung beenden",
  "admin.employment.ended": "Beschäftigung beendet.",
  "admin.consent.revokeNamed": "Widerruf erfassen: {document}",
  "admin.consent.revokeConsequence":
    "Der Widerruf der Einwilligung vom {granted} ({document}) wird mit dem heutigen Datum erfasst; ab heute gelten wieder die gesetzlichen Grenzen. Das lässt sich nicht rückgängig machen.",
  "admin.consent.revokeConfirm": "Widerruf endgültig erfassen",
  "admin.consent.revokedNow": "Widerruf erfasst.",
  "admin.consent.added": "Einwilligung erfasst.",
  "admin.protection.added": "Zeitraum des Mutterschutzes erfasst.",
  "admin.externalWork.period.endConsequence":
    "Der Zeitraum der Mehrfachbeschäftigung endet mit Ablauf des {date}.",
  "admin.externalWork.period.endConfirm": "Zeitraum endgültig beenden",
  "admin.externalWork.period.ended": "Zeitraum beendet.",
  "admin.externalWork.period.added": "Zeitraum erfasst.",
  "admin.externalWork.declaration.withdrawConsequence":
    "Die Angabe {from} – {to} wird zurückgezogen und nicht mehr berücksichtigt. Das lässt sich nicht rückgängig machen; erfassen Sie bei Bedarf eine neue Angabe.",
  "admin.externalWork.declaration.withdrawConfirm": "Angabe endgültig zurückziehen",
  "admin.externalWork.declaration.withdrawnNow": "Angabe zurückgezogen.",
  "admin.externalWork.declaration.added": "Angabe erfasst.",
  "admin.preparation.withdrawConsequence":
    "Der Eintrag vom {date} wird zurückgezogen und nicht mehr berücksichtigt. Das lässt sich nicht rückgängig machen; erfassen Sie bei Bedarf einen neuen Eintrag.",
  "admin.preparation.withdrawConfirm": "Eintrag endgültig zurückziehen",
  "admin.preparation.withdrawnNow": "Eintrag zurückgezogen.",
  "admin.preparation.added": "Zeit kategorisiert.",
  "admin.employee.sections": "Bereiche zu {name}",
  "admin.employee.section.master": "Stammdaten",
  "admin.employee.section.employment": "Beschäftigung",
  "admin.employee.section.protection": "Schutz",
  "admin.employee.section.multiple": "Mehrfachbeschäftigung",
  "admin.employee.section.onCall": "Rufbereitschaft",
  "admin.employee.section.absences": "Abwesenheiten",
  "admin.employee.section.preparation": "Vor- und Nachbereitung",
  "admin.employee.section.leave": "Urlaub",
  "admin.employee.section.timeAccount": "Zeitkonto",
  "admin.leave.entitlements": "Jahresanspruch",
  "admin.leave.entitlements.hint":
    "Der vertragliche Urlaubsanspruch mit Gültigkeit und Quelle. Er darf in keinem Zeitraum unter dem gesetzlichen Mindesturlaub liegen (§ 3 BUrlG, für Jugendliche § 19 JArbSchG); bei einer anderen Zahl von Arbeitstagen je Woche wird er umgerechnet.",
  "admin.leave.accountStart": "Urlaubskonto ab {year}.",
  "admin.leave.accountStart.none":
    "Noch kein Urlaubskonto: Es beginnt, sobald die Urlaubsregeln des Mandanten gespeichert sind und die Person eine Beschäftigung hat.",
  "admin.leave.entitlements.none":
    "Kein eigener Anspruch erfasst. Es gilt der Standard des Mandanten: {days} Tage bei {week} Arbeitstagen je Woche.",
  "admin.leave.default.belowMinimum":
    "Ab {date} gilt für diese Person kein eigener Anspruch, und der Standard des Mandanten liegt unter dem gesetzlichen Minimum ({rule}: mindestens {days} Tage bei {week} Arbeitstagen je Woche). Erfassen Sie einen eigenen Anspruch.",
  "admin.leave.entitlement.item": "{days} Tage bei {week} Arbeitstagen je Woche, {from} – {to}",
  "admin.leave.entitlement.source.Contract": "Arbeitsvertrag",
  "admin.leave.entitlement.source.CollectiveAgreement": "Tarifvertrag",
  "admin.leave.entitlement.source.WorksAgreement": "Betriebsvereinbarung",
  "admin.leave.entitlement.reference": "Fundstelle oder Begründung",
  "admin.leave.entitlement.referenceHint": "Zum Beispiel „Arbeitsvertrag vom 01.01.2026, § 7“.",
  "admin.leave.entitlement.withdrawn": "Zurückgezogen am {date}: {reason}",
  "admin.leave.minimum.caption": "Gesetzliches Minimum je Zeitraum",
  "admin.leave.minimum.period": "Zeitraum",
  "admin.leave.minimum.week": "Arbeitstage je Woche",
  "admin.leave.minimum.noFixedDays":
    "{days} (Bezugswoche des Anspruchs, das Arbeitszeitmodell hat keine festen Arbeitstage)",
  "admin.leave.minimum.rule": "Regel",
  "admin.leave.minimum.minimum": "Minimum (Tage)",
  "admin.leave.minimum.entitled": "Anspruch (Tage)",
  "admin.leave.minimum.met": "erfüllt",
  "admin.leave.minimum.notMet": "unterschritten",
  "admin.leave.entitlement.new": "Neuer Anspruch",
  "admin.leave.entitlement.newHint":
    "Ein neuer Anspruch beendet den bisherigen unbefristeten Anspruch am Vortag.",
  "admin.leave.entitlement.validTo": "Gültig bis",
  "admin.leave.annualDays": "Tage pro Kalenderjahr",
  "admin.leave.annualDaysHint": "In ganzen oder halben Tagen, zum Beispiel 30 oder 27,5.",
  "admin.leave.referenceWeek": "Bezogen auf Arbeitstage je Woche",
  "admin.leave.source": "Quelle",
  "admin.leave.save": "Anspruch erfassen",
  "admin.leave.saved": "Der Anspruch ist erfasst.",
  "admin.leave.withdraw": "Anspruch zurückziehen",
  "admin.leave.withdrawConfirm": "Anspruch endgültig zurückziehen",
  "admin.leave.withdrawConsequence":
    "Der Anspruch gilt danach nicht mehr, bleibt aber mit Ihrer Begründung im Verlauf. Hatte er einen früheren Anspruch beendet, gilt dieser wieder.",
  "admin.leave.withdrawn": "Der Anspruch ist zurückgezogen.",
  "admin.leave.reason": "Begründung",
  "admin.leave.daysInvalid": "Bitte geben Sie eine Zahl in ganzen oder halben Tagen ein.",
  "admin.leave.bookings": "Übernahme aus dem Vorsystem und Korrekturen",
  "admin.leave.bookings.hint":
    "Der Anfangsbestand ist der aus den Vorjahren übertragene Resturlaub zum 1. Januar; „Im Vorsystem genommen“ sind die Tage des Urlaubsjahres, die vor der Umstellung genommen wurden. Buchungen werden nie geändert oder gelöscht; eine falsche Buchung heben Sie mit einer Gegenbuchung auf.",
  "admin.leave.bookings.year": "Urlaubsjahr",
  "admin.leave.bookings.yearInvalid": "Bitte geben Sie ein Jahr von {min} bis {max} ein.",
  "admin.leave.bookings.none": "Keine Buchungen im Urlaubsjahr {year}.",
  "admin.leave.booking.kind.OpeningBalance": "Anfangsbestand",
  "admin.leave.booking.kind.Correction": "Korrektur",
  "admin.leave.booking.kind.PriorEmployerCredit": "Anrechnung des Vorarbeitgebers",
  "admin.leave.booking.kind.ParentalLeaveReduction": "Kürzung wegen Elternzeit",
  "admin.leave.booking.kind.SickDuringLeaveRestore": "Gutschrift für Krankheit im Urlaub",
  "admin.leave.booking.kind.Forfeiture": "Verfall",
  "admin.leave.booking.kind.Payout": "Abgeltung",
  "admin.leave.booking.kind.TakenInPreviousSystem": "Im Vorsystem genommen",
  "admin.leave.part.Statutory": "gesetzlicher Urlaub",
  "admin.leave.part.Extra": "Mehrurlaub",
  "admin.leave.booking.item": "{kind}: {days} Tage, {part} – {reason}",
  "admin.leave.booking.reversed": "Durch eine Gegenbuchung aufgehoben.",
  "admin.leave.booking.reversal": "Gegenbuchung",
  "admin.leave.booking.reverse": "Gegenbuchung erfassen",
  "admin.leave.booking.reverseConfirm": "Buchung aufheben",
  "admin.leave.booking.reverseConsequence":
    "Es wird eine Buchung mit {days} Tagen erfasst; die ursprüngliche Buchung bleibt sichtbar.",
  "admin.leave.booking.reversedDone": "Die Gegenbuchung ist erfasst.",
  "admin.leave.booking.new": "Neue Buchung",
  "admin.leave.booking.relationship": "Arbeitsverhältnis",
  "admin.leave.booking.relationshipHint":
    "Im Jahr einer Wiedereinstellung: zu welchem Arbeitsverhältnis die Buchung gehört. Ohne Auswahl entscheidet das Buchungsdatum.",
  "admin.leave.booking.relationship.byDate": "Nach Buchungsdatum",
  "admin.leave.booking.kind": "Art",
  "admin.leave.booking.days": "Tage",
  "admin.leave.booking.daysHint": "Positiv für eine Gutschrift, negativ für einen Abzug.",
  "admin.leave.booking.daysHintTaken":
    "Die genommenen Tage als positive Zahl; sie werden vom Urlaubskonto abgezogen.",
  "admin.leave.booking.part": "Teil",
  "admin.leave.booking.save": "Buchung erfassen",
  "admin.leave.booking.saved": "Die Buchung ist erfasst.",
  "admin.leave.booking.defaultReason": "Resturlaub aus dem Vorsystem",
  "admin.leave.booking.defaultReasonTaken": "Im Vorsystem genommener Urlaub",
  "admin.leave.exit.title": "Eintritt und Austritt",
  "admin.leave.exit.hint":
    "Je Arbeitsverhältnis: Urlaub, den ein Vorarbeitgeber für das Eintrittsjahr gewährt oder abgegolten hat, wird angerechnet, soweit zusammen mehr als ein voller Jahresurlaub entstünde (§ 6 Abs. 1 BUrlG). Beim Austritt berechnet Zeitavo Teilurlaub (§ 5 BUrlG) und Abgeltung (§ 7 Abs. 4 BUrlG) und erstellt die Urlaubsbescheinigung (§ 6 Abs. 2 BUrlG).",
  "admin.leave.exit.none": "Für diese Person ist keine Beschäftigung erfasst.",
  "admin.leave.exit.since": "Arbeitsverhältnis seit {from}",
  "admin.leave.exit.period": "Arbeitsverhältnis vom {from} bis {to}",
  "admin.leave.exit.openEntitlement":
    "Ein Urlaubsanspruch aus der Zeit vor dieser Wiedereinstellung gilt weiter. Beenden Sie ihn unter „Jahresanspruch“, wenn er nicht mehr zum neuen Vertrag passt.",
  "admin.leave.exit.noEntryAccount":
    "Für das Eintrittsjahr {year} gibt es kein Urlaubskonto; Urlaub eines Vorarbeitgebers lässt sich nicht anrechnen.",
  "admin.leave.exit.credit": "Urlaub des Vorarbeitgebers für {year} anrechnen",
  "admin.leave.exit.credited.total":
    "Laut Bescheinigungen gebucht: {days} Tage, davon angerechnet: {effective} Tage.",
  "admin.leave.exit.credited.rule":
    "Angerechnet wird nur, soweit der Urlaub des Vorarbeitgebers und der Anspruch hier ({entitled} Tage) zusammen einen vollen Jahresurlaub von {fullYear} Tagen übersteigen (§ 6 Abs. 1 BUrlG).",
  "admin.leave.exit.creditDays": "Gewährte oder abgegoltene Tage laut Bescheinigung",
  "admin.leave.exit.creditDaysHint":
    "Nur Urlaub für das Eintrittsjahr {year}, ohne Übertrag aus Vorjahren; höchstens ein voller Jahresurlaub hier, auch wenn die Bescheinigung mehr nennt. In halben Tagen, zum Beispiel 8 oder 7,5.",
  "admin.leave.exit.creditTooMany":
    "Zusammen mit den schon gebuchten Tagen liegt das über einem vollen Jahresurlaub hier von {fullYear} Tagen. Buchen Sie höchstens so viele Tage; mehr mindert den Anspruch nicht weiter.",
  "admin.leave.exit.creditSource": "Quelle (Bescheinigung, Arbeitgeber, Datum)",
  "admin.leave.exit.creditSave": "Anrechnen",
  "admin.leave.exit.credited": "Der Urlaub des Vorarbeitgebers ist angerechnet.",
  "admin.leave.exit.exit": "Austritt am {date}",
  "admin.leave.exit.caption": "Urlaub im Austrittsjahr {year}",
  "admin.leave.exit.year": "Urlaubsjahr",
  "admin.leave.exit.waitingPeriod": "Wartezeit (§ 4 BUrlG)",
  "admin.leave.exit.waitingPeriod.before": "vor dem Urlaubsjahr erfüllt",
  "admin.leave.exit.waitingPeriod.fulfilled": "erfüllt am {date}",
  "admin.leave.exit.waitingPeriod.notFulfilled": "nicht erfüllt (erst am {date})",
  "admin.leave.exit.entitled": "Anspruch",
  "admin.leave.exit.partial": "{days} Tage (Teilurlaub {months}/12, § 5 BUrlG)",
  "admin.leave.exit.carriedOver": "Übertrag aus Vorjahren",
  "admin.leave.exit.netEntitled": "Anspruch nach Anrechnung, wie bescheinigt",
  "admin.leave.exit.notDeducted": "Zuviel eines früheren Arbeitsverhältnisses, nicht verrechnet",
  "admin.leave.exit.withCarryOver": "{days} (davon {carried} aus Vorjahren)",
  "admin.leave.exit.booked": "Buchungen (Korrekturen, Anrechnungen)",
  "admin.leave.exit.granted":
    "Gewährt (genommen und bis zum Austritt geplant, ohne bescheinigte Krankheit im Urlaub)",
  "admin.leave.exit.forfeited": "Verfallen",
  "admin.leave.exit.paidOut": "Abgegolten",
  "admin.leave.exit.openPayout": "Noch abzugelten",
  "admin.leave.exit.openRequests":
    "Offene Urlaubsanträge über {days} Tage: Entscheiden Sie sie, bevor Sie die Abgeltung buchen.",
  "admin.leave.exit.excess":
    "{days} Tage wurden mehr gewährt als zustanden. Sie werden nicht zurückgefordert; späteren Urlaub im selben Jahr mindern sie nur, soweit zusammen mehr als ein voller Jahresurlaub entstünde (§ 5 Abs. 3, § 6 Abs. 1 BUrlG).",
  "admin.leave.exit.overpaid":
    "{days} Tage wurden mehr abgegolten als zustehen, etwa weil der letzte Tag vorverlegt wurde. Heben Sie die Abgeltung unter „Übernahme aus dem Vorsystem und Korrekturen“ mit einer Gegenbuchung auf und buchen Sie sie dann neu.",
  "admin.leave.exit.noExitAccount":
    "Abgeltung und Urlaubsbescheinigung für das Austrittsjahr {year} sind hier nicht möglich. {reason}",
  "admin.leave.exit.payOut": "Abgeltung von {days} Tagen buchen",
  "admin.leave.exit.payOutConsequence":
    "{days} Tage werden als Urlaubsabgeltung zum {date} gebucht und im DATEV-Lohnexport dieses Monats übergeben. Eine falsche Buchung heben Sie mit einer Gegenbuchung auf.",
  "admin.leave.exit.payOutConfirm": "Abgeltung buchen",
  "admin.leave.exit.paidOutDone": "Die Abgeltung ist gebucht.",
  "admin.leave.exit.certificate": "Urlaubsbescheinigung (PDF)",
  "tenant.leave.title": "Urlaubsregeln",
  "tenant.leave.hint":
    "Gelten für alle Beschäftigten ohne eigenen Anspruch. Änderungen gelten ab dem gewählten Tag; Urlaubsgrundsätze sind mitbestimmungspflichtig (§ 87 Abs. 1 Nr. 5 BetrVG).",
  "tenant.leave.default": "Noch keine eigenen Regeln gespeichert; es gelten die Standardwerte.",
  "tenant.leave.since": "Die aktuellen Regeln gelten seit {date}.",
  "tenant.leave.statutory":
    "Gesetzliches Minimum: {days} Werktage bei {week} Werktagen je Woche ({rule}), das sind {fiveDays} Tage bei fünf Arbeitstagen.",
  "tenant.leave.validFrom": "Gültig ab",
  "tenant.leave.validFromHint":
    "Frühestens der 1. Januar des laufenden Jahres; eine Verschlechterung frühestens heute.",
  "tenant.leave.defaultDays": "Standardanspruch (Tage pro Kalenderjahr)",
  "tenant.leave.referenceWeek": "Bezogen auf Arbeitstage je Woche",
  "tenant.leave.accountStart": "Urlaubskonto ab (Urlaubsjahr)",
  "tenant.leave.accountStartHint":
    "Ab diesem Jahr führt Zeitavo Urlaubskonten, bei späterem Eintritt ab dem Eintrittsjahr; frühere Jahre nur mit einer Übernahme aus dem Vorsystem. Bei den ersten Urlaubsregeln sind Vorjahr, laufendes und nächstes Jahr möglich. Ändern lässt sich der Beginn nur innerhalb dieser Jahre und, sobald Urlaubsdaten bestehen, nicht hinter Jahre mit Urlaubsdaten und nicht vor das laufende Jahr.",
  "tenant.leave.accountStartInvalid": "Bitte geben Sie ein Jahr von 2000 bis 2100 ein.",
  "tenant.leave.carryOver": "Übertragener Urlaub ist zu nehmen bis (TT.MM. des Folgejahres)",
  "tenant.leave.carryOverHint": "Gesetzlich bis 31.03.; ein späterer Tag ist möglich.",
  "tenant.leave.carryOverInvalid": "Bitte geben Sie einen Tag als TT.MM. ein, zum Beispiel 31.03.",
  "tenant.leave.halfDays": "Halbe Urlaubstage erlauben",
  "tenant.leave.extraDays": "Mehrurlaub wie gesetzlichen Urlaub behandeln",
  "tenant.leave.extraDaysReference": "Grundlage der Abweichung",
  "tenant.leave.extraDaysReferenceHint":
    "Arbeitsvertrag, Tarifvertrag oder Betriebsvereinbarung mit Fundstelle, nach der Mehrurlaub anders als der gesetzliche Urlaub behandelt wird.",
  "tenant.leave.extraDaysReferenceMissing": "Bitte nennen Sie die Grundlage der Abweichung.",
  "tenant.leave.aboveBalance": "Anträge über dem Urlaubskonto",
  "tenant.leave.aboveBalance.Block": "ablehnen",
  "tenant.leave.aboveBalance.HrApproval": "nur mit Freigabe der Personalabteilung",
  "tenant.leave.daysOff": "Betriebliche freie Tage",
  "tenant.leave.daysOffHint":
    "Tage ohne Arbeitspflicht für alle, die keine gesetzlichen Feiertage sind, zum Beispiel 24.12. und 31.12. als halbe Tage. Sie zählen nicht als Urlaubstage, halbe freie Tage auch dann nicht, wenn halbe Urlaubstage nicht erlaubt sind.",
  "tenant.leave.daysOff.none": "Keine betrieblichen freien Tage.",
  "tenant.leave.dayOff.item": "{date}, {length}",
  "tenant.leave.dayOff.half": "halber Tag",
  "tenant.leave.dayOff.full": "ganzer Tag",
  "tenant.leave.dayOff.everyYear": "Jedes Jahr",
  "tenant.leave.dayOff.halfDay": "Halber Tag",
  "tenant.leave.dayOff.date": "Freier Tag",
  "tenant.leave.dayOff.add": "Tag hinzufügen",
  "tenant.leave.dayOff.remove": "{date} entfernen",
  "tenant.leave.dayOff.duplicate": "Dieser Tag ist schon eingetragen.",
  "tenant.leave.save": "Urlaubsregeln speichern",
  "tenant.leave.saved": "Die Urlaubsregeln sind gespeichert.",
  "setup.leave.title": "Urlaubskonten aus dem Vorsystem übernehmen",
  "setup.leave.hint":
    "Je Person und Urlaubsjahr eine Zeile mit Personalnummer und Urlaubsjahr sowie Resturlaub (aus den Vorjahren übertragener Urlaub zum 1. Januar) und/oder Genommen (Tage des Urlaubsjahres, die vor der Umstellung im Vorsystem genommen wurden), optional Teil (gesetzlich oder Mehrurlaub) und Begründung. Speichern Sie zuerst die Urlaubsregeln: Übernommen werden nur Jahre ab „Urlaubskonto ab“, vom Vorjahr bis zum nächsten Jahr. Resturlaub gibt es je Person nur für das erste Jahr ihres Urlaubskontos, Genommen auch für Folgejahre. Den Jahresanspruch erfassen Sie nicht hier, sondern als Anspruch oder Standard. Prüfen Sie die Datei zuerst; importiert wird nur eine Datei ohne Fehler, dann alle Zeilen.",
  "setup.leave.imported": "Übernommene Zeilen: {count}.",
  "setup.leave.checkOk": "Keine Fehler. Zeilen, die übernommen werden können: {count}.",
  "admin.employee.section.absencesOpen": "Abwesenheiten ({count} offen)",
  "admin.employee.minorUntilShort": "Minderjährig bis",
  "admin.employee.notMinor": "nicht minderjährig",
  "admin.employee.noEmployment":
    "Erfassen Sie zuerst eine Beschäftigung unter „Beschäftigung“; Einwilligungen und Mutterschutz gehören zu ihr.",
  // UX WP-5: tenant administration (ux-review.md).
  "tenant.employerTitle": "Arbeitgeber und Datenschutz",
  "tenant.sections": "Bereiche der Mandantenverwaltung",
  "tenant.section.general": "Allgemein",
  "tenant.section.regimes": "Sonderregime",
  "tenant.section.rules": "Abweichungen",
  "tenant.section.access": "Rollen und Zugänge",
  "tenant.section.support": "Support-Zugriff",
  "tenant.section.contract": "Vertrag und Export",
  "tenant.section.open.one": "{count} offen",
  "tenant.section.open.other": "{count} offen",
  "contacts.saved": "Ansprechpersonen gespeichert.",
  "legal.short.Terms": "AGB",
  "legal.short.Dpa": "AVV",
  "legal.short.Sla": "SLA",
  "legal.short.PrivacyNotice": "Datenschutzhinweise",
  "legal.promptLine.one": "Neue Vertragsfassung zur Prüfung: {documents}.",
  "legal.promptLine.other": "Neue Vertragsfassungen zur Prüfung: {documents}.",
  "legal.review": "Jetzt prüfen",
  "legal.acceptShort": "Annehmen",
  "legal.declineShort": "Ablehnen",
  "legal.acceptConsequence":
    "Mit der Annahme gilt Fassung {version} von „{document}“ ab {day} verbindlich für Ihr Unternehmen.",
  "legal.acceptConfirm": "Verbindlich annehmen",
  "legal.declineConsequence":
    "Sie lehnen Fassung {version} ab. Bis zum Ende Ihres Vertrags gilt weiter Fassung {inForce}.",
  "legal.declineConfirm": "Fassung ablehnen",
  "legal.acceptedAnnounce": "{document}: Fassung {version} angenommen.",
  "legal.declinedAnnounce": "{document}: Fassung {version} abgelehnt.",
  "emergency.approveConsequence.one":
    "{name} darf dann {count} Stunde lang lesend auf die Daten Ihres Unternehmens zugreifen; jeder Zugriff wird im Audit-Log protokolliert.",
  "emergency.approveConsequence.other":
    "{name} darf dann {count} Stunden lang lesend auf die Daten Ihres Unternehmens zugreifen; jeder Zugriff wird im Audit-Log protokolliert.",
  "emergency.approveConfirm": "Zugriff freigeben",
  "emergency.rejectConsequence":
    "{name} erhält keinen Zugriff. Braucht der Support später Zugriff, muss er neu anfragen.",
  "emergency.rejectConfirm": "Anfrage ablehnen",
  "emergency.revokeConsequence":
    "Der Zugriff von {name} endet sofort. Braucht der Support später wieder Zugriff, muss er neu anfragen.",
  "emergency.revokeConfirm": "Zugriff jetzt beenden",
  "emergency.approved": "Zugriff freigegeben.",
  "emergency.rejected": "Anfrage abgelehnt.",
  "emergency.revoked": "Zugriff beendet.",
  "scim.revokeConsequence":
    "Das Identitätssystem mit dem Zugang „{name}“ kann danach keine Beschäftigten mehr anlegen, ändern oder sperren. Der Widerruf lässt sich nicht rückgängig machen.",
  "scim.revokeConfirm": "Endgültig widerrufen",
  "scim.revoked": "Zugang {name} widerrufen.",
  "publicApi.revokeConsequence":
    "{name} kann danach keine Daten mehr abrufen. Der Widerruf lässt sich nicht rückgängig machen.",
  "publicApi.revokeConfirm": "Endgültig widerrufen",
  "publicApi.revoked": "API-Zugang {name} widerrufen.",
  "publicApi.disableConsequence":
    "Der Empfänger erhält danach keine Benachrichtigungen mehr. Ein deaktivierter Webhook lässt sich nicht wieder einschalten; legen Sie bei Bedarf einen neuen an.",
  "publicApi.disableConfirm": "Endgültig deaktivieren",
  "publicApi.disabled": "Webhook {url} deaktiviert.",
  "settings.logoRemoveConsequence":
    "Das Logo verschwindet für alle Beschäftigten aus der Kopfzeile. Sie können jederzeit ein neues hochladen.",
  "settings.logoSaved": "Logo gespeichert.",
  "settings.logoRemoved": "Logo entfernt.",
  "overrides.invalidParameters": "Bitte prüfen Sie die Parameter von Abweichung {number}.",
  "legalDeviations.invalidParameters": "Bitte prüfen Sie die Parameter.",
  "legalDeviations.maxDuration.one": "Höchstens {count} Tag je Eintrag.",
  "legalDeviations.maxDuration.other": "Höchstens {count} Tage je Eintrag.",
  "legalDeviations.justificationHint.one":
    "Mindestens 20 Zeichen, ohne Gesundheitsdaten. Ein Notfall kann höchstens {count} Tag nach seinem Beginn erfasst werden.",
  "legalDeviations.justificationHint.other":
    "Mindestens 20 Zeichen, ohne Gesundheitsdaten. Ein Notfall kann höchstens {count} Tage nach seinem Beginn erfasst werden.",
  "legalDeviations.reasonsHint.one":
    "Mindestens 20 Zeichen, ohne Gesundheitsdaten und ohne Angaben zu einzelnen Personen. Halten Sie die Gründe vor den betroffenen Ruhetagen fest, höchstens {count} Tag nach dem Beginn.",
  "legalDeviations.reasonsHint.other":
    "Mindestens 20 Zeichen, ohne Gesundheitsdaten und ohne Angaben zu einzelnen Personen. Halten Sie die Gründe vor den betroffenen Ruhetagen fest, höchstens {count} Tage nach dem Beginn.",
  "ruleParameters.legend": "Parameter",
  "ruleParameters.intro": "Leere Felder übernehmen den Wert des Regelprofils.",
  "ruleParameters.none": "Für diese Auswahl gibt es keine änderbaren Parameter.",
  "ruleParameters.json": "Parameter (JSON)",
  "ruleParameters.expert": "Als JSON bearbeiten (Expertenansicht)",
  "ruleParameters.unset": "Wert des Regelprofils",
  "ruleParameters.yes": "Ja",
  "ruleParameters.no": "Nein",
  "ruleParameters.hours": "{duration} h",
  "ruleParameters.window": "{start}–{end} Uhr",
  "ruleParameters.durationHint": "Stunden:Minuten, zum Beispiel 9:30.",
  "ruleParameters.percentHint": "Ganze Zahl in Prozent, zum Beispiel 50.",
  "ruleParameters.percent": "{value} %",
  "ruleParameters.range": "Erlaubt: {min} bis {max}.",
  "ruleParameters.windowHint": "Beginn zwischen {earliest} und {latest} Uhr, Dauer {duration}.",
  "ruleParameters.jsonHint": "Wert in JSON-Schreibweise ({name}).",
  "ruleParameters.problem.required": "Bitte geben Sie einen Wert ein.",
  "ruleParameters.problem.duration": "Bitte als Stunden:Minuten eingeben, zum Beispiel 9:30.",
  "ruleParameters.problem.percent": "Bitte eine ganze Zahl eingeben, zum Beispiel 50.",
  "ruleParameters.problem.time": "Bitte eine Uhrzeit wie 22:00 eingeben.",
  "ruleParameters.problem.json": "Das ist kein gültiger JSON-Wert.",
  "ruleParameters.problem.choice": "Bitte wählen Sie einen der angebotenen Werte.",
  "ruleParameters.problem.window": "Der Beginn muss zwischen {earliest} und {latest} Uhr liegen.",
  "ruleParameters.problem.object":
    'Die Parameter müssen ein JSON-Objekt sein, zum Beispiel {"minRestSeconds": 39600}.',
  "ruleParameter.dailyRegularMaxSeconds": "Regelmäßige Höchstarbeitszeit je Tag",
  "ruleParameter.dailyAbsoluteMaxSeconds": "Höchstarbeitszeit je Tag",
  "ruleParameter.weeklyMaxSeconds": "Höchstarbeitszeit je Woche",
  "ruleParameter.averagingPeriod": "Ausgleichszeitraum",
  "ruleParameter.averageCountsAbsenceDays": "Abwesenheitstage im Durchschnitt mitzählen",
  "ruleParameter.minBreakSegmentSeconds": "Mindestlänge eines Pausenabschnitts",
  "ruleParameter.maxContinuousWorkSeconds": "Höchstdauer der Arbeit ohne Pause",
  "ruleParameter.minRestSeconds": "Mindestruhezeit",
  "ruleParameter.reducedMinRestSeconds": "Verkürzte Mindestruhezeit",
  "ruleParameter.restCompensationMinSeconds": "Ruhezeit zum Ausgleich einer Verkürzung",
  "ruleParameter.restCompensationPeriod": "Ausgleichszeitraum für verkürzte Ruhezeiten",
  "ruleParameter.nightWindow": "Nachtzeit",
  "ruleParameter.nightWorkerAveragingPeriod": "Ausgleichszeitraum bei Nachtarbeit",
  "ruleParameter.weeklyAveragingPeriod": "Ausgleichszeitraum der Wochenarbeitszeit",
  "ruleParameter.adjoiningRestSeconds": "Ruhezeit zusammen mit einem Ruhetag",
  "ruleParameter.onCallMaxDeploymentPercent": "Höchstanteil der Einsätze an der Ruhezeit",
  "ruleParameter.onCallCompensationPeriod":
    "Ausgleichszeitraum für Einsätze in der Rufbereitschaft",
  "ruleParameter.deviationAverageWeeklyMaxSeconds":
    "Durchschnittliche Höchstarbeitszeit je Woche bei Abweichungen",
  "ruleParameter.deviationAveragingPeriod": "Ausgleichszeitraum des Durchschnitts bei Abweichungen",
  "ruleParameter.deviationPermitAveragingPeriod":
    "Ausgleichszeitraum des Durchschnitts bei behördlicher Bewilligung",
  "averagingPeriod.FourWeeks": "4 Wochen",
  "averagingPeriod.OneCalendarMonth": "1 Kalendermonat",
  "averagingPeriod.SixteenWeeks": "16 Wochen",
  "averagingPeriod.FourCalendarMonths": "4 Kalendermonate",
  "averagingPeriod.TwentyFourWeeks": "24 Wochen",
  "averagingPeriod.SixCalendarMonths": "6 Kalendermonate",
  "averagingPeriod.TwelveCalendarMonths": "12 Kalendermonate",
  // UX WP-7: screens outside the shell and signup (ux-review.md).
  "auth.failedTitle": "Anmeldung fehlgeschlagen",
  "auth.failedHint":
    "Die Anmeldung konnte nicht abgeschlossen werden, zum Beispiel weil die Verbindung unterbrochen war oder die Anmeldung zu lange gedauert hat. Bitte melden Sie sich erneut an.",
  "signup.company": "Unternehmen",
  "signup.contact": "Ansprechperson",
  "signup.legalFormHint": "Zum Beispiel GmbH, UG oder e. K.",
  "signup.vatIdHint": "Zum Beispiel DE123456789",
  "signup.contactEmailHint": "An diese Adresse senden wir den Link zur Bestätigung.",
  "signup.federalStateChoose": "Bitte auswählen",
  "signup.readTerms": "Allgemeine Geschäftsbedingungen lesen (öffnet neues Fenster)",
  "signup.readDpa": "Vertrag über die Auftragsverarbeitung lesen (öffnet neues Fenster)",
  "signup.errorSummary": "Die Registrierung kann noch nicht gesendet werden:",
  "signup.problem.companyName": "Bitte geben Sie die Firma Ihres Unternehmens an.",
  "signup.problem.legalForm": "Bitte geben Sie die Rechtsform an, zum Beispiel GmbH.",
  "signup.problem.street": "Bitte geben Sie Straße und Hausnummer an.",
  "signup.problem.postalCode": "Bitte geben Sie die Postleitzahl an.",
  "signup.problem.postalCodeFormat": "Die Postleitzahl hat fünf Ziffern, zum Beispiel 80331.",
  "signup.problem.city": "Bitte geben Sie den Ort an.",
  "signup.problem.federalState": "Bitte wählen Sie das Bundesland des ersten Betriebs.",
  "signup.problem.vatId":
    "Die USt-IdNr. beginnt mit dem Länderkürzel, zum Beispiel DE123456789. Lassen Sie das Feld leer, wenn Sie keine haben.",
  "signup.problem.contactFirstName": "Bitte geben Sie den Vornamen der Ansprechperson an.",
  "signup.problem.contactLastName": "Bitte geben Sie den Nachnamen der Ansprechperson an.",
  "signup.problem.contactEmail": "Bitte geben Sie die E-Mail-Adresse der Ansprechperson an.",
  "signup.problem.contactEmailFormat":
    "Bitte geben Sie eine vollständige E-Mail-Adresse an, zum Beispiel name@firma.de.",
  "signup.problem.businessUse":
    "Bitte bestätigen Sie, dass Sie das Unternehmen als Unternehmer registrieren. Das Angebot richtet sich nur an Unternehmen.",
  "signup.problem.acceptTerms": "Bitte akzeptieren Sie die Allgemeinen Geschäftsbedingungen.",
  "signup.problem.acceptDpa": "Bitte schließen Sie den Vertrag über die Auftragsverarbeitung ab.",
  "signup.linkExpiredHint":
    "Links zur Bestätigung gelten nur eine begrenzte Zeit. Mit einer neuen Registrierung erhalten Sie einen neuen Link.",
  "signup.registerAgain": "Erneut registrieren",
  "signup.toSignIn": "Zur Anmeldung",
  // UX WP-8: billing (ux-review.md).
  "plan.trial": "Testphase",
  "plan.basic": "Basis",
  "plan.business": "Business",
  "plan.enterprise": "Enterprise",
  "subscription.pastDueForBilling":
    "Eine Zahlung ist fehlgeschlagen. Bitte prüfen Sie die Zahlungsart unter „Abo und Zahlung“; nach Ablauf der Mahnfrist wird die Verwaltung schreibgeschützt.",
  "subscription.pastDueForAdministration":
    "Eine Zahlung ist fehlgeschlagen. Die Zahlungsart ändern Personen mit der Rolle „Abrechnung“; nach Ablauf der Mahnfrist wird die Verwaltung schreibgeschützt.",
  "subscription.suspendedForBilling":
    "Die Verwaltung ist schreibgeschützt, weil eine Zahlung offen ist. Bitte prüfen Sie die Zahlungsart unter „Abo und Zahlung“; nach der Zahlung ist alles wieder verfügbar. Stempeln, eigene Zeiten und Exporte funktionieren weiter.",
  "subscription.suspendedForAdministration":
    "Die Verwaltung ist schreibgeschützt, weil eine Zahlung offen ist. Stempeln, eigene Zeiten und Exporte funktionieren weiter. Sobald Personen mit der Rolle „Abrechnung“ die Zahlung veranlasst haben, ist alles wieder verfügbar.",
  "subscription.total": "Gesamt",
  "subscription.entitlementsTitle": "Zusatzfunktionen",
  "subscription.noEntitlementsText": "Der Tarif enthält keine Zusatzfunktionen.",
  "serviceStatus.pastDueForBilling":
    "Eine Zahlung für das Abo ist fehlgeschlagen. Bitte prüfen Sie die Zahlungsart; ohne Zahlung wird die Verwaltung nach Ablauf der Mahnfrist schreibgeschützt.",
  "serviceStatus.pastDueForAdministration":
    "Eine Zahlung für das Abo ist fehlgeschlagen. Die Zahlungsart ändern Personen mit der Rolle „Abrechnung“; ohne Zahlung wird die Verwaltung nach Ablauf der Mahnfrist schreibgeschützt.",
  "serviceStatus.suspendedForBilling":
    "Die Verwaltung ist schreibgeschützt, weil eine Zahlung offen ist. Bitte prüfen Sie die Zahlungsart; nach der Zahlung ist alles wieder verfügbar.",
  "serviceStatus.suspendedForAdministration":
    "Die Verwaltung ist schreibgeschützt, weil eine Zahlung offen ist. Stempeln, eigene Zeiten und Exporte funktionieren weiter. Sobald Personen mit der Rolle „Abrechnung“ die Zahlung veranlasst haben, ist alles wieder verfügbar.",
  "billing.managedByBillingRole":
    "Zahlung, Rechnungen und Rechnungsdaten verwalten Personen mit der Rolle „Abrechnung“.",
  "billing.country": "Land",
  "billing.countryHint": "Zur Auswahl stehen die Mitgliedstaaten der Europäischen Union.",
  "billing.saved": "Rechnungsdaten gespeichert.",
  "invoices.list": "Rechnungen und Gutschriften",
  "invoices.pdf": "PDF",
  // UX WP-6: app shell, routes and navigation (ux-review.md).
  "notFound.title": "Seite nicht gefunden",
  "notFound.hint": "Prüfen Sie die Adresse oder öffnen Sie die Startseite.",
  "screenError.title": "Etwas ist schiefgelaufen",
  "screenError.text":
    "Dieser Bereich konnte nicht angezeigt werden. Laden Sie die Seite neu oder öffnen Sie die Startseite.",
  "screenError.offline.title": "Dieser Bereich ist offline noch nicht verfügbar",
  "screenError.offline.text":
    "Er ist auf diesem Gerät noch nicht gespeichert. Stempeln funktioniert auch offline. Versuchen Sie es erneut, sobald Sie wieder online sind.",
  "screenError.unavailable.title": "Dieser Bereich konnte nicht geladen werden",
  "screenError.unavailable.text":
    "Möglicherweise wurde Zeitavo gerade aktualisiert. Mit „Erneut versuchen“ laden Sie die Seite neu.",
  "screenError.stillOffline":
    "Sie sind noch offline. Versuchen Sie es erneut, sobald die Verbindung zurück ist.",
  "access.denied.title": "Keine Berechtigung",
  "access.denied.text":
    "Dieser Bereich ist für Ihre Rolle nicht freigegeben. Wenn Sie ihn für Ihre Arbeit brauchen, wenden Sie sich an die Personalabteilung oder die Administration Ihres Arbeitgebers.",
  "start.overview.title": "Übersicht",
  "start.overview.functions": "Ihre Funktionen in der App",
  "start.overview.privacy": "Datenschutzinformationen und Ihre Rechte",
  "start.overview.notInApp": "Nicht in der App",
  "start.overview.records":
    "Behördenexporte und die Aufzeichnungen einzelner Personen sind in der App nicht enthalten. Wenden Sie sich dafür an die Personalabteilung des Unternehmens.",
  "start.overview.reports":
    "Auswertungen nach der Betriebsvereinbarung sind in der App nicht enthalten. Wenden Sie sich dafür an die Personalabteilung des Unternehmens.",
  "start.overview.more":
    "Einstellungen und Abmelden finden Sie im Kontomenü an Ihrem Namen oben rechts.",
  "privacy.toc": "Inhalt dieser Seite",
  "privacy.infoHint": "Öffnen Sie ein Thema, um die Einzelheiten zu lesen.",
  "privacy.notificationsHint":
    "Ob dieses Gerät Erinnerungen als Benachrichtigung erhält, stellen Sie unter „Einstellungen“ im Kontomenü an Ihrem Namen ein.",
  "privacy.notificationsLink": "Benachrichtigungen einstellen",
  "setup.step.LeavePolicy": "Urlaubsregeln festgelegt",
  "leave.account.title": "Urlaubskonto",
  "leave.account.year": "Urlaubsjahr",
  "leave.account.notSetUp": "Urlaubskonto noch nicht eingerichtet",
  "leave.account.notSetUp.text":
    "Ihr Arbeitgeber hat die Urlaubsregeln noch nicht in Zeitavo hinterlegt. Sie können trotzdem Urlaub beantragen; Ihr Urlaubskonto erscheint hier, sobald es eingerichtet ist.",
  "leave.account.notSetUp.hr":
    "Legen Sie die Urlaubsregeln fest, damit Zeitavo die Urlaubskonten der Beschäftigten führt.",
  "leave.account.notSetUp.link": "Urlaubsregeln festlegen",
  "leave.account.beforeStart":
    "Das Urlaubskonto beginnt im Urlaubsjahr {year}. Für frühere Jahre führt Zeitavo kein Urlaubskonto.",
  "leave.account.offline": "Offline: letzter bekannter Stand vom {time}.",
  "leave.account.entitled": "Anspruch",
  "leave.account.carriedOver": "Übertrag aus Vorjahren",
  "leave.account.booked": "Buchungen der Personalabteilung",
  "leave.account.taken": "Genommen",
  "leave.account.approved": "Geplant (genehmigt)",
  "leave.account.requested": "Beantragt",
  "leave.account.forfeited": "Verfallen",
  "leave.account.paidOut": "Abgegolten",
  "leave.account.pendingPayout": "Abzugelten aus einem beendeten Arbeitsverhältnis",
  "leave.account.notDeducted": "Zuviel eines früheren Arbeitsverhältnisses, nicht verrechnet",
  "leave.account.available": "Verfügbar",
  "leave.account.availableHint":
    "Verfügbar sind die Tage, die noch beantragt werden können: Anspruch und Übertrag abzüglich genommener, geplanter und beantragter Tage.",
  "leave.days.one": "{count} Tag",
  "leave.days.other": "{count} Tage",
  "leave.carryOver.expires":
    "Davon {days} aus {years}: verfallen am {date}, wenn sie bis dahin nicht genommen werden.",
  "leave.carryOver.keeps":
    "Davon {days} aus {years}: verfallen nicht, weil kein rechtzeitiger Hinweis auf den Verfall verschickt wurde; sie werden weiter übertragen.",
  "leave.carryOver.negative": "Im Voraus genommen ({years}): {days}",
  "leave.items": "Einzelposten anzeigen",
  "leave.items.hint": "Jeder Posten nennt die Regel, nach der er berechnet ist.",
  "leave.item.Entitlement": "Anspruch",
  "leave.item.WaitingPeriod": "Wartezeit",
  "leave.item.PartialLeave": "Teilurlaub",
  "leave.item.Rounding": "Rundung",
  "leave.item.SameYearCap": "Begrenzung bei mehreren Arbeitsverhältnissen im Jahr",
  "leave.item.CarryOver": "Übertrag",
  "leave.item.CarryOverLimit": "Nicht übertragbarer Vorgriff",
  "leave.item.Booking": "Buchung",
  "leave.item.Taken": "Genommen",
  "leave.item.Approved": "Geplant",
  "leave.item.Requested": "Beantragt",
  "leave.item.Forfeiture": "Verfall",
  "leave.item.Payout": "Abgeltung",
  "leave.item.WithoutEffect": "Ohne Wirkung",
  "leave.item.withoutEffect.vacation":
    "Urlaub vor Beginn des Urlaubskontos ({date}), ohne Wirkung: zählt in keinem Urlaubskonto ({days})",
  "leave.item.withoutEffect.booking":
    "Buchung für ein Jahr vor Beginn des Urlaubskontos, ohne Wirkung: zählt in keinem Urlaubskonto ({days})",
  "leave.item.origin": "aus {year}",
  "leave.item.rule": "Regel {rule}",
  "leave.request.counted": "Gezählte Urlaubstage: {days}",
  "leave.request.countedHint":
    "Gezählt werden Ihre Arbeitstage ohne Feiertage; ein halber betrieblicher freier Tag zählt halb.",
  "leave.request.noWorkingDay":
    "Im gewählten Zeitraum liegt kein Arbeitstag; es wird kein Urlaubstag angerechnet. Bitte prüfen Sie die Daten.",
  "leave.request.rest": "Rest danach im Urlaubsjahr {year}: {days}",
  "leave.request.forfeits":
    "Davon verfallen {days} bis zum Jahresende, wenn sie nicht vorher genommen werden.",
  "leave.request.covered": "Das Urlaubskonto deckt diesen Antrag.",
  "leave.request.blocked":
    "Das Urlaubskonto deckt diesen Antrag nicht. Anträge über das Urlaubskonto hinaus sind nicht möglich; wenden Sie sich bei Bedarf an die Personalabteilung.",
  "leave.request.toHr":
    "Das Urlaubskonto deckt diesen Antrag nicht. Sie können ihn trotzdem stellen; die Personalabteilung entscheidet darüber.",
  "leave.request.beforeStart":
    "Der Antrag beginnt vor dem Beginn Ihres Urlaubskontos ({year}). Urlaub davor zählt in keinem Urlaubskonto und wird wie bisher entschieden.",
  "leave.request.calculating": "Die Urlaubstage werden berechnet …",
  "leave.request.tooFarAhead": "Urlaub kann höchstens bis zum {date} beantragt werden.",
  "leave.request.previewUnavailable":
    "Die Urlaubstage lassen sich gerade nicht berechnen. Der Antrag wird beim Absenden gegen das Urlaubskonto geprüft.",
  "leave.request.laterYear":
    "Im Urlaubsjahr {year} reicht der Urlaub danach nicht mehr für den dort schon geplanten oder beantragten Urlaub.",
  "leave.request.noHalfDays": "Halbe Urlaubstage sind bei Ihrem Arbeitgeber nicht vorgesehen.",
  "leave.request.submittedToHr":
    "Der Antrag wurde gestellt. Die Personalabteilung entscheidet darüber, weil das Urlaubskonto ihn nicht deckt.",
  "leave.request.hr.notCovered":
    "Das Urlaubskonto deckt diesen Urlaub nicht. Sie können ihn nur mit einer Begründung erfassen.",
  "leave.request.hr.beforeStart":
    "Der Urlaub beginnt vor dem Beginn des Urlaubskontos. Tage davor zählen in keinem Urlaubskonto.",
  "leave.reason": "Begründung",
  "leave.reason.hint":
    "Die Begründung wird gespeichert und ist für die beschäftigte Person sichtbar.",
  "leave.reason.missing": "Bitte geben Sie eine Begründung ein.",
  "leave.coverage.Covered": "Konto deckt den Antrag",
  "leave.coverage.NotCovered": "Konto deckt den Antrag nicht",
  "leave.coverage.BeforeAccountStart": "Vor Beginn des Urlaubskontos",
  "leave.coverage.hrDecides": "Darüber entscheidet die Personalabteilung mit Begründung.",
  "leave.coverage.notCoveredHrDecides":
    "Das Urlaubskonto deckt den Antrag nicht; darüber entscheidet die Personalabteilung mit Begründung.",
  "leave.coverage.unknownHrDecides":
    "Der Antrag ließ sich nicht gegen das Urlaubskonto prüfen; darüber entscheidet die Personalabteilung.",
  "leave.approveWithReason": "Mit Begründung genehmigen",
  "leave.approveWithReason.consequence":
    "Das Urlaubskonto deckt diesen Antrag nicht, oder er ließ sich nicht dagegen prüfen. Genehmigen Sie ihn nur mit einer Begründung.",
  "leave.approveWithReason.confirm": "Genehmigen",
  "leave.approvalReason": "Begründung der Freigabe: {reason}",
  "error.TT-3090":
    "Das Urlaubskonto deckt diesen Antrag nicht, und Anträge über das Urlaubskonto hinaus sind nicht möglich. Wenden Sie sich bei Bedarf an die Personalabteilung.",
  "error.TT-3091":
    "Das Urlaubskonto deckt diesen Antrag nicht, oder er ließ sich nicht dagegen prüfen. Darüber entscheidet die Personalabteilung.",
  "error.TT-3092":
    "Urlaub über das Urlaubskonto hinaus oder mit ungeklärter Deckung kann nur mit einer Begründung genehmigt oder erfasst werden.",
  "error.TT-3094": "Urlaub vor dem Jahr 2000 lässt sich nicht gegen das Urlaubskonto prüfen.",
  "error.TT-3095":
    "Urlaub kann höchstens bis zum Ende des übernächsten Jahres beantragt oder erfasst werden.",
  "error.TT-3093":
    "Halbe Urlaubstage sind bei Ihrem Arbeitgeber nicht vorgesehen. Bitte beantragen Sie den ganzen Tag.",
  "absences.kind.Rehabilitation": "Reha oder Kur",
  "absences.code.Rehabilitation": "R",
  "absences.rehabilitationHint":
    "Maßnahmen der medizinischen Vorsorge oder Rehabilitation werden nicht auf den Urlaub angerechnet (§ 10 BUrlG). Nur die Personalabteilung erfasst sie; Führungskräfte sehen nur „abwesend“.",
  "admin.leave.booking.daysHintSick":
    "Nur mit ärztlichem Zeugnis (§ 9 BUrlG): die Urlaubstage der Arbeitsunfähigkeit als positive Zahl; sie kehren ins Urlaubskonto zurück. Keine Diagnose in die Begründung eintragen.",
  "admin.leave.withdrawnItem": "Zurückgezogen: {reason}",
  "admin.leave.disability.title": "Schwerbehinderung (Zusatzurlaub nach § 208 SGB IX)",
  "admin.leave.disability.hint":
    "Gesundheitsdatum: nur die Personalabteilung sieht und pflegt es, gespeichert wird es verschlüsselt. Fünf Arbeitstage Zusatzurlaub bei fünf Arbeitstagen je Woche, im Jahr des Beginns oder Endes ein Zwölftel je vollem Monat. Die beschäftigte Person sieht den Zusatzurlaub im eigenen Urlaubskonto, Führungskräfte nie.",
  "admin.leave.disability.none": "Keine Schwerbehinderung erfasst.",
  "admin.leave.disability.open": "ab {from}",
  "admin.leave.disability.closed": "{from} bis {to}",
  "admin.leave.disability.item": "{period} – {reference}",
  "admin.leave.disability.from": "Gilt ab",
  "admin.leave.disability.to": "Gilt bis",
  "admin.leave.disability.toHint": "Leer lassen, solange die Schwerbehinderung unbefristet gilt.",
  "admin.leave.disability.reference": "Nachweis",
  "admin.leave.disability.referenceHint":
    "Zum Beispiel „Bescheid des Versorgungsamts vom …“. Keine Diagnose und keinen Grad der Behinderung eintragen.",
  "admin.leave.disability.save": "Schwerbehinderung erfassen",
  "admin.leave.disability.saved": "Die Schwerbehinderung ist erfasst.",
  "admin.leave.disability.endDate": "Letzter Tag",
  "admin.leave.disability.end": "Ende erfassen",
  "admin.leave.disability.ended": "Das Ende ist erfasst.",
  "admin.leave.protection.withdraw": "Zurückziehen",
  "admin.leave.protection.withdrawConfirm": "Eintrag endgültig zurückziehen",
  "admin.leave.protection.withdrawConsequence":
    "Der Eintrag gilt danach nicht mehr für das Urlaubskonto, bleibt aber mit Ihrer Begründung im Verlauf.",
  "admin.leave.protection.withdrawn": "Der Eintrag ist zurückgezogen.",
  "admin.leave.parental.title": "Elternzeit (§ 17 BEEG)",
  "admin.leave.parental.hint":
    "Der Urlaub wird nur gekürzt, wenn der Arbeitgeber die Kürzung erklärt hat: ein Zwölftel je vollem Kalendermonat Elternzeit, nicht bei Teilzeit bei uns während der Elternzeit und nicht für Monate im Mutterschutz. Erfassen Sie die Erklärung erst, wenn sie der beschäftigten Person zugegangen ist. Resturlaub aus der Zeit vor der Elternzeit verfällt frühestens am Ende des Urlaubsjahres nach der Elternzeit (§ 17 Abs. 2 BEEG).",
  "admin.leave.parental.none": "Keine Elternzeit erfasst.",
  "admin.leave.parental.item": "{from} bis {to}",
  "admin.leave.parental.partTimeItem": "Teilzeit bei uns während der Elternzeit, keine Kürzung",
  "admin.leave.parental.declared": "Kürzung erklärt, erfasst am {date}: {reference}",
  "admin.leave.parental.notDeclared": "Keine Kürzung erklärt, der Urlaub wird nicht gekürzt.",
  "admin.leave.parental.from": "Erster Tag",
  "admin.leave.parental.to": "Letzter Tag",
  "admin.leave.parental.partTime": "Teilzeit bei uns während der Elternzeit",
  "admin.leave.parental.save": "Elternzeit erfassen",
  "admin.leave.parental.saved": "Die Elternzeit ist erfasst.",
  "admin.leave.parental.reference": "Erklärung des Arbeitgebers",
  "admin.leave.parental.referenceHint":
    "Zum Beispiel „Schreiben vom …“. Erst mit dieser Angabe lässt sich die Kürzung erfassen, und nur solange das Arbeitsverhältnis besteht.",
  "admin.leave.parental.declare": "Kürzung erfassen",
  "admin.leave.parental.declareConfirm": "Kürzung endgültig erfassen",
  "admin.leave.parental.declareConsequence":
    "Das Urlaubskonto wird für jeden vollen Kalendermonat dieser Elternzeit um ein Zwölftel des Jahresurlaubs gekürzt. Die Erklärung bleibt mit Zeitpunkt im Verlauf.",
  "admin.leave.parental.declaredDone": "Die Erklärung ist erfasst.",
  "privacy.categories.severeDisability": "Schwerbehinderung",
  "privacy.categories.severeDisability.basis":
    "Pflichten aus § 208 SGB IX (Zusatzurlaub) für Gesundheitsdaten (Art. 9 Abs. 2 lit. b DSGVO). Nur die Personalabteilung sieht den Zeitraum; Sie sehen den Zusatzurlaub in Ihrem Urlaubskonto, Führungskräfte nie.",
  "privacy.categories.severeDisability.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres, in dem der Zeitraum endete, wie die Abwesenheiten.",
  "privacy.categories.severeDisability.portability":
    "Die Verarbeitung beruht auf Art. 9 Abs. 2 lit. b DSGVO, nicht auf Einwilligung oder Vertrag.",
  "privacy.categories.parentalLeave": "Elternzeit",
  "privacy.categories.parentalLeave.basis":
    "Arbeitsvertrag und rechtliche Verpflichtung (Art. 6 Abs. 1 lit. b und c DSGVO; § 17 BEEG): Zeitraum, Teilzeit und die Erklärung einer Kürzung des Urlaubs.",
  "privacy.categories.parentalLeave.retention":
    "Löschung {years} Jahre nach Ende des Kalenderjahres, in dem die Elternzeit endete, wie die Abwesenheiten.",
  "privacy.categories.parentalLeave.portability":
    "Den Zeitraum Ihrer Elternzeit haben Sie selbst verlangt; insoweit gilt Art. 20 DSGVO. Die Erklärung einer Kürzung stammt von Ihrem Arbeitgeber und fällt nicht darunter.",
  "error.TT-1090":
    "Bei Teilzeit während der Elternzeit darf der Urlaub nicht gekürzt werden (§ 17 Abs. 1 Satz 2 BEEG).",
  "error.TT-3110":
    "Der Zeitraum berührt keine Beschäftigung der Person. Erfassen Sie zuerst die Beschäftigung.",
  "admin.leave.protection.reasonHint":
    "Pflichtangabe, ohne Diagnose oder Grad der Behinderung; erst dann lässt sich der Eintrag zurückziehen.",
  "admin.leave.protection.error.required": "Pflichtangabe: bitte ausfüllen.",
  "admin.leave.protection.error.beforeStart":
    "Der letzte Tag liegt vor dem ersten Tag. Bitte einen späteren Tag wählen.",
  "error.TT-3111":
    "Die Kürzung wegen Elternzeit lässt sich nur erklären, solange das Arbeitsverhältnis besteht, in dem die Elternzeit liegt.",
  "leave.item.SevereDisability": "Zusatzurlaub (Schwerbehinderung)",
  "leave.item.ParentalLeaveReduction": "Kürzung wegen Elternzeit",
  "leave.item.ExcessNotDeducted": "Zuviel eines früheren Arbeitsverhältnisses (nicht verrechnet)",
  "leave.item.PendingPayout": "Abzugelten (beendetes Arbeitsverhältnis)",
  "leave.item.withoutMaternityMonths": "ohne Mutterschutzmonate",
  "leave.notices.title": "Hinweise zu Resturlaub und Verfall",
  "leave.notices.new":
    "Ihr Arbeitgeber hat Ihnen einen Hinweis zu Ihrem Resturlaub geschickt. Bitte lesen Sie ihn und bestätigen Sie, dass Sie ihn gelesen haben.",
  "leave.notices.heading": "Hinweis vom {date} zum Urlaubsjahr {year}",
  "leave.notices.emailSent": "Per E-Mail zugestellt am {time}.",
  "leave.notices.confirm": "Gelesen und zur Kenntnis genommen",
  "leave.notices.confirmed": "Gelesen am {time}.",
  "leave.notices.confirmedNow": "Der Hinweis ist als gelesen vermerkt.",
  "leave.notices.read": "Hinweis lesen",
  "admin.leave.notices.title": "Hinweise auf Resturlaub und Verfall",
  "admin.leave.notices.hint":
    "Übertragener Urlaub verfällt nur nach einem rechtzeitig zugestellten Hinweis: per E-Mail angenommen, in der App bestätigt oder als Brief übergeben. Der Text bleibt so gespeichert, wie er versandt wurde.",
  "admin.leave.notices.none": "Noch kein Hinweis verschickt.",
  "admin.leave.notices.sendNow": "Hinweis jetzt senden",
  "admin.leave.notices.sent": "Der Hinweis ist verschickt.",
  "admin.leave.notices.item": "{kind} vom {date} zum Urlaubsjahr {year}",
  "admin.leave.notices.kind.Annual": "Jahreshinweis",
  "admin.leave.notices.kind.Reminder": "Erinnerung",
  "admin.leave.notices.kind.CarryOver": "Hinweis zum Übertrag",
  "admin.leave.notices.figures": "Genannt: {days} Resturlaub, Verfall mit Ablauf des {deadline}.",
  "admin.leave.notices.delivered.Email": "Per E-Mail, gilt als zugestellt am {date}.",
  "admin.leave.notices.delivered.InApp": "In der App bestätigt, gilt als zugestellt am {date}.",
  "admin.leave.notices.delivered.Letter": "Als Brief übergeben, gilt als zugestellt am {date}.",
  "admin.leave.notices.notDelivered": "Noch nicht zugestellt, zählt noch nicht.",
  "admin.leave.notices.email.Pending": "Die E-Mail wartet auf den Versand.",
  "admin.leave.notices.email.Sent": "Die E-Mail ist zugestellt.",
  "admin.leave.notices.email.Failed": "Die E-Mail ist fehlgeschlagen.",
  "admin.leave.notices.email.NoAddress": "Keine E-Mail-Adresse bekannt.",
  "admin.leave.notices.email.NotConfigured": "Kein E-Mail-Versand eingerichtet.",
  "admin.leave.notices.bySystem": "Automatisch erstellt am {time}.",
  "admin.leave.notices.byHr": "Von der Personalabteilung erstellt am {time}.",
  "admin.leave.notices.proof": "Vorlage {version}, Prüfsumme {hash}",
  "admin.leave.notices.text": "Text anzeigen",
  "admin.leave.notices.resend": "E-Mail erneut senden",
  "admin.leave.notices.resent": "Die E-Mail wird erneut versandt.",
  "admin.leave.notices.letterOn": "Als Brief übergeben am",
  "admin.leave.notices.letter": "Brief vermerken",
  "admin.leave.notices.lettered": "Der Brief ist vermerkt.",
  "admin.leave.notices.overview.title": "Hinweise auf Resturlaub {year}",
  "admin.leave.notices.overview.hint":
    "Ohne zugestellten Hinweis verfällt kein Urlaub, und die Verjährung beginnt nicht. Hier stehen die Beschäftigten, bei denen noch etwas zu tun ist; Zahlen sehen Sie im Urlaubskonto der Person.",
  "admin.leave.notices.overview.delivered.one": "{count} Person hat einen zugestellten Hinweis.",
  "admin.leave.notices.overview.delivered.other":
    "{count} Personen haben einen zugestellten Hinweis.",
  "admin.leave.notices.overview.allDone":
    "Für alle Beschäftigten mit Urlaubskonto liegt ein zugestellter Hinweis vor.",
  "admin.leave.notices.figuresWithoutDay":
    "Genannt: {days} Resturlaub; kein Verfallstag, weil eine gesetzliche Schutzregel den Urlaub derzeit erhält.",
  "admin.leave.notices.proofKind.EmailOnly":
    "Nur per E-Mail (vom Mailserver angenommen, zählt ab dem nächsten Werktag), ohne Lesebestätigung.",
  "admin.leave.notices.proofKind.Confirmed": "Von der Person in der App bestätigt.",
  "admin.leave.notices.proofKind.Letter": "Als Brief übergeben.",
  "admin.leave.notices.lateWarning":
    "Der Stichtag für rechtzeitige Hinweise war der {date}. Ein Hinweis, der jetzt zugestellt wird, informiert, lässt aber keinen Urlaub verfallen.",
  "admin.leave.notices.state.DeliveredLate": "Hinweis zu spät zugestellt (kein Verfall)",
  "error.TT-1083":
    "Ein Brief lässt sich höchstens 14 Tage nach der Übergabe vermerken. Senden Sie stattdessen einen neuen Hinweis.",
  "error.TT-1084":
    "Ein geplanter Hinweis liegt weniger als eine Woche vor dem Stichtag für rechtzeitige Hinweise und käme dann womöglich zu spät. Wählen Sie einen früheren Tag.",
  "admin.leave.notices.state.Missing": "Hinweis fehlt",
  "admin.leave.notices.state.Pending": "Zustellung läuft",
  "admin.leave.notices.state.NotDelivered": "Hinweis nicht zugestellt",
  "admin.leave.notices.state.Delivered": "Hinweis zugestellt",
  "admin.leave.notices.carriedWithoutNotice":
    "Übertrag aus {years} ohne rechtzeitigen Hinweis: verfällt nicht.",
  "admin.leave.notices.forfeitureDeferred":
    "Der Verfall wird erst gebucht, wenn über einen offenen Urlaubsantrag entschieden ist.",
  "admin.leave.notices.overview.lateSchedule":
    "Die Urlaubsregeln planen einen Hinweis am {days}. Er kann dann zu spät ankommen und lässt keinen Urlaub verfallen. Legen Sie ihn in den Urlaubsregeln mindestens eine Woche vor den Stichtag {date}.",
  "team.leaveHints.title": "Urlaubsplanung ansprechen",
  "team.leaveHints.hint":
    "Diese Teammitglieder haben noch viel Urlaub, der weder genommen noch geplant ist. Zahlen sehen nur die Person selbst und die Personalabteilung.",
  "error.TT-1080":
    "Ein Verfall folgt aus dem Urlaubskonto und lässt sich nicht aufheben. Buchen Sie stattdessen eine Korrektur mit Begründung.",
  "error.TT-1081": "Der Tag des Briefs muss zwischen dem Tag des Hinweises und heute liegen.",
  "error.TT-3100":
    "Kein Hinweis verschickt: Die Person hat in diesem Jahr kein Urlaubskonto oder heute keine Beschäftigung.",
  "error.TT-3101":
    "Heute wurde schon ein Hinweis verschickt. Senden Sie seine E-Mail erneut oder vermerken Sie einen Brief.",
  "error.TT-3102": "Die E-Mail dieses Hinweises wartet auf den Versand oder ist schon zugestellt.",
  "leave.account.closed":
    "Urlaubsjahr abgeschlossen am {time}: Das Urlaubskonto ist eingefroren. Spätere Korrekturen bucht die Personalabteilung im laufenden Jahr.",
  "leave.account.deleted":
    "Dieses Urlaubsjahr ist abgeschlossen; seine Daten sind nach Ablauf der Aufbewahrungsfrist gelöscht.",
  "admin.leave.closing.title": "Jahresabschluss Urlaub",
  "admin.leave.closing.hint":
    "Nach dem 31. Dezember werden die Urlaubskonten eines Jahres eingefroren: Der Übertrag ins Folgejahr steht dann fest, spätere Korrekturen bucht die Personalabteilung im laufenden Jahr. Konten mit offenen Urlaubsanträgen oder noch abzugeltendem Urlaub bleiben offen, bis beides erledigt ist.",
  "admin.leave.closing.year": "Urlaubsjahr",
  "admin.leave.closing.notYet":
    "Das Urlaubsjahr {year} lässt sich erst nach seinem Ende und mit hinterlegten Urlaubsregeln abschließen.",
  "admin.leave.closing.open": "Das Urlaubsjahr {year} ist noch nicht abgeschlossen.",
  "admin.leave.closing.closedAutomatically":
    "Das Urlaubsjahr {year} wurde am {time} automatisch abgeschlossen.",
  "admin.leave.closing.closedByHr":
    "Das Urlaubsjahr {year} wurde am {time} von der Personalabteilung abgeschlossen.",
  "admin.leave.closing.automatic": "Zeitavo schließt das Jahr am {date} selbst ab.",
  "admin.leave.closing.counts":
    "Eingefroren: {frozen} · bereit zum Abschluss: {ready} · noch offen: {pending}",
  "admin.leave.closing.pending": "Noch nicht eingefroren",
  "admin.leave.closing.blocker.OpenRequests": "Ein Urlaubsantrag ist noch nicht entschieden.",
  "admin.leave.closing.blocker.OpenPayout": "Urlaub ist noch abzugelten.",
  "admin.leave.closing.blocker.NotCalculable": "Das Urlaubskonto lässt sich nicht berechnen.",
  "admin.leave.closing.close": "Urlaubsjahr {year} abschließen",
  "admin.leave.closing.closeRemaining": "Verbleibende Konten {year} abschließen",
  "admin.leave.closing.consequence":
    "Die Urlaubskonten {year} werden eingefroren. Danach lässt sich in diesem Jahr kein Urlaub mehr beantragen, genehmigen oder stornieren und nichts mehr buchen; Korrekturen bucht die Personalabteilung im laufenden Jahr. Erfassen Sie vorher alle Austritte des Jahres: Ein später erfasster Austritt wird im ersten offenen Jahr abgegolten.",
  "admin.leave.closing.confirm": "Endgültig abschließen",
  "admin.leave.closing.done": "Urlaubsjahr {year} abgeschlossen.",
  "admin.leave.report.title": "Auswertung „Urlaub je Person“ {year}",
  "admin.leave.report.hint":
    "Anspruch, Übertrag, Buchungen, genommene, geplante, verfallene und abgegoltene Tage aller Beschäftigten aus dem Urlaubskonto. Ohne das Recht auf Gesundheitsdaten zählen Posten, die darauf beruhen, zu den Buchungen.",
  "admin.leave.report.csv": "Als CSV herunterladen",
  "admin.leave.report.pdf": "Als PDF herunterladen",
  "datev.category.LeaveTakenDays": "Urlaubstage laut Urlaubskonto (statt „Urlaubstage“)",
  "error.TT-1120": "Dieses Urlaubsjahr ist abgeschlossen; sein Urlaubskonto ist eingefroren.",
  "error.TT-1121": "Ein Urlaubsjahr lässt sich erst nach dem 31. Dezember abschließen.",
  "error.TT-3140": "Das Urlaubsjahr ist abgeschlossen. Buchen Sie die Korrektur im laufenden Jahr.",
  "error.TT-3141":
    "Der Urlaub liegt in einem abgeschlossenen Urlaubsjahr und lässt sich nicht mehr ändern. Die Personalabteilung bucht eine Korrektur im laufenden Jahr.",
  "error.TT-3142": "In diesem Urlaubsjahr gibt es keine Urlaubskonten zum Abschließen.",
  "privacy.categories.leaveAccount": "Urlaubskonto",
  "privacy.categories.leaveAccount.basis":
    "Arbeitsvertrag und rechtliche Verpflichtung (Art. 6 Abs. 1 lit. b und c DSGVO; BUrlG): Urlaubsansprüche, Buchungen der Personalabteilung, die beim Jahresabschluss eingefrorenen Urlaubskonten und die Hinweise auf Resturlaub mit ihrer Zustellung.",
  "privacy.categories.leaveAccount.retention":
    "Löschung {years} Jahre nach Ende des Urlaubsjahres, sobald es abgeschlossen ist; Hinweise auf Resturlaub frühestens {years} Jahre nach Ende des Jahres, in dem sie zugestellt wurden (Nachweis für Verfall und Verjährung).",
  "privacy.categories.leaveAccount.portability":
    "Die Daten stammen von Ihrem Arbeitgeber oder werden aus Ihren Abwesenheiten berechnet; Art. 20 DSGVO gilt nicht. Sie erhalten sie mit der Auskunft nach Art. 15 DSGVO.",
  "admin.leave.closing.review": "Bitte prüfen",
  "admin.leave.closing.review.ExitAfterClosing":
    "Austritt nach dem Abschluss erfasst: Die Abgeltung ist noch offen und wird im ersten offenen Urlaubsjahr gebucht.",
  "admin.leave.closing.review.Deviation":
    "Stand weicht ab, bitte prüfen und im offenen Jahr korrigieren.",
  "admin.leave.closing.review.NotVerifiable": "Das Urlaubsjahr lässt sich nicht erneut berechnen.",
  "admin.leave.closing.verify": "Eingefrorene Konten prüfen",
  "admin.leave.closing.verifyHint":
    "Berechnet die eingefrorenen Konten des Jahres aus den heutigen Daten neu und nennt Personen, deren Stand abweicht, ohne Zahlen und ohne Grund.",
  "admin.leave.closing.verifiedNone":
    "Kein eingefrorenes Konto weicht von der erneuten Berechnung ab.",
  "admin.leave.exit.closedYear":
    "Das Urlaubsjahr {year} war schon abgeschlossen, als der letzte Tag erfasst wurde: Die Abgeltung wird im Urlaubsjahr {payoutYear} gebucht, mindestens mit dem eingefrorenen Rest. Im DATEV-Export gehört sie zum Monat des letzten Tages; exportieren Sie diesen Monat erneut.",
  "admin.leave.closedYearReached":
    "Die Angabe reicht in Urlaubsjahre, die für diese Person schon abgeschlossen sind (bis {year}). Abgeschlossene Jahre ändern sich nicht: Prüfen Sie unter „Abwesenheitsanträge → Jahresabschluss Urlaub“ mit „Eingefrorene Konten prüfen“, ob das eingefrorene Konto abweicht, und buchen Sie eine nötige Korrektur im ersten offenen Urlaubsjahr.",
  "admin.employment.endedInClosedYear":
    "Das Urlaubsjahr {year} ist für diese Person schon abgeschlossen. Die Abgeltung des Resturlaubs buchen Sie unter „Urlaub → Eintritt und Austritt“; sie wird im ersten offenen Urlaubsjahr gebucht.",
  "error.TT-1122":
    "Das Urlaubsjahr lässt sich nicht erneut berechnen: Das eingefrorene Konto des Vorjahres ist nach Ablauf der Aufbewahrungsfrist gelöscht.",
  "error.TT-3143":
    "Der Beginn der Urlaubskonten lässt sich nicht mehr ändern: Urlaubsjahre sind abgeschlossen.",
  "error.TT-3160":
    "Die Stempelung gehört zu einer Schicht, die in einem bereits abgeschlossenen Monat begonnen hat. Bitte beantragen Sie eine Korrektur mit dieser Uhrzeit, zusammen mit dem Beginn der Schicht, falls auch er abgelehnt wurde; Ihre Führungskraft entscheidet darüber. Bis dahin gilt die Schicht als nicht beendet.",
  "admin.monthClosing": "Monatsabschluss",
  "admin.monthClosing.open": "Monatsabschluss und Monatsfreigabe öffnen",
  "closing.title": "Monatsabschluss",
  "closing.hint":
    "Schließen Sie einen Monat ab, wenn alle Zeiten erfasst und geprüft sind. Danach lassen sich Stempelzeiten des Monats nur noch über genehmigte Korrekturanträge ändern, Abwesenheiten und Beschäftigungen erst nach einer Wiedereröffnung. Ändert eine genehmigte Korrektur den Monat, erhalten Sie hier einen Hinweis, den Lohnexport des Monats erneut zu erstellen.",
  "closing.month": "Monat",
  "closing.scope": "Bereich",
  "closing.scope.tenant": "Alle Betriebe",
  "closing.state.open": "{month} ist noch offen und kann abgeschlossen werden.",
  "closing.state.closed": "{month} ist abgeschlossen (am {time}).",
  "closing.state.closedForTenant": "{month} ist für alle Betriebe abgeschlossen.",
  "closing.state.notOver":
    "{month} ist noch nicht vorbei. Abschließen lässt er sich ab dem Folgemonat.",
  "closing.state.blocked": "{month} lässt sich noch nicht abschließen.",
  "closing.counts":
    "{persons} Beschäftigte, davon {confirmed} bestätigt und {approved} freigegeben. Bestätigung und Freigabe sind keine Voraussetzung für den Abschluss.",
  "closing.violations":
    "{count} Hinweise des Monats sind noch nicht zur Kenntnis genommen. Sie verhindern den Abschluss nicht.",
  "closing.recentlyEnded":
    "{month} ist erst vor wenigen Tagen zu Ende gegangen. Stempelungen der letzten Tage, die ein Gerät noch offline hält, werden nach dem Abschluss abgelehnt und müssen als Korrekturantrag nachgereicht werden.",
  "closing.blocked": "Noch offen",
  "closing.blocker.OpenShift": "Eine Schicht des Monats ist nicht beendet.",
  "closing.blocker.PendingCorrection": "Ein Korrekturantrag wartet auf eine Entscheidung.",
  "closing.blocker.PendingAbsence": "Ein Abwesenheitsantrag wartet auf eine Entscheidung.",
  "closing.close": "Monat abschließen",
  "closing.closeConsequence":
    "Danach lassen sich Stempelzeiten des Monats nur über genehmigte Korrekturanträge ändern, Abwesenheiten und Beschäftigungen erst nach einer Wiedereröffnung. Bestätigungen und Freigaben des Monats werden bei einer Wiedereröffnung überholt.",
  "closing.closed": "{month} ist abgeschlossen.",
  "closing.reopen": "Monat wieder öffnen",
  "closing.reopenReason": "Begründung",
  "closing.reopenHint": "Die Begründung wird im Verlauf angezeigt und protokolliert.",
  "closing.reasonRequired": "Bitte geben Sie eine Begründung an.",
  "closing.reopenConsequence":
    "Stempelzeiten, Abwesenheiten und Beschäftigungen des Monats lassen sich danach wieder direkt ändern. Bestätigungen und Freigaben des Monats werden überholt und müssen neu erteilt werden. Die Begründung wird protokolliert.",
  "closing.reopened": "{month} ist wieder geöffnet.",
  "closing.history": "Verlauf",
  "closing.history.closed": "Abgeschlossen am {time}",
  "closing.history.reopened": "Abgeschlossen am {closed}, wieder geöffnet am {reopened}: {reason}",
  "closing.notices": "Nach dem Abschluss geändert",
  "closing.noticesHint":
    "Genehmigte Korrekturen haben den abgeschlossenen Monat geändert. Exportieren Sie die Lohndaten des Monats erneut.",
  "closing.notice": "{person}, {month}: Korrektur genehmigt am {time}",
  "closing.noticeAcknowledge": "Zur Kenntnis nehmen",
  "closing.noticeAcknowledgeFor": "Zur Kenntnis nehmen: {person}, {month}",
  "closing.noticeAcknowledged": "Zur Kenntnis genommen am {time}",
  "closing.approvals": "Monatsfreigabe",
  "closing.approvals.hint":
    "Mit der Freigabe bestätigen Sie die erfassten Zeiten und den Saldo des Monats. Zweifeln Sie an einzelnen Zeiten oder Überstunden, geben Sie mit Vorbehalt frei und nennen Sie den Grund.",
  "closing.approvals.empty": "Keine Personen in diesem Monat.",
  "closing.approvals.notYet": "Freigeben lässt sich der Monat nach seinem Ende.",
  "closing.approvals.azvWithheld":
    "Monate mit Tagen unter der AZV gibt die Personalabteilung frei (§ 7 Abs. 8 AZV); nicht aufgeführt: {count}",
  "closing.column.person": "Person",
  "closing.column.state": "Stand",
  "closing.column.comment": "Anmerkung und Vorbehalt",
  "closing.note.comment": "Anmerkung: {text}",
  "closing.note.reservation": "Vorbehalt: {text}",
  "closing.column.action": "Aktion",
  "closing.person.Approved": "Freigegeben",
  "closing.person.ApprovedWithReservation": "Mit Vorbehalt freigegeben",
  "closing.person.Confirmed": "Bestätigt",
  "closing.person.Withdrawn": "Bestätigung zurückgenommen",
  "closing.person.Open": "Offen",
  "closing.approve": "Prüfen und freigeben",
  "closing.approveTitle": "Monat von {person} freigeben",
  "closing.approvalText":
    "Ich habe die Arbeitszeiten von {person} für {month} geprüft und gebe sie mit dem angezeigten Saldo frei. Die Freigabe kann ein ausgewiesenes Zeitguthaben unstreitig stellen; bei Zweifeln geben Sie mit Vorbehalt frei.",
  "closing.reservation": "Vorbehalt mit Begründung",
  "closing.approveConfirm": "Monat freigeben",
  "closing.approveCancel": "Abbrechen",
  "closing.approved": "Der Monat von {person} ist freigegeben.",
  "closing.balance.target": "Soll",
  "closing.balance.actual": "Ist",
  "closing.balance.absence": "Abwesenheiten",
  "closing.balance.month": "Saldo des Monats",
  "closing.balance.account": "Zeitkonto am Monatsende",
  "closing.balance.caption": "Saldo {month}",
  "closing.balance.captionPerson": "Saldo von {person} für {month}",
  "closing.locked": "Abgeschlossen",
  "closing.own.title": "Monat bestätigen",
  "closing.own.hint":
    "Mit der Bestätigung geben Sie an, dass Sie die erfassten Zeiten des Monats zur Kenntnis genommen haben. Sie verzichten damit auf nichts und können die Bestätigung bis zur Freigabe zurücknehmen. Fehler melden Sie mit einem Korrekturantrag.",
  "closing.own.disabled": "Ihr Arbeitgeber fragt keine Bestätigung des Monats ab.",
  "closing.own.notYet": "Bestätigen lässt sich der Monat nach seinem Ende.",
  "closing.own.comment": "Anmerkung für die Freigabe",
  "closing.own.confirm": "Monat bestätigen",
  "closing.own.withdraw": "Bestätigung zurücknehmen",
  "closing.own.confirmed": "Bestätigt am {time}.",
  "closing.own.commentShown": "Ihre Anmerkung: {comment}",
  "closing.own.withdrawn": "Bestätigung zurückgenommen am {time}.",
  "closing.own.approved": "Freigegeben am {time}.",
  "closing.own.approvedWithReservation": "Freigegeben am {time} mit Vorbehalt: {reservation}",
  "closing.own.locked":
    "Der Monat ist abgeschlossen. Änderungen sind nur noch über einen Korrekturantrag möglich.",
  "closing.own.announceConfirmed": "Der Monat ist bestätigt.",
  "closing.own.announceWithdrawn": "Die Bestätigung ist zurückgenommen.",
  "corrections.lockedMonth": "Betrifft gesperrten Monat",
  "corrections.lockedMonthHint":
    "Die Korrektur ändert einen abgeschlossenen Monat. Nach der Genehmigung erhält die Personalabteilung einen Hinweis, weil sich die Lohndaten des Monats ändern.",
  "corrections.lockedMonthPreview":
    "Der Antrag wird nicht automatisch genehmigt: Ihre Führungskraft entscheidet, und die Personalabteilung erhält nach der Genehmigung einen Hinweis.",
  "settings.monthConfirmation": "Monatsabschluss",
  "settings.monthConfirmation.hint":
    "Beschäftigte bestätigen ihren Monat, bevor Führungskraft oder Personalabteilung ihn freigeben. Die Bestätigung ist eine Kenntnisnahme ohne Verzicht, bis zur Freigabe widerrufbar und keine Voraussetzung für den Monatsabschluss.",
  "settings.monthConfirmation.label": "Bestätigung des Monats durch die Beschäftigten",
  "error.TT-1170":
    "Der Monat ist bereits freigegeben; die Bestätigung lässt sich nicht mehr ändern.",
  "error.TT-1171": "Der Monat ist bereits bestätigt.",
  "error.TT-1172": "Der Monat ist nicht bestätigt; es gibt nichts zurückzunehmen.",
  "error.TT-1173": "Der Monat ist für diesen Bereich nicht abgeschlossen.",
  "error.TT-1180": "Wählen Sie mindestens einen Betrieb (höchstens 200).",
  "error.TT-1181":
    "Nur die Rolle Personal ohne Mandantenverwaltung und Prüfung kann auf Betriebe beschränkt werden.",
  "error.TT-3240":
    "Diese Funktion gilt für den ganzen Mandanten. Ihre Personalrechte sind auf einzelne Betriebe beschränkt.",
  "error.TT-3241": "Dieser Betrieb gehört nicht zu Ihren Betrieben.",
  "error.TT-1174": "Der Monat dieser Person ist bereits freigegeben.",
  "error.TT-3220":
    "Der Monat lässt sich nicht abschließen: Eine Schicht des Monats ist noch nicht beendet. Die betroffenen Personen stehen unter „Noch offen“.",
  "error.TT-3221":
    "Der Monat lässt sich nicht abschließen: Korrekturanträge des Monats warten auf eine Entscheidung.",
  "error.TT-3222":
    "Der Monat lässt sich nicht abschließen: Abwesenheitsanträge des Monats warten auf eine Entscheidung.",
  "error.TT-3223": "Der Monat ist für diesen Bereich oder für alle Betriebe bereits abgeschlossen.",
  "error.TT-3224":
    "Der Monat ist noch nicht vorbei: Abschließen, bestätigen und freigeben lässt er sich erst nach seinem Ende, auch in den Zeitzonen aller Betriebe.",
  "error.TT-3225": "Ihr Arbeitgeber fragt keine Bestätigung des Monats ab.",
  "error.TT-3226":
    "Die Abwesenheit hat einen Tag in einem abgeschlossenen Monat. Die Personalabteilung muss den Monat zuerst mit Begründung wieder öffnen.",
  "error.TT-3227": "Der Monat ist für diesen Bereich nicht abgeschlossen.",
  "error.TT-3228":
    "Der Monat lässt sich noch nicht freigeben: Eine Schicht des Monats ist nicht beendet oder ein Korrektur- oder Abwesenheitsantrag des Monats wartet auf eine Entscheidung. Der angezeigte Saldo würde sich noch ändern.",
  "error.TT-3229":
    "Die Änderung der Beschäftigung betrifft einen abgeschlossenen Monat. Öffnen Sie den Monat zuerst unter „Monatsabschluss“ mit Begründung wieder.",
  "error.TT-3520":
    "Der Monat wurde gerade an anderer Stelle geändert, zum Beispiel bestätigt, freigegeben oder durch eine Korrektur neu geöffnet. Der aktuelle Stand wird neu geladen; prüfen Sie ihn und entscheiden Sie dann erneut.",
  "absences.kind.EducationLeave": "Bildungsurlaub",
  "absences.kind.Other": "Sonstige Abwesenheit",
  "absences.code.EducationLeave": "BU",
  "absences.code.Other": "A",
  "absences.educationLeaveHint":
    "Bildungsurlaub (Bildungszeit) nach dem Gesetz Ihres Bundeslandes: bezahlte Freistellung mit eigenem Kontingent, nicht vom Urlaubskonto abgezogen. Anerkennung der Veranstaltung, Anmeldefrist und Nachweise klären Sie mit der Personalabteilung; zusätzliche Weiterbildung beantragen Sie als Fortbildung.",
  "absences.error.pastEducationLeave":
    "Bildungsurlaub lässt sich ab heute ({date}) beantragen. Vergangene Tage trägt die Personalabteilung ein.",
  "educationLeave.title": "Bildungsurlaub",
  "educationLeave.remaining": "Noch {days} frei (Kontingent {quota}, {from} bis {to})",
  "educationLeave.approved": "Genehmigt: {days}",
  "educationLeave.requested": "Beantragt: {days}",
  "educationLeave.carriedOver": "Davon aus dem Vorjahr übertragen: {days}",
  "educationLeave.advance": "Davon im Vorgriff auf das Folgejahr: {days}",
  "educationLeave.hrDecides":
    "Außerhalb des gesetzlichen Anspruchs (Wartezeit oder Kontingent); darüber entscheidet die Personalabteilung mit Begründung.",
  "educationLeave.approveWithReason.consequence":
    "Der Bildungsurlaub liegt außerhalb des gesetzlichen Anspruchs (Wartezeit oder Kontingent). Genehmigen Sie ihn nur mit einer Begründung, zum Beispiel einem Übertrag nach Ablehnung oder einer Vereinbarung.",
  "educationLeave.statute": "Rechtsgrundlage ({state}): {reference}.",
  "educationLeave.unverified":
    "Die Werte dieses Landes sind noch nicht an der amtlichen Fassung geprüft; maßgeblich ist das Landesgesetz.",
  "educationLeave.waiting": "Anspruch auf Bildungsurlaub ab {date} (Wartezeit).",
  "educationLeave.noStatute": "In {state} gibt es keinen gesetzlichen Bildungsurlaub.",
  "educationLeave.noEmployment":
    "Ohne Beschäftigung an diesem Tag besteht kein Anspruch auf Bildungsurlaub.",
  "educationLeave.hint":
    "Bildungsurlaub wird nicht vom Urlaubskonto abgezogen. Das Kontingent ist die gesetzliche Obergrenze für eigene Anträge; ob eine Veranstaltung anerkannt ist, prüft die Personalabteilung.",
  "settings.educationLeave": "Bildungsurlaub nach Landesrecht",
  "settings.educationLeave.label": "Bildungsurlaub als eigene Abwesenheitsart anbieten",
  "settings.educationLeave.hint":
    "Standardmäßig aus. Eingeschaltet können Beschäftigte Bildungsurlaub beantragen; das Kontingent richtet sich nach dem Bundesland des Betriebs am ersten Tag und wird nicht vom Urlaubskonto abgezogen. Eigene Anträge über das Kontingent oder vor Ende der Wartezeit lehnt das System ab; mehr erfasst oder genehmigt nur die Personalabteilung mit Begründung (etwa Übertrag nach Ablehnung oder Vereinbarung). Freiwillige Freistellungen erfassen Sie als Fortbildung oder Sonderurlaub.",
  "settings.educationLeave.warning":
    "Vor dem Einschalten rechtlich prüfen lassen: Die Werte je Bundesland stammen aus Profil {version} und sind nur teilweise an der amtlichen Fassung geprüft (Spalte „Geprüft“). Anerkennung der Veranstaltung, Ankündigungsfristen, Betriebsgröße, Ablehnungsgründe und die Anrechnung beim früheren Arbeitgeber prüft die entscheidende Person.",
  "settings.educationLeave.rules": "Werte je Bundesland",
  "settings.educationLeave.column.state": "Bundesland",
  "settings.educationLeave.column.quota": "Kontingent",
  "settings.educationLeave.column.waiting": "Wartezeit",
  "settings.educationLeave.column.reference": "Rechtsgrundlage",
  "settings.educationLeave.column.verified": "Geprüft",
  "settings.educationLeave.none": "kein Gesetz",
  "settings.educationLeave.perYear": "{days} Arbeitstage je Kalenderjahr",
  "settings.educationLeave.perYearCarried":
    "{days} Arbeitstage je Kalenderjahr, Vorjahr übertragbar",
  "settings.educationLeave.perYearAdvance":
    "{days} Arbeitstage je Kalenderjahr, Vorgriff auf das Folgejahr möglich",
  "settings.educationLeave.perTwoYears": "{days} Arbeitstage in zwei Kalenderjahren",
  "settings.educationLeave.perTwoYearsOdd":
    "{days} Arbeitstage in zwei Kalenderjahren ab einem ungeraden Jahr",
  "settings.educationLeave.perTwoYearsFirstUse":
    "{days} Arbeitstage in zwei Kalenderjahren ab der ersten Inanspruchnahme",
  "settings.educationLeave.stateFrom": "{state} (ab {date})",
  "settings.educationLeave.stateUntil": "{state} (bis {date})",
  "settings.educationLeave.months": "{months} Monate",
  "settings.educationLeave.verifiedOn": "am {date}",
  "settings.educationLeave.notVerified": "nein",
  "error.TT-1150":
    "Im Bundesland Ihres Betriebs gibt es an diesem Tag keinen gesetzlichen Bildungsurlaub. Eine Freistellung darüber hinaus beantragen Sie als Fortbildung oder Sonderurlaub.",
  "error.TT-1151":
    "Der Anspruch auf Bildungsurlaub besteht erst nach der Wartezeit. Bitte wählen Sie einen späteren ersten Tag; davor trägt nur die Personalabteilung mit Begründung ein.",
  "error.TT-1152":
    "Der Bildungsurlaub übersteigt das gesetzliche Kontingent des Zeitraums. Darüber hinaus trägt nur die Personalabteilung mit Begründung ein (etwa Übertrag nach Ablehnung oder Vereinbarung); sonst als Fortbildung oder Sonderurlaub.",
  "error.TT-1153":
    "An diesem Tag besteht keine Beschäftigung und daher kein Anspruch auf Bildungsurlaub.",
  "error.TT-1154": "Für diesen Tag liegen keine Regeln zum Bildungsurlaub vor.",
  "error.TT-3190":
    "Bildungsurlaub ist bei Ihrem Arbeitgeber nicht eingeschaltet. Nur die Mandantenverwaltung schaltet ihn nach rechtlicher Prüfung ein.",
  "error.TT-3191":
    "Bildungsurlaub lässt sich nur ab heute beantragen. Vergangene Tage trägt die Personalabteilung ein.",
  "error.TT-3192":
    "Halbe Tage sind bei Ihrem Arbeitgeber nicht vorgesehen. Bitte beantragen Sie den ganzen Tag.",
  "error.TT-3193":
    "Bildungsurlaub kann höchstens bis zum Ende des übernächsten Jahres beantragt oder erfasst werden.",
  "error.TT-3194":
    "Bildungsurlaub außerhalb des gesetzlichen Anspruchs (Wartezeit oder Kontingent) lässt sich nur mit einer Begründung erfassen oder genehmigen.",
  "error.TT-3195":
    "Dieser Bildungsurlaub liegt außerhalb des gesetzlichen Anspruchs. Genehmigen kann ihn nur die Personalabteilung mit Begründung.",
  "terminal.title": "Stempel-Terminal",
  "terminal.loading": "Terminal wird geladen …",
  "terminal.privacy":
    "Dieses Terminal zeigt keine Namen. Es speichert nur verschlüsselte Prüfdaten der Beschäftigten dieses Betriebs.",
  "terminal.pair.title": "Terminal koppeln",
  "terminal.pair.intro":
    "Die Personalabteilung legt das Terminal unter „Verwaltung“ › „Betriebe“ an und erhält einen Kopplungscode. Öffnen Sie den Link des Codes auf diesem Gerät oder fügen Sie den Code hier ein.",
  "terminal.pair.code": "Kopplungscode",
  "terminal.pair.submit": "Koppeln",
  "terminal.pair.pairing": "Wird gekoppelt …",
  "terminal.pair.invalid":
    "Der Code ist ungültig, abgelaufen oder wurde schon verwendet. Bitte lassen Sie von der Personalabteilung ein neues Terminal anlegen.",
  "terminal.pair.offline":
    "Keine Verbindung. Zum Koppeln braucht das Terminal einmal eine Verbindung zum Server.",
  "terminal.pair.error":
    "Das Terminal konnte nicht gekoppelt werden. Bitte versuchen Sie es erneut.",
  "terminal.revoked": "Dieses Terminal wurde von der Personalabteilung abgemeldet.",
  "terminal.revoked.deleted": "Alle Daten wurden vom Gerät gelöscht.",
  "terminal.revoked.uploading.one":
    "{count} Stempelung wird noch übertragen, sobald eine Verbindung besteht; danach löscht das Terminal alle Daten.",
  "terminal.revoked.uploading.other":
    "{count} Stempelungen werden noch übertragen, sobald eine Verbindung besteht; danach löscht das Terminal alle Daten.",
  "terminal.revoked.lost.one":
    "{count} Stempelung konnte nicht übertragen werden. Alle Daten wurden vom Gerät gelöscht; bitte informieren Sie die Personalabteilung.",
  "terminal.revoked.lost.other":
    "{count} Stempelungen konnten nicht übertragen werden. Alle Daten wurden vom Gerät gelöscht; bitte informieren Sie die Personalabteilung.",
  "terminal.pair.pending.one":
    "Auf diesem Gerät ist {count} Stempelung der bisherigen Kopplung noch nicht übertragen. Stellen Sie eine Verbindung her und versuchen Sie es erneut – beim Koppeln ginge sie verloren.",
  "terminal.pair.pending.other":
    "Auf diesem Gerät sind {count} Stempelungen der bisherigen Kopplung noch nicht übertragen. Stellen Sie eine Verbindung her und versuchen Sie es erneut – beim Koppeln gingen sie verloren.",
  "terminal.pair.discard.one": "Trotzdem koppeln und {count} Stempelung verwerfen",
  "terminal.pair.discard.other": "Trotzdem koppeln und {count} Stempelungen verwerfen",
  "terminal.pair.personSignedIn":
    "Auf diesem Gerät ist eine Person in der App angemeldet. Ein Terminal ist ein geteiltes Gerät: Bitte melden Sie die Person zuerst ab und öffnen Sie dann den Kopplungslink erneut.",
  "terminal.pair.signOutPerson": "Person abmelden",
  "terminal.header": "{name} · {establishment}",
  "terminal.offline": "Offline",
  "terminal.pending.one": "{count} Stempelung wird übertragen, sobald eine Verbindung besteht.",
  "terminal.pending.other":
    "{count} Stempelungen werden übertragen, sobald eine Verbindung besteht.",
  "terminal.signIn.title": "Zum Stempeln anmelden",
  "terminal.signIn.byNumber": "Personalnummer und PIN",
  "terminal.signIn.byBadge": "QR-Ausweis",
  "terminal.signIn.method": "Art der Anmeldung",
  "terminal.signIn.number": "Personalnummer",
  "terminal.signIn.pin": "PIN",
  "terminal.signIn.pinHint": "6 Ziffern",
  "terminal.signIn.badge": "QR-Ausweis",
  "terminal.signIn.badgeHint":
    "Halten Sie den Ausweis an den Scanner oder lesen Sie ihn mit der Kamera.",
  "terminal.signIn.badgeRead": "Ausweis gelesen.",
  "terminal.signIn.camera": "Ausweis mit der Kamera lesen",
  "terminal.signIn.cameraStop": "Kamera schließen",
  "terminal.signIn.cameraVideo": "Kamerabild zum Lesen des Ausweises",
  "terminal.signIn.cameraFailed":
    "Die Kamera ist nicht verfügbar. Bitte nutzen Sie den Scanner oder Personalnummer und PIN.",
  "terminal.signIn.submit": "Anmelden",
  "terminal.signIn.checking": "Wird geprüft …",
  "terminal.signIn.idle": "Ohne Eingabe wird die Anmeldung nach 10 Sekunden verworfen.",
  "terminal.signIn.failed": "Die Anmeldedaten stimmen nicht.",
  "terminal.signIn.locked": "Zu viele Fehlversuche. Die Anmeldung ist für einige Minuten gesperrt.",
  "terminal.signIn.incomplete":
    "Bitte geben Sie Personalnummer und 6-stellige PIN ein oder lesen Sie Ihren Ausweis (mit PIN, wo verlangt).",
  "terminal.signIn.unavailable":
    "Keine Verbindung und keine gültigen Offline-Daten. Bitte stempeln Sie später oder in der App.",
  "terminal.signIn.error": "Die Anmeldung ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "terminal.person.title": "Personalnummer {number}",
  "terminal.person.state.Off": "Nicht eingestempelt",
  "terminal.person.state.Working": "Arbeitet",
  "terminal.person.state.OnBreak": "Pause",
  "terminal.person.since": "seit {time}",
  "terminal.person.offline":
    "Offline geprüft. Die Stempelung wird übertragen, sobald eine Verbindung besteht.",
  "terminal.person.rejected":
    "„{action}“ vom {time} wurde nicht übernommen (Fehlercode {code}). Bitte stellen Sie in der App einen Korrekturantrag oder wenden Sie sich an die Personalabteilung.",
  "terminal.person.actions": "Stempeln",
  "terminal.person.idle": "Ohne Eingabe meldet sich das Terminal nach 10 Sekunden ab.",
  "terminal.action.ClockIn": "Kommen",
  "terminal.action.BreakStart": "Pause",
  "terminal.action.BreakEnd": "Weiter",
  "terminal.action.ClockOut": "Gehen",
  "terminal.signOut": "Abmelden",
  "terminal.recorded": "„{action}“ um {time} erfasst.",
  "terminal.recordFailed":
    "Die Stempelung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
  "admin.terminals.title": "Terminals",
  "admin.terminals.intro":
    "Ein Terminal ist ein geteiltes Gerät (Tablet) im Betrieb, an dem Beschäftigte ohne eigenes Diensthandy mit Personalnummer und PIN oder QR-Ausweis stempeln. Es zeigt keine Namen; PIN und Ausweis stellen Sie bei der Person unter „Stammdaten“ aus.",
  "admin.terminals.establishment": "Betrieb",
  "admin.terminals.name": "Name des Terminals",
  "admin.terminals.nameHint": "Zum Beispiel „Eingang Lager“",
  "admin.terminals.badgeRequiresPin":
    "QR-Ausweis nur zusammen mit der PIN (empfohlen, ein QR-Code lässt sich kopieren)",
  "admin.terminals.create": "Terminal anlegen",
  "admin.terminals.none": "Noch kein Terminal.",
  "admin.terminals.list": "Terminals",
  "admin.terminals.column.name": "Terminal",
  "admin.terminals.column.establishment": "Betrieb",
  "admin.terminals.column.status": "Status",
  "admin.terminals.column.lastSeen": "Zuletzt aktiv",
  "admin.terminals.column.actions": "Aktionen",
  "admin.terminals.status.Pending": "Wartet auf Kopplung",
  "admin.terminals.status.Expired": "Code abgelaufen",
  "admin.terminals.status.Paired": "Gekoppelt",
  "admin.terminals.status.Revoked": "Widerrufen",
  "admin.terminals.revoke": "Widerrufen",
  "admin.terminals.revokeNamed": "Terminal „{name}“ widerrufen",
  "admin.terminals.revokeConfirm":
    "Das Terminal wird abgewiesen und löscht seine Daten. Noch nicht übertragene Stempelungen gehen verloren; prüfen Sie „Zuletzt aktiv“.",
  "admin.terminals.revoked": "Terminal „{name}“ widerrufen.",
  "admin.terminals.created": "Terminal „{name}“ angelegt.",
  "admin.terminals.code.title": "Kopplungscode für „{name}“",
  "admin.terminals.code.intro":
    "Gültig bis {time}, nur einmal verwendbar und nur jetzt sichtbar. Scannen Sie den QR-Code mit dem Tablet, öffnen Sie den Link dort oder fügen Sie den Code im Terminal ein.",
  "admin.terminals.code.link": "Link für das Tablet",
  "admin.terminals.code.code": "Kopplungscode",
  "admin.terminals.code.qr": "QR-Code mit dem Link für das Tablet",
  "admin.terminals.code.done": "Fertig",
  "admin.terminalAccess.title": "Terminal-Anmeldung",
  "admin.terminalAccess.intro":
    "PIN und QR-Ausweis für das Stempeln am Terminal. Sie werden nur beim Ausstellen angezeigt; gespeichert ist nur ein Hash.",
  "admin.terminalAccess.pin": "PIN",
  "admin.terminalAccess.badge": "QR-Ausweis",
  "admin.terminalAccess.issuedAt": "ausgestellt am {date}",
  "admin.terminalAccess.none": "keine",
  "admin.terminalAccess.lockedUntil":
    "Nach Fehlversuchen gesperrt bis {time}; eine neue PIN hebt die Sperre auf.",
  "admin.terminalAccess.issuePin": "Neue PIN erzeugen",
  "admin.terminalAccess.issueBadge": "Neuen QR-Ausweis erzeugen",
  "admin.terminalAccess.remove": "Terminal-Anmeldung entfernen",
  "admin.terminalAccess.removeConfirm": "PIN und QR-Ausweis werden sofort ungültig.",
  "admin.terminalAccess.removed": "Terminal-Anmeldung entfernt.",
  "admin.terminalAccess.newPin":
    "Neue PIN: {pin}. Geben Sie sie der Person persönlich oder verschlossen weiter; sie wird nicht wieder angezeigt.",
  "admin.terminalAccess.newBadge":
    "Neuer QR-Ausweis. Drucken Sie ihn jetzt aus; er wird nicht wieder angezeigt.",
  "admin.terminalAccess.badgeQr": "QR-Ausweis der Personalnummer {number}",
  "admin.terminalAccess.print": "Ausweis drucken",
  "admin.terminalAccess.hide": "Ausblenden",
  "error.TT-1200": "Der Name des Terminals fehlt oder ist länger als 100 Zeichen.",
  "error.TT-1201": "Der Kopplungscode ist ungültig, abgelaufen oder wurde schon verwendet.",
  "error.TT-1202": "Für die Anmeldung fehlen Personalnummer und 6-stellige PIN oder der Ausweis.",
  "error.TT-1203": "Das Terminal ist bereits widerrufen.",
  "error.TT-3260": "Diese Funktion steht nur einem gekoppelten Terminal zur Verfügung.",
  "error.TT-3261": "Das Terminal wurde widerrufen.",
  "error.TT-3262": "Die Anmeldedaten stimmen nicht.",
  "error.TT-3263": "Zu viele Fehlversuche. Die Anmeldung ist für einige Minuten gesperrt.",
  "error.TT-3264": "Die Person ist an diesem Tag nicht im Betrieb des Terminals beschäftigt.",
  "error.TT-3265": "Die Quelle „Terminal“ ist gekoppelten Terminals vorbehalten.",
  "error.TT-3266":
    "Die Stempelung gehört nicht zur Anmeldung an diesem Terminal (Person, Terminal oder Zeit passen nicht).",
  "error.TT-3267":
    "Die offline erfasste Stempelung lässt sich keiner Anmeldung an diesem Terminal zuordnen.",
  "location.basis.LegitimateInterest": "Berechtigtes Interesse (Art. 6 Abs. 1 lit. f DSGVO)",
  "location.basis.WorksAgreement": "Betriebsvereinbarung ({reference})",
  "location.notice.title": "Standort beim Stempeln",
  "location.notice.purpose":
    "Ihr Arbeitgeber erfasst beim Stempeln einmalig Ihren ungefähren Standort. Zweck: {purpose}",
  "location.notice.basis": "Rechtsgrundlage: {basis}.",
  "location.notice.how":
    "Erfasst wird nur im Moment des Stempelns, grob (Abweichung bis zu einigen Kilometern) und auf etwa 100 m gerundet, nie im Hintergrund und ohne Wege. Der Standort wird getrennt von der Stempelung gespeichert und nach {days} Tagen gelöscht; die Stempelung bleibt. Personalabteilung und zuständige Führungskraft sehen Koordinaten und Entfernung zum Betrieb in Kilometern, keine Karte.",
  "location.notice.objection":
    "Sie können der Erfassung aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit widersprechen (Art. 21 Abs. 1 DSGVO), z. B. bei der Personalabteilung oder der oder dem Datenschutzbeauftragten.",
  "location.notice.privacyLink": "Mehr dazu unter Datenschutz",
  "location.notice.withoutLocation": "Ohne Standort stempeln",
  "location.locating": "Standort wird ermittelt … Die Stempelung ist bereits gespeichert.",
  "location.notice.choice":
    "Ihr Gerät fragt nach der Erlaubnis. Lehnen Sie ab oder ist kein Standort verfügbar, wird trotzdem gestempelt. Die Erlaubnis können Sie jederzeit in den Einstellungen Ihres Geräts ändern.",
  "location.notice.confirm": "Verstanden, stempeln",
  "location.clockHint":
    "Beim Stempeln wird einmalig Ihr ungefährer Standort erfasst (Zweck: {purpose}). Ohne Erlaubnis wird ohne Standort gestempelt.",
  "location.settings.title": "Standort beim Stempeln",
  "location.settings.hint":
    "Standard aus. Die App fragt den ungefähren Standort nur im Moment des eigenen Stempelns ab (auf etwa 100 m gerundet), nie im Hintergrund, und stempelt ohne Erlaubnis trotzdem. Die Erfassung ist nach § 87 Abs. 1 Nr. 6 BetrVG mitbestimmungspflichtig und braucht eine Datenschutz-Folgenabschätzung; Zweck und Rechtsgrundlage erscheinen in der Information an die Beschäftigten und im Konfigurationsexport.",
  "location.settings.purpose": "Zweck",
  "location.settings.purposeHint":
    "Wofür der Standort gebraucht wird, z. B. „Nachweis von Außeneinsätzen“ (10 bis 500 Zeichen).",
  "location.settings.legalBasis": "Rechtsgrundlage",
  "location.settings.worksAgreement": "Betriebsvereinbarung",
  "location.settings.reference": "Betriebsvereinbarung (Titel und Datum)",
  "location.settings.referenceHint": "Erscheint in der Information an die Beschäftigten.",
  "location.settings.retentionDays": "Löschung nach Tagen",
  "location.settings.retentionHint":
    "Höchstens {days} Tage nach dem Stempeln; Sie können die Frist nur verkürzen. Die Stempelung selbst bleibt.",
  "location.settings.assessment":
    "Die Datenschutz-Folgenabschätzung ist durchgeführt und der Betriebsrat, falls vorhanden, beteiligt.",
  "location.settings.save": "Standort-Einstellung speichern",
  "location.settings.saved": "Standort-Einstellung gespeichert.",
  "location.settings.notEntitled":
    "Der Standort beim Stempeln gehört zur Funktion „NFC und Standort“ der Pakete Business und Enterprise.",
  "location.settings.inactive":
    "Eingeschaltet, aber nicht aktiv: Das Paket enthält die Funktion nicht mehr oder Zweck und Rechtsgrundlage fehlen. Die App fragt keinen Standort ab.",
  "location.establishments.title": "Koordinaten der Betriebe",
  "location.establishments.hint":
    "Für die Entfernung eines Stempelstandorts zum Betrieb: Breite und Länge in Grad (z. B. 48,137 und 11,575), auf drei Nachkommastellen gerundet. Leere Felder entfernen die Koordinaten.",
  "location.establishments.latitude": "Breitengrad",
  "location.establishments.longitude": "Längengrad",
  "location.establishments.save": "Koordinaten speichern",
  "location.establishments.saved": "Koordinaten von {name} gespeichert.",
  "location.establishments.invalid":
    "Bitte eine Zahl in Grad eingeben (z. B. 48,137) oder das Feld leer lassen.",
  "location.day.title": "Standort beim Stempeln",
  "location.day.hint":
    "Ungefähre Koordinaten und Entfernung zum Betrieb in ganzen Kilometern je Stempelung des gewählten Tages; der Gerätestandort ist grob. Jeder Abruf wird protokolliert; keine Karte, keine Wege, keine Auswertung.",
  "location.day.person": "Person",
  "location.day.show": "Standorte anzeigen",
  "location.day.none": "An diesem Tag wurde kein Standort erfasst.",
  "location.day.distanceBelowOne": "weniger als 1 km vom Betrieb",
  "location.day.distanceKilometers": "etwa {kilometers} km vom Betrieb",
  "location.day.accuracy.Android":
    "Ungefährer Standort der Android-App: kann um bis zu etwa 3 km abweichen.",
  "location.day.accuracy.Ios":
    "Ungefährer Standort der iOS-App: kann um mehrere Kilometer abweichen.",
  "location.day.accuracy.Web":
    "Standort des Browsers (meist aus WLAN oder Mobilfunknetz): kann um mehrere Kilometer abweichen.",
  "location.day.noEstablishment": "Keine Beschäftigung an diesem Tag, keine Entfernung.",
  "location.day.noEstablishmentCoordinates":
    "Für den Betrieb sind keine Koordinaten hinterlegt, keine Entfernung.",
  "privacy.location.title": "Standort beim Stempeln",
  "privacy.location.off": "Ihr Arbeitgeber erfasst beim Stempeln keinen Standort.",
  "privacy.location.on":
    "Ihr Arbeitgeber erfasst beim Stempeln einmalig Ihren ungefähren Standort (grob, auf etwa 100 m gerundet), nie im Hintergrund. Zweck: {purpose}. Rechtsgrundlage: {basis}. Löschung nach {days} Tagen, getrennt von der Stempelung. Ohne Erlaubnis Ihres Geräts wird ohne Standort gestempelt. Bei berechtigtem Interesse können Sie der Erfassung widersprechen (Art. 21 Abs. 1 DSGVO).",
  "error.TT-1190": "Bitte geben Sie den Zweck der Standorterfassung an (10 bis 500 Zeichen).",
  "error.TT-1191": "Standorte werden höchstens 60 Tage aufbewahrt; bitte wählen Sie 1 bis 60 Tage.",
  "error.TT-1192":
    "Bitte nennen Sie die Betriebsvereinbarung (Titel und Datum, höchstens 200 Zeichen).",
  "error.TT-3250":
    "Bitte bestätigen Sie die Datenschutz-Folgenabschätzung und die Beteiligung des Betriebsrats, bevor Sie den Standort einschalten.",
  "geofence.title": "Erinnerung am Standort",
  "geofence.titleShiftStart": "Erinnerung zum Schichtbeginn",
  "geofence.consent.regions":
    "Wenn Sie die Erinnerung einschalten, erkennt Ihr Gerät, wenn Sie den Bereich Ihres Betriebs betreten, und erinnert Sie ans Einstempeln – nur an Tagen, an denen Sie laut Arbeitszeitmodell oder Dienstplan arbeiten, und nur, wenn Sie noch nicht eingestempelt sind. Ihr Standort wird nur auf diesem Gerät ausgewertet; er wird weder an Zeitavo noch an Ihren Arbeitgeber übermittelt und nicht gespeichert. Gestempelt wird nie automatisch.",
  "geofence.consent.background":
    "Dafür nutzt Zeitavo Ihren genauen Standort auch im Hintergrund, also wenn die App geschlossen ist oder nicht verwendet wird. Android fragt danach; wählen Sie dort „Immer zulassen“. Verlassen Sie den Betrieb eingestempelt, fragt die App „Noch eingestempelt?“.",
  "geofence.consent.ios":
    "iOS erinnert Sie beim Betreten, ohne die App zu starten; dafür reicht die Erlaubnis „Beim Verwenden der App“. Beim Verlassen kann iOS nicht erinnern.",
  "geofence.consent.shiftStart":
    "Wenn Sie die Erinnerung einschalten, erinnert Sie die App zu Beginn Ihrer veröffentlichten Schichten ans Einstempeln, wenn Sie noch nicht eingestempelt sind. Ihr Standort wird dafür nicht verwendet.",
  "geofence.consent.voluntary":
    "Die Erinnerung ist freiwillig. Sie können sie hier jederzeit ohne Nachteil ausschalten; Ihr Arbeitgeber erfährt nicht, ob Sie sie nutzen.",
  "geofence.enable": "Erinnerung einschalten",
  "geofence.disable": "Erinnerung ausschalten",
  "geofence.state.on": "Die Erinnerung ist auf diesem Gerät eingeschaltet.",
  "geofence.hint.notifications":
    "Mitteilungen sind für Zeitavo ausgeschaltet; ohne sie erscheint keine Erinnerung.",
  "geofence.hint.location":
    "Der Standort ist für Zeitavo nicht erlaubt; ohne ihn erinnert Ihr Gerät nicht am Standort.",
  "geofence.hint.background":
    "Der Standort im Hintergrund ist nicht erlaubt. Bis Sie „Immer zulassen“ wählen, erinnert die App nur zum Beginn Ihrer veröffentlichten Schichten.",
  "geofence.hint.precise":
    "Mit dem ungefähren Standort erinnert iOS möglicherweise nicht. Schalten Sie in den Einstellungen „Genauer Standort“ ein, wenn Sie zuverlässig erinnert werden möchten.",
  "geofence.hint.noRegion":
    "Für Ihren Betrieb ist noch kein Bereich hinterlegt; Ihre Personalabteilung kann ihn eintragen.",
  "geofence.hint.noShift": "Zurzeit ist keine Schicht von Ihnen veröffentlicht.",
  "geofence.openSettings": "Einstellungen öffnen",
  "geofence.tenant.title": "Erinnerung am Standort",
  "geofence.tenant.hint":
    "Standard aus. Beschäftigte können in den Apps selbst einschalten, dass ihr Gerät sie beim Betreten ihres Betriebs ans Einstempeln erinnert (nur an Arbeitstagen und vor Schichten). Der Standort wird nur auf dem Gerät ausgewertet; weder Zeitavo noch Sie erfahren ihn oder wer die Erinnerung nutzt, und gestempelt wird nie automatisch. Die Funktion ist nach § 87 Abs. 1 Nr. 6 BetrVG mitbestimmungspflichtig. Den Bereich legen Sie je Betrieb als Radius bei den Koordinaten fest.",
  "geofence.tenant.enabled": "Erinnerung am Standort anbieten",
  "geofence.tenant.agreement":
    "Die Erinnerung ist mit dem Betriebsrat, falls vorhanden, vereinbart, und die Beschäftigten werden informiert, dass sie freiwillig ist und jederzeit ohne Nachteil ausgeschaltet werden kann.",
  "geofence.tenant.save": "Einstellung speichern",
  "geofence.tenant.saved": "Einstellung zur Erinnerung am Standort gespeichert.",
  "geofence.tenant.notEntitled":
    "Die Erinnerung am Standort gehört zur Funktion „NFC und Standort“ der Pakete Business und Enterprise.",
  "geofence.tenant.inactive":
    "Eingeschaltet, aber nicht aktiv: Das Paket enthält die Funktion nicht mehr. Die Apps bieten keine Erinnerung an.",
  "geofence.radius.label": "Radius der Erinnerung für {name} (Meter)",
  "geofence.radius.hint":
    "100 bis 1000 m um die Koordinaten. Leer: keine Erinnerung an diesem Betrieb.",
  "geofence.radius.save": "Radius speichern",
  "geofence.radius.saved": "Radius von {name} gespeichert.",
  "geofence.radius.invalid":
    "Bitte eine ganze Zahl von 100 bis 1000 eingeben oder das Feld leer lassen.",
  "error.TT-1193": "Der Radius der Erinnerung beträgt 100 bis 1000 Meter.",
  "error.TT-3251":
    "Bitte bestätigen Sie die Vereinbarung mit dem Betriebsrat und die Information der Beschäftigten, bevor Sie die Erinnerung am Standort einschalten.",
  "error.TT-3252": "Ein Radius braucht zuerst die Koordinaten des Betriebs.",
  "nfc.clock.title": "Am NFC-Tag stempeln",
  "nfc.clock.hint":
    "Schritt wählen und das Telefon an den NFC-Tag am Arbeitsplatz halten. Nur mit Verbindung, ohne Standort.",
  "nfc.clock.action": "{action} am NFC-Tag",
  "nfc.clock.disabled":
    "NFC ist ausgeschaltet. Bitte schalten Sie NFC in den Einstellungen des Telefons ein.",
  "nfc.clock.pending":
    "Gespeicherte Stempelungen werden zuerst gesendet; danach können Sie am NFC-Tag stempeln.",
  "nfc.clock.prompt": "{action}: Halten Sie Ihr iPhone an den NFC-Tag am Arbeitsplatz.",
  "nfc.clock.reading": "Halten Sie Ihr Telefon jetzt an den NFC-Tag …",
  "nfc.clock.notRead":
    "Es wurde kein NFC-Tag gelesen. Bitte erneut versuchen und das Telefon ruhig an den Tag halten.",
  "nfc.clock.failed":
    "Die Stempelung am NFC-Tag ist fehlgeschlagen. Bitte erneut versuchen oder ohne Tag stempeln.",
  "nfc.clock.recorded": "{action} um {time} am NFC-Tag „{tag}“ gespeichert.",
  "admin.nfc.title": "NFC-Tags und Chips",
  "admin.nfc.intro":
    "Arbeitsplatz-Tags (NTAG 424 DNA mit SUN-Nachricht) prüft der Server bei jedem Stempeln; persönliche Chips (MIFARE DESFire EV3) ersetzen am Android-Terminal den QR-Ausweis, die PIN bleibt nach Einstellung des Terminals Pflicht. UID und Schlüssel werden nie angezeigt.",
  "admin.nfc.create": "Tag anlegen",
  "admin.nfc.notEntitled":
    "Neue Tags und Chips können nur mit dem Leistungsmerkmal „NFC und Standort“ angelegt werden. Vorhandene Tags lassen sich weiter sperren.",
  "admin.nfc.establishment": "Betrieb",
  "admin.nfc.kind": "Art",
  "admin.nfc.kind.Workplace": "Arbeitsplatz-Tag",
  "admin.nfc.kind.PersonalBadge": "Persönlicher Chip",
  "admin.nfc.name": "Name",
  "admin.nfc.nameHint": "z. B. „Eingang Lager“ oder „Chip 12“ (höchstens 100 Zeichen)",
  "admin.nfc.uid": "UID",
  "admin.nfc.uidHint":
    "4, 7 oder 10 Bytes in Hexadezimalschreibweise, z. B. 04:DE:5F:1E:AC:C0:40; gespeichert wird nur ein Hash.",
  "admin.nfc.sunKey": "SUN-Schlüssel (SDM File Read Key)",
  "admin.nfc.sunKeyHint":
    "32 Hexadezimalziffern; wird verschlüsselt gespeichert und nie wieder angezeigt.",
  "admin.nfc.employee": "Person",
  "admin.nfc.created": "Tag „{name}“ angelegt.",
  "admin.nfc.blocked": "Tag „{name}“ gesperrt.",
  "admin.nfc.none": "Noch keine NFC-Tags.",
  "admin.nfc.list": "NFC-Tags",
  "admin.nfc.column.name": "Name",
  "admin.nfc.column.kind": "Art",
  "admin.nfc.column.establishment": "Betrieb",
  "admin.nfc.column.state": "Status",
  "admin.nfc.column.lastUsed": "Zuletzt gestempelt",
  "admin.nfc.column.actions": "Aktionen",
  "admin.nfc.state.active": "Aktiv",
  "admin.nfc.state.blocked": "Gesperrt",
  "admin.nfc.block": "Sperren",
  "admin.nfc.blockNamed": "Tag „{name}“ sperren",
  "admin.nfc.blockConfirm":
    "Ein gesperrter Tag stempelt nie wieder. Er lässt sich nicht entsperren, nur neu anlegen.",
  "terminal.signIn.byChip": "NFC-Chip",
  "terminal.signIn.chipHint": "Halten Sie Ihren Chip an das Gerät.",
  "terminal.signIn.chipRead": "Chip gelesen.",
  "terminal.signIn.chipFailed": "Der Chip ist unbekannt oder gesperrt, oder die PIN stimmt nicht.",
  "terminal.signIn.chipOffline":
    "Ohne Verbindung ist die Anmeldung mit Chip nicht möglich. Bitte mit Personalnummer und PIN anmelden.",
  "error.TT-1220": "Die UID des Tags hat 4, 7 oder 10 Bytes in Hexadezimalschreibweise.",
  "error.TT-1221": "Der SUN-Schlüssel hat 32 Hexadezimalziffern (AES-128).",
  "error.TT-1222": "Der Name des Tags fehlt oder ist länger als 100 Zeichen.",
  "error.TT-1223": "Ein aktiver Tag mit dieser UID ist bereits angelegt. Sperren Sie ihn zuerst.",
  "error.TT-1224": "Der Tag ist bereits gesperrt.",
  "error.TT-1225": "Der NFC-Tag trägt keine gültige SUN-Nachricht. Es wurde nichts gestempelt.",
  "error.TT-1226":
    "Ein Arbeitsplatz-Tag braucht einen SUN-Schlüssel und keine Person, ein persönlicher Chip eine Person und keinen Schlüssel.",
  "error.TT-3280":
    "Dieser NFC-Tag konnte nicht als Tag Ihres Arbeitgebers geprüft werden. Es wurde nichts gestempelt.",
  "error.TT-3281": "Dieser NFC-Tag ist gesperrt. Es wurde nichts gestempelt.",
  "error.TT-3283":
    "Diese Nachricht des NFC-Tags wurde schon verwendet. Bitte das Telefon erneut an den Tag halten.",
  "error.TT-3284": "Die Quelle „NFC-Tag“ setzt nur der Server nach Prüfung eines Tags.",
  "error.TT-3285":
    "Der Tag gehört zu einem Betrieb, in dem Sie heute nicht beschäftigt sind. Bitte ohne Tag stempeln.",
  // Rostering (T-176, ADR-0146).
  "nav.roster": "Dienstplanung",
  "roster.inactive": "Die Dienstplanung ist für Ihr Unternehmen nicht eingeschaltet.",
  "roster.notPlanner":
    "Sie erstellen keine Dienstpläne. Das Recht „Dienstplan erstellen“ vergibt die Personalabteilung.",
  "roster.intro":
    "Schichtvorlagen und Besetzungsbedarf sind die Grundlage der Dienstpläne. Ein Dienstplan ist eine Planung: Aufgezeichnet wird weiterhin nur, was gestempelt wird.",
  "roster.establishment": "Betrieb",
  "roster.allEstablishments": "Alle Betriebe",
  "roster.team": "Team",
  "roster.wholeEstablishment": "Ganzer Betrieb",
  "roster.start": "Beginn",
  "roster.end": "Ende",
  "roster.endHint": "Liegt das Ende vor dem Beginn, liegt es am Folgetag.",
  "roster.validFrom": "Gültig ab",
  "roster.validTo": "Gültig bis",
  "roster.validity": "Gültigkeit",
  "roster.validSince": "ab {from}",
  "roster.validBetween": "{from} bis {to}",
  "roster.time": "Zeit",
  "roster.timeSameDay": "{start}–{end}",
  "roster.timeNextDay": "{start}–{end} (Folgetag)",
  "roster.minutes": "{minutes} min",
  "roster.actions": "Aktionen",
  "roster.edit": "Bearbeiten",
  "roster.delete": "Löschen",
  "roster.settings.title": "Dienstplanung",
  "roster.settings.hint":
    "Standardmäßig aus. Dienst- und Schichtpläne sind mitbestimmungspflichtig (§ 87 Abs. 1 Nr. 2 und 3 BetrVG). Die Planungsgrundsätze stehen im Konfigurationsexport für die Betriebsvereinbarung.",
  "roster.settings.notEntitled": "Die Dienstplanung ist in Ihrem Tarif nicht enthalten.",
  "roster.settings.enabled": "Dienstplanung einschalten",
  "roster.settings.leadTime": "Vorlauf in Kalendertagen",
  "roster.settings.leadTimeHint":
    "Wird ein Plan kurzfristiger veröffentlicht oder geändert, erscheint ein Hinweis, keine Sperre ({min} bis {max} Tage; ohne Tarif- oder Betriebsvereinbarung üblich: 4).",
  "roster.settings.colleagueNames":
    "Beschäftigte sehen im veröffentlichten Plan die Namen ihrer Kolleginnen und Kollegen",
  "roster.settings.swapAutoApproval":
    "Schichttausch ohne Plan-Hinweis ohne Freigabe der Planenden übernehmen",
  "roster.settings.planActualPerPerson":
    "Plan-Ist-Vergleich mit Werten je Person und je Tag (nur mit Betriebsvereinbarung; sonst nur Summen des Zeitraums, nie Ranglisten)",
  "roster.settings.planActualMinimumGroup":
    "Mindestgruppe für Summen im Plan-Ist-Vergleich (Personen)",
  "roster.settings.planActualMinimumGroupHint":
    "Ohne Werte je Person zeigt der Vergleich Summen erst ab so vielen verschiedenen Personen (2 bis 50, üblich: 5), damit keine Summe auf eine Person schließen lässt.",
  "roster.settings.codetermination":
    "Mir ist bekannt, dass Dienstpläne der Mitbestimmung des Betriebsrats unterliegen, und der Betriebsrat ist beteiligt, sofern es einen gibt.",
  "roster.settings.save": "Dienstplanung speichern",
  "roster.settings.saved": "Dienstplanung gespeichert.",
  "roster.compare.title": "Plan-Ist-Vergleich",
  "roster.compare.hint":
    "Veröffentlichte Schichten gegen erfasste Arbeitszeit eines Betriebs oder Teams. Abweichungen bei Beginn und Ende zählen erst über der Toleranz; Schichten, die noch nicht zu Ende sind, werden nicht verglichen. Keine Ranglisten; Werte je Person nur, wenn der Mandant sie per Betriebsvereinbarung freigeschaltet hat.",
  "roster.compare.team": "Team",
  "roster.compare.allRosters": "Alle Pläne des Betriebs, die Sie planen",
  "roster.compare.from": "Von",
  "roster.compare.to": "Bis",
  "roster.compare.tolerance": "Toleranz in Minuten",
  "roster.compare.toleranceHint":
    "Abweichungen bis zu dieser Dauer zählen nicht (0 bis {max} Minuten).",
  "roster.compare.show": "Vergleichen",
  "roster.compare.suppressed.one":
    "Im Zeitraum hat {count} Person eine verglichene Schicht (beendet, ohne Abwesenheit), weniger als die Mindestgruppe von {minimum}. Ohne Werte je Person werden dann keine Summen gezeigt, damit sie nicht auf einzelne Personen schließen lassen.",
  "roster.compare.suppressed.other":
    "Im Zeitraum haben {count} Personen eine verglichene Schicht (beendet, ohne Abwesenheit), weniger als die Mindestgruppe von {minimum}. Ohne Werte je Person werden dann keine Summen gezeigt, damit sie nicht auf einzelne Personen schließen lassen.",
  "roster.compare.shiftCount.one": "{count} Schicht",
  "roster.compare.shiftCount.other": "{count} Schichten",
  "roster.compare.personCount.one": "{count} Person",
  "roster.compare.personCount.other": "{count} Personen",
  "roster.compare.total.shifts": "Verglichene Schichten",
  "roster.compare.total.shiftsValue": "{shifts} von {persons}; {pending} noch nicht zu Ende",
  "roster.compare.total.time": "Arbeitszeit",
  "roster.compare.total.timeValue":
    "geplant {planned} h, erfasst {recorded} h, ohne Schicht erfasst {unplanned} h",
  "roster.compare.total.deviations": "Abweichungen über {minutes} Minuten",
  "roster.compare.total.deviationsValue":
    "{missed} ohne Erfassung; Beginn {late}× später, {early}× früher; Ende {earlyEnd}× früher, {lateEnd}× später",
  "roster.compare.total.notCompared": "Nicht verglichen",
  "roster.compare.total.notComparedValue":
    "{absent} an Tagen mit Abwesenheit, {unevaluable} mit nicht auswertbarer Erfassung",
  "roster.compare.days": "Tage",
  "roster.compare.daysCaption": "Plan-Ist-Vergleich je Tag",
  "roster.compare.day": "Tag",
  "roster.compare.persons": "Personen",
  "roster.compare.personsCaption": "Plan-Ist-Vergleich je Person",
  "roster.compare.person": "Person",
  "roster.compare.personsHint":
    "Nach Namen geordnet; die Tabelle lässt sich nicht nach Werten sortieren.",
  "roster.compare.perPersonOff":
    "Werte je Tag und je Person sind im Mandanten nicht freigeschaltet; es werden nur die Summen des Zeitraums gezeigt.",
  "roster.compare.noShifts": "Im Zeitraum gibt es keine veröffentlichten Schichten.",
  "roster.compare.shifts": "Schichten",
  "roster.compare.planned": "Geplant (h)",
  "roster.compare.recorded": "Erfasst (h)",
  "roster.compare.unplanned": "Ohne Schicht (h)",
  "roster.compare.missed": "Ohne Erfassung",
  "roster.compare.begin": "Abweichung Beginn",
  "roster.compare.end": "Abweichung Ende",
  "roster.compare.notCompared": "Nicht verglichen",
  "roster.templates.title": "Schichtvorlagen",
  "roster.templates.hint":
    "Vorlagen gelten für alle Betriebe oder einen Betrieb. Eine Vorlage wird nicht gelöscht; sie endet mit ihrem letzten Gültigkeitstag. Geplante Schichten behalten ihre Zeiten.",
  "roster.templates.empty": "Noch keine Schichtvorlagen.",
  "roster.templates.new": "Neue Schichtvorlage",
  "roster.templates.edit": "Schichtvorlage bearbeiten",
  "roster.templates.editNamed": "Schichtvorlage {name} bearbeiten",
  "roster.templates.name": "Name",
  "roster.templates.break": "Pause in Minuten",
  "roster.templates.breakInvalid": "Bitte geben Sie die Pause in ganzen Minuten an (0 bis 1440).",
  "roster.templates.save": "Schichtvorlage speichern",
  "roster.templates.saved": "Schichtvorlage gespeichert.",
  "roster.requirements.title": "Besetzungsbedarf",
  "roster.requirements.hint":
    "Wie viele Personen mindestens gebraucht werden, je Wochentag oder an einem Datum. Die Planung zeigt Abweichungen als Hinweis.",
  "roster.requirements.empty": "Noch kein Besetzungsbedarf.",
  "roster.requirements.new": "Neuer Besetzungsbedarf",
  "roster.requirements.edit": "Besetzungsbedarf bearbeiten",
  "roster.requirements.editNamed": "Besetzungsbedarf {day} bearbeiten",
  "roster.requirements.deleteNamed": "Besetzungsbedarf {day} löschen",
  "roster.requirements.deleteConsequence":
    "Der Besetzungsbedarf wird gelöscht. Bestehende Pläne bleiben unverändert.",
  "roster.requirements.deleteConfirm": "Besetzungsbedarf löschen",
  "roster.requirements.deleted": "Besetzungsbedarf gelöscht.",
  "roster.requirements.day": "Tag",
  "roster.requirements.weekly": "Jede Woche",
  "roster.requirements.once": "An einem Datum",
  "roster.requirements.weekday": "Wochentag",
  "roster.requirements.date": "Datum",
  "roster.requirements.every": "jeden {weekday}",
  "roster.requirements.minimum": "Mindestbesetzung",
  "roster.requirements.save": "Besetzungsbedarf speichern",
  "roster.requirements.saved": "Besetzungsbedarf gespeichert.",
  "roster.planners.title": "Planende",
  "roster.planners.hint":
    "Wer für einen Betrieb oder ein Team Dienstpläne erstellt. Das Recht geht nicht auf Vertretungen über. Die Personalabteilung plant für ihre Betriebe.",
  "roster.planners.empty": "Noch niemand erstellt Dienstpläne.",
  "roster.planners.new": "Recht „Dienstplan erstellen“ vergeben",
  "roster.planners.person": "Person",
  "roster.planners.choosePerson": "Person wählen",
  "roster.planners.otherEstablishment":
    "Person, die jetzt in einem anderen Betrieb beschäftigt ist",
  "roster.planners.grant": "Recht vergeben",
  "roster.planners.granted": "Recht vergeben.",
  "roster.planners.revoke": "Entziehen",
  "roster.planners.revokeNamed": "Recht von {name} entziehen",
  "roster.planners.revokeConsequence":
    "Das Recht endet gestern; ein noch nicht begonnenes Recht wird gelöscht.",
  "roster.planners.revokeConfirm": "Recht entziehen",
  "roster.planners.revoked": "Recht entzogen.",
  "entitlement.ProjectBilling": "Stundensätze und Abrechnung",
  "entitlement.Rostering": "Dienstplanung",
  "error.TT-1210":
    "Beginn und Ende der Schicht ergeben keine Schicht. Bitte prüfen Sie die Zeiten (volle Minuten, höchstens ein Tag).",
  "error.TT-1211": "Die Pause muss kürzer als die Schicht sein.",
  "error.TT-1212": "Bitte wählen Sie entweder einen Wochentag oder ein Datum.",
  "error.TT-1213": "Die Mindestbesetzung liegt zwischen 1 und 999 Personen.",
  "error.TT-1214": "Ein Dienstplan umfasst einen abgeschlossenen Zeitraum von höchstens 93 Tagen.",
  "error.TT-1215": "Zwei Schichten derselben Person überschneiden sich.",
  "error.TT-1216": "Die Schicht liegt außerhalb der Beschäftigung der Person in diesem Betrieb.",
  "error.TT-1217":
    "Diese Version des Dienstplans ist veröffentlicht. Eine Änderung beginnt eine neue Version.",
  "error.TT-1218": "Die Schicht beginnt außerhalb des Zeitraums des Dienstplans.",
  "error.TT-1219": "Der Vorlauf liegt zwischen 1 und 60 Kalendertagen.",
  "error.TT-3270": "Die Dienstplanung ist ausgeschaltet.",
  "error.TT-3271":
    "Bitte bestätigen Sie den Hinweis auf die Mitbestimmung des Betriebsrats, bevor Sie die Dienstplanung einschalten.",
  "error.TT-3272": "Sie erstellen keine Dienstpläne für diesen Betrieb oder dieses Team.",
  "error.TT-3273":
    "Die Person hat das Recht für diesen Betrieb und dieses Team bereits in einem überschneidenden Zeitraum.",
  "error.TT-3275":
    "Der Dienstplan wurde inzwischen von einer anderen Person geändert. Bitte laden Sie ihn neu und wiederholen Sie die Änderung.",
  "error.TT-3274": "Das Team gehört zu einem anderen Betrieb.",
  // Planning view and rule check of rosters (T-177, ADR-0148).
  "roster.plan.title": "Dienstplan",
  "roster.plan.hint":
    "Die Regelprüfung zeigt Hinweise je Person und Tag zusammen mit der erfassten Arbeitszeit davor – sie sind keine Verstöße.",
  "roster.plan.rosters": "Dienstpläne",
  "roster.plan.noRosters": "Für diesen Betrieb gibt es noch keinen Dienstplan, den Sie planen.",
  "roster.plan.period": "{from} bis {to}",
  "roster.plan.status.Draft": "Entwurf",
  "roster.plan.status.Published": "Veröffentlicht",
  "roster.plan.open": "Öffnen",
  "roster.plan.openNamed": "Dienstplan {period} öffnen",
  "roster.plan.new": "Neuer Dienstplan",
  "roster.plan.periodStart": "Erster Tag",
  "roster.plan.periodEnd": "Letzter Tag",
  "roster.plan.periodHint": "Höchstens 93 Tage.",
  "roster.plan.create": "Dienstplan anlegen",
  "roster.plan.created": "Dienstplan angelegt.",
  "roster.plan.range": "Ansicht",
  "roster.plan.week": "Woche",
  "roster.plan.month": "Monat",
  "roster.plan.previous.week": "Vorherige Woche",
  "roster.plan.next.week": "Nächste Woche",
  "roster.plan.previous.month": "Vorheriger Monat",
  "roster.plan.next.month": "Nächster Monat",
  "roster.plan.gridLabel": "Dienstplan: Personen und Tage",
  "roster.plan.gridHint":
    "Mit den Pfeiltasten wechseln Sie die Zelle, mit Eingabe oder Leertaste öffnen Sie sie.",
  "roster.plan.person": "Person",
  "roster.plan.openShifts": "Offene Schichten",
  "roster.plan.noticeCount.one": "{count} Hinweis",
  "roster.plan.noticeCount.other": "{count} Hinweise",
  "roster.plan.breachCount.one": "{count} Regelverstoß",
  "roster.plan.breachCount.other": "{count} Regelverstöße",
  "roster.plan.cellNotices": "In dieser Zelle: {summary}.",
  "roster.plan.cellNoNotices": "In dieser Zelle gibt es keine Hinweise.",
  "roster.plan.cellTitle": "{name}, {day}",
  "roster.plan.notices": "Hinweise der Regelprüfung",
  "roster.plan.noNotices": "Keine Hinweise.",
  "roster.plan.ruleId": "Regel-ID {ruleId}",
  "roster.plan.rule.ROSTER-NOT-PLANNABLE": "Nicht einplanbar",
  "roster.plan.rule.ROSTER-ABSENT": "Abwesend",
  "roster.plan.rule.ROSTER-OVERLAP": "Überschneidet sich mit einer anderen Schicht der Person",
  "roster.plan.rule.ROSTER-STAFFING": "Besetzung unter dem Bedarf",
  "roster.plan.staffingValues": "geplant {planned} · Bedarf {minimum}",
  "roster.plan.notPlannableHint": "Den Grund kennt nur die Personalabteilung.",
  "roster.plan.severity.Breach": "Regelverstoß, wenn so gearbeitet wird",
  "roster.plan.severity.Attention": "Bitte prüfen",
  "roster.plan.shifts": "Schichten",
  "roster.plan.noShifts": "Keine Schicht.",
  "roster.plan.editShift": "Schicht {times} bearbeiten",
  "roster.plan.deleteShift": "Schicht {times} löschen",
  "roster.plan.deleteConsequence": "Die Schicht wird aus dem Entwurf gelöscht.",
  "roster.plan.deleteConfirm": "Schicht löschen",
  "roster.plan.deleted": "Schicht gelöscht.",
  "roster.plan.newShift": "Neue Schicht",
  "roster.plan.changeShift": "Schicht ändern",
  "roster.plan.kind": "Art der Schicht",
  "roster.plan.fromTemplate": "Aus Vorlage",
  "roster.plan.free": "Freie Zeiten",
  "roster.plan.template": "Schichtvorlage",
  "roster.plan.noTemplates": "An diesem Tag gilt keine Schichtvorlage.",
  "roster.plan.openShift": "Offene Schicht (ohne Person)",
  "roster.plan.breakHint": "Leer: die Pause der Vorlage, bei freien Zeiten keine.",
  "roster.plan.note": "Hinweis für die Person",
  "roster.plan.saveShift": "Schicht speichern",
  "roster.plan.saved": "Schicht gespeichert.",
  "roster.plan.copyTitle": "Woche kopieren",
  "roster.plan.copyHint":
    "Kopiert alle Schichten einer Woche mit denselben Uhrzeiten. Schichten von Personen, die am neuen Tag nicht beschäftigt sind, und Hinweise für die Person werden nicht kopiert; Schichten, die in der Zielwoche schon geplant sind, werden nicht noch einmal angelegt.",
  "roster.plan.copyFrom": "Von der Woche ab",
  "roster.plan.copyTo": "In die Woche ab",
  "roster.plan.copy": "Woche kopieren",
  "roster.plan.copied":
    "{copied} Schichten kopiert, {skipped} ausgelassen, {alreadyPlanned} waren schon geplant.",
  "roster.plan.publishedHint":
    "Diese Version ist veröffentlicht und kann hier nicht geändert werden.",
  "roster.plan.close": "Zelle schließen",
  "nav.myRoster": "Mein Dienstplan",
  "myRoster.own": "Ihre Schicht",
  "myRoster.open": "Offene Schicht",
  "myRoster.colleague": "Kollegin oder Kollege",
  "myRoster.break": "{minutes} Min. Pause geplant",
  "myRoster.fromDevice": "Ohne Verbindung – veröffentlichter Dienstplan, Stand vom {time}",
  "myRoster.state": "Veröffentlichter Dienstplan, Stand vom {time}",
  "myRoster.next": "Ihre nächste Schicht",
  "myRoster.days": "Die nächsten vier Wochen",
  "myRoster.empty": "In den nächsten vier Wochen sind keine Schichten veröffentlicht.",
  "myRoster.target": "Soll laut Dienstplan: {hours} h",
  "myRoster.targetTotal":
    "Soll laut Dienstplan ab heute: {hours} h (ohne Feiertage und Abwesenheiten; maßgeblich ist der Saldo)",
  "myRoster.hint":
    "Der Dienstplan ist eine Planung. Ihre Arbeitszeit erfassen Sie weiter mit Kommen und Gehen.",
  "clock.nextShift": "Nächste Schicht laut Dienstplan: {date}, {times}.",
  "clock.myRosterLink": "Mein Dienstplan",
  "roster.publish.title": "Veröffentlichen",
  "roster.publish.draftHint":
    "Der Entwurf ist nur für Planende sichtbar. Erst nach dem Veröffentlichen sehen die Beschäftigten ihre Schichten und werden benachrichtigt.",
  "roster.publish.draftHintRevision":
    "Die Beschäftigten sehen bis zum Veröffentlichen weiter die zuletzt veröffentlichte Version.",
  "roster.publish.open": "Veröffentlichen …",
  "roster.publish.codetermination":
    "Dienstpläne unterliegen der Mitbestimmung des Betriebsrats (§ 87 Abs. 1 Nr. 2 und 3 BetrVG). Veröffentlichen Sie nur Pläne, die nach den vereinbarten Grundsätzen aufgestellt sind.",
  "roster.publish.changes": "Neu: {added}, geändert: {changed}, entfernt: {removed}.",
  "roster.publish.affected":
    "Benachrichtigt werden nur betroffene Personen mit noch nicht beendeten Schichten: {count} (Sie selbst nicht).",
  "roster.publish.changeList": "Änderungen gegenüber der veröffentlichten Version",
  "roster.publish.kind.Added": "Neu",
  "roster.publish.kind.Changed": "Geändert",
  "roster.publish.kind.Removed": "Entfernt",
  "roster.publish.before": "vorher {date}, {times}",
  "roster.publish.beforePerson": "vorher {date}, {times} · {name}",
  "roster.publish.moreChanges.one": "Und {count} weitere Änderung.",
  "roster.publish.moreChanges.other": "Und {count} weitere Änderungen.",
  "roster.publish.notices":
    "Die Prüfung zeigt {notices}. Sie können trotzdem veröffentlichen, wenn Sie eine Begründung angeben.",
  "roster.publish.noticesWithBreaches":
    "Die Prüfung zeigt {notices}, davon {breaches}. Sie können trotzdem veröffentlichen, wenn Sie eine Begründung angeben.",
  "roster.publish.shortNotice":
    "Vorlauf unterschritten: Zwischen heute und dem Schichttag liegen weniger als {days} volle Kalendertage (heute und der Schichttag zählen nicht). Das ist ein Hinweis, keine Sperre.",
  "roster.publish.shortNoticeItem.one": "{date} (Vorlauf {count} voller Kalendertag): {name}",
  "roster.publish.shortNoticeItem.other": "{date} (Vorlauf {count} volle Kalendertage): {name}",
  "roster.publish.hiddenPerson": "Person außerhalb Ihrer Sicht",
  "roster.publish.reason": "Begründung",
  "roster.publish.reasonHint":
    "Zum Beispiel der Anlass einer kurzfristigen Änderung. Keine Gesundheitsangaben und keine Namen Dritter.",
  "roster.publish.reasonHintRequired":
    "Erforderlich, solange die Prüfung Hinweise zeigt; sie wird mit der Version gespeichert. Keine Gesundheitsangaben und keine Namen Dritter.",
  "roster.publish.reasonMissing": "Geben Sie eine Begründung an, die Prüfung zeigt Hinweise.",
  "roster.publish.reasonTooLong": "Die Begründung hat höchstens 500 Zeichen.",
  "roster.publish.confirm": "Jetzt veröffentlichen",
  "roster.publish.done":
    "Version {version} veröffentlicht. {count} Personen werden benachrichtigt.",
  "roster.publish.publishedHint":
    "Diese Version ist veröffentlicht. Für Änderungen legen Sie eine neue Version an; bis zu deren Veröffentlichung gilt diese Version weiter.",
  "roster.publish.revise": "Neue Version bearbeiten",
  "roster.publish.revised": "Version {version} ist ein Entwurf.",
  "roster.publish.versions": "Veröffentlichte Versionen",
  "roster.publish.version": "Version",
  "roster.publish.publishedAt": "Veröffentlicht am",
  "roster.publish.publishedBy": "Von",
  "roster.publish.changeColumn": "Änderungen",
  "roster.publish.noticeColumn": "Hinweise",
  "roster.publish.noticeCell": "{notices}, {short} mit kurzem Vorlauf",
  "roster.publish.notShown": "nicht angezeigt",
  "roster.publish.reasonGiven": "Begründung vorhanden",
  "availability.title": "Meine Verfügbarkeiten",
  "availability.hint":
    "Sagen Sie den Planenden, wann Sie können, nicht können oder gerne arbeiten. Nur Sie und die Planenden Ihres Teams oder Betriebs sehen Ihre Verfügbarkeiten, Kolleginnen und Kollegen nicht. Sie sind ein Hinweis für die Planung, keine Sperre.",
  "availability.empty": "Sie haben keine Verfügbarkeiten eingetragen.",
  "availability.add": "Verfügbarkeit eintragen",
  "availability.new": "Neue Verfügbarkeit",
  "availability.edit": "Verfügbarkeit ändern",
  "availability.kind": "Art",
  "availability.kind.Available": "Verfügbar",
  "availability.kind.Unavailable": "Nicht verfügbar",
  "availability.kind.Preferred": "Wunsch",
  "availability.date": "Tag",
  "availability.wholeDay": "Ganzer Tag",
  "availability.wholeDayShort": "ganztägig",
  "availability.weekly": "Jede Woche wiederholen",
  "availability.until": "Wiederholen bis",
  "availability.untilHint": "Höchstens ein Jahr nach dem ersten Tag.",
  "availability.note": "Notiz für die Planenden",
  "availability.noteHint": "Zum Beispiel ein fester Termin. Keine Gesundheitsangaben.",
  "availability.save": "Verfügbarkeit speichern",
  "availability.saved": "Verfügbarkeit gespeichert.",
  "availability.item": "{date}, {time}",
  "availability.weeklyUntil": "wöchentlich bis {date}",
  "availability.editItem": "Verfügbarkeit {item} ändern",
  "availability.deleteItem": "Verfügbarkeit {item} löschen",
  "availability.deleteConsequence": "Die Planenden sehen diese Verfügbarkeit danach nicht mehr.",
  "availability.deleteConfirm": "Verfügbarkeit löschen",
  "availability.deleted": "Verfügbarkeit gelöscht.",
  "availability.cellTitle": "Verfügbarkeit",
  "availability.error.date": "Wählen Sie einen Tag.",
  "availability.error.times": "Geben Sie Beginn und Ende an; sie dürfen nicht gleich sein.",
  "availability.error.until":
    "Die Wiederholung endet frühestens am ersten Tag und höchstens ein Jahr danach.",
  "availability.error.note": "Die Notiz hat höchstens 500 Zeichen.",
  "shiftRequest.title": "Tausch und offene Schichten",
  "shiftRequest.hint":
    "Sie können eigene Schichten abgeben und sich auf offene Schichten Ihres Teams bewerben. Jede Übernahme wird vorher nach den Regeln zur Arbeitszeit geprüft; in der Regel geben Planende sie frei. Erst nach der Freigabe ändert sich der Dienstplan.",
  "shiftRequest.offers": "Angebote aus Ihrem Team",
  "shiftRequest.noOffers": "Zurzeit bietet niemand eine Schicht an.",
  "shiftRequest.mine": "Ihre Anfragen",
  "shiftRequest.noRequests": "Sie haben keine offenen oder kürzlich entschiedenen Anfragen.",
  "shiftRequest.handOver": "Abgeben",
  "shiftRequest.handOverItem": "Schicht {times} abgeben",
  "shiftRequest.apply": "Übernehmen",
  "shiftRequest.applyItem": "Für die offene Schicht {times} bewerben",
  "shiftRequest.target": "An wen",
  "shiftRequest.targetHint": "Ein Angebot an das Team kann jede Person Ihres Teams annehmen.",
  "shiftRequest.toTeam": "An das Team",
  "shiftRequest.toTeamOnly":
    "Die Schicht wird Ihrem Team angeboten; jede Person Ihres Teams kann sie annehmen.",
  "shiftRequest.sendHandover": "Schicht anbieten",
  "shiftRequest.sendApplication": "Bewerbung senden",
  "shiftRequest.sentHandover": "Die Schicht wird angeboten.",
  "shiftRequest.sentApplication": "Ihre Bewerbung ist gesendet; die Planenden entscheiden.",
  "shiftRequest.accept": "Annehmen …",
  "shiftRequest.acceptConfirm": "Verbindlich annehmen",
  "shiftRequest.decline": "Ablehnen",
  "shiftRequest.declined": "Anfrage abgelehnt.",
  "shiftRequest.withdraw": "Zurückziehen",
  "shiftRequest.withdrawn": "Anfrage zurückgezogen.",
  "shiftRequest.offline":
    "Ohne Verbindung können Sie Anfragen und Verfügbarkeiten nur ansehen, nicht ändern.",
  "shiftRequest.acceptItem": "Schicht {shift} annehmen",
  "shiftRequest.declineItem": "Anfrage zur Schicht {shift} ablehnen",
  "shiftRequest.withdrawItem": "Anfrage zur Schicht {shift} zurückziehen",
  "shiftRequest.approveItem": "Anfrage zur Schicht {shift} freigeben",
  "shiftRequest.rejectItem": "Anfrage zur Schicht {shift} ablehnen",
  "shiftRequest.shiftGone": "Schicht nicht mehr im Dienstplan",
  "shiftRequest.kind.Application": "Bewerbung auf eine offene Schicht",
  "shiftRequest.kind.Offer": "Angebot an das Team",
  "shiftRequest.kind.Handover": "Abgabe an {name}",
  "shiftRequest.from": "von {name}",
  "shiftRequest.stale":
    "Die Schicht hat sich seit der Anfrage geändert; die Anfrage kann nur noch zurückgezogen oder abgelehnt werden.",
  "shiftRequest.reason": "Begründung: {reason}",
  "shiftRequest.status.Open": "Wartet auf Annahme",
  "shiftRequest.status.Accepted": "Wartet auf Freigabe",
  "shiftRequest.status.Approved": "Freigegeben",
  "shiftRequest.status.Rejected": "Abgelehnt",
  "shiftRequest.status.Withdrawn": "Zurückgezogen",
  "shiftRequest.status.Superseded": "Erledigt, die Schicht wurde anders vergeben oder geändert",
  "shiftRequest.approval.Required": "Planende geben die Übernahme frei.",
  "shiftRequest.approval.Automatic":
    "Die Übernahme wird ohne Planende freigegeben, weil die Prüfung keinen Hinweis zeigt.",
  "shiftRequest.approval.OnAcceptance":
    "Nach der Annahme wird die Übernahme je nach den Regeln Ihres Betriebs von Planenden oder automatisch freigegeben.",
  "shiftRequest.check.noNotices": "Die Prüfung zeigt für Sie keinen Hinweis.",
  "shiftRequest.check.notices":
    "Die Prüfung zeigt für Sie diese Hinweise. Sie können die Anfrage trotzdem senden; Planende entscheiden dann.",
  "shiftRequest.check.shortNotice.one":
    "Kurzer Vorlauf: Zwischen heute und der Schicht liegt {count} voller Kalendertag, weniger als die vereinbarten {days}. Das ist ein Hinweis, keine Sperre.",
  "shiftRequest.check.shortNotice.other":
    "Kurzer Vorlauf: Zwischen heute und der Schicht liegen {count} volle Kalendertage, weniger als die vereinbarten {days}. Das ist ein Hinweis, keine Sperre.",
  "shiftRequest.decision.reason": "Begründung",
  "shiftRequest.decision.reasonHint":
    "Wird den Beteiligten angezeigt. Keine Gesundheitsangaben und keine Namen Dritter.",
  "shiftRequest.decision.reasonHintRequired":
    "Zum Freigeben erforderlich, solange die Prüfung Hinweise zeigt; wird den Beteiligten angezeigt. Keine Gesundheitsangaben und keine Namen Dritter.",
  "shiftRequest.decision.reasonMissing":
    "Geben Sie eine Begründung an, die Prüfung zeigt Hinweise.",
  "shiftRequest.approve": "Freigeben",
  "shiftRequest.reject": "Ablehnen",
  "shiftRequest.approved":
    "Freigegeben. Eine neue Version des Dienstplans ist veröffentlicht; beide Personen werden benachrichtigt.",
  "shiftRequest.rejected": "Abgelehnt. Die Beteiligten werden benachrichtigt.",
  "shiftRequest.planner.title": "Anfragen zu Schichten",
  "shiftRequest.planner.hint":
    "Abgaben und Bewerbungen der Beschäftigten. Eine Freigabe veröffentlicht eine neue Version mit Änderungsliste; über Anfragen, an denen Sie selbst beteiligt sind, entscheidet eine andere planende Person.",
  "shiftRequest.planner.empty": "Keine offenen Anfragen.",
  "shiftRequest.planner.application": "Bewerbung von {name}",
  "shiftRequest.planner.handover": "{from} gibt ab an {to}",
  "shiftRequest.planner.team": "das Team (noch niemand angenommen)",
  "shiftRequest.planner.shortNotice":
    "Kurzer Vorlauf: Die Umbesetzung liegt innerhalb der Vorlaufzeit. Das ist ein Hinweis, keine Sperre.",
  "shiftRequest.planner.waiting": "Wartet auf die Annahme durch eine Kollegin oder einen Kollegen.",
  "error.TT-1232":
    "Eine wöchentliche Verfügbarkeit endet frühestens am ersten Tag und höchstens ein Jahr danach.",
  "error.TT-1233": "Diese Anfrage zu einer Schicht ist so nicht möglich.",
  "error.TT-1234": "Die Schicht hat schon begonnen und kann nicht mehr übernommen werden.",
  "error.TT-1235":
    "Über eine Anfrage, an der Sie selbst beteiligt sind, entscheidet eine andere planende Person.",
  "error.TT-3276": "Sie können diese Anfrage nicht bearbeiten.",
  "error.TT-3277":
    "Der Dienstplan wird gerade überarbeitet. Entscheiden Sie die Anfrage nach der Veröffentlichung.",
  "error.TT-3278":
    "Die Schicht hat sich seit der Anfrage geändert. Die Anfrage kann nur noch zurückgezogen oder abgelehnt werden.",
  "error.TT-3279": "Zu dieser Schicht gibt es schon eine offene Anfrage.",
  "error.TT-3294":
    "Die Prüfung zeigt Hinweise. Geben Sie eine Begründung an, um die Übernahme trotzdem freizugeben.",
  "error.TT-3295":
    "In Ihrem Betrieb werden keine Namen von Kolleginnen und Kollegen angezeigt. Bieten Sie die Schicht dem Team an.",
  "error.TT-1236": "Das Soll aus dem Dienstplan gibt es nur für Schichtmodelle.",
  "error.TT-1237":
    "Das Soll aus dem Dienstplan wird ab dem ersten Tag eines Monats ein- oder ausgeschaltet.",
  "error.TT-1238": "Die Toleranz liegt zwischen 0 und 120 Minuten.",
  "error.TT-1239": "Die Mindestgruppe liegt zwischen 2 und 50 Personen.",
  "error.TT-3296":
    "Die Änderung würde vergangene Tage betreffen. Das Soll aus dem Dienstplan ändert sich erst ab einem Monat, der noch nicht begonnen hat.",
  "error.TT-3293":
    "Die Prüfung zeigt Hinweise. Geben Sie eine Begründung an, um den Dienstplan trotzdem zu veröffentlichen.",
  "error.TT-1230": "Eine Woche wird in eine andere Woche kopiert, ganze Wochen vor oder zurück.",
  "error.TT-1231": "Die Schichtvorlage gilt an diesem Tag nicht.",
  "error.TT-3290": "Für diesen Betrieb und dieses Team gibt es im Zeitraum schon einen Dienstplan.",
  "error.TT-3291": "Die Schichtvorlage gehört zu einem anderen Betrieb.",
  "error.TT-3292": "Die Person gehört an diesem Tag nicht zum Team oder Betrieb des Dienstplans.",
  "datev.program.Generic": "Anderes Lohnprogramm (CSV)",
  "datev.genericHint":
    "Für andere Lohnprogramme (zum Beispiel Lexware lohn+gehalt oder ADDISON) entsteht eine CSV-Datei mit Kopfzeile und den gewählten Spalten. Beraternummer und Mandantennummer entfallen.",
  "datev.category.OvertimePayoutHours":
    "Ausgezahlte Überstunden des Überstundenkontos (Auszahlungsbuchungen; neben dem Zuwachs nur mit Umstellungsmonaten)",
  "datev.category.VacationHours": "Urlaubsstunden",
  "datev.category.SickHours": "Krankheitsstunden (mit Reha oder Kur)",
  "datev.category.SpecialLeaveHours": "Sonderurlaubsstunden",
  "datev.category.TrainingHours": "Fortbildungsstunden",
  "datev.category.EducationLeaveHours": "Bildungsurlaubsstunden",
  "datev.exclusiveHint":
    "Nie doppelt: Zuwachs und ausgezahlte Überstunden zusammen nur mit Umstellungsmonaten (jeder Monat überträgt genau eins davon), entweder Abwesenheitsstunden gesamt oder je Art, eine Abwesenheitsart entweder als Kalendarium oder als Stunden oder Tage. Gleitzeit-Auszahlungen haben eine eigene Lohnart.",
  "datev.surcharges": "Zuschlagsstunden",
  "datev.surchargesHint":
    "Die Stunden je Zuschlagsart kommen aus dem Zuschlagsprofil. Zuschläge im Lohnexport gehören zum DATEV-Lohnexport des Tarifs.",
  "datev.column.surcharge": "Zuschlagsart",
  "datev.transferSurcharge": "Zuschlag {code} übertragen",
  "datev.surchargeWageTypeFor": "Lohnart für Zuschlag {code}",
  "datev.surchargeKeyFor": "Bearbeitungsschlüssel für Zuschlag {code}",
  "datev.calendar": "Abwesenheiten als Kalendarium",
  "datev.calendarHint":
    "Tage dieser Abwesenheitsarten werden je Tag mit Ausfallschlüssel und Stunden übertragen statt als Stunden oder Tage im Monat. Nur LODAS und andere Lohnprogramme; den Ausfallschlüssel nennt das Steuerbüro.",
  "datev.column.absenceKind": "Abwesenheitsart",
  "datev.column.outageKey": "Ausfallschlüssel",
  "datev.calendarFor": "{kind} als Kalendarium übertragen",
  "datev.outageKeyFor": "Ausfallschlüssel für {kind}",
  "datev.costCenters": "Kostenstellen je Betrieb",
  "datev.costCentersHint":
    "Jeder Wert einer Person trägt die Kostenstelle des Betriebs, zu dem sie im Monat zuletzt gehört. Leer lassen für keine Kostenstelle.",
  "datev.column.establishment": "Betrieb",
  "datev.column.costCenter": "Kostenstelle",
  "datev.costCenterFor": "Kostenstelle für {establishment}",
  "datev.columns": "Spalten der CSV-Datei",
  "datev.columnFor": "Spalte {column} ausgeben",
  "datev.columnUp": "{column} nach vorne",
  "datev.columnDown": "{column} nach hinten",
  "datev.columnName.PersonnelNumber": "Personalnummer",
  "datev.columnName.Period": "Zeitraum",
  "datev.columnName.WageType": "Lohnart",
  "datev.columnName.Quantity": "Menge",
  "datev.columnName.Unit": "Einheit",
  "datev.columnName.CostCenter": "Kostenstelle",
  "datev.columnName.Date": "Datum",
  "datev.columnName.OutageKey": "Ausfallschlüssel",
  "datev.columnName.Year": "Jahr",
  "datev.columnName.Month": "Monat",
  "datev.downloadGeneric": "Lohnexport (CSV) herunterladen",
  "datev.check": "Prüfprotokoll anzeigen",
  "datev.checkTitle": "Prüfprotokoll {month}",
  "datev.provisional":
    "Der Monat ist noch nicht für alle Personen abgeschlossen oder Zuschläge sind nicht berechenbar: Die Datei ist vorläufig und trägt „vorlaeufig“ im Namen.",
  "datev.final":
    "Der Monat ist abgeschlossen: Die Datei ist endgültig. Bei gleichen Daten und Einstellungen entsteht dieselbe Datei; Urlaubsabgeltung, Urlaubstage laut Urlaubskonto, Einstellungen und Stammdaten können sich noch ändern.",
  "datev.checkTotals": "Summen",
  "datev.column.value": "Wert",
  "datev.column.quantity": "Menge",
  "datev.column.records": "Sätze",
  "datev.column.person": "Person",
  "datev.column.previous": "Letzte Datei",
  "datev.column.current": "Jetzt",
  "datev.withoutValues": "Ohne Werte im Monat: {persons}",
  "datev.surchargeFailures":
    "Zuschläge nicht berechenbar, die Datei enthält für sie keine Zuschläge: {persons}",
  "datev.unmappedSurcharges": "Zuschlagsarten mit Stunden, aber ohne Lohnart: {codes}",
  "datev.noPrevious": "Für diesen Monat wurde noch keine Datei heruntergeladen.",
  "datev.previous": "Abweichungen zur Datei vom {date}",
  "datev.noDeviations": "Keine Abweichungen zur zuletzt heruntergeladenen Datei.",
  "datev.surchargeLabel": "Zuschlag {code}",
  "datev.calendarLabel": "Kalendarium {kind}",
  "datev.unit.hours": "Std.",
  "datev.unit.days": "Tage",
  "error.TT-3330":
    "Die Einstellungen nennen ein anderes Lohnprogramm. Laden Sie die Datei des eingestellten Programms herunter.",
  "error.TT-3331": "Eine Kostenstelle nennt einen Betrieb, den es nicht gibt.",
  "error.TT-3332":
    "Die Umstellung zwischen Zuwachs und ausgezahlten Überstunden muss bestätigt werden.",
  "error.TT-3333":
    "Die Umstellung des Überstunden-Modus beginnt erst in einem Monat, der noch nicht begonnen hat und noch nicht exportiert wurde; frühere Monate behalten ihren Modus, beide Lohnarten und die bisherigen Umstellungen bleiben deshalb.",
  "datev.category.FlexitimePayoutHours": "Ausgezahlte Gleitzeitstunden (Auszahlungsbuchungen)",
  "datev.overtimeModeWarning":
    "Sie ändern, wie Überstunden übertragen werden. Die Umstellung gilt in beide Richtungen erst ab einem Monat, der noch nicht begonnen hat und noch nicht exportiert wurde; frühere Monate behalten ihre Übertragung, deshalb bleiben beide Lohnarten nötig. Stunden, die schon als Zuwachs übertragen wurden, dürfen nicht nochmals ausgezahlt werden; das Prüfprotokoll nennt Auszahlungen, die das betreffen kann.",
  "datev.confirmOvertimeModeChange":
    "Ich bestätige die Änderung und prüfe die Auszahlungen gegen den bereits übertragenen Zuwachs.",
  "datev.calendarHealthHint":
    "Achtung: Im Kalendarium werden einzelne Krankheitstage übermittelt – Gesundheitsdaten nach Art. 9 DSGVO. Datenschutzhinweis und Datenschutzbeauftragte prüfen lassen.",
  "datev.calendarRehabilitationHint":
    "Ohne eigenen Schlüssel folgt Reha oder Kur dem Ausfallschlüssel der Krankheit. Einzelne Tage sind Gesundheitsdaten nach Art. 9 DSGVO.",
  "datev.column.day": "Tag",
  "datev.payout": "{person}: {hours} Std. {account}",
  "datev.account.Overtime": "Überstundenkonto",
  "datev.account.Flexitime": "Gleitzeitkonto",
  "datev.untransferredPayouts":
    "Auszahlungen gebucht, nicht übertragen (keine Lohnart in diesem Monat): {payouts}",
  "datev.untransferredAbsences":
    "Abwesenheiten mit Gutschrift, aber ohne Lohnart, Ausfallschlüssel oder Tageskategorie (nicht übertragen): {absences}",
  "datev.untransferredAbsence": "{kind} {hours} Std. bei {persons} Personen",
  "datev.establishmentChanges":
    "Betriebswechsel im Monat, alle Werte tragen die Kostenstelle des letzten Betriebs: {persons}",
  "datev.previousCompared":
    "Die letzte Datei wurde mit ihrer Vorgängerin verglichen ({count} Abweichungen).",
  "datev.overtimeSwitchFrom.Payouts":
    "Ausgezahlte Überstunden übertragen ab (Monat; davor der Zuwachs)",
  "datev.overtimeSwitchFrom.Increase":
    "Wieder den Zuwachs übertragen ab (Monat; davor die Auszahlungen)",
  "datev.overtimeHistory":
    "Umstellungen des Überstunden-Modus (bleiben, solange frühere Monate exportiert werden können): {switches}",
  "datev.overtimeSwitch.Payouts": "ab {month} ausgezahlte Überstunden",
  "datev.overtimeSwitch.Increase": "ab {month} Zuwachs",
  "datev.possiblyTransferredPayouts":
    "Ausgezahlte Überstunden, die möglicherweise bereits als Zuwachs übertragen wurden – mit dem übertragenen Zuwachs abgleichen: {payouts}",
  "datev.possiblyTransferredPayout":
    "{payout} (bisher {open} Std. mehr als Zuwachs übertragen als ausgezahlt)",
  "absences.kind.VocationalTraining": "Berufsschule oder Prüfung",
  "absences.code.VocationalTraining": "BS",
  "absences.vocational.category": "Art der Freistellung",
  "absences.vocational.category.SchoolDay": "Berufsschultag (mehr als fünf Unterrichtsstunden)",
  "absences.vocational.category.BlockWeek": "Blockunterricht (Blockwoche)",
  "absences.vocational.category.Lessons": "Unterricht mit Uhrzeiten",
  "absences.vocational.category.Examination": "Prüfung oder außerbetriebliche Ausbildungsmaßnahme",
  "absences.vocational.category.ExamEve": "Arbeitstag vor der schriftlichen Abschlussprüfung",
  "absences.vocational.category.Other": "Berufsschule oder Prüfung",
  "absences.vocational.startsAt": "Beginn",
  "absences.vocational.endsAt": "Ende",
  "absences.vocational.travel": "Wegezeit in Minuten",
  "absences.vocational.travelHint":
    "Nur die notwendige Wegezeit zwischen Schule oder Prüfung und Betrieb, wenn am selben Tag im Betrieb gearbeitet wird.",
  "absences.vocational.blockStartsAt": "Unterrichtsbeginn",
  "absences.vocational.blockStartsAtHint":
    "Beginnt der Blockunterricht vor 9 Uhr, prüft Zeitavo, dass an den Schultagen vorher nicht gearbeitet wird. Ohne Angabe ist diese Prüfung nicht möglich.",
  "absences.vocational.hint":
    "Freistellung für Berufsschule und Prüfungen (§ 15 BBiG, §§ 9 und 10 JArbSchG). Dafür wird nicht gestempelt und keine Projektzeit gebucht: Die Zeit zählt für Soll und Saldo und in der Prüfung der Arbeitszeit – ein ganzer Tag mit der durchschnittlichen täglichen Arbeitszeit (Wochensoll geteilt durch die Arbeitstage), auch an einem freien Tag des Arbeitszeitmodells, eine Blockwoche mit der durchschnittlichen wöchentlichen Arbeitszeit, Unterricht und Prüfung mit ihrer Dauer einschließlich Pausen und Wegezeit, abzüglich eigener Arbeit in dieser Zeit. Ein Berufsschultag mit mehr als fünf Unterrichtsstunden zählt einmal pro Woche als ganzer Tag; weitere Schultage derselben Woche tragen Sie als Unterricht mit Uhrzeiten ein.",
  "absences.vocational.earlyHint":
    "Unterricht vor 9 Uhr: An diesem Tag – in einer Blockwoche an jedem Schultag – darf vor dem Unterricht nicht gearbeitet werden.",
  "absences.vocational.blockHint":
    "Mindestens fünf Tage jeder Kalenderwoche. Daneben sind höchstens zwei Stunden betriebliche Ausbildungsveranstaltungen pro Woche erlaubt.",
  "absences.vocational.timed":
    "{category}, {from}–{to} Uhr, Wegezeit {minutes} Min. (angerechnet {hours} Std.)",
  "absences.vocational.block": "{category}, Unterrichtsbeginn {from} Uhr",
  "error.TT-1320": "Bitte die Art der Freistellung für Berufsschule oder Prüfung angeben.",
  "error.TT-1321":
    "Unterricht und Prüfung brauchen Beginn und ein späteres Ende am selben Tag, jeweils in ganzen Minuten; eine Blockwoche hat höchstens einen Unterrichtsbeginn, ganze Tage haben keine Uhrzeiten.",
  "error.TT-1322":
    "Die Wegezeit liegt zwischen 0 und 240 Minuten und gehört nur zu Unterricht oder Prüfung.",
  "error.TT-1323":
    "Diese Art umfasst genau einen ganzen Tag; eine Blockwoche mindestens fünf Tage jeder Kalenderwoche. Halbe Tage gibt es nicht.",
  "error.TT-1324":
    "In dieser Woche gibt es schon einen Berufsschultag. Tragen Sie den weiteren Schultag als Unterricht mit Uhrzeiten ein.",
  "error.TT-1325":
    "Die Freistellung für Berufsschule und Prüfungen gibt es nur für Auszubildende und für Jugendliche, die am ersten Tag noch nicht 18 Jahre alt sind.",
  "error.TT-1326":
    "Eine Blockwoche gibt ihre ganzen Kalenderwochen frei: In diesen Wochen gibt es keine weitere Freistellung für Berufsschule oder Prüfung, auch nicht an einem Tag außerhalb des Blocks.",
  "error.TT-1360": "Nur wer den Korrekturantrag gestellt hat, kann ihn zurückziehen.",
  "error.TT-3390":
    "Berufsschule und Prüfungen können nicht über die öffentliche API beantragt werden; die Person beantragt sie oder HR erfasst sie in Zeitavo mit Art und Uhrzeiten.",
  "rule.JARBSCHG-SCHOOL": "Berufsschule und Prüfungen Jugendlicher (§§ 9, 10 JArbSchG)",
  "rule.BBIG-SCHOOL": "Freistellung für Berufsschule und Prüfungen (§ 15 BBiG)",
  "check.SchoolDayWork": "Arbeit an einem Berufsschultag",
  "check.ExamEveWork": "Arbeit am Tag vor der schriftlichen Abschlussprüfung",
  "check.BlockWeekWork": "Mehr als zwei Stunden Arbeit in einer Blockwoche",
  "check.EarlyLessonWork": "Arbeit vor einem Unterricht, der vor 9 Uhr beginnt",
  "check.ReleaseWork": "Arbeit während Unterricht oder Prüfung",
  "check.TrainingCreditUnknown": "Durchschnittliche Arbeitszeit für die Anrechnung fehlt",
  // On-call duty and on-site standby (F-106).
  "rule.ARBZG-ONCALL-REST": "Ruhezeit bei Rufbereitschaft (§ 5 Abs. 3 ArbZG)",
  "rule.ARBZG-EXTENDED-DAY-REST": "Ruhezeit nach mehr als 12 Stunden Arbeit (§ 7 Abs. 9 ArbZG)",
  "rule.ARBZG-DEVIATION-AVERAGE": "Wochendurchschnitt bei Abweichungen (§ 7 Abs. 8 ArbZG)",
  "check.OnCallRest": "Ruhezeit nach Einsätzen in der Rufbereitschaft unterschritten",
  "check.RestAfterOnCall":
    "Ruhezeit nach Einsatz in der Rufbereitschaft unterschritten – kürzen dürfen nur Krankenhäuser und Pflegeeinrichtungen oder ein Tarifvertrag nach § 7 Abs. 2 Nr. 1 ArbZG, nicht bei Jugendlichen und im Mutterschutz",
  "check.OnCallCompensation": "Ausgleich für Einsätze in der Rufbereitschaft",
  "check.ExtendedDayRest": "Ruhezeit nach einem Arbeitstag über 12 Stunden unterschritten",
  "check.DeviationAverage":
    "Durchschnittliche Arbeitszeit je Woche bei einer Abweichung nach § 7 ArbZG überschritten (§ 7 Abs. 8 ArbZG)",
  // Working time rules of federal civil servants (F-115).
  "rule.AZV-DAILY-MAX": "Tägliche Arbeitszeit einschließlich Pausen (§ 4 AZV)",
  "rule.AZV-AVERAGE": "Wöchentliche Arbeitszeit im Jahresdurchschnitt (§ 87 Abs. 1 BBG, § 3 AZV)",
  "rule.AZV-BREAK": "Ruhepausen (§ 5 Abs. 1 AZV)",
  "rule.AZV-REST": "Ruhezeit (§ 5 Abs. 3 AZV)",
  "rule.AZV-WEEKLY-REST": "Wöchentliche Ruhezeit (§ 5 Abs. 3 AZV)",
  "rule.AZV-NIGHT": "Nachtdienst (§ 14 AZV)",
  "rule.AZV-FREE-DAY": "Dienstfreie Tage (§ 6 AZV)",
  "rule.AZV-MULTI-EMPLOYER":
    "Tätigkeit bei anderen Arbeitgebern (Beamtinnen und Beamte des Bundes)",
  "check.WeeklyRest": "Zu wenige wöchentliche Ruhezeiten von 24 Stunden in 14 Tagen",
  "check.LateBreak": "Ruhepause zu spät – vor Erreichen der Stundengrenze zu kurz",
  "check.ServiceFreeDay":
    "Dienst an einem grundsätzlich dienstfreien Tag – nur angeordnet oder freiwillig",
  "error.TT-1450":
    "Das Regelprofil gehört zu einem anderen Arbeitszeitrecht als die Beschäftigung. Ohne Zuordnung gilt das Profil des Arbeitszeitrechts.",
  "onCall.title": "Rufbereitschaft und Bereitschaftsdienst",
  "onCall.hint":
    "Einsätze erfassen Sie nicht gesondert: Eine gestempelte Schicht, die in einer Rufbereitschaft beginnt, ist ein Einsatz. Bereitschaftsdienst zählt immer als Arbeitszeit.",
  "onCall.none": "Keine Zeiträume im angezeigten Zeitraum.",
  "onCall.person": "Person",
  "onCall.item": "{kind}: {start} bis {end}, {counts}",
  "onCall.item.counts": "zählt als Arbeitszeit",
  "onCall.item.deployments": "Arbeitszeit nur bei Einsatz",
  "onCall.item.withdrawn": "{item} (zurückgezogen am {at})",
  "onCall.kind": "Art",
  "onCall.kind.OnCall": "Rufbereitschaft",
  "onCall.kind.OnSiteStandby": "Bereitschaftsdienst",
  "onCall.new": "Zeitraum hinzufügen",
  "onCall.startDate": "Beginn (Datum)",
  "onCall.startTime": "Beginn (Uhrzeit)",
  "onCall.endDate": "Ende (Datum)",
  "onCall.endTime": "Ende (Uhrzeit)",
  "onCall.counts":
    "Ganz als Arbeitszeit werten (die Einschränkungen beeinträchtigen die Freizeit ganz erheblich)",
  "onCall.standbyCounts": "Bereitschaftsdienst zählt als Arbeitszeit.",
  "onCall.invalid": "Das Ende muss nach dem Beginn liegen; ein Zeitraum dauert höchstens 7 Tage.",
  "onCall.add": "Hinzufügen",
  "onCall.added": "Zeitraum hinzugefügt.",
  "onCall.withdraw": "Zurückziehen",
  "onCall.withdrawConsequence":
    "Der Zeitraum wird zurückgezogen; Schichten darin gelten danach nicht mehr als Einsätze. Er bleibt als zurückgezogen in der Liste, und das Protokoll behält die Änderung.",
  "onCall.withdrawConfirm": "Zeitraum zurückziehen",
  "onCall.withdrawn": "Zeitraum zurückgezogen.",
  "onCall.tooEarly":
    "Ein Zeitraum kann frühestens am {date} beginnen: Ältere Tage werden nicht mehr neu ausgewertet.",
  "roster.onCall.hint":
    "Zeiträume gehören zu keiner Version des Dienstplans: Änderungen gelten sofort, auch in einem veröffentlichten Dienstplan, und fließen in die Regelprüfung ein.",
  "roster.onCall.none": "Keine Rufbereitschaft und kein Bereitschaftsdienst an diesem Tag.",
  "roster.onCall.notReadable": "Die Zeiträume dieser Person sehen Sie nicht.",
  "roster.onCall.readOnly": "Die Zeiträume dieser Person dürfen Sie nicht ändern.",
  "roster.onCall.tooOld": "Liegt zu weit zurück, um ihn zu ändern.",
  "roster.onCall.changeLabel": "{item} ändern",
  "roster.onCall.withdrawLabel": "{item} zurückziehen",
  "roster.onCall.changeTitle": "Zeitraum ändern",
  "roster.onCall.changeHint":
    "Beim Speichern wird der bisherige Zeitraum zurückgezogen und als neue Version erfasst; der bisherige bleibt als Nachweis erhalten.",
  "roster.onCall.save": "Speichern",
  "roster.onCall.changed": "Zeitraum geändert.",
  "roster.onCall.legend": "RB: Rufbereitschaft, BD: Bereitschaftsdienst.",
  "roster.onCall.mark.OnCall": "RB",
  "roster.onCall.mark.OnSiteStandby": "BD",
  "error.TT-3600":
    "Zeiträume, die mehr als drei Monate zurückliegen, können nicht mehr erfasst, geändert oder zurückgezogen werden.",
  "error.TT-3661":
    "An Tagen unter der AZV sehen Vorgesetzte keine Buchungen, Zeiten und Befunde der Person (§ 7 Abs. 8 AZV); die Personalabteilung ist zuständig.",
  "error.TT-1420": "Ein Zeitraum endet nach seinem Beginn und dauert höchstens 7 Tage.",
  "error.TT-1421": "Bereitschaftsdienst zählt immer als Arbeitszeit.",
  // Operator area (F-69): its own file, so the pages of the area extend it without this dictionary.
  ...platformMessagesDe,
} as const satisfies Record<string, string>;

/** Identifier of a translatable message. */
export type MessageKey = keyof typeof messagesDe;
